import { Directive, ElementRef, Renderer2, Input, HostListener, NgModule, Inject, Pipe, EventEmitter, Component, Output, ViewChild, Injectable, Self, Optional, HostBinding, forwardRef, ViewEncapsulation, ContentChildren, TemplateRef, ViewChildren, ChangeDetectionStrategy, ContentChild, ChangeDetectorRef } from '@angular/core';
import { DOCUMENT, CommonModule } from '@angular/common';
import { timer, BehaviorSubject, Subject, Subscription, of, defer, merge } from 'rxjs';
import { take, switchMap, filter, startWith, map, takeUntil } from 'rxjs/operators';
import { VoxelSegmentService, VoxelSegmentModule, VoxelButtonModule, enforceBoolean as enforceBoolean$1, VoxelIconModule, VoxelInputModule, VoxelFormFieldModule, VoxelLoadingCircleModule, VoxelHeaderModule } from '@voxel/components';
import { trigger, transition, style, animate, state, AnimationBuilder } from '@angular/animations';
import { NgControl, FormsModule, FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { CdkConnectedOverlay, OverlayModule } from '@angular/cdk/overlay';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { CdkTableModule } from '@angular/cdk/table';
import { RouterModule } from '@angular/router';
import { QRCodeModule } from 'angularx-qrcode';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { BarcodeFormat } from '@zxing/library';

/**
 * Ripple é um efeito executado no click/touch de um elemento. Esta diretiva pode ser adicionada
 * a qualquer elemento para que tenha o efeito aplicado.
 *
 * *Ripple is an effect performed on the click / touch of an element.*
 * *This directive can be added to any element to have the effect applied.*
 *
 * **Module:**
 *
 * `import { VclRippleModule } from '@voxel/community';`
 *
 * **SCSS:**
 *
 * Importar o arquivo `~@voxel/community/styles/utils.scss` no arquivo `styles.scss` da aplicação
 *
 * *Import the file `~@voxel/community/styles/utils.scss` in the application's `styles.scss` file*
 *
 * @example aplicado a um botão
 * <button
 *   type="button"
 *   vclRipple
 *   rippleStyle="dark">
 *     ripple effect
 * </button>
 *
 *
 * @example aplicado a um botão e desabilitado
 * <button
 *   type="button"
 *   vclRipple
 *   disableRipple="true">
 *     ripple effect
 * </button>
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@voxel/components';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@angular/forms';
import * as ɵngcc4 from '@angular/cdk/a11y';
import * as ɵngcc5 from '@angular/cdk/overlay';
import * as ɵngcc6 from '@angular/animations';
import * as ɵngcc7 from 'angularx-qrcode';
import * as ɵngcc8 from '@zxing/ngx-scanner';

const _c0 = ["closeButton"];
function VclModalComponent_h2_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h2", 13);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("id", "modal-title-" + ctx_r1.id);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.modalTitle, " ");
} }
function VclModalComponent_a_9_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 14);
    ɵngcc0.ɵɵlistener("click", function VclModalComponent_a_9_Template_a_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.emmitModalButtonClick($event, ctx_r5.ModalButtonTypes.headerAction); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.headerActionLabel);
} }
function VclModalComponent_button_13_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 15);
    ɵngcc0.ɵɵlistener("click", function VclModalComponent_button_13_Template_button_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.emmitModalButtonClick($event, ctx_r7.ModalButtonTypes.secondary); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r3.secondaryButtonDisabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r3.buttonLabels.secondary, " ");
} }
function VclModalComponent_button_14_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 16);
    ɵngcc0.ɵɵlistener("click", function VclModalComponent_button_14_Template_button_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.emmitModalButtonClick($event, ctx_r9.ModalButtonTypes.primary); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r4.primaryButtonDisabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r4.buttonLabels.primary, " ");
} }
const _c1 = function (a0) { return { "z-index": a0 }; };
const _c2 = function (a0, a1) { return { "width": a0, "height": a1 }; };
const _c3 = ["*"];
function VclSnackBarComponent_div_0_p_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.snackBarInfo.label2, " ");
} }
function VclSnackBarComponent_div_0_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementStart(1, "button", 6);
    ɵngcc0.ɵɵlistener("click", function VclSnackBarComponent_div_0_div_5_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(2); return ctx_r3.onAction(); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.snackBarInfo.action, " ");
} }
function VclSnackBarComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "p");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, VclSnackBarComponent_div_0_p_4_Template, 2, 1, "p", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, VclSnackBarComponent_div_0_div_5_Template, 3, 1, "div", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("@openDismiss", undefined)("ngClass", ctx_r0.snackBarInfo.label2 ? "two-lines" : "one-line");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.snackBarInfo.label1, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.snackBarInfo.label2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.snackBarInfo.action);
} }
const _c4 = ["actions"];
const _c5 = ["actionButton1"];
const _c6 = ["actionButton2"];
const _c7 = ["actionButton3"];
function VclDialogComponent_div_0_h2_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h2", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵattribute("id", "title-" + ctx_r1.id);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.dialogTitle);
} }
function VclDialogComponent_div_0_button_12_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 9, 13);
    ɵngcc0.ɵɵlistener("click", function VclDialogComponent_div_0_button_12_Template_button_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.emmitDialogButtonClick($event, ctx_r7.DialogButtonTypes.action2); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("voxelButtonContextual", true);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r4.buttonLabels.action2, " ");
} }
function VclDialogComponent_div_0_button_13_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 9, 14);
    ɵngcc0.ɵɵlistener("click", function VclDialogComponent_div_0_button_13_Template_button_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.emmitDialogButtonClick($event, ctx_r10.DialogButtonTypes.action3); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("voxelButtonContextual", true);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r5.buttonLabels.action3, " ");
} }
function VclDialogComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "dialog", 3);
    ɵngcc0.ɵɵelementStart(3, "div", 4);
    ɵngcc0.ɵɵtemplate(4, VclDialogComponent_div_0_h2_4_Template, 2, 2, "h2", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 6);
    ɵngcc0.ɵɵprojection(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 7, 8);
    ɵngcc0.ɵɵelementStart(9, "button", 9, 10);
    ɵngcc0.ɵɵlistener("click", function VclDialogComponent_div_0_Template_button_click_9_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.emmitDialogButtonClick($event, ctx_r12.DialogButtonTypes.action1); });
    ɵngcc0.ɵɵtext(11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(12, VclDialogComponent_div_0_button_12_Template, 3, 2, "button", 11);
    ɵngcc0.ɵɵtemplate(13, VclDialogComponent_div_0_button_13_Template, 3, 2, "button", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(13, _c1, ctx_r0.zIndex));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵattribute("id", ctx_r0.id)("open", ctx_r0.showDialog ? ctx_r0.onResize() : null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.dialogTitle);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("id", "desc-" + ctx_r0.id);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassMapInterpolate1("actions ", ctx_r0.buttonAlignment, "");
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.buttonLabels.action3 ? "three-buttons" : "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("voxelButtonContextual", true);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.buttonLabels.action1, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.buttonLabels.action2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.buttonLabels.action3);
} }
const _c8 = function (a0, a1) { return { "steps__content-step--checked": a0, "steps__content-step--current": a1 }; };
function VclStepsComponent_li_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "li", 5);
} if (rf & 2) {
    const step_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(2, _c8, ctx_r0.current >= step_r1 + 1, ctx_r0.current == step_r1 + 1));
    ɵngcc0.ɵɵattribute("id", ctx_r0.id);
} }
const _c9 = ["option"];
const _c10 = ["autocomplete"];
const _c11 = ["autocompleteInput"];
const _c12 = ["panel"];
function VclAutocompleteComponent_span_6_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 8);
    ɵngcc0.ɵɵlistener("click", function VclAutocompleteComponent_span_6_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.clearSearch(); });
    ɵngcc0.ɵɵelementEnd();
} }
function VclAutocompleteComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 9);
} }
function VclAutocompleteComponent_ng_template_11_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵpipe(1, "async");
    ɵngcc0.ɵɵelementStart(2, "div", 14);
    ɵngcc0.ɵɵelementStart(3, "span", 15);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "span", 16);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassMapInterpolate1("vcl-autocomplete__not-options ", ɵngcc0.ɵɵpipeBind1(1, 5, ctx_r9.segment), "");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ctx_r9.notFoundTitle);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r9.notFoundMessage);
} }
function VclAutocompleteComponent_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 10, 11);
    ɵngcc0.ɵɵlistener("keydown", function VclAutocompleteComponent_ng_template_11_Template_div_keydown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.handleKeydown($event); });
    ɵngcc0.ɵɵprojection(2);
    ɵngcc0.ɵɵtemplate(3, VclAutocompleteComponent_ng_template_11_div_3_Template, 7, 7, "div", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("id", ctx_r5.panelId);
    ɵngcc0.ɵɵattribute("aria-labelledby", ctx_r5.labelId)("aria-hidden", !ctx_r5.panelOpen);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r5.hasSearch && ctx_r5.autocompleteSearch);
} }
const _c13 = [[["vcl-option"]]];
const _c14 = function (a1, a2) { return { "vcl-autocomplete__text": true, "voxel-txt-color-sand-200": a1, "voxel-txt-color-sand-900": a2, "voxel-text-l": true }; };
const _c15 = function (a1, a2, a3, a4) { return { "vcl-autocomplete__icon": true, "vcl-autocomplete__icon--disabled": a1, "voxel-txt-color-sand-200": a2, "vcl-autocomplete__icon--open": a3, "rotate": a4 }; };
const _c16 = ["vcl-option"];
function VclCardDropdownComponent_section_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "section", 7);
    ɵngcc0.ɵɵprojection(1, 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("@toggleExpansion", ctx_r0.expanded);
} }
const _c17 = [[["", "role", "header"]], [["", "role", "footer"]], [["", "role", "content"]]];
const _c18 = ["[role=header]", "[role=footer]", "[role=content]"];
const _c19 = ["carousel"];
function VclCarouselComponent_li_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 5);
    ɵngcc0.ɵɵelementContainer(1, 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r3 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", item_r3.tpl);
} }
function VclCarouselComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵelementStart(1, "div", 8);
    ɵngcc0.ɵɵelementStart(2, "button", 9);
    ɵngcc0.ɵɵlistener("click", function VclCarouselComponent_div_4_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.prev(); });
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 10);
    ɵngcc0.ɵɵelementStart(5, "ul", 11);
    ɵngcc0.ɵɵlistener("click", function VclCarouselComponent_div_4_Template_ul_click_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.moveByButton($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 8);
    ɵngcc0.ɵɵelementStart(7, "button", 12);
    ɵngcc0.ɵɵlistener("click", function VclCarouselComponent_div_4_Template_button_click_7_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.next(); });
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r2.prevButtonDisabled)("voxelButtonContextual", true);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.textButtonPrev, " ");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("disabled", ctx_r2.nextButtonDisabled)("voxelButtonContextual", true);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.textButtonNext, " ");
} }
function VclPaginatorComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 9);
    ɵngcc0.ɵɵtext(1, "|");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate4(" ", ctx_r1.firstVisibleItem, " - ", ctx_r1.lastVisibleItem, " de ", ctx_r1.length, " ", ctx_r1.language === "PT" ? "Itens" : ctx_r1.language === "ENG" ? "Items" : "Elementos", "");
} }
function VclPaginatorComponent_div_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function VclPaginatorComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵtemplate(1, VclPaginatorComponent_div_6_ng_container_1_Template, 1, 0, "ng-container", 11);
    ɵngcc0.ɵɵelementStart(2, "span", 12);
    ɵngcc0.ɵɵtext(3, "|");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r0 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r0);
} }
function VclPaginatorComponent_div_7_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function VclPaginatorComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵtemplate(1, VclPaginatorComponent_div_7_ng_container_1_Template, 1, 0, "ng-container", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r0 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r0);
} }
function VclPaginatorComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span", 13);
    ɵngcc0.ɵɵtext(2, "|");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 6);
    ɵngcc0.ɵɵelementStart(4, "vcl-select", 2);
    ɵngcc0.ɵɵlistener("selectedValueChange", function VclPaginatorComponent_ng_container_8_Template_vcl_select_selectedValueChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.pageSelectChange($event); })("listOpenChange", function VclPaginatorComponent_ng_container_8_Template_vcl_select_listOpenChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.listStateChange($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "span", 14);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementContainerStart(7);
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementContainerEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("selectedValue", ctx_r4.pageSelectCurrent)("options", ctx_r4.pageSelectOptions)("numVisibleOptions", ctx_r4.numVisibleSelectOptions);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate2(" ", ctx_r4.language === "PT" ? "de" : ctx_r4.language === "ENG" ? "of" : "de", " ", ctx_r4.totalPages, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.language === "PT" ? ctx_r4.totalPages > 1 ? "p\u00E1ginas" : "p\u00E1gina" : ctx_r4.language === "ENG" ? ctx_r4.totalPages > 1 ? "pages" : "page" : ctx_r4.totalPages > 1 ? "p\u00E1ginas" : "p\u00E1gina");
} }
function VclSelectComponent$1_div_6_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 7);
    ɵngcc0.ɵɵlistener("click", function VclSelectComponent_1_div_6_span_1_Template_span_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r4); const option_r2 = restoredCtx.$implicit; const ctx_r3 = ɵngcc0.ɵɵnextContext(2); return ctx_r3.select(option_r2); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r2 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(option_r2);
} }
function VclSelectComponent$1_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵtemplate(1, VclSelectComponent$1_div_6_span_1_Template, 2, 1, "span", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("max-height", 48 / 16 * ctx_r0.numVisibleOptions, "rem");
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.listPosition);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.options);
} }
const _c20 = function (a0) { return { "vcl-select__selected-option--icon--expanded": a0 }; };
function VclFormFieldComponent_span_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("errorMsgId", ctx_r1.describedById);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.msgErr, " ");
} }
function VclFormFieldComponent_span_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("successMsgId", ctx_r2.describedById);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.msgSuccess, " ");
} }
function VclFormFieldComponent_ng_template_13_span_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("hintFieldId", ctx_r5.describedById)("hintMsgAriaLive", ctx_r5.ariaLive);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r5.description, " ");
} }
function VclFormFieldComponent_ng_template_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, VclFormFieldComponent_ng_template_13_span_0_Template, 2, 3, "span", 9);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.description && !ctx_r4.showSuccess);
} }
const _c21 = ["*", [["voxel-icon"]]];
const _c22 = function (a1) { return { "vcl-form-field__content": true, "vcl-form-field__content--suffix": a1 }; };
const _c23 = ["*", "voxel-icon"];
const _c24 = ["inputSearch"];
const _c25 = function (a1, a2) { return { "vcl-internal-search__icon": true, "vcl-internal-search__icon--dark": a1, "vcl-internal-search__icon--disabled": a2 }; };
const _c26 = function (a1, a2) { return { "vcl-internal-search__input": true, "vcl-internal-search__input--dark": a1, "vcl-internal-search__input--dark--disabled": a2 }; };
const _c27 = function (a1) { return { "vcl-internal-search__clear-icon": true, "vcl-internal-search__clear-icon--dark": a1 }; };
const _c28 = ["comboHeader"];
function VclHeaderComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵelement(1, "img", 14);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("src", ctx_r0.brandPath, ɵngcc0.ɵɵsanitizeUrl);
} }
function VclHeaderComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵelementStart(1, "div");
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 16);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("vcl-header__top__right-section__combo-header__list__company-name  ", ɵngcc0.ɵɵpipeBind1(2, 5, ctx_r2.segment), "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.userInfo == null ? null : ctx_r2.userInfo.companyName, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.userInfo == null ? null : ctx_r2.userInfo.userName, " ");
} }
function VclHeaderComponent_vcl_mega_menu_29_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "vcl-mega-menu", 17);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("menuItems", ctx_r3.menuItems)("language", ctx_r3.language);
} }
const _c29 = function (a0) { return { "open": a0 }; };
const _c30 = ["menuWrapper"];
const _c31 = ["menuMore"];
const _c32 = ["menuItems"];
const _c33 = function (a0) { return { "active": a0 }; };
function VclMegaMenuComponent_div_5_voxel_icon_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "voxel-icon", 14);
    ɵngcc0.ɵɵtext(1, " seta_baixo ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r12 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r15 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(1, _c33, item_r12.label === (ctx_r15.visibleItems[ctx_r15.itemIdx] == null ? null : ctx_r15.visibleItems[ctx_r15.itemIdx].label)));
} }
const _c34 = function (a0, a1) { return { "first-el": a0, "has-subitems": a1 }; };
function VclMegaMenuComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 10, 11);
    ɵngcc0.ɵɵlistener("click", function VclMegaMenuComponent_div_5_Template_div_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r18); const item_r12 = restoredCtx.$implicit; const i_r13 = restoredCtx.index; const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.onItemClick(item_r12, i_r13); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵtemplate(3, VclMegaMenuComponent_div_5_voxel_icon_3_Template, 2, 3, "voxel-icon", 12);
    ɵngcc0.ɵɵelement(4, "div", 13);
    ɵngcc0.ɵɵpipe(5, "async");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r12 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r12.label, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r12.subItems);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("vcl-mega-menu__menu__items__item active-bar ", ɵngcc0.ɵɵpipeBind1(5, 7, ctx_r1.segment), "");
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(9, _c34, item_r12.label === (ctx_r1.visibleItems[0] == null ? null : ctx_r1.visibleItems[0].label), item_r12.subItems));
    ɵngcc0.ɵɵattribute("active", item_r12.label === (ctx_r1.visibleItems[ctx_r1.itemIdx] == null ? null : ctx_r1.visibleItems[ctx_r1.itemIdx].label));
} }
function VclMegaMenuComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 15, 16);
    ɵngcc0.ɵɵlistener("click", function VclMegaMenuComponent_div_6_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r20 = ɵngcc0.ɵɵnextContext(); return ctx_r20.onMoreClick(); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementStart(3, "voxel-icon", 17);
    ɵngcc0.ɵɵtext(4, " outros ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(5, "div");
    ɵngcc0.ɵɵpipe(6, "async");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.language.toUpperCase() === "PT" ? "Mais" : "M\u00E1s", " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵclassMapInterpolate1("vcl-mega-menu__menu__more active ", ɵngcc0.ɵɵpipeBind1(6, 5, ctx_r2.segment), "");
    ɵngcc0.ɵɵattribute("active", ctx_r2.itemIdx === -1);
} }
function VclMegaMenuComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function VclMegaMenuComponent_ng_template_8_ng_container_0_div_2_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 25);
    ɵngcc0.ɵɵlistener("click", function VclMegaMenuComponent_ng_template_8_ng_container_0_div_2_div_4_Template_div_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r28); const item_r26 = restoredCtx.$implicit; const ctx_r27 = ɵngcc0.ɵɵnextContext(4); return ctx_r27.onSubItemClick(item_r26); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r26 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r26.label, " ");
} }
function VclMegaMenuComponent_ng_template_8_ng_container_0_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 22);
    ɵngcc0.ɵɵelementStart(1, "div", 23);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainer(3, 21);
    ɵngcc0.ɵɵtemplate(4, VclMegaMenuComponent_ng_template_8_ng_container_0_div_2_div_4_Template, 2, 1, "div", 24);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const subItem_r24 = ctx.$implicit;
    ɵngcc0.ɵɵnextContext(3);
    const _r8 = ɵngcc0.ɵɵreference(13);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", subItem_r24.title, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r8);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", subItem_r24.items);
} }
function VclMegaMenuComponent_ng_template_8_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 19);
    ɵngcc0.ɵɵtemplate(2, VclMegaMenuComponent_ng_template_8_ng_container_0_div_2_Template, 5, 3, "div", 20);
    ɵngcc0.ɵɵelementContainer(3, 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r22 = ɵngcc0.ɵɵnextContext(2);
    const _r10 = ɵngcc0.ɵɵreference(15);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r22.visibleItems[ctx_r22.itemIdx].subItems);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r10);
} }
function VclMegaMenuComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, VclMegaMenuComponent_ng_template_8_ng_container_0_Template, 4, 2, "ng-container", 18);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.visibleItems[ctx_r5.itemIdx].subItems);
} }
function VclMegaMenuComponent_ng_template_10_ng_container_0_div_2_div_4_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r37 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 25);
    ɵngcc0.ɵɵlistener("click", function VclMegaMenuComponent_ng_template_10_ng_container_0_div_2_div_4_div_3_Template_div_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r37); const item_r35 = restoredCtx.$implicit; const ctx_r36 = ɵngcc0.ɵɵnextContext(5); return ctx_r36.onMoreItemClick(item_r35); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r35 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r35.label, " ");
} }
function VclMegaMenuComponent_ng_template_10_ng_container_0_div_2_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 28);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, VclMegaMenuComponent_ng_template_10_ng_container_0_div_2_div_4_div_3_Template, 2, 1, "div", 24);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const subItem_r33 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", subItem_r33.title, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", subItem_r33.items);
} }
const _c35 = function (a0) { return { "clickable": a0 }; };
function VclMegaMenuComponent_ng_template_10_ng_container_0_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r39 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 22);
    ɵngcc0.ɵɵelementStart(1, "div", 26);
    ɵngcc0.ɵɵlistener("click", function VclMegaMenuComponent_ng_template_10_ng_container_0_div_2_Template_div_click_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r39); const hiddenItem_r31 = restoredCtx.$implicit; const ctx_r38 = ɵngcc0.ɵɵnextContext(3); return ctx_r38.onMoreItemClick(hiddenItem_r31.subItems ? undefined : hiddenItem_r31); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainer(3, 21);
    ɵngcc0.ɵɵtemplate(4, VclMegaMenuComponent_ng_template_10_ng_container_0_div_2_div_4_Template, 4, 2, "div", 27);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const hiddenItem_r31 = ctx.$implicit;
    ɵngcc0.ɵɵnextContext(3);
    const _r8 = ɵngcc0.ɵɵreference(13);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(4, _c35, !hiddenItem_r31.subItems));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", hiddenItem_r31.label, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r8);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", hiddenItem_r31.subItems);
} }
function VclMegaMenuComponent_ng_template_10_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 19);
    ɵngcc0.ɵɵtemplate(2, VclMegaMenuComponent_ng_template_10_ng_container_0_div_2_Template, 5, 6, "div", 20);
    ɵngcc0.ɵɵelementContainer(3, 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r29 = ɵngcc0.ɵɵnextContext(2);
    const _r10 = ɵngcc0.ɵɵreference(15);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r29.hiddenItems);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r10);
} }
function VclMegaMenuComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, VclMegaMenuComponent_ng_template_10_ng_container_0_Template, 4, 2, "ng-container", 18);
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r7.itemIdx === -1);
} }
function VclMegaMenuComponent_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 29);
} }
function VclMegaMenuComponent_ng_template_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 30);
} }
function VclSelectOptionComponent_voxel_icon_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "voxel-icon", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.icon);
} }
const _c36 = ["select"];
const _c37 = ["selectInput"];
function VclSelectComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵlistener("click", function VclSelectComponent_div_0_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.close(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("aria-hidden", !ctx_r0.panelOpen);
} }
function VclSelectComponent_voxel_icon_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "voxel-icon");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.optionIcon);
} }
function VclSelectComponent_span_8_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 11);
    ɵngcc0.ɵɵlistener("click", function VclSelectComponent_span_8_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.clearSearch(); });
    ɵngcc0.ɵɵelementEnd();
} }
function VclSelectComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 12);
} }
function VclSelectComponent_ng_template_13_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 13, 14);
    ɵngcc0.ɵɵlistener("keydown", function VclSelectComponent_ng_template_13_Template_div_keydown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.handleKeydown($event); });
    ɵngcc0.ɵɵprojection(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("max-height", ctx_r7.maxHeight);
    ɵngcc0.ɵɵproperty("id", ctx_r7.panelId);
    ɵngcc0.ɵɵattribute("aria-labelledby", ctx_r7.labelId)("aria-hidden", !ctx_r7.panelOpen);
} }
const _c38 = [[["vcl-select-option"]]];
const _c39 = function (a1, a2, a4) { return { "vcl-select__text": true, "voxel-txt-color-sand-200": a1, "voxel-txt-color-sand-900": a2, "voxel-text-l": true, "vcl-select__text--has-icon": a4 }; };
const _c40 = function (a1, a2, a3, a4) { return { "vcl-select__icon": true, "vcl-select__icon--disabled": a1, "voxel-txt-color-sand-200": a2, "vcl-select__icon--open": a3, "rotate": a4 }; };
const _c41 = ["vcl-select-option"];
function VclFooterTwoComponent_img_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 9);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("src", ctx_r0.itauLogoPath, ɵngcc0.ɵɵsanitizeUrl);
} }
function VclFooterTwoComponent_div_4_a_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "a", 12);
} if (rf & 2) {
    const item_r4 = ctx.$implicit;
    ɵngcc0.ɵɵclassMap(item_r4.icon);
    ɵngcc0.ɵɵpropertyInterpolate("href", item_r4.url, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵpropertyInterpolate("id", item_r4.id);
} }
function VclFooterTwoComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵtemplate(1, VclFooterTwoComponent_div_4_a_1_Template, 1, 5, "a", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.socialMediaItems);
} }
function VclFooterTwoComponent_img_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 13);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("src", ctx_r2.supervisorLogoPath, ɵngcc0.ɵɵsanitizeUrl);
} }
function VclNpsComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 7);
    ɵngcc0.ɵɵelementStart(2, "voxel-icon", 8);
    ɵngcc0.ɵɵtext(3, "feedback_outline");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 9);
    ɵngcc0.ɵɵelementStart(5, "h2", 10);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "p", 11);
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 12);
    ɵngcc0.ɵɵelementStart(10, "button", 13);
    ɵngcc0.ɵɵlistener("click", function VclNpsComponent_ng_container_7_Template_button_click_10_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.step1PositiveClick(); });
    ɵngcc0.ɵɵtext(11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "button", 14);
    ɵngcc0.ɵɵlistener("click", function VclNpsComponent_ng_container_7_Template_button_click_12_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.step1NegativeClick(); });
    ɵngcc0.ɵɵtext(13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵattribute("id", "nps--intro-title-" + ctx_r0.id);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.parameters.introTitle, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("id", "nps-intro-text-" + ctx_r0.id);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.parameters.introText, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("id", "nps-intro-positive-" + ctx_r0.id)("disabled", false);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.parameters.introButtonPositiveLabel, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("id", "nps-intro-negative-" + ctx_r0.id)("disabled", false);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.parameters.introButtonNegativeLabel, " ");
} }
function VclNpsComponent_ng_container_8_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 26);
    ɵngcc0.ɵɵelementStart(1, "input", 27);
    ɵngcc0.ɵɵlistener("click", function VclNpsComponent_ng_container_8_div_9_Template_input_click_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r9); const option_r7 = restoredCtx.$implicit; const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.optionClick(option_r7); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "label", 28);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r7 = ctx.$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("id", "nps-score-option-" + option_r7 + "-" + ctx_r6.id)("value", option_r7);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("for", "nps-score-option-" + option_r7 + "-" + ctx_r6.id);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(option_r7);
} }
function VclNpsComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 7);
    ɵngcc0.ɵɵelementStart(2, "div", 9);
    ɵngcc0.ɵɵelementStart(3, "h2", 10);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "p", 15);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "form", 16);
    ɵngcc0.ɵɵelementStart(8, "div", 17);
    ɵngcc0.ɵɵtemplate(9, VclNpsComponent_ng_container_8_div_9_Template, 4, 4, "div", 18);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "voxel-form-field", 19);
    ɵngcc0.ɵɵelement(11, "input", 20);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "voxel-form-field", 21);
    ɵngcc0.ɵɵelement(13, "input", 22);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "voxel-form-field", 23);
    ɵngcc0.ɵɵelement(15, "textarea", 24);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "div", 12);
    ɵngcc0.ɵɵelementStart(17, "button", 25);
    ɵngcc0.ɵɵlistener("click", function VclNpsComponent_ng_container_8_Template_button_click_17_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.step2NextClick(); });
    ɵngcc0.ɵɵtext(18);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵattribute("id", "nps-score-title-" + ctx_r1.id);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.parameters.scoreTitle, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("id", "nps-score-text-" + ctx_r1.id);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.parameters.scoreText, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r1.form);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.scoreOptions);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("invisible", ctx_r1.form.controls.name.disabled);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassProp("invisible", ctx_r1.form.controls.squad.disabled);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassProp("invisible", ctx_r1.form.controls.comment.disabled);
    ɵngcc0.ɵɵproperty("label", ctx_r1.commentLabel);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("id", "nps-score-next-" + ctx_r1.id)("disabled", !ctx_r1.form.valid);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.parameters.scoreButtonNextLabel, " ");
} }
function VclNpsComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 7);
    ɵngcc0.ɵɵelementStart(2, "voxel-icon", 29);
    ɵngcc0.ɵɵtext(3, "check");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 30);
    ɵngcc0.ɵɵelementStart(5, "h2", 10);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "p", 31);
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 12);
    ɵngcc0.ɵɵelementStart(10, "button", 32);
    ɵngcc0.ɵɵlistener("click", function VclNpsComponent_ng_container_9_Template_button_click_10_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.step3DoneClick(); });
    ɵngcc0.ɵɵtext(11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵattribute("id", "nps-finish-title-" + ctx_r2.id);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.parameters.finishTitle, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("id", "nps-finish-text-" + ctx_r2.id);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.parameters.finishText, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("id", "nps-finish-done-" + ctx_r2.id)("disabled", false);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.parameters.finishButtonLabel, " ");
} }
function VclTagComponent_div_0_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 6);
    ɵngcc0.ɵɵelementStart(1, "voxel-icon", 7);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("size", ctx_r1.iconSize);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.icon);
} }
function VclTagComponent_div_0_label_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("title", ctx_r2.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r2.label, " ");
} }
function VclTagComponent_div_0_a_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("href", ctx_r3.link, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.label);
} }
function VclTagComponent_div_0_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 10);
    ɵngcc0.ɵɵlistener("click", function VclTagComponent_div_0_button_4_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.closeTag(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵattribute("disabled", ctx_r4.disabled ? true : null);
} }
const _c42 = function (a0) { return { "max-width.rem": a0 }; };
function VclTagComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtemplate(1, VclTagComponent_div_0_span_1_Template, 3, 2, "span", 2);
    ɵngcc0.ɵɵtemplate(2, VclTagComponent_div_0_label_2_Template, 2, 2, "label", 3);
    ɵngcc0.ɵɵtemplate(3, VclTagComponent_div_0_a_3_Template, 2, 2, "a", 4);
    ɵngcc0.ɵɵtemplate(4, VclTagComponent_div_0_button_4_Template, 1, 1, "button", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.disabled ? "disabled" : "")("ngStyle", ɵngcc0.ɵɵpureFunction1(7, _c42, ctx_r0.tagMaxWidth));
    ɵngcc0.ɵɵattribute("aria-disabled", ctx_r0.disabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.link);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.link);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.close);
} }
const _c43 = ["steps"];
const _c44 = function (a0) { return { "pr0": a0 }; };
function VclStepperComponent_div_5_footer_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "footer", 19);
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r5 = ɵngcc0.ɵɵnextContext().index;
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c44, i_r5 == ctx_r7.listSteps.length - 1));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r7.descriptionsList[i_r5], " ");
} }
const _c45 = function (a0, a1, a2) { return { "oval-active": a0, "oval-ok": a1, "oval-inactive": a2 }; };
const _c46 = function (a0) { return { "icon-itaufonts_check": a0 }; };
function VclStepperComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵelementStart(1, "header", 12);
    ɵngcc0.ɵɵelementStart(2, "div", 13, 14);
    ɵngcc0.ɵɵelementStart(4, "div", 15);
    ɵngcc0.ɵɵelement(5, "i", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 17);
    ɵngcc0.ɵɵelementStart(7, "span", 0);
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(9, VclStepperComponent_div_5_footer_9_Template, 3, 4, "footer", 18);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r4 = ctx.$implicit;
    const i_r5 = ctx.index;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("max-width", ctx_r0.stepMaxWidth);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(9, _c44, i_r5 == ctx_r0.listSteps.length - 1));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(11, _c45, i_r5 == ctx_r0.currentStep - 1, ctx_r0.currentStep - 1 > i_r5, i_r5 > ctx_r0.currentStep - 1));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(15, _c46, ctx_r0.currentStep - 1 > i_r5));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", i_r5 == ctx_r0.currentStep - 1 ? "text-bold" : "text");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2("0", i_r5 + 1, ". ", item_r4, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r0.descriptionsList == null ? null : ctx_r0.descriptionsList.length) > 0);
} }
function VclStepperComponent_div_8_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 23, 14);
    ɵngcc0.ɵɵelementStart(2, "span", 0);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext();
    const i_r10 = ctx_r15.index;
    const item_r9 = ctx_r15.$implicit;
    const ctx_r11 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", i_r10 == ctx_r11.currentStep - 1 ? "textBold" : "text");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r9, " ");
} }
function VclStepperComponent_div_8_div_2_label_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 26);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r10 = ɵngcc0.ɵɵnextContext(2).index;
    const ctx_r16 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2(" etapa ", i_r10 + 1, " de ", ctx_r16.listSteps.length, " ");
} }
function VclStepperComponent_div_8_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 24);
    ɵngcc0.ɵɵtemplate(1, VclStepperComponent_div_8_div_2_label_1_Template, 2, 2, "label", 25);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r10 = ɵngcc0.ɵɵnextContext().index;
    const ctx_r12 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", i_r10 == ctx_r12.currentStep - 1);
} }
const _c47 = function (a0, a1) { return { "icon-itaufonts_seta_down": a0, "icon-itaufonts_seta_up": a1 }; };
function VclStepperComponent_div_8_div_3_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 29);
    ɵngcc0.ɵɵlistener("click", function VclStepperComponent_div_8_div_3_span_1_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r20 = ɵngcc0.ɵɵnextContext(3); return ctx_r20.toggleDescriptionBox(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(1, _c47, !ctx_r19.descriptionBoxOpen, ctx_r19.descriptionBoxOpen));
} }
function VclStepperComponent_div_8_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 27);
    ɵngcc0.ɵɵtemplate(1, VclStepperComponent_div_8_div_3_span_1_Template, 1, 4, "span", 28);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r10 = ɵngcc0.ɵɵnextContext().index;
    const ctx_r13 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", i_r10 == ctx_r13.currentStep - 1);
} }
function VclStepperComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵtemplate(1, VclStepperComponent_div_8_div_1_Template, 4, 2, "div", 20);
    ɵngcc0.ɵɵtemplate(2, VclStepperComponent_div_8_div_2_Template, 2, 1, "div", 21);
    ɵngcc0.ɵɵtemplate(3, VclStepperComponent_div_8_div_3_Template, 2, 1, "div", 22);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r10 = ctx.index;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", i_r10 == ctx_r1.currentStep - 1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.expansible);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.expansible);
} }
function VclStepperComponent_footer_12_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 30);
    ɵngcc0.ɵɵelementStart(1, "span", 32);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r24 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(item_r24);
} }
function VclStepperComponent_footer_12_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, VclStepperComponent_footer_12_div_1_div_1_Template, 3, 1, "div", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r25 = ctx.index;
    const ctx_r23 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", i_r25 == ctx_r23.currentStep - 1);
} }
function VclStepperComponent_footer_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "footer", 30);
    ɵngcc0.ɵɵtemplate(1, VclStepperComponent_footer_12_div_1_Template, 2, 1, "div", 31);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.descriptionsList);
} }
function VclStepperComponent_div_13_div_2_footer_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "footer", 30);
    ɵngcc0.ɵɵelementStart(1, "span", 32);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r30 = ɵngcc0.ɵɵnextContext().index;
    const ctx_r31 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r31.descriptionsList[i_r30]);
} }
function VclStepperComponent_div_13_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵelementStart(1, "div", 15);
    ɵngcc0.ɵɵelement(2, "i", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "span", 0);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, VclStepperComponent_div_13_div_2_footer_5_Template, 3, 1, "footer", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r29 = ctx.$implicit;
    const i_r30 = ctx.index;
    const ctx_r28 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(6, _c45, i_r30 == ctx_r28.currentStep - 1, ctx_r28.currentStep - 1 > i_r30, i_r30 > ctx_r28.currentStep - 1));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(10, _c46, ctx_r28.currentStep - 1 > i_r30));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", i_r30 == ctx_r28.currentStep - 1 ? "textBold" : "text");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2(" 0", i_r30 + 1, ".", item_r29, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r28.descriptionsList == null ? null : ctx_r28.descriptionsList.length) > 0);
} }
function VclStepperComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 33);
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵtemplate(2, VclStepperComponent_div_13_div_2_Template, 6, 12, "div", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.listSteps);
} }
const _c48 = function (a1) { return { "vcl-stepper-container": true, "no-description-container": a1 }; };
function VclLoadingCardComponent_span_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.label);
} }
function VclQrCodeScannerComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5, 6);
    ɵngcc0.ɵɵelementStart(2, "div", 7);
    ɵngcc0.ɵɵelementStart(3, "h1", 8);
    ɵngcc0.ɵɵtext(4, "Apunta tu c\u00E1mara al c\u00F3digo QR y espera unos segundos");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 9);
    ɵngcc0.ɵɵelement(6, "div", 10);
    ɵngcc0.ɵɵelement(7, "div", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function VclActionSheetComponent_vcl_backdrop_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "vcl-backdrop", 3);
    ɵngcc0.ɵɵlistener("click", function VclActionSheetComponent_vcl_backdrop_0_Template_vcl_backdrop_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.onBdClick(); });
    ɵngcc0.ɵɵelementEnd();
} }
function VclActionSheetComponent_dialog_2_li_8_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 9);
    ɵngcc0.ɵɵlistener("click", function VclActionSheetComponent_dialog_2_li_8_Template_li_click_0_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r7); const option_r5 = restoredCtx.$implicit; const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.onItemClick($event, option_r5); });
    ɵngcc0.ɵɵelementStart(1, "h3", 10);
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "p", 11);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r5 = ctx.$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵattribute("aria-label", option_r5.title + "," + option_r5.description);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("voxel-pb-s voxel-text-l-bd color-", ɵngcc0.ɵɵpipeBind1(2, 6, ctx_r4.segment$), "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", option_r5.title, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", option_r5.description, " ");
} }
function VclActionSheetComponent_dialog_2_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dialog", 4);
    ɵngcc0.ɵɵelementStart(1, "voxel-header");
    ɵngcc0.ɵɵelementStart(2, "h1", 5);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "button", 6);
    ɵngcc0.ɵɵlistener("click", function VclActionSheetComponent_dialog_2_Template_button_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.onBdClick(); });
    ɵngcc0.ɵɵelementStart(5, "voxel-icon");
    ɵngcc0.ɵɵtext(6, "fechar");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "ul", 7);
    ɵngcc0.ɵɵtemplate(8, VclActionSheetComponent_dialog_2_li_8_Template, 6, 8, "li", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("vclA11YFocus", ctx_r1.showActionSheet)("focusTarget", "container")("@slideInOut", undefined);
    ɵngcc0.ɵɵattribute("id", "action-sheet-" + ctx_r1.id);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.title);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.options);
} }
const _c49 = ["loadingBar"];
function VclSteppedHeaderComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelementStart(1, "button", 9);
    ɵngcc0.ɵɵlistener("click", function VclSteppedHeaderComponent_div_2_Template_button_click_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.goBack($event); });
    ɵngcc0.ɵɵelementStart(2, "voxel-icon");
    ɵngcc0.ɵɵtext(3, "seta_esquerda_outline");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r0.headerAccessibility);
} }
function VclSteppedHeaderComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelementStart(1, "button", 10);
    ɵngcc0.ɵɵlistener("click", function VclSteppedHeaderComponent_div_12_Template_button_click_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.goAdditional($event); });
    ɵngcc0.ɵɵelement(2, "span");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r2.additionalButtonAccessibility);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(ctx_r2.additionaIcon);
} }
const _c50 = function (a1) { return { "voxel-header": true, "voxel-header--fixed": a1 }; };
class VclRippleDirective {
    /**
     * @internal
     */
    constructor(elem, elemRenderer) {
        this.elem = elem;
        this.elemRenderer = elemRenderer;
        /**
         * Define o estilo do efeito ripple
         *
         * *Defines ripple's effect style*
         */
        this.rippleStyle = 'light';
        /**
         * Desabilita o efeito de ripple
         *
         * *Disables ripple's effect*
         */
        this.disableRipple = false;
    }
    /**
     *
     * @internal
     */
    onClick(event) {
        if (this.disableRipple) {
            return;
        }
        // Get element where ripple effect will be applied
        let currentElem = this.elem.nativeElement;
        let wrapper = currentElem.querySelector('.vcl-ripple');
        // Remove elements if are still in the DOM
        if (wrapper) {
            this.elemRenderer.removeChild(currentElem, currentElem.querySelector('.vcl-ripple'));
        }
        currentElem.insertAdjacentHTML('afterbegin', `<div class="vcl-ripple">
        <span class="ripple ${this.rippleStyle}"></span>
      </div>`);
        wrapper = currentElem.querySelector('.vcl-ripple');
        const ripple = currentElem.querySelector('.ripple');
        // Get element's background-color;
        let backgroundColor = window.getComputedStyle(currentElem, null).getPropertyValue('background-color');
        // Maybe the color is not in the current element, but on its children. Ex: voxel-button
        // If so, we need to use that element as the current element
        if (backgroundColor === 'rgba(0, 0, 0, 0)' && currentElem.children[1]) {
            backgroundColor = window
                .getComputedStyle(currentElem.children[1], null)
                .getPropertyValue('background-color');
            currentElem = currentElem.children[1];
        }
        // Add transparent opacity using element's background color
        backgroundColor = backgroundColor.replace(')', ', 0.2)');
        // Setup
        const elemPosX = currentElem.getBoundingClientRect().left;
        const elemPosY = currentElem.getBoundingClientRect().top;
        let elemWidth = currentElem.offsetWidth;
        let elemHeight = currentElem.offsetHeight;
        // Set wrapper size so ripple effect will be contained inside
        wrapper.style.width = `${elemWidth}px`;
        wrapper.style.height = `${elemHeight}px`;
        // Make it round
        if (elemWidth >= elemHeight) {
            elemHeight = elemWidth;
        }
        else {
            elemWidth = elemHeight;
        }
        // Get the center of the element
        const x = event.clientX - elemPosX - elemWidth / 2;
        const y = event.clientY - elemPosY - elemHeight / 2;
        // Set ripple size, position and background
        ripple.style.width = `${elemWidth}px`;
        ripple.style.height = `${elemHeight}px`;
        ripple.style.top = `${y}px`;
        ripple.style.left = `${x}px`;
        ripple.style.backgroundColor = backgroundColor;
        // Add ripple effect class to trigger ripple
        ripple.classList.add('ripple-effect');
        // Remove added elements after effected is triggered
        setTimeout(() => {
            this.elemRenderer.removeChild(currentElem, wrapper);
        }, 500);
    }
}
VclRippleDirective.ɵfac = function VclRippleDirective_Factory(t) { return new (t || VclRippleDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
VclRippleDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VclRippleDirective, selectors: [["", "vclRipple", ""]], hostBindings: function VclRippleDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function VclRippleDirective_click_HostBindingHandler($event) { return ctx.onClick($event); });
    } }, inputs: { rippleStyle: "rippleStyle", disableRipple: "disableRipple" } });
VclRippleDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
VclRippleDirective.propDecorators = {
    rippleStyle: [{ type: Input }],
    disableRipple: [{ type: Input }],
    onClick: [{ type: HostListener, args: ['click', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclRippleDirective, [{
        type: Directive,
        args: [{
                selector: '[vclRipple]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { rippleStyle: [{
            type: Input
        }], disableRipple: [{
            type: Input
        }], 
    /**
     *
     * @internal
     */
    onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }] }); })();

class VclRippleModule {
}
VclRippleModule.ɵfac = function VclRippleModule_Factory(t) { return new (t || VclRippleModule)(); };
VclRippleModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VclRippleModule });
VclRippleModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclRippleModule, [{
        type: NgModule,
        args: [{
                declarations: [VclRippleDirective],
                exports: [VclRippleDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VclRippleModule, { declarations: [VclRippleDirective], exports: [VclRippleDirective] }); })();

/**
 * Diretiva para deixar um elemento com modal acessível
 *
 * *Directive to make an element with acessible modal*
 *
 * @example <div [vclA11YAriaRegion]="myBooleanVar">My Modal</div>
 */
class VclA11YAriaRegionDirective {
    /**
     * @internal
     */
    constructor(document, elementRef, renderer2) {
        this.document = document;
        this.elementRef = elementRef;
        this.renderer2 = renderer2;
        this.hiddenElements = [];
    }
    /**
     * Input que recebe a condição se o container deve ter aria-region
     *
     * *Input thats receive the condition if the containter must get an aria-region*
     *
     */
    set vclA11YAriaRegion(value) {
        if (value && typeof value === 'boolean') {
            this.ariaHiddenElements();
        }
        else if (this.hiddenElements.length > 0) {
            this.unhiddenElements();
        }
    }
    ariaHiddenElements() {
        this.hiddenElements = this.recursiveAriaHiddenElements(this.elementRef.nativeElement, [], []);
    }
    recursiveAriaHiddenElements(pTarget, pExceptions, pHiddenElements) {
        let lHiddenElements = pHiddenElements;
        const cParent = this.renderer2.parentNode(pTarget);
        const cChildren = Array.from(cParent.children);
        const cExceptions = pExceptions;
        cExceptions.push(pTarget);
        if (pTarget !== this.document.body) {
            lHiddenElements = pHiddenElements.concat(this.ariaHiddenChildren(cChildren, pExceptions));
            return this.recursiveAriaHiddenElements(cParent, cExceptions, lHiddenElements);
        }
        return lHiddenElements;
    }
    ariaHiddenChildren(children, exceptions) {
        const elementsHidden = [];
        const excludeTags = ['SCRIPT', 'ROUTER-OUTLET'];
        for (const cChild of children) {
            if (exceptions.includes(cChild)) {
                continue;
            }
            if (excludeTags.includes(cChild.tagName)) {
                continue;
            }
            const elementAriaHidden = this.attemptAriaHidden(cChild);
            if (elementAriaHidden) {
                elementsHidden.push(elementAriaHidden);
            }
        }
        return elementsHidden;
    }
    attemptAriaHidden(child) {
        if (child.getAttribute('aria-hidden') === 'true') {
            return null;
        }
        const cAlreadyHadAriaHidden = child.getAttribute('aria-hidden') === 'false';
        this.renderer2.setAttribute(child, 'aria-hidden', 'true');
        return {
            element: child,
            alreadyHadAriaHidden: cAlreadyHadAriaHidden,
        };
    }
    unhiddenElements() {
        for (const hiddenElement of this.hiddenElements) {
            if (hiddenElement.alreadyHadAriaHidden) {
                this.renderer2.setAttribute(hiddenElement.element, 'aria-hidden', 'false');
            }
            else {
                this.renderer2.removeAttribute(hiddenElement.element, 'aria-hidden');
            }
        }
    }
}
VclA11YAriaRegionDirective.ɵfac = function VclA11YAriaRegionDirective_Factory(t) { return new (t || VclA11YAriaRegionDirective)(ɵngcc0.ɵɵdirectiveInject(DOCUMENT), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
VclA11YAriaRegionDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VclA11YAriaRegionDirective, selectors: [["", "vclA11YAriaRegion", ""]], inputs: { vclA11YAriaRegion: "vclA11YAriaRegion" } });
VclA11YAriaRegionDirective.ctorParameters = () => [
    { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: ElementRef },
    { type: Renderer2 }
];
VclA11YAriaRegionDirective.propDecorators = {
    vclA11YAriaRegion: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclA11YAriaRegionDirective, [{
        type: Directive,
        args: [{
                selector: '[vclA11YAriaRegion]'
            }]
    }], function () { return [{ type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { vclA11YAriaRegion: [{
            type: Input
        }] }); })();

/**
 * @internal
 */
const SWIPABLE_ELEMENTS = [
    'H1',
    'H2',
    'H3',
    'H4',
    'H5',
    'P',
    'SPAN',
    'LI',
];
/**
 * Diretiva para focar elementos dentro de containers
 *
 * *Directive to focus elements inside containers*
 *
 * @example <button [vclA11YFocus]="myBooleanVar">My Focusable Element</button>
 */
class VclA11YFocusDirective {
    /**
     * @internal
     */
    constructor(elementRef, renderer2) {
        this.elementRef = elementRef;
        this.renderer2 = renderer2;
        /**
         * O foco pode procurar por elementos navegáveis ou somente tabeáveis
         *
         * *The focus can search for swipeable or only tabbable elements*
         *
         */
        this.focusType = 'swipeable';
        /**
         * Focar elementos dentro do container ou incluindo o container (all)
         *
         * *To focus only elements inside the container or including the container (all)*
         *
         */
        this.focusTarget = 'all';
        /**
         * Delay in millisegundos para o leitor de tela detectar a mudança do foco
         *
         * *Delay in milliseconds for the screen reader detect the focus change*
         *
         */
        this.screenReaderDelay = 250;
    }
    /**
     * Input que recebe a condição se o container deve ser focado
     *
     * *Input thats receive the condition if the containter must be focused*
     *
     */
    set vclA11YFocus(value) {
        if (!value || typeof value !== 'boolean') {
            return;
        }
        this.focusElement(this.findFocusableElement(this.elementRef.nativeElement));
    }
    isFocusable(element) {
        if (element.getAttribute('aria-hidden') === 'true') {
            return false;
        }
        if (this.focusType !== 'swipeable') {
            return element.tabIndex > -1;
        }
        return element.tabIndex > -1 || SWIPABLE_ELEMENTS.includes(element.nodeName) || !!element.getAttribute('role');
    }
    findFocusableElement(container) {
        if (this.focusTarget === 'all' && this.isFocusable(container)) {
            return container;
        }
        for (const child of Array.from(container.children)) {
            const childElement = child;
            if (this.isFocusable(childElement)) {
                return childElement;
            }
            const cRecursiveChild = this.findFocusableElement(childElement);
            if (cRecursiveChild) {
                return cRecursiveChild;
            }
        }
        return null;
    }
    focusElement(element) {
        if (!element) {
            return;
        }
        timer(this.screenReaderDelay).pipe(take(1)).subscribe(() => {
            if (element.tabIndex < 0 && !element.getAttribute('tabindex')) {
                this.renderer2.setAttribute(element, 'tabindex', '-1');
            }
            element.focus();
        });
    }
}
VclA11YFocusDirective.ɵfac = function VclA11YFocusDirective_Factory(t) { return new (t || VclA11YFocusDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
VclA11YFocusDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VclA11YFocusDirective, selectors: [["", "vclA11YFocus", ""]], inputs: { focusType: "focusType", focusTarget: "focusTarget", screenReaderDelay: "screenReaderDelay", vclA11YFocus: "vclA11YFocus" } });
VclA11YFocusDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
VclA11YFocusDirective.propDecorators = {
    focusType: [{ type: Input }],
    focusTarget: [{ type: Input }],
    screenReaderDelay: [{ type: Input }],
    vclA11YFocus: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclA11YFocusDirective, [{
        type: Directive,
        args: [{
                selector: '[vclA11YFocus]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { focusType: [{
            type: Input
        }], focusTarget: [{
            type: Input
        }], screenReaderDelay: [{
            type: Input
        }], vclA11YFocus: [{
            type: Input
        }] }); })();

class VclA11YUtilsModule {
}
VclA11YUtilsModule.ɵfac = function VclA11YUtilsModule_Factory(t) { return new (t || VclA11YUtilsModule)(); };
VclA11YUtilsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VclA11YUtilsModule });
VclA11YUtilsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclA11YUtilsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                ],
                declarations: [
                    VclA11YFocusDirective,
                    VclA11YAriaRegionDirective,
                ],
                exports: [
                    VclA11YFocusDirective,
                    VclA11YAriaRegionDirective,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VclA11YUtilsModule, { declarations: function () { return [VclA11YFocusDirective, VclA11YAriaRegionDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [VclA11YFocusDirective, VclA11YAriaRegionDirective]; } }); })();

class SearchPipe {
    transform(value, args) {
        if (!value) {
            return null;
        }
        if (!args) {
            return value;
        }
        return value.filter(item => {
            return JSON.stringify(item).toLowerCase().includes(args.toLowerCase());
        });
    }
}
SearchPipe.ɵfac = function SearchPipe_Factory(t) { return new (t || SearchPipe)(); };
SearchPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "search", type: SearchPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SearchPipe, [{
        type: Pipe,
        args: [{
                name: 'search'
            }]
    }], null, null); })();

const BREAKPOINTS = {
    // Extra small screen / phone
    xs: 0,
    // Small screen / phone
    sm: 768,
    // Medium screen / tablet
    md: 1024,
    // Large screen / desktop
    lg: 1280,
    // Extra large screen / wide desktop
    xl: 1600,
};

/**
 *
 * Tipos de botão do modal
 *
 * *Modal button types*
 *
 * @export
 * @enum {string}
 */
var ModalButtonTypes;
(function (ModalButtonTypes) {
    ModalButtonTypes["close"] = "close";
    ModalButtonTypes["primary"] = "primary";
    ModalButtonTypes["secondary"] = "secondary";
    ModalButtonTypes["headerAction"] = "headerAction";
})(ModalButtonTypes || (ModalButtonTypes = {}));
/**
 * Modal é um elemento que exibe uma informação sobreposta na tela, ocupando todo o espaço em telas pequenas.
 * Ele sempre acompanha a opção de fechar.
 *
 * *Modal is an element that displays information superimposed on the screen, occupying the entire space on small screens.*
 * *It always comes with the option to close.*
 *
 * ### Acessible
 *
 * <acessible class="not-tested">Acessibilidade - Não testado</acessible>
 *
 * **Module:**
 *
 * `import { VclModalModule } from '@voxel/community';`
 *
 * <example-url>../../demo/index.html#/portfolio/components/modal?componentOnly=true</example-url>
 *
 * @example com botão principal
 * <vcl-modal
 *   id="modal-a"
 *   modalTitle="Título do modal A"
 *   [(showModal)]="modalShow.simple"
 *   [buttonLabels]=" { primary: 'primário' } ">
 *     text content
 * </vcl-modal>
 *
 *
 * @example Com botão principal e secundário
 * <vcl-modal
 *   id="modal-b"
 *   modalTitle="Título do modal B"
 *   [(showModal)]="modalShow.bothInline"
 *   [buttonLabels]=" { primary: 'primário', secondary: 'secundário' } "
 *   buttonAlignment="horizontal">
 *     text content
 * </vcl-modal>
 *
 *
 * @example Com botões desabilitados
 * <vcl-modal
 *   id="modal-c"
 *   modalTitle="Título do modal C"
 *   [(showModal)]="modalShow.bothInline"
 *   [buttonLabels]=" { primary: 'primário', secondary: 'secundário' } "
 *   buttonAlignment="horizontal"
 *   [primaryButtonDisabled]="true"
 *   [secondaryButtonDisabled]="true">
 *     text content
 * </vcl-modal>
 *
 *
 * @example Com espaçamento interno dos botões customizável
 * <vcl-modal
 *   id="modal-d"
 *   modalTitle="Título do modal D"
 *   [(showModal)]="modalShow.withCustomBottomPadding"
 *   [buttonLabels]=" { primary: 'primário', secondary: 'secundário' } "
 *   buttonAlignment="horizontal"
 *   [actionButtonsPadding]="'0 2.5rem'"
 * >
 *     text content
 * </vcl-modal>
 *
 */
class VclModalComponent {
    /**
     * @internal
     */
    constructor(renderer, voxelSegmentService) {
        this.renderer = renderer;
        this.voxelSegmentService = voxelSegmentService;
        /**
         * @internal
         */
        this.ModalButtonTypes = ModalButtonTypes;
        /**
         * Exibe e oculta o modal. Usar com two way data binding `[(showModal)]` para o funcionamento correto
         *
         * *Shows and hides the modal. Use with two way data binding `[(showModal)]` to work properly*
         */
        this.showModal = false;
        /**
         * @internal
         */
        this.showModalChange = new EventEmitter();
        /**
         * Rótulos dos botões fechar, primário e secundário
         *
         * *Close, primary and secondary buttons labels*
         * @memberof VoxelModalComponent
         */
        this.buttonLabels = {
            primary: 'ok',
        };
        /**
         * Alinhamento dos botões de ação
         *
         * *Action buttons alignment*
         */
        this.buttonAlignment = 'vertical';
        /**
         * Valor da propriedade de estilo `z-index` do wrapper do modal
         *
         * *Modal wrapper's `z-index` css property*
         */
        this.zIndex = '10';
        /**
         * Valor da propriedade de estilo `width` que define a largura do modal
         *
         * *Modal `width` css property*
         */
        this.width = '60%';
        /**
         * Valor da propriedade de estilo `height` que define a altura do modal
         *
         * *Modal `heigth` css property*
         */
        this.height = '60%';
        /**
         * Desabilita botão primário
         *
         * *Disables primary button*
         */
        this.primaryButtonDisabled = false;
        /**
         * Desabilita botão secundário
         *
         * *Disables secondary button*
         */
        this.secondaryButtonDisabled = false;
        /**
         * Evento disparado no clique dos botões do modal
         *
         * *Event triggered by the modal buttons clicks*
         */
        this.modalButtonClick = new EventEmitter();
        /**
         * @internal
         */
        this.segment = this.voxelSegmentService.segment;
        /**
         * @internal
         */
        this.defaultPadding = this.defaultModalPadding();
    }
    /**
     * @internal
     */
    onResize() {
        this.defaultPadding = this.defaultModalPadding();
    }
    defaultModalPadding() {
        return window.innerWidth >= BREAKPOINTS.sm ? '.5rem 3rem' : '';
    }
    /**
     * @internal
     */
    closeModal($event) {
        this.showModal = false;
        this.showModalChange.emit(false);
        this.emmitModalButtonClick($event, ModalButtonTypes.close);
    }
    /**
     * @internal
     */
    emmitModalButtonClick($event, type) {
        this.modalButtonClick.emit({ $event, type });
    }
    /**
     * @internal
     */
    ngOnChanges(changes) {
        if (!changes.showModal.currentValue) {
            return;
        }
        setTimeout(() => {
            this.renderer.setStyle(this.closeButton.nativeElement, 'outline', 'none');
            this.closeButton.nativeElement.setAttribute('tabindex', '0');
            this.closeButton.nativeElement.focus();
        }, 1000);
    }
}
VclModalComponent.ɵfac = function VclModalComponent_Factory(t) { return new (t || VclModalComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.VoxelSegmentService)); };
VclModalComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VclModalComponent, selectors: [["vcl-modal"]], viewQuery: function VclModalComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.closeButton = _t.first);
    } }, hostBindings: function VclModalComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function VclModalComponent_resize_HostBindingHandler() { return ctx.onResize(); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { showModal: "showModal", buttonLabels: "buttonLabels", buttonAlignment: "buttonAlignment", zIndex: "zIndex", width: "width", height: "height", primaryButtonDisabled: "primaryButtonDisabled", secondaryButtonDisabled: "secondaryButtonDisabled", id: "id", modalTitle: "modalTitle", headerActionLabel: "headerActionLabel", actionButtonsPadding: "actionButtonsPadding" }, outputs: { showModalChange: "showModalChange", modalButtonClick: "modalButtonClick" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c3, decls: 15, vars: 24, consts: [[1, "modal-overlay", 3, "hidden", "ngStyle"], [1, "dialog-wrapper"], ["aria-modal", "true", 1, "modal", 3, "ngStyle"], [1, "close-button-wrapper"], [3, "id", "click"], ["closeButton", ""], [1, "title"], ["class", "title__text", 4, "ngIf"], ["class", "voxel-link title__action", 3, "click", 4, "ngIf"], [1, "content", 3, "id"], [1, "actions", 3, "ngClass"], ["voxelButton", "", "class", "secondary", "buttonStyle", "secondary", 3, "disabled", "click", 4, "ngIf"], ["voxelButton", "", "class", "primary", 3, "disabled", "click", 4, "ngIf"], [1, "title__text"], [1, "voxel-link", "title__action", 3, "click"], ["voxelButton", "", "buttonStyle", "secondary", 1, "secondary", 3, "disabled", "click"], ["voxelButton", "", 1, "primary", 3, "disabled", "click"]], template: function VclModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "dialog", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "button", 4, 5);
        ɵngcc0.ɵɵlistener("click", function VclModalComponent_Template_button_click_4_listener($event) { return ctx.closeModal($event); });
        ɵngcc0.ɵɵpipe(6, "async");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 6);
        ɵngcc0.ɵɵtemplate(8, VclModalComponent_h2_8_Template, 2, 2, "h2", 7);
        ɵngcc0.ɵɵtemplate(9, VclModalComponent_a_9_Template, 2, 1, "a", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 9);
        ɵngcc0.ɵɵprojection(11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 10);
        ɵngcc0.ɵɵtemplate(13, VclModalComponent_button_13_Template, 2, 2, "button", 11);
        ɵngcc0.ɵɵtemplate(14, VclModalComponent_button_14_Template, 2, 2, "button", 12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hidden", !ctx.showModal)("ngStyle", ɵngcc0.ɵɵpureFunction1(19, _c1, ctx.zIndex));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction2(21, _c2, ctx.width, ctx.height));
        ɵngcc0.ɵɵattribute("id", "modal-" + ctx.id)("aria-labelledby", ctx.modalTitle)("open", ctx.showModal ? "" : null);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassMapInterpolate1("", ɵngcc0.ɵɵpipeBind1(6, 17, ctx.segment), " close-button button__transparent icon-itaufonts_fechar");
        ɵngcc0.ɵɵproperty("id", "modal-close-button-" + ctx.id);
        ɵngcc0.ɵɵattribute("aria-label", ctx.buttonLabels.close || "fechar");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.modalTitle);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.headerActionLabel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("id", "modal-desc-" + ctx.id);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ctx.buttonAlignment);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.buttonLabels.secondary);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.buttonLabels.primary);
    } }, directives: [ɵngcc2.NgStyle, ɵngcc2.NgIf, ɵngcc2.NgClass, ɵngcc1.VoxelButtonComponent], pipes: [ɵngcc2.AsyncPipe], styles: [".modal-overlay[_ngcontent-%COMP%]{overflow:auto;position:fixed;top:0;right:0;bottom:0;left:0;background-color:#000c}.modal-overlay[_ngcontent-%COMP%]   .dialog-wrapper[_ngcontent-%COMP%]{width:100%;height:100%;display:flex;justify-content:center;align-items:center}.modal[_ngcontent-%COMP%]{border:0;padding:0 1.5rem 1.5rem;display:flex;flex-direction:column;margin:auto;border-radius:4px;background-color:#fff}.close-button-wrapper[_ngcontent-%COMP%]{width:100%;height:3rem;text-align:right}.close-button[_ngcontent-%COMP%]{height:3rem;background-color:Transparent;border:none;cursor:pointer;margin-right:-.8rem}.title[_ngcontent-%COMP%]{display:flex;width:100%;justify-content:space-between;align-items:center;margin:.3125rem 0 .9375rem}.title__text[_ngcontent-%COMP%]{font-family:\"Itau Display\";font-size:1.5rem;font-weight:900;color:#231d19}.title__action[_ngcontent-%COMP%]{white-space:nowrap;padding-left:2rem}.content[_ngcontent-%COMP%]{flex:1;overflow-y:scroll;padding-bottom:1rem;line-height:1.5rem}.actions[_ngcontent-%COMP%]{margin-top:-1rem;padding-top:2.5rem;background-color:#fffc;z-index:2;display:flex;flex-direction:row}.actions[_ngcontent-%COMP%]   .secondary[_ngcontent-%COMP%]{margin-right:1rem}[_ngcontent-%COMP%]::-webkit-scrollbar{-webkit-appearance:none;width:7px}[_ngcontent-%COMP%]::-webkit-scrollbar-thumb{border-radius:4px;background-color:#00000080;box-shadow:0 0 1px #ffffff80}@media only screen and (max-width: 767.98px){.modal[_ngcontent-%COMP%]{width:100%!important;height:100%!important;border-radius:0}.title__action[_ngcontent-%COMP%]{cursor:pointer;padding-left:1.5rem}.actions.vertical[_ngcontent-%COMP%]{display:block}.actions.vertical[_ngcontent-%COMP%]   .secondary[_ngcontent-%COMP%]{margin:0 0 1rem!important}}@media only screen and (min-width: 1280px){.title__text[_ngcontent-%COMP%]{font-size:2rem}}@media only screen and (min-width: 1600px){.modal[_ngcontent-%COMP%]{padding:0 2rem 2rem}.close-button[_ngcontent-%COMP%]{margin-right:-1.3rem}}.varejo.close-button[_ngcontent-%COMP%]{color:#ec7000}.personnalite.close-button[_ngcontent-%COMP%]{color:#d0a967}.uniclass.close-button[_ngcontent-%COMP%]{color:#ec7000}.empresas.close-button[_ngcontent-%COMP%]{color:#ec7000}.itaucard.close-button[_ngcontent-%COMP%]{color:#ec7000}.private.close-button[_ngcontent-%COMP%]{color:#ec7000}.parceiro-itaucard.close-button[_ngcontent-%COMP%]{color:#ec7000}.parceiro-credicard.close-button[_ngcontent-%COMP%]{color:#0d456f}.parceiro-hipercard.close-button[_ngcontent-%COMP%]{color:#ba1319}.parceiro-magazine-luiza.close-button[_ngcontent-%COMP%]{color:#0083ca}.personal-bank.close-button[_ngcontent-%COMP%]{color:#ce9141}.itau-bba.close-button[_ngcontent-%COMP%]{color:#2449cc}.personnalite.close-button[_ngcontent-%COMP%]{color:#876632}"] });
/**
 * @internal
 */
VclModalComponent.selector = 'vcl-modal';
VclModalComponent.ctorParameters = () => [
    { type: Renderer2 },
    { type: VoxelSegmentService }
];
VclModalComponent.propDecorators = {
    id: [{ type: Input }],
    showModal: [{ type: Input }],
    showModalChange: [{ type: Output }],
    buttonLabels: [{ type: Input }],
    buttonAlignment: [{ type: Input }],
    modalTitle: [{ type: Input }],
    zIndex: [{ type: Input }],
    width: [{ type: Input }],
    height: [{ type: Input }],
    headerActionLabel: [{ type: Input }],
    primaryButtonDisabled: [{ type: Input }],
    secondaryButtonDisabled: [{ type: Input }],
    actionButtonsPadding: [{ type: Input }],
    modalButtonClick: [{ type: Output }],
    closeButton: [{ type: ViewChild, args: ['closeButton', { static: true },] }],
    onResize: [{ type: HostListener, args: ['window:resize',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclModalComponent, [{
        type: Component,
        args: [{
                selector: 'vcl-modal',
                template: "<div class=\"modal-overlay\"\n     [hidden]=\"!showModal\"\n     [ngStyle]=\"{ 'z-index' : zIndex }\"\n     >\n  <div class=\"dialog-wrapper\">\n    <dialog [attr.id]=\" 'modal-' + id \"\n            aria-modal=\"true\"\n            [attr.aria-labelledby]=\"modalTitle\"\n            class=\"modal\"\n            [attr.open]=\"showModal ? '' : null\"\n            [ngStyle]=\"{'width': width, 'height': height}\">\n\n      <div class=\"close-button-wrapper\">\n        <button\n          #closeButton\n          [id]=\" 'modal-close-button-' + id \"\n          class=\"{{ segment | async }} close-button button__transparent icon-itaufonts_fechar\"\n          [attr.aria-label]=\"buttonLabels.close || 'fechar'\"\n          (click)=\"closeModal($event)\">\n        </button>\n      </div>\n\n      <div class=\"title\">\n        <h2\n          *ngIf=\"modalTitle\"\n          [attr.id]=\" 'modal-title-' + id \"\n          class=\"title__text\">\n          {{ modalTitle }}\n        </h2>\n        <a class=\"voxel-link title__action\" *ngIf=\"headerActionLabel\" (click)=\"emmitModalButtonClick($event, ModalButtonTypes.headerAction)\">{{ headerActionLabel }}</a>\n      </div>\n\n      <div class=\"content\" [id]=\" 'modal-desc-' + id \">\n        <ng-content></ng-content>\n      </div>\n\n      <div class=\"actions\" [ngClass]=\"buttonAlignment\">\n        <button\n          voxelButton\n          *ngIf=\"buttonLabels.secondary\"\n          class=\"secondary\"\n          buttonStyle=\"secondary\"\n          [disabled]=\"secondaryButtonDisabled\"\n          (click)=\"emmitModalButtonClick($event, ModalButtonTypes.secondary)\"\n        >\n          {{buttonLabels.secondary}}\n        </button>\n\n        <button\n          voxelButton\n          *ngIf=\"buttonLabels.primary\"\n          class=\"primary\"\n          [disabled]=\"primaryButtonDisabled\"\n          (click)=\"emmitModalButtonClick($event, ModalButtonTypes.primary)\"\n        >\n          {{buttonLabels.primary}}\n        </button>\n      </div>\n    </dialog>\n  </div>\n</div>\n",
                styles: [".modal-overlay{overflow:auto;position:fixed;top:0;right:0;bottom:0;left:0;background-color:#000c}.modal-overlay .dialog-wrapper{width:100%;height:100%;display:flex;justify-content:center;align-items:center}.modal{border:0;padding:0 1.5rem 1.5rem;display:flex;flex-direction:column;margin:auto;border-radius:4px;background-color:#fff}.close-button-wrapper{width:100%;height:3rem;text-align:right}.close-button{height:3rem;background-color:Transparent;border:none;cursor:pointer;margin-right:-.8rem}.title{display:flex;width:100%;justify-content:space-between;align-items:center;margin:.3125rem 0 .9375rem}.title__text{font-family:\"Itau Display\";font-size:1.5rem;font-weight:900;color:#231d19}.title__action{white-space:nowrap;padding-left:2rem}.content{flex:1;overflow-y:scroll;padding-bottom:1rem;line-height:1.5rem}.actions{margin-top:-1rem;padding-top:2.5rem;background-color:#fffc;z-index:2;display:flex;flex-direction:row}.actions .secondary{margin-right:1rem}::-webkit-scrollbar{-webkit-appearance:none;width:7px}::-webkit-scrollbar-thumb{border-radius:4px;background-color:#00000080;box-shadow:0 0 1px #ffffff80}@media only screen and (max-width: 767.98px){.modal{width:100%!important;height:100%!important;border-radius:0}.title__action{cursor:pointer;padding-left:1.5rem}.actions.vertical{display:block}.actions.vertical .secondary{margin:0 0 1rem!important}}@media only screen and (min-width: 1280px){.title__text{font-size:2rem}}@media only screen and (min-width: 1600px){.modal{padding:0 2rem 2rem}.close-button{margin-right:-1.3rem}}.varejo.close-button{color:#ec7000}.personnalite.close-button{color:#d0a967}.uniclass.close-button{color:#ec7000}.empresas.close-button{color:#ec7000}.itaucard.close-button{color:#ec7000}.private.close-button{color:#ec7000}.parceiro-itaucard.close-button{color:#ec7000}.parceiro-credicard.close-button{color:#0d456f}.parceiro-hipercard.close-button{color:#ba1319}.parceiro-magazine-luiza.close-button{color:#0083ca}.personal-bank.close-button{color:#ce9141}.itau-bba.close-button{color:#2449cc}.personnalite.close-button{color:#876632}\n"]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc1.VoxelSegmentService }]; }, { showModal: [{
            type: Input
        }], showModalChange: [{
            type: Output
        }], buttonLabels: [{
            type: Input
        }], buttonAlignment: [{
            type: Input
        }], zIndex: [{
            type: Input
        }], width: [{
            type: Input
        }], height: [{
            type: Input
        }], primaryButtonDisabled: [{
            type: Input
        }], secondaryButtonDisabled: [{
            type: Input
        }], modalButtonClick: [{
            type: Output
        }], 
    /**
     * @internal
     */
    onResize: [{
            type: HostListener,
            args: ['window:resize']
        }], id: [{
            type: Input
        }], modalTitle: [{
            type: Input
        }], headerActionLabel: [{
            type: Input
        }], actionButtonsPadding: [{
            type: Input
        }], closeButton: [{
            type: ViewChild,
            args: ['closeButton', { static: true }]
        }] }); })();

class VclModalModule {
}
VclModalModule.ɵfac = function VclModalModule_Factory(t) { return new (t || VclModalModule)(); };
VclModalModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VclModalModule });
VclModalModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            VoxelSegmentModule,
            VoxelButtonModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclModalModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    VoxelSegmentModule,
                    VoxelButtonModule,
                ],
                declarations: [VclModalComponent],
                exports: [VclModalComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VclModalModule, { declarations: function () { return [VclModalComponent]; }, imports: function () { return [CommonModule,
        VoxelSegmentModule,
        VoxelButtonModule]; }, exports: function () { return [VclModalComponent]; } }); })();

class VclSnackBarService {
    constructor() {
        this.snackBarInfo = {
            label1: undefined,
            action: undefined,
            show: false,
        };
        this.snackBarInfoSubject = new BehaviorSubject(this.snackBarInfo);
        this.onActionSubject = new Subject();
    }
    /**
     * Recebe os valores e exibe a snack bar
     *
     * *Receives the values and display the snack bar*
     * @param label1 Label primário
     * @param [action] Label da ação ao clicar no botão
     * @param [label2] Label secundário
     * @param [config] Objeto adicional de configuração
     */
    open(label1, action, label2, config) {
        this.snackBarInfo = {
            label1,
            action,
            label2,
            show: true,
            config,
        };
        this.snackBarInfoSubject.next(this.snackBarInfo);
    }
    /**
     * Esconde a snack bar
     *
     * *Hides the snack bar*
     */
    dismiss() {
        this.snackBarInfo.show = false;
        this.snackBarInfoSubject.next(this.snackBarInfo);
    }
    /**
     * @returns Um observable que será disparado sempre que o botão de ação for clicado
     *
     * *An observable that will be triggered every time the action button is clicked*
     */
    onAction() {
        return this.onActionSubject.asObservable();
    }
    /**
     * @internal
     */
    getSnackBarInfo() {
        return this.snackBarInfoSubject.asObservable();
    }
    /**
     * @internal
     */
    dispatchOnAction() {
        this.onActionSubject.next(true);
    }
}
VclSnackBarService.ɵfac = function VclSnackBarService_Factory(t) { return new (t || VclSnackBarService)(); };
VclSnackBarService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: VclSnackBarService, factory: VclSnackBarService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclSnackBarService, [{
        type: Injectable
    }], function () { return []; }, null); })();

/**
 * Objeto de configuração da snack bar
 *
 * *Snack bar configuration object*
 */
class SnackBarConfig {
    constructor() {
        this.duration = 3000;
    }
}
/**
 * Snack bar é um componente que mostra para o usuário o status de processamento do sistema.
 * Também podem ser utilizadas para desfazer alguma ação feita pelo usuário.
 *
 * *Snack bar is a component that shows the user the processing status of the system.
 * They can also be used to undo any action taken by the user.*
 *
 * ### Acessible
 *
 * <acessible class="not-tested">Acessibilidade - Não testado</acessible>
 *
 * **Module:**
 *
 * `import { VclSnackBarModule } from '@voxel/community';`
 *
 * <example-url>../../demo/index.html#/portfolio/components/snack-bar?componentOnly=true</example-url>
 *
 * @example single line
 * this.vclSnackBarService.open('single-line message');
 *
 * @example single line with action
 * this.vclSnackBarService.open('single-line message', 'label');
 *
 * @example two lines
 * this.vclSnackBarService.open('This item already has the label "travel".', '', ' You can add a new label.');
 *
 * @example two lines with action and dismissal
 * this.vclSnackBarService.open('This item already has the label "travel".', 'label', 'You can add a new label.', new SnackBarConfig());
 */
class VclSnackBarComponent {
    /**
     * @internal
     */
    constructor(vclSnackBarService) {
        this.vclSnackBarService = vclSnackBarService;
        /**
         * @internal
         */
        this.subscription = new Subscription();
    }
    /**
     * @internal
     */
    ngOnInit() {
        this.subscription.add(this.vclSnackBarService
            .getSnackBarInfo()
            .subscribe((snackBarInfo) => {
            this.handleSnackBarInfo(snackBarInfo);
        }));
    }
    /**
     * @internal
     */
    handleSnackBarInfo(snackBarInfo) {
        if (this.snackBarInfo && this.snackBarInfo.show && snackBarInfo.show) {
            this.snackBarInfo.show = false;
            setTimeout(() => {
                this.snackBarInfo = snackBarInfo;
                this.handleExhibition();
            }, 200);
            return;
        }
        this.snackBarInfo = snackBarInfo;
        this.handleExhibition();
    }
    /**
     * @internal
     */
    handleExhibition() {
        if (!this.snackBarInfo.show ||
            (!this.snackBarInfo.config ||
                (this.snackBarInfo.config &&
                    (!this.snackBarInfo.config.duration ||
                        this.snackBarInfo.config.duration === 0)))) {
            return;
        }
        if (this.timeoutRef) {
            clearTimeout(this.timeoutRef);
        }
        this.timeoutRef = setTimeout(() => {
            this.vclSnackBarService.dismiss();
            this.timeoutRef = undefined;
        }, this.snackBarInfo.config.duration);
    }
    /**
     * @internal
     */
    onAction() {
        this.vclSnackBarService.dispatchOnAction();
        this.vclSnackBarService.dismiss();
    }
    /**
     * @internal
     */
    ngOnDestroy() {
        if (this.snackBarInfo.show) {
            this.vclSnackBarService.dismiss();
        }
        this.subscription.unsubscribe();
    }
}
VclSnackBarComponent.ɵfac = function VclSnackBarComponent_Factory(t) { return new (t || VclSnackBarComponent)(ɵngcc0.ɵɵdirectiveInject(VclSnackBarService)); };
VclSnackBarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VclSnackBarComponent, selectors: [["vcl-snack-bar"]], decls: 1, vars: 1, consts: [["class", "vcl-snack-bar", 3, "ngClass", 4, "ngIf"], [1, "vcl-snack-bar", 3, "ngClass"], ["aria-live", "polite", 1, "label-wrapper"], [4, "ngIf"], ["class", "button-wrapper", 4, "ngIf"], [1, "button-wrapper"], ["voxelButton", "", "voxelButtonContextual", "", "buttonStyle", "light", 3, "click"]], template: function VclSnackBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, VclSnackBarComponent_div_0_Template, 6, 5, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.snackBarInfo.show);
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgClass, ɵngcc1.VoxelButtonComponent], styles: [".vcl-snack-bar[_ngcontent-%COMP%]{display:flex;background-color:#231d19;color:#fff;position:fixed;bottom:0;margin:1.25rem 1rem;width:calc(100% - 2rem);border-radius:4px;z-index:9999;flex-wrap:wrap}.vcl-snack-bar[_ngcontent-%COMP%]   .label-wrapper[_ngcontent-%COMP%]{padding:.75rem 1rem;line-height:24px}.vcl-snack-bar[_ngcontent-%COMP%]   .button-wrapper[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;flex:auto;padding:.5rem}.vcl-snack-bar.one-line[_ngcontent-%COMP%]{justify-content:space-between}.vcl-snack-bar.two-lines[_ngcontent-%COMP%]{flex-direction:column}@media only screen and (min-width: 768px) and (max-width: 1023.98px){.vcl-snack-bar[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{display:inline}.vcl-snack-bar.two-lines[_ngcontent-%COMP%]{justify-content:space-between;flex-direction:unset}}@media only screen and (min-width: 1024px) and (max-width: 1279.98px){.vcl-snack-bar[_ngcontent-%COMP%]{max-width:28.9375rem}}@media only screen and (min-width: 1280px) and (max-width: 1599.98px){.vcl-snack-bar[_ngcontent-%COMP%]{max-width:24.625rem}}@media only screen and (min-width: 1600px){.vcl-snack-bar[_ngcontent-%COMP%]{max-width:28.625rem}}"], data: { animation: [
            trigger('openDismiss', [
                transition(':enter', [
                    style({ opacity: 0 }),
                    animate('200ms', style({ opacity: 1 })),
                ]),
                transition(':leave', [animate('200ms', style({ opacity: 0 }))]),
            ]),
        ] } });
/**
 * @internal
 */
VclSnackBarComponent.selector = 'vcl-snack-bar';
VclSnackBarComponent.ctorParameters = () => [
    { type: VclSnackBarService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclSnackBarComponent, [{
        type: Component,
        args: [{
                selector: 'vcl-snack-bar',
                template: "<div *ngIf=\"snackBarInfo.show\" [@openDismiss] class=\"vcl-snack-bar\" [ngClass]=\"snackBarInfo.label2 ? 'two-lines': 'one-line'\">\n  <div class=\"label-wrapper\" aria-live=\"polite\">\n    <p>\n      {{snackBarInfo.label1}}\n    </p>\n    <p *ngIf=\"snackBarInfo.label2\">\n      {{snackBarInfo.label2}}\n    </p>\n  </div>\n  <div *ngIf=\"snackBarInfo.action\" class=\"button-wrapper\">\n    <button\n      voxelButton\n      voxelButtonContextual\n      buttonStyle=\"light\"\n      (click)=\"onAction()\"\n    >\n      {{snackBarInfo.action}}\n    </button>\n  </div>\n</div>\n",
                animations: [
                    trigger('openDismiss', [
                        transition(':enter', [
                            style({ opacity: 0 }),
                            animate('200ms', style({ opacity: 1 })),
                        ]),
                        transition(':leave', [animate('200ms', style({ opacity: 0 }))]),
                    ]),
                ],
                styles: [".vcl-snack-bar{display:flex;background-color:#231d19;color:#fff;position:fixed;bottom:0;margin:1.25rem 1rem;width:calc(100% - 2rem);border-radius:4px;z-index:9999;flex-wrap:wrap}.vcl-snack-bar .label-wrapper{padding:.75rem 1rem;line-height:24px}.vcl-snack-bar .button-wrapper{display:flex;justify-content:flex-end;flex:auto;padding:.5rem}.vcl-snack-bar.one-line{justify-content:space-between}.vcl-snack-bar.two-lines{flex-direction:column}@media only screen and (min-width: 768px) and (max-width: 1023.98px){.vcl-snack-bar p{display:inline}.vcl-snack-bar.two-lines{justify-content:space-between;flex-direction:unset}}@media only screen and (min-width: 1024px) and (max-width: 1279.98px){.vcl-snack-bar{max-width:28.9375rem}}@media only screen and (min-width: 1280px) and (max-width: 1599.98px){.vcl-snack-bar{max-width:24.625rem}}@media only screen and (min-width: 1600px){.vcl-snack-bar{max-width:28.625rem}}\n"]
            }]
    }], function () { return [{ type: VclSnackBarService }]; }, null); })();

class VclSnackBarModule {
}
VclSnackBarModule.ɵfac = function VclSnackBarModule_Factory(t) { return new (t || VclSnackBarModule)(); };
VclSnackBarModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VclSnackBarModule });
VclSnackBarModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        VclSnackBarService,
    ], imports: [[
            CommonModule,
            VoxelButtonModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclSnackBarModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    VoxelButtonModule,
                ],
                declarations: [
                    VclSnackBarComponent,
                ],
                providers: [
                    VclSnackBarService,
                ],
                exports: [
                    VclSnackBarComponent,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VclSnackBarModule, { declarations: function () { return [VclSnackBarComponent]; }, imports: function () { return [CommonModule,
        VoxelButtonModule]; }, exports: function () { return [VclSnackBarComponent]; } }); })();

/**
 * Tipos de botão do dialog
 * *Button types in dialog component*
 *
 * @export
 * @enum {string}
 */
var DialogButtonTypes;
(function (DialogButtonTypes) {
    DialogButtonTypes["action1"] = "action1";
    DialogButtonTypes["action2"] = "action2";
    DialogButtonTypes["action3"] = "action3";
})(DialogButtonTypes || (DialogButtonTypes = {}));
/**
 * Componente de Dialog é um elemento de sobreposição que exige interação com o usuário.
 * *Dialog component is a sobreposition element that requires user interation*
 *
 * ### Acessible
 *
 * <acessible class="not-tested">Acessibilidade - Não testado</acessible>
 *
 * **Module:**
 *
 * `import { VclDialogModule } from '@voxel/community';`
 *
 * <example-url>../../demo/index.html#/portfolio/components/dialog?componentOnly=true</example-url>
 *
 * @example one action
 * <vcl-dialog
 *  [id]="'dialog-a'"
 *  [buttonLabels]=" { action1: 'ok, entendi' } "
 *  [dialogTitle]="'Lorem ipsum dolor sit amet'"
 *  [buttonAlignment]="'horizontal'"
 *  [(showDialog)]="dialogShow.action1"
 *  (dialogButtonClick)="dialogButtonClicked($event, 'action1')">
 *  <p>
 *      Consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.
 *  </p>
 *  </vcl-dialog>
 *
 * @example two action
 * <vcl-dialog
 *  [id]="'dialog-b'"
 *  [buttonLabels]=" { action1: 'aceitar', action2: 'recusar' } "
 *  [dialogTitle]="'Lorem ipsum dolor sit amet'"
 *  [buttonAlignment]="'horizontal'"
 *  [(showDialog)]="dialogShow.action2"
 *  (dialogButtonClick)="dialogButtonClicked($event, 'action2')">
 *  <p>
 *      Consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.
 *  </p>
 *  </vcl-dialog>
 *
 * @example three action
 * <vcl-dialog
 *  [id]="'dialog-c'"
 *  [buttonLabels]=" { action1: 'ação 1', action2: 'ação 2', action3: 'ação 3' } "
 *  [dialogTitle]="'Lorem ipsum dolor sit amet'"
 *  [buttonAlignment]="'vertical'"
 *  [(showDialog)]="dialogShow.action3"
 *  (dialogButtonClick)="dialogButtonClicked($event, 'action3')">
 *  <p>
 *      Consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.
 *  </p>
 *  </vcl-dialog>
 *
 * @example With internal spacing of the buttons customizable
 * <vcl-dialog
 *  [id]="'dialog-d'"
 *  [buttonLabels]=" { action1: 'ação 1', action2: 'ação 2', action3: 'ação 3' } "
 *  [dialogTitle]="'Lorem ipsum dolor sit amet'"
 *  [buttonAlignment]="'vertical'"
 *  [(showDialog)]="dialogShow.action3"
 *  (dialogButtonClick)="dialogButtonClicked($event, 'action3')"
 *  [buttonsPadding]="'0 1.2rem'">
 *  <p>
 *      Consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.
 *  </p>
 *  </vcl-dialog>
 */
class VclDialogComponent {
    constructor() {
        /**
         * @internal
         */
        this.DialogButtonTypes = DialogButtonTypes;
        /**
         * Rótulos dos botões de ação
         * *Action button labels*
         *
         */
        this.buttonLabels = {
            action1: 'ok',
        };
        /**
         * Valor da propriedade de estilo `z-index` do wrapper do dialog
         * *`z-index` property value in dialog wrapper*
         *
         */
        this.zIndex = '10';
        /**
         * Exibe e oculta o dialog
         * *Property that show/hide dialog*
         *
         */
        this.showDialog = false;
        /**
         * Define o espaçamento interno (padding) dos botões
         * *Sets the internal buttons spacing (padding)*
         *
         */
        this.buttonsPadding = '0 1.5rem';
        /**
         * Alinhamento dos botões de ação
         * *Action buttons alignment*
         *
         */
        this.buttonAlignment = 'horizontal';
        /**
         * @internal
         */
        this.showDialogChange = new EventEmitter();
        /**
         * Evento disparado no clique dos botões do dialog
         * *Dialog button click event*
         *
         */
        this.dialogButtonClick = new EventEmitter();
    }
    /**
     * @internal
     */
    onResize() {
        if (!this.actionButton1 ||
            !this.actionButton2 ||
            this.buttonAlignment === 'vertical') {
            return;
        }
        this.actions.nativeElement.removeAttribute('style');
        this.actionButton1.nativeElement.removeAttribute('style');
        this.actionButton2.nativeElement.removeAttribute('style');
        if ((this.actionButton3 &&
            this.actionButton1.nativeElement.offsetTop ===
                this.actionButton3.nativeElement.offsetTop) ||
            (!this.actionButton3 &&
                this.actionButton1.nativeElement.offsetTop ===
                    this.actionButton2.nativeElement.offsetTop)) {
            return;
        }
        this.actions.nativeElement.style.display = 'block';
        this.actionButton1.nativeElement.style.marginRight = '0';
        this.actionButton2.nativeElement.style.marginRight = '0';
    }
    /**
     * @internal
     */
    emmitDialogButtonClick($event, type) {
        this.showDialog = false;
        this.showDialogChange.emit(false);
        this.dialogButtonClick.emit({ $event, type });
    }
}
VclDialogComponent.ɵfac = function VclDialogComponent_Factory(t) { return new (t || VclDialogComponent)(); };
VclDialogComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VclDialogComponent, selectors: [["vcl-dialog"]], viewQuery: function VclDialogComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c4, 5);
        ɵngcc0.ɵɵviewQuery(_c5, 5, ElementRef);
        ɵngcc0.ɵɵviewQuery(_c6, 5, ElementRef);
        ɵngcc0.ɵɵviewQuery(_c7, 5, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.actions = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.actionButton1 = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.actionButton2 = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.actionButton3 = _t.first);
    } }, hostBindings: function VclDialogComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function VclDialogComponent_resize_HostBindingHandler() { return ctx.onResize(); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { buttonLabels: "buttonLabels", zIndex: "zIndex", showDialog: "showDialog", buttonsPadding: "buttonsPadding", buttonAlignment: "buttonAlignment", id: "id", dialogTitle: "dialogTitle" }, outputs: { showDialogChange: "showDialogChange", dialogButtonClick: "dialogButtonClick" }, ngContentSelectors: _c3, decls: 1, vars: 1, consts: [["class", "overlay", 3, "ngStyle", 4, "ngIf"], [1, "overlay", 3, "ngStyle"], [1, "dialog-wrapper"], ["aria-modal", "true", 1, "modal"], [1, "title"], ["class", "title__text", 4, "ngIf"], [1, "content", 3, "id"], [3, "ngClass"], ["actions", ""], [3, "voxelButtonContextual", "click"], ["actionButton1", ""], [3, "voxelButtonContextual", "click", 4, "ngIf"], [1, "title__text"], ["actionButton2", ""], ["actionButton3", ""]], template: function VclDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, VclDialogComponent_div_0_Template, 14, 15, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.showDialog);
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgStyle, ɵngcc2.NgClass, ɵngcc1.VoxelButtonComponent], styles: [".overlay[_ngcontent-%COMP%]{overflow:auto;position:fixed;top:0;right:0;bottom:0;left:0;background-color:#000c}.overlay[_ngcontent-%COMP%]   .dialog-wrapper[_ngcontent-%COMP%]{width:100%;height:100%;display:flex;justify-content:center;align-items:center}.modal[_ngcontent-%COMP%]{border:0;display:flex;flex-direction:column;margin:auto;border-radius:4px;box-shadow:0 1px 8px #60575133;background-color:#fff}.title[_ngcontent-%COMP%]{margin:1rem 1.5rem 0}.title__text[_ngcontent-%COMP%]{font-family:\"Itau Display\";font-size:1.25rem;line-height:1.5rem;font-weight:900;color:#231d19}.content[_ngcontent-%COMP%]{font-family:\"Itau Text\";font-size:1rem;line-height:1.5rem;color:#231d19;margin:.5rem 1.5rem 1.5rem}.actions[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;margin:0 1.5rem 1.5rem}.actions[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin-top:.5rem}.actions.three-buttons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{flex-grow:1}.actions.horizontal[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:nth-child(-n+2){margin-right:.5rem}.actions.vertical[_ngcontent-%COMP%]{display:block}@media only screen and (max-width: 767.98px){.modal[_ngcontent-%COMP%]{max-width:16.5rem}}@media only screen and (min-width: 768px) and (max-width: 1023.98px){.modal[_ngcontent-%COMP%]{max-width:22rem}}@media only screen and (min-width: 1024px) and (max-width: 1279.98px){.modal[_ngcontent-%COMP%]{max-width:18.75rem}}@media only screen and (min-width: 1280px) and (max-width: 1599.98px){.modal[_ngcontent-%COMP%]{max-width:24.625rem}}@media only screen and (min-width: 1600px){.modal[_ngcontent-%COMP%]{max-width:28.625rem}}@media only screen and (min-width: 1024px){.title__text[_ngcontent-%COMP%]{font-size:1.5rem;line-height:2.25rem}}"] });
/**
 * @internal
 */
VclDialogComponent.selector = 'vcl-dialog';
VclDialogComponent.propDecorators = {
    actions: [{ type: ViewChild, args: ['actions',] }],
    actionButton1: [{ type: ViewChild, args: ['actionButton1', { read: ElementRef },] }],
    actionButton2: [{ type: ViewChild, args: ['actionButton2', { read: ElementRef },] }],
    actionButton3: [{ type: ViewChild, args: ['actionButton3', { read: ElementRef },] }],
    id: [{ type: Input }],
    buttonLabels: [{ type: Input }],
    zIndex: [{ type: Input }],
    showDialog: [{ type: Input }],
    buttonsPadding: [{ type: Input }],
    dialogTitle: [{ type: Input }],
    buttonAlignment: [{ type: Input }],
    showDialogChange: [{ type: Output }],
    dialogButtonClick: [{ type: Output }],
    onResize: [{ type: HostListener, args: ['window:resize',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclDialogComponent, [{
        type: Component,
        args: [{
                selector: 'vcl-dialog',
                template: "<div class=\"overlay\"\n     *ngIf=\"showDialog\"\n     [ngStyle]=\"{ 'z-index' : zIndex }\"\n     >\n  <div class=\"dialog-wrapper\">\n    <dialog [attr.id]=\"id\"\n            aria-modal=\"true\"\n            class=\"modal\"\n            [attr.open]=\"showDialog ? onResize() : null\">\n\n      <div class=\"title\">\n        <h2 [attr.id]=\"'title-' + id\" *ngIf=\"dialogTitle\" class=\"title__text\">{{ dialogTitle }}</h2>\n      </div>\n\n      <div class=\"content\" [id]=\"'desc-' + id\">\n        <ng-content></ng-content>\n      </div>\n\n      <div #actions class=\"actions {{buttonAlignment}}\" [ngClass]=\"buttonLabels.action3 ? 'three-buttons' : ''\">\n        <button\n          #actionButton1\n          [voxelButtonContextual]=\"true\"\n          (click)=\"emmitDialogButtonClick($event, DialogButtonTypes.action1)\"\n        >\n          {{buttonLabels.action1}}\n        </button>\n\n        <button\n          #actionButton2\n          *ngIf=\"buttonLabels.action2\"\n          [voxelButtonContextual]=\"true\"\n          (click)=\"emmitDialogButtonClick($event, DialogButtonTypes.action2)\"\n        >\n          {{buttonLabels.action2}}\n        </button>\n\n        <button\n          #actionButton3\n          *ngIf=\"buttonLabels.action3\"\n          [voxelButtonContextual]=\"true\"\n          (click)=\"emmitDialogButtonClick($event, DialogButtonTypes.action3)\"\n        >\n          {{buttonLabels.action3}}\n        </button>\n      </div>\n\n    </dialog>\n  </div>\n</div>\n",
                styles: [".overlay{overflow:auto;position:fixed;top:0;right:0;bottom:0;left:0;background-color:#000c}.overlay .dialog-wrapper{width:100%;height:100%;display:flex;justify-content:center;align-items:center}.modal{border:0;display:flex;flex-direction:column;margin:auto;border-radius:4px;box-shadow:0 1px 8px #60575133;background-color:#fff}.title{margin:1rem 1.5rem 0}.title__text{font-family:\"Itau Display\";font-size:1.25rem;line-height:1.5rem;font-weight:900;color:#231d19}.content{font-family:\"Itau Text\";font-size:1rem;line-height:1.5rem;color:#231d19;margin:.5rem 1.5rem 1.5rem}.actions{display:flex;flex-wrap:wrap;margin:0 1.5rem 1.5rem}.actions button{margin-top:.5rem}.actions.three-buttons button{flex-grow:1}.actions.horizontal button:nth-child(-n+2){margin-right:.5rem}.actions.vertical{display:block}@media only screen and (max-width: 767.98px){.modal{max-width:16.5rem}}@media only screen and (min-width: 768px) and (max-width: 1023.98px){.modal{max-width:22rem}}@media only screen and (min-width: 1024px) and (max-width: 1279.98px){.modal{max-width:18.75rem}}@media only screen and (min-width: 1280px) and (max-width: 1599.98px){.modal{max-width:24.625rem}}@media only screen and (min-width: 1600px){.modal{max-width:28.625rem}}@media only screen and (min-width: 1024px){.title__text{font-size:1.5rem;line-height:2.25rem}}\n"]
            }]
    }], function () { return []; }, { buttonLabels: [{
            type: Input
        }], zIndex: [{
            type: Input
        }], showDialog: [{
            type: Input
        }], buttonsPadding: [{
            type: Input
        }], buttonAlignment: [{
            type: Input
        }], showDialogChange: [{
            type: Output
        }], dialogButtonClick: [{
            type: Output
        }], 
    /**
     * @internal
     */
    onResize: [{
            type: HostListener,
            args: ['window:resize']
        }], actions: [{
            type: ViewChild,
            args: ['actions']
        }], actionButton1: [{
            type: ViewChild,
            args: ['actionButton1', { read: ElementRef }]
        }], actionButton2: [{
            type: ViewChild,
            args: ['actionButton2', { read: ElementRef }]
        }], actionButton3: [{
            type: ViewChild,
            args: ['actionButton3', { read: ElementRef }]
        }], id: [{
            type: Input
        }], dialogTitle: [{
            type: Input
        }] }); })();

class VclDialogModule {
}
VclDialogModule.ɵfac = function VclDialogModule_Factory(t) { return new (t || VclDialogModule)(); };
VclDialogModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VclDialogModule });
VclDialogModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            VoxelButtonModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclDialogModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    VoxelButtonModule,
                ],
                declarations: [VclDialogComponent],
                exports: [VclDialogComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VclDialogModule, { declarations: function () { return [VclDialogComponent]; }, imports: function () { return [CommonModule,
        VoxelButtonModule]; }, exports: function () { return [VclDialogComponent]; } }); })();

/**
 * Representação visual usada para dar a ideia de progresso, localização e quantidade de
 * etapas necessárias para a conclusão de uma tarefa longa ou complexa
 *
 * *Visual representation used to convey the idea of progress, location and the number of steps required to complete a long or complex task*
 *
 * ### Acessible
 *
 * <acessible class="not-tested">Acessibilidade - Não testado</acessible>
 *
 * **Module:**
 *
 * `import { VclStepsModule } from '@voxel/community';`
 *
 * <example-url>../../demo/index.html#/portfolio/components/steps?componentOnly=true</example-url>
 *
 * @example steps
 *   <vcl-steps
 *     [amount]="5">
 *   </vcl-steps>
 *
 * @example com passos ativos</h2>
 *   <vcl-steps
 *     [amount]="3"
 *     [current]="2">
 *   </vcl-steps>
 */
class VclStepsComponent {
    /**
     * @internal
     */
    constructor(voxelSegmentService) {
        this.voxelSegmentService = voxelSegmentService;
        /**
         * Inserir o atributo aria live no steps para paginas dinâmica
         *
         * *Include the aria-live attribute in the steps for dynamic page*
         */
        this.stepsAriaLive = 'off';
        /**
         * Número do passo atual
         *
         * *Number of the current step*
         */
        this.current = 1;
        /**
         * @internal
         */
        this.segment = this.voxelSegmentService.segment;
    }
    ngOnInit() {
        this.arrayAmount = Array.apply(null, { length: this.amount }).map(Number.call, Number);
    }
}
VclStepsComponent.ɵfac = function VclStepsComponent_Factory(t) { return new (t || VclStepsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.VoxelSegmentService)); };
VclStepsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VclStepsComponent, selectors: [["vcl-steps"]], inputs: { stepsAriaLive: "stepsAriaLive", current: "current", id: "id", amount: "amount" }, decls: 7, vars: 10, consts: [["aria-relevant", "all"], [1, "steps__content-block"], [1, "steps__content"], ["class", "steps__content-step", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "steps__amount", "text__small"], [1, "steps__content-step", 3, "ngClass"]], template: function VclStepsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵpipe(1, "async");
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵelementStart(3, "ul", 2);
        ɵngcc0.ɵɵtemplate(4, VclStepsComponent_li_4_Template, 1, 5, "li", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "span", 4);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate2("", ɵngcc0.ɵɵpipeBind1(1, 8, ctx.segment), " steps amount-", ctx.amount, "");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.arrayAmount);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("aria-live", ctx.stepsAriaLive);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate2(" ", ctx.current, " de ", ctx.amount, " ");
    } }, directives: [ɵngcc2.NgForOf, ɵngcc2.NgClass], pipes: [ɵngcc2.AsyncPipe], styles: [".steps[_ngcontent-%COMP%]{display:flex;flex-direction:column;height:2rem;justify-content:center;overflow:hidden}.steps__content-block[_ngcontent-%COMP%]{display:flex}.steps__content[_ngcontent-%COMP%]{display:flex;width:100%;align-items:center}.steps__content-step[_ngcontent-%COMP%]{flex-grow:1;background-color:#56504c;height:.25rem;border-radius:4px}.steps__content-step[_ngcontent-%COMP%]:not(:last-child){margin-right:3.5%}.steps__content-step--current[_ngcontent-%COMP%]{height:.375rem;flex-grow:2}.steps__amount[_ngcontent-%COMP%]{min-width:2.5rem;margin:0 0 .1875rem .5rem;color:#605751}.varejo.steps[_ngcontent-%COMP%]   .steps__content[_ngcontent-%COMP%]   .steps__content-step.steps__content-step--checked[_ngcontent-%COMP%]{background-color:#ec7000}.personnalite.steps[_ngcontent-%COMP%]   .steps__content[_ngcontent-%COMP%]   .steps__content-step.steps__content-step--checked[_ngcontent-%COMP%]{background-color:#d0a967}.uniclass.steps[_ngcontent-%COMP%]   .steps__content[_ngcontent-%COMP%]   .steps__content-step.steps__content-step--checked[_ngcontent-%COMP%]{background-color:#ec7000}.empresas.steps[_ngcontent-%COMP%]   .steps__content[_ngcontent-%COMP%]   .steps__content-step.steps__content-step--checked[_ngcontent-%COMP%]{background-color:#ec7000}.itaucard.steps[_ngcontent-%COMP%]   .steps__content[_ngcontent-%COMP%]   .steps__content-step.steps__content-step--checked[_ngcontent-%COMP%]{background-color:#ec7000}.private.steps[_ngcontent-%COMP%]   .steps__content[_ngcontent-%COMP%]   .steps__content-step.steps__content-step--checked[_ngcontent-%COMP%]{background-color:#ec7000}.parceiro-itaucard.steps[_ngcontent-%COMP%]   .steps__content[_ngcontent-%COMP%]   .steps__content-step.steps__content-step--checked[_ngcontent-%COMP%]{background-color:#ec7000}.parceiro-credicard.steps[_ngcontent-%COMP%]   .steps__content[_ngcontent-%COMP%]   .steps__content-step.steps__content-step--checked[_ngcontent-%COMP%]{background-color:#0d456f}.parceiro-hipercard.steps[_ngcontent-%COMP%]   .steps__content[_ngcontent-%COMP%]   .steps__content-step.steps__content-step--checked[_ngcontent-%COMP%]{background-color:#ba1319}.parceiro-magazine-luiza.steps[_ngcontent-%COMP%]   .steps__content[_ngcontent-%COMP%]   .steps__content-step.steps__content-step--checked[_ngcontent-%COMP%]{background-color:#0083ca}.personal-bank.steps[_ngcontent-%COMP%]   .steps__content[_ngcontent-%COMP%]   .steps__content-step.steps__content-step--checked[_ngcontent-%COMP%]{background-color:#ce9141}.itau-bba.steps[_ngcontent-%COMP%]   .steps__content[_ngcontent-%COMP%]   .steps__content-step.steps__content-step--checked[_ngcontent-%COMP%]{background-color:#2449cc}"] });
/**
 * @internal
 */
VclStepsComponent.selector = 'vcl-steps';
VclStepsComponent.ctorParameters = () => [
    { type: VoxelSegmentService }
];
VclStepsComponent.propDecorators = {
    id: [{ type: Input }],
    stepsAriaLive: [{ type: Input }],
    amount: [{ type: Input }],
    current: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclStepsComponent, [{
        type: Component,
        args: [{
                selector: 'vcl-steps',
                template: "<div\n  class=\"{{ segment | async }} steps amount-{{ amount }}\"\n  aria-relevant=\"all\">\n\n  <div class=\"steps__content-block\" >\n\n    <ul class=\"steps__content\">\n      <li class=\"steps__content-step\"\n        [attr.id]=\"id\"\n        *ngFor=\"let step of arrayAmount\"\n        [ngClass]=\"{\n          'steps__content-step--checked' : current >= step + 1,\n          'steps__content-step--current' : current == step + 1\n        }\">\n      </li>\n    </ul>\n    <span [attr.aria-live]=\"stepsAriaLive\" class=\"steps__amount text__small\">\n      {{ current }} de {{ amount }}\n    </span>\n  </div>\n</div>\n",
                styles: [".steps{display:flex;flex-direction:column;height:2rem;justify-content:center;overflow:hidden}.steps__content-block{display:flex}.steps__content{display:flex;width:100%;align-items:center}.steps__content-step{flex-grow:1;background-color:#56504c;height:.25rem;border-radius:4px}.steps__content-step:not(:last-child){margin-right:3.5%}.steps__content-step--current{height:.375rem;flex-grow:2}.steps__amount{min-width:2.5rem;margin:0 0 .1875rem .5rem;color:#605751}.varejo.steps .steps__content .steps__content-step.steps__content-step--checked{background-color:#ec7000}.personnalite.steps .steps__content .steps__content-step.steps__content-step--checked{background-color:#d0a967}.uniclass.steps .steps__content .steps__content-step.steps__content-step--checked{background-color:#ec7000}.empresas.steps .steps__content .steps__content-step.steps__content-step--checked{background-color:#ec7000}.itaucard.steps .steps__content .steps__content-step.steps__content-step--checked{background-color:#ec7000}.private.steps .steps__content .steps__content-step.steps__content-step--checked{background-color:#ec7000}.parceiro-itaucard.steps .steps__content .steps__content-step.steps__content-step--checked{background-color:#ec7000}.parceiro-credicard.steps .steps__content .steps__content-step.steps__content-step--checked{background-color:#0d456f}.parceiro-hipercard.steps .steps__content .steps__content-step.steps__content-step--checked{background-color:#ba1319}.parceiro-magazine-luiza.steps .steps__content .steps__content-step.steps__content-step--checked{background-color:#0083ca}.personal-bank.steps .steps__content .steps__content-step.steps__content-step--checked{background-color:#ce9141}.itau-bba.steps .steps__content .steps__content-step.steps__content-step--checked{background-color:#2449cc}\n"]
            }]
    }], function () { return [{ type: ɵngcc1.VoxelSegmentService }]; }, { stepsAriaLive: [{
            type: Input
        }], current: [{
            type: Input
        }], id: [{
            type: Input
        }], amount: [{
            type: Input
        }] }); })();

class VclStepsModule {
}
VclStepsModule.ɵfac = function VclStepsModule_Factory(t) { return new (t || VclStepsModule)(); };
VclStepsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VclStepsModule });
VclStepsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclStepsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                ],
                declarations: [VclStepsComponent],
                exports: [VclStepsComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VclStepsModule, { declarations: function () { return [VclStepsComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [VclStepsComponent]; } }); })();

/**
 * Força um valor (normalmente uma string) para boolean.
 * Normalmente utilizado para converter valores recebidos de
 * @Inputs dos componentes para boolean.
 *
 * @internal
 */
function enforceBoolean(value) {
    return value != null && `${value}` !== 'false';
}
/**
 * função que verifica se o parâmetro passado é um número e devolve um booleano
 *
 * @internal
 */
function isNumber(value) {
    return !isNaN(parseFloat(value)) && !isNaN(Number(value));
}
/**
 * recebe um valor 'any' e força que o retorno seja um número
 *
 * @internal
 */
function enforceNumber(value, defaultValue = 0) {
    return isNumber(value) ? Number(value) : defaultValue;
}
function capitalizeText(text) {
    return `${text[0].toUpperCase()}${text.slice(1)}`;
}

/**
 * @internal
 */
const noop = (...args) => args;
const ɵ0 = noop;
// TODO: implementar forma de completar estado do formulário (formState)
/**
 * @internal
 */
function FormAcessorMixin(base) {
    class FormAcessor extends base {
        constructor(...args) {
            super(...args);
            this.formState = new Subject();
            this._value = null;
            this._disabled = false;
            this._focused = false;
            this._active = false;
            this.formAcessorChanged = noop;
            this.formAcessorTouched = noop;
            if (this.ngControl) {
                this.ngControl.valueAccessor = this;
            }
            this.errorState = this.formState.pipe(switchMap(() => {
                if (!this.ngControl) {
                    return of(null);
                }
                return of(this.ngControl.touched &&
                    this.ngControl.invalid &&
                    !this.active);
            }), filter(state => state !== null));
        }
        /**
         * Valor do componente
         *
         * *Value of the component*
         */
        set value(newValue) {
            if (newValue !== this._value) {
                this._value = newValue;
                this.formAcessorChanged(newValue);
            }
        }
        get value() { return this._value; }
        /**
         * Desabilita a edição do campo
         *
         * *Disables the field editing*
         */
        set disabled(disabled) { this._disabled = enforceBoolean(disabled); }
        get disabled() { return this._disabled; }
        set focused(focused) { this._focused = focused; }
        get focused() { return this._focused; }
        set active(active) { this._active = active; }
        get active() { return this._active; }
        formAcessorHandleFocus() {
            this.focused = true;
            this.formState.next();
        }
        formAcessorHandleBlur() {
            this.focused = false;
            this.active = false;
            this.formAcessorTouched();
            this.formState.next();
        }
        writeValue(newValue) {
            // tslint:disable-next-line:early-exit
            if (newValue !== this._value) {
                this._value = newValue;
                this.elementRef.nativeElement.value = newValue;
                this.formAcessorTouched();
            }
        }
        registerOnChange(fn) {
            this.formAcessorChanged = (value) => {
                if (this.focused) {
                    this.active = true;
                }
                fn(value);
                this.formState.next();
            };
        }
        registerOnTouched(fn) {
            this.formAcessorTouched = fn;
        }
        setDisabledState(isDisabled) {
            this._disabled = isDisabled;
            this.formState.next();
        }
    }
    FormAcessor.decorators = [
        { type: Directive }
    ];
    FormAcessor.ctorParameters = () => [
        { type: Array }
    ];
    FormAcessor.propDecorators = {
        value: [{ type: Input }],
        disabled: [{ type: Input }]
    };
    return FormAcessor;
}

/**
 * @internal
 */
class VclFieldBase {
    constructor(ngControl, elementRef, errorState) {
        this.ngControl = ngControl;
        this.elementRef = elementRef;
        this.errorState = errorState;
    }
}
/**
 * @internal
 */
// tslint:disable-next-line:directive-class-suffix
class VclFieldMixinBase extends FormAcessorMixin(VclFieldBase) {
    constructor(ngControl, elementRef) {
        super(ngControl, elementRef);
        this.ngControl = ngControl;
        this.elementRef = elementRef;
        this._controlAriaInvalid = null;
        this.controlDescribedBy = null;
    }
    get controlAriaInvalid() {
        return this._controlAriaInvalid;
    }
    set controlAriaInvalid(value) {
        this._controlAriaInvalid = value;
    }
    get nativeElement() {
        return this.elementRef.nativeElement;
    }
    a11yHandler(described, describedId) {
        this.controlDescribedBy = described ? null : describedId;
    }
    onErrorStatusChange(hasDescription, describedById, state) {
        this.controlDescribedBy = null;
        this.controlAriaInvalid = null;
        if (hasDescription) {
            this.controlDescribedBy = describedById;
        }
        if (state) {
            this.controlDescribedBy = describedById;
            this.controlAriaInvalid = state;
        }
    }
}
VclFieldMixinBase.ɵfac = function VclFieldMixinBase_Factory(t) { return new (t || VclFieldMixinBase)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NgControl, 10), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
VclFieldMixinBase.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VclFieldMixinBase, selectors: [["do-not-use-vcl-field-mixin-base"]], hostVars: 2, hostBindings: function VclFieldMixinBase_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-describedby", ctx.controlDescribedBy)("aria-invalid", ctx.controlAriaInvalid);
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
VclFieldMixinBase.ctorParameters = () => [
    { type: NgControl, decorators: [{ type: Self }, { type: Optional }] },
    { type: ElementRef }
];
VclFieldMixinBase.propDecorators = {
    controlDescribedBy: [{ type: HostBinding, args: ['attr.aria-describedby',] }],
    controlAriaInvalid: [{ type: HostBinding, args: ['attr.aria-invalid',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclFieldMixinBase, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: 'do-not-use-vcl-field-mixin-base'
            }]
    }], function () { return [{ type: ɵngcc3.NgControl, decorators: [{
                type: Self
            }, {
                type: Optional
            }] }, { type: ɵngcc0.ElementRef }]; }, { controlDescribedBy: [{
            type: HostBinding,
            args: ['attr.aria-describedby']
        }], controlAriaInvalid: [{
            type: HostBinding,
            args: ['attr.aria-invalid']
        }] }); })();

/**
 * @internal
 */
let NEXT_ID$7 = 0;
/**
 *  @internal
 *  Componente base para select.
 *
 * *Base component to select.*
 */
class VclOptionComponent {
    /**
     * @internal
     */
    constructor(segmentService, _element) {
        this.segmentService = segmentService;
        this._element = _element;
        this._selected = false;
        this._disabled = false;
        this._showing = true;
        /**
         *  Identificação única da opção.
         *
         * *Unique option identification.*
         */
        this.optionId = `vcl-option-${NEXT_ID$7++}`;
        /**
         * Evento disparado quando ouver mudança na opção.
         *
         * *Event fired when you hear a change in option.*
         */
        this.change = new EventEmitter();
        /**
         * @internal
         */
        this.segment = this.segmentService.segment;
    }
    /**
     * Indica se a opção ficara desabilitato.
     *
     * *Indicates whether the option will be disabled.*
     */
    get disabled() { return this._disabled; }
    set disabled(value) { this._disabled = enforceBoolean$1(value); }
    /**
     * Indica se a opção esta selecionada.
     *
     * *Indicates whether the option is selected.*
     */
    get selected() { return this._selected; }
    set selected(value) { this._selected = enforceBoolean$1(value); }
    /**
     * @internal
     */
    get showing() {
        return this._showing;
    }
    /**
     * @internal
     */
    get optionValue() {
        return (this._element.nativeElement.textContent || '').trim();
    }
    /**
     * @internal
     */
    get getOptionClasses() {
        return {
            'vcl-option--selected': this.selected,
            'vcl-option--disabled': this.disabled,
            'vcl-option--hide': !this.showing,
            'vcl-option': true,
            'voxel-txt-color-sand-900': true,
            'voxel-ph-lg': true,
        };
    }
    /**
     * @internal
     */
    getTabIndex() {
        return this.disabled ? '-1' : '0';
    }
    /**
     * @internal
     */
    select(close = false) {
        if (this.disabled) {
            return;
        }
        this._selected = true;
        this._emitOptionChangeEvent(close);
    }
    /**
     * @internal
     */
    deselect() {
        this._selected = false;
        this._emitOptionChangeEvent();
    }
    /**
     * @internal
     */
    show() {
        this._showing = true;
    }
    /**
     * @internal
     */
    hide() {
        this._showing = false;
    }
    /**
     * @internal
     */
    _emitOptionChangeEvent(_close) {
        this.change.emit({ option: this, close: _close });
    }
}
VclOptionComponent.ɵfac = function VclOptionComponent_Factory(t) { return new (t || VclOptionComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.VoxelSegmentService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
VclOptionComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VclOptionComponent, selectors: [["vcl-option"]], viewQuery: function VclOptionComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c9, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.option = _t.first);
    } }, hostAttrs: ["tabindex", "-1"], inputs: { optionId: "optionId", disabled: "disabled", selected: "selected", value: "value" }, outputs: { change: "change" }, ngContentSelectors: _c3, decls: 6, vars: 11, consts: [["role", "option", 3, "ngClass", "tabindex", "id", "click"], ["option", ""], [1, "vcl-option__wrapper"], [1, "vcl-option__wrapper-text", 3, "ngClass"]], template: function VclOptionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵlistener("click", function VclOptionComponent_Template_div_click_0_listener() { return ctx.select(true); });
        ɵngcc0.ɵɵpipe(2, "async");
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵelementStart(4, "span", 3);
        ɵngcc0.ɵɵprojection(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ɵngcc0.ɵɵpipeBind1(2, 9, ctx.segment));
        ɵngcc0.ɵɵproperty("ngClass", ctx.getOptionClasses)("tabindex", ctx.getTabIndex())("id", ctx.optionId);
        ɵngcc0.ɵɵattribute("aria-selected", ctx.selected)("aria-disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngClass", ctx.selected ? "voxel-text-m-bd" : "voxel-text-m");
    } }, directives: [ɵngcc2.NgClass], pipes: [ɵngcc2.AsyncPipe], styles: ["[_nghost-%COMP%]{display:block}.vcl-option[_ngcontent-%COMP%]{height:3rem;display:flex;align-items:center;padding:0 1.5rem;cursor:pointer}.vcl-option[_ngcontent-%COMP%]   .vcl-option__wrapper[_ngcontent-%COMP%]{width:100%;height:100%;display:flex;align-items:center;border-bottom:1px solid #efe9e5}.vcl-option[_ngcontent-%COMP%]   .vcl-option__wrapper-text[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.vcl-option[_ngcontent-%COMP%]:hover{background-color:#efe9e5}.vcl-option--selected[_ngcontent-%COMP%]{border-left:.25rem solid;padding-left:1.25rem}.vcl-option--hide[_ngcontent-%COMP%]{display:none}.vcl-option--disabled[_ngcontent-%COMP%]{color:#d6d0cc;pointer-events:none}.varejo.vcl-option[_ngcontent-%COMP%]{border-color:#ec7000}.personnalite.vcl-option[_ngcontent-%COMP%]{border-color:#d0a967}.uniclass.vcl-option[_ngcontent-%COMP%]{border-color:#ec7000}.empresas.vcl-option[_ngcontent-%COMP%]{border-color:#ec7000}.itaucard.vcl-option[_ngcontent-%COMP%]{border-color:#ec7000}.private.vcl-option[_ngcontent-%COMP%]{border-color:#ec7000}.parceiro-itaucard.vcl-option[_ngcontent-%COMP%]{border-color:#ec7000}.parceiro-credicard.vcl-option[_ngcontent-%COMP%]{border-color:#0d456f}.parceiro-hipercard.vcl-option[_ngcontent-%COMP%]{border-color:#ba1319}.parceiro-magazine-luiza.vcl-option[_ngcontent-%COMP%]{border-color:#0083ca}.personal-bank.vcl-option[_ngcontent-%COMP%]{border-color:#ce9141}.itau-bba.vcl-option[_ngcontent-%COMP%]{border-color:#2449cc}.varejo.vcl-option--selected[_ngcontent-%COMP%]{color:#ec7000}.personnalite.vcl-option--selected[_ngcontent-%COMP%]{color:#d0a967}.uniclass.vcl-option--selected[_ngcontent-%COMP%]{color:#ec7000}.empresas.vcl-option--selected[_ngcontent-%COMP%]{color:#ec7000}.itaucard.vcl-option--selected[_ngcontent-%COMP%]{color:#ec7000}.private.vcl-option--selected[_ngcontent-%COMP%]{color:#ec7000}.parceiro-itaucard.vcl-option--selected[_ngcontent-%COMP%]{color:#ec7000}.parceiro-credicard.vcl-option--selected[_ngcontent-%COMP%]{color:#0d456f}.parceiro-hipercard.vcl-option--selected[_ngcontent-%COMP%]{color:#ba1319}.parceiro-magazine-luiza.vcl-option--selected[_ngcontent-%COMP%]{color:#0083ca}.personal-bank.vcl-option--selected[_ngcontent-%COMP%]{color:#ce9141}.itau-bba.vcl-option--selected[_ngcontent-%COMP%]{color:#2449cc}.personnalite.vcl-option[_ngcontent-%COMP%]{border-color:#876632}"] });
VclOptionComponent.ctorParameters = () => [
    { type: VoxelSegmentService },
    { type: ElementRef }
];
VclOptionComponent.propDecorators = {
    optionId: [{ type: Input }],
    value: [{ type: Input }],
    disabled: [{ type: Input }],
    selected: [{ type: Input }],
    change: [{ type: Output }],
    option: [{ type: ViewChild, args: ['option', { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclOptionComponent, [{
        type: Component,
        args: [{
                selector: 'vcl-option',
                template: "<div\n  #option\n  class=\"{{ segment | async }}\"\n  [ngClass]=\"getOptionClasses\"\n  [tabindex]=\"getTabIndex()\"\n  (click)=\"select(true)\"\n  role=\"option\"\n  [attr.aria-selected]=\"selected\"\n  [attr.aria-disabled]=\"disabled\"\n  [id]=\"optionId\"\n>\n  <div class=\"vcl-option__wrapper\">\n    <span class=\"vcl-option__wrapper-text\" [ngClass]=\"selected ? 'voxel-text-m-bd' : 'voxel-text-m'\"><ng-content></ng-content></span>\n  </div>\n</div>\n",
                // tslint:disable-next-line: no-host-metadata-property
                host: {
                    tabindex: '-1'
                },
                styles: [":host{display:block}.vcl-option{height:3rem;display:flex;align-items:center;padding:0 1.5rem;cursor:pointer}.vcl-option .vcl-option__wrapper{width:100%;height:100%;display:flex;align-items:center;border-bottom:1px solid #efe9e5}.vcl-option .vcl-option__wrapper-text{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.vcl-option:hover{background-color:#efe9e5}.vcl-option--selected{border-left:.25rem solid;padding-left:1.25rem}.vcl-option--hide{display:none}.vcl-option--disabled{color:#d6d0cc;pointer-events:none}.varejo.vcl-option{border-color:#ec7000}.personnalite.vcl-option{border-color:#d0a967}.uniclass.vcl-option{border-color:#ec7000}.empresas.vcl-option{border-color:#ec7000}.itaucard.vcl-option{border-color:#ec7000}.private.vcl-option{border-color:#ec7000}.parceiro-itaucard.vcl-option{border-color:#ec7000}.parceiro-credicard.vcl-option{border-color:#0d456f}.parceiro-hipercard.vcl-option{border-color:#ba1319}.parceiro-magazine-luiza.vcl-option{border-color:#0083ca}.personal-bank.vcl-option{border-color:#ce9141}.itau-bba.vcl-option{border-color:#2449cc}.varejo.vcl-option--selected{color:#ec7000}.personnalite.vcl-option--selected{color:#d0a967}.uniclass.vcl-option--selected{color:#ec7000}.empresas.vcl-option--selected{color:#ec7000}.itaucard.vcl-option--selected{color:#ec7000}.private.vcl-option--selected{color:#ec7000}.parceiro-itaucard.vcl-option--selected{color:#ec7000}.parceiro-credicard.vcl-option--selected{color:#0d456f}.parceiro-hipercard.vcl-option--selected{color:#ba1319}.parceiro-magazine-luiza.vcl-option--selected{color:#0083ca}.personal-bank.vcl-option--selected{color:#ce9141}.itau-bba.vcl-option--selected{color:#2449cc}.personnalite.vcl-option{border-color:#876632}\n"]
            }]
    }], function () { return [{ type: ɵngcc1.VoxelSegmentService }, { type: ɵngcc0.ElementRef }]; }, { optionId: [{
            type: Input
        }], change: [{
            type: Output
        }], disabled: [{
            type: Input
        }], selected: [{
            type: Input
        }], value: [{
            type: Input
        }], option: [{
            type: ViewChild,
            args: ['option', { static: true }]
        }] }); })();

/**
 * Dados dos eventos do autocomplete
 *
 * *Select event data*
 */
class IVclAutocompleteEvent {
    /**
     * @internal
     */
    constructor(source, value) {
        this.source = source;
        this.value = value;
    }
}
/**
 * @internal
 */
let NEXT_ID$6 = 0;
/**
 * Autocomplete é um tipo de input utilizado em formulários, no qual o usuário tem a possibilidade de filtrar
 * fazer uma escolha dentre uma lista de opções (4 ou mais), que são exibidas após o clique no componente.
 *
 * *Autocomplete is a type of input used in forms, in which the user has the possibility to filter and make
 * a choice from a list of options (4 or more), which are displayed after clicking on the component.*
 *
 * ### Acessible
 *
 * <acessible class="not-tested">Acessibilidade - Não testado</acessible>
 *
 * ### Module
 *
 * `import { VclAutocompleteModule } from '@voxel/community';`
 *
 * <example-url>../../demo/index.html#/portfolio/components/autocomplete?componentOnly=true</example-url>
 * @example simples
 * <vcl-autocomplete
 *  placeholder="Simples"
 * >
 *  <vcl-option value="Label1">Label 1</vcl-option>
 *  <vcl-option value="Label2" disabled>Label 2</vcl-option>
 *  <vcl-option value="Label3">Label 3</vcl-option>
 * </vcl-autocomplete>
 *
 * @example desabilitado
 * <vcl-autocomplete
 *  placeholder="Simples"
 *  disabled
 * >
 *  <vcl-option value="Label1">Label 1</vcl-option>
 *  <vcl-option value="Label2">Label 2</vcl-option>
 *  <vcl-option value="Label3" selected>Label 3</vcl-option>
 * </vcl-autocomplete>
 *
 * @example simples
 * <vcl-autocomplete
 *  placeholder="Simples"
 *  required
 * >
 *  <vcl-option value="Label1">Label 1</vcl-option>
 *  <vcl-option value="Label2">Label 2</vcl-option>
 *  <vcl-option value="Label3">Label 3</vcl-option>
 * </vcl-autocomplete>
 */
class VclAutocompleteComponent extends VclFieldMixinBase {
    /**
     * @internal
     */
    constructor(ngControl, elementRef, segmentService, liveAnnouncer) {
        super(ngControl, elementRef) /* istanbul ignore next */;
        this.ngControl = ngControl;
        this.elementRef = elementRef;
        this.segmentService = segmentService;
        this.liveAnnouncer = liveAnnouncer;
        /**
         *  Identificação única do autocomplete.
         *
         *  *Unique autocomplete identification.*
         */
        this.id = `vcl-autocomplete-${NEXT_ID$6++}`;
        /**
         * Título de texto não encontrado
         *
         * *Not found text title*
         */
        this.notFoundTitle = 'Nenhum resultado encontrado';
        /**
         * Mensagem de texto não encontrado
         *
         * *Not found text message*
         */
        this.notFoundMessage = 'Tente novamente utilizando outras palavras.';
        /**
         * Ícone do autocomplete
         *
         * *Autocomplete icon*
         */
        this.icon = 'seta_baixo';
        /**
         * Define se o ícone irá girar 180 graus ao abrir/fechar
         *
         * *Defines if the icon will rotate 180 degrees when open/close*
         */
        this.rotateIcon = true;
        /**
         * Evento disparado com a mudança no autocomplete.
         *
         * *Event triggered with the change in the autocomplete.*
         */
        this.change = new EventEmitter();
        /**
         * Evento disparado com o focus no autocomplete.
         *
         * *Event triggered with focus on autocomplete.*
         */
        this.focus = new EventEmitter();
        /**
         * Evento disparado com o blur no autocomplete.
         *
         * *Event triggered with blur on autocomplete.*
         */
        this.blur = new EventEmitter();
        /**
         * @internal
         */
        this._panelOpen = false;
        /**
         * @internal
         */
        this._destroy = new Subject();
        /**
         * @internal
         */
        this._panelId = `vcl-autocomplete__panel-options-${NEXT_ID$6}`;
        /**
         * @internal
         */
        this.controlId = `vcl-autocomplete__input-${NEXT_ID$6}`;
        /**
         * @internal
         */
        this.labelId = `vcl-autocomplete-label-${NEXT_ID$6}`;
        /**
         * @internal
         */
        this.autocompleteSearch = false;
        /**
         * @internal
         */
        this.autocompleteInSearch = false;
        /**
         * @internal
         */
        this.segment = this.segmentService.segment;
        /**
         * @internal
         */
        this._positions = [
            {
                originX: 'start',
                originY: 'bottom',
                overlayX: 'start',
                overlayY: 'top',
            },
            {
                originX: 'start',
                originY: 'top',
                overlayX: 'start',
                overlayY: 'bottom',
            },
        ];
    }
    /**
     * Indica se o autocomplete é obrigatório.
     *
     * *Indicates whether autocomplete is mandatory.*
     */
    set required(value) { this._required = enforceBoolean$1(value); }
    get required() { return this._required; }
    /**
     * @internal
     */
    get panelOpen() {
        return this._panelOpen;
    }
    /**
     * @internal
     */
    get autocompleteWidth() {
        return this._autocompleteWidth;
    }
    /**
     * @internal
     */
    get panelId() {
        return this._panelId;
    }
    /**
     * @internal
     */
    get optionSeleted() {
        return this._lastOptionSeleted;
    }
    /**
     * @internal
     */
    get arrayOption() {
        return this.options.toArray();
    }
    /**
     * @internal
     */
    get enableOption() {
        return this.arrayOption.filter(item => !item.disabled && item.showing);
    }
    /**
     * @internal
     */
    get optionTextValue() {
        if (!this.autocompleteSearch) {
            return this.optionSeleted ? this.optionSeleted.optionValue : '';
        }
        return this.searchNoResults;
    }
    /**
     * @internal
     */
    onInputResize() {
        this._autocompleteWidth = this.autocomplete.nativeElement.offsetWidth;
    }
    /**
     * @internal
     */
    ngAfterViewInit() {
        this.options.changes
            .pipe(startWith(this.options), map(() => this.options), takeUntil(this._destroy))
            .subscribe(() => {
            this.options.map((option) => option.change
                .pipe(takeUntil(this._destroy))
                .subscribe((_event) => {
                if (option.selected) {
                    this.selectOption(option, _event.close);
                }
            }));
            this.initializeSelection(this.ngControl ? this.ngControl.value : this.value);
        });
    }
    /**
     * @internal
     */
    ngOnDestroy() {
        this._destroy.complete();
    }
    /**
     * @internal
     */
    initializeSelection(value) {
        Promise.resolve().then(() => {
            const optionSelected = this.enableOption.find(opt => opt.value === value);
            const initialSelect = this.arrayOption.filter(opt => opt.selected);
            if (optionSelected) {
                optionSelected.select();
                this.arrayOption.filter(opt => {
                    if (opt.selected && opt.value !== optionSelected.value) {
                        opt.deselect();
                    }
                });
            }
            if (initialSelect.length > 0 && !optionSelected) {
                this.selectOption(initialSelect[initialSelect.length - 1]);
            }
        });
    }
    /**
     * @internal
     */
    onFocus() {
        this.formAcessorHandleFocus();
        this.focus.emit(new IVclAutocompleteEvent(this, this.value));
    }
    /**
     * @internal
     */
    onBlur() {
        this.formAcessorHandleBlur();
        this.blur.emit(new IVclAutocompleteEvent(this, this.value));
    }
    /**
     * @internal
     */
    onSelect(_event) {
        _event.target.selectionStart = _event.target.selectionEnd;
    }
    /**
     * @internal
     */
    toggle() {
        this.panelOpen ? this.close() : this.open();
    }
    /**
     * @internal
     */
    open() {
        this._panelOpen = true;
        this.onInputResize();
        if (!this.focused) {
            this.autocompleteInput.nativeElement.focus();
        }
        if (!this.optionSeleted) {
            return;
        }
        this.arrayOption.map(option => {
            this.normalizeText(option.optionValue).includes(this.normalizeText(this.optionSeleted.optionValue)) && !option.disabled
                ? option.show()
                : option.hide();
        });
    }
    /**
     * @internal
     */
    attached() {
        this.overlayDir.positionChange.pipe(take(1)).subscribe(() => {
            this.setScrollPosition(this.optionSeleted);
        });
    }
    /**
     * @internal
     */
    close() {
        this._panelOpen = false;
        if (this.autocompleteSearch) {
            this.resetSearch();
        }
    }
    /**
     * @internal
     */
    updateValueSelect(autocompleteOption) {
        if (!this._lastOptionSeleted || !(this._lastOptionSeleted.value === autocompleteOption.value)) {
            this.value = autocompleteOption.value;
            this._emitSelectChangeEvent();
        }
        this._lastOptionSeleted = autocompleteOption;
    }
    /**
     * @internal
     */
    selectOption(autocompleteOption, close) {
        if (this.optionSeleted && !(this.optionSeleted.value === autocompleteOption.value)) {
            this.optionSeleted.deselect();
        }
        if (close) {
            this.close();
        }
        this.updateValueSelect(autocompleteOption);
        this.setScrollPosition(autocompleteOption);
    }
    /**
     * @internal
     */
    setSelectOptionByIndex(index = 1) {
        const optionSelected = this._lastOptionSeleted ? this.enableOption.findIndex(opt => opt.selected) : -1;
        if (this.enableOption[optionSelected + index] && !this.autocompleteSearch) {
            this.enableOption[optionSelected + index].select();
        }
        if (this.autocompleteSearch && this.hasSearch && this.enableOption[optionSelected + index]) {
            this.enableOption[optionSelected + index].select();
        }
    }
    /**
     * @internal
     */
    handleKeydown(_event) {
        this.panelOpen ? this.handleOpenKeydown(_event) : this.handleClosedKeydown(_event);
    }
    /**
     * @internal
     */
    handleClosedKeydown(_event) {
        const isOpenKey = _event.code === 'Enter' || _event.code === 'NumpadEnter' || _event.code === 'Space';
        const isArrowKey = _event.code === 'ArrowUp' || _event.code === 'ArrowDown' ||
            _event.code === 'ArrowLeft' || _event.code === 'ArrowRight';
        if (isOpenKey && !this.autocompleteInSearch || (_event.altKey && isArrowKey)) {
            _event.preventDefault();
            this.open();
        }
        if (_event.code === 'Home') {
            _event.preventDefault();
            this.enableOption[0].select();
        }
        if (_event.code === 'End') {
            _event.preventDefault();
            this.enableOption[this.enableOption.length - 1].select();
        }
        if ((_event.code === 'ArrowUp' || _event.code === 'ArrowLeft') && !_event.altKey) {
            _event.preventDefault();
            this.setSelectOptionByIndex(-1);
        }
        if ((_event.code === 'ArrowDown' || _event.code === 'ArrowRight') && !_event.altKey) {
            _event.preventDefault();
            this.setSelectOptionByIndex(1);
        }
        return;
    }
    /**
     * @internal
     */
    handleOpenKeydown(_event) {
        const isEnterKey = _event.code === 'Enter' || _event.code === 'NumpadEnter';
        const isArrowKey = _event.code === 'ArrowUp' || _event.code === 'ArrowDown';
        if (_event.shiftKey && !this.focused) {
            this.autocompleteInput.nativeElement.focus();
        }
        if (isEnterKey ||
            _event.code === 'Tab' ||
            _event.code === 'Escape' ||
            (isArrowKey && _event.altKey) ||
            (_event.code === 'Space' && !this.autocompleteInSearch)) {
            _event.preventDefault();
            this.close();
        }
        if (_event.code === 'Home') {
            _event.preventDefault();
            this.selectOption(this.enableOption[0]);
        }
        if (_event.code === 'End') {
            _event.preventDefault();
            this.selectOption(this.enableOption[this.enableOption.length - 1]);
        }
        if (_event.code === 'ArrowUp' && !_event.altKey) {
            _event.preventDefault();
            this.setSelectOptionByIndex(-1);
            this.autocompleteInSearch = false;
        }
        if (_event.code === 'ArrowDown' && !_event.altKey) {
            _event.preventDefault();
            this.setSelectOptionByIndex(1);
            this.autocompleteInSearch = false;
            if (!this.hasSearch && this.autocompleteSearch) {
                this.liveAnnouncer.announce(`${this.notFoundTitle} ${this.notFoundMessage}`, 10000);
            }
        }
        return;
    }
    /**
     * @internal
     */
    searchOptions(_event) {
        const searchValue = this.normalizeText(_event.target.value);
        this.autocompleteInSearch = true;
        if (!this.panelOpen) {
            this.open();
        }
        if (!this.autocompleteSearch) {
            if (this.optionSeleted) {
                this.clearSelectedValue();
                if (!searchValue) {
                    return;
                }
            }
            this.autocompleteSearch = true;
        }
        else if (!searchValue) {
            this.resetSearch();
            this.autocompleteSearch = false;
            return;
        }
        this.arrayOption.map(option => {
            this.normalizeText(option.optionValue).includes(searchValue) && !option.disabled ? option.show() : option.hide();
        });
        this.hasSearch = this.arrayOption.find(option => this.normalizeText(option.optionValue).includes(searchValue) && !option.disabled);
        this.searchNoResults = _event.target.value;
    }
    /**
     * @internal
     */
    resetSearch() {
        this.autocompleteSearch = false;
        this.autocompleteInSearch = false;
        this.searchNoResults = '';
        this.arrayOption.map(option => option.show());
    }
    /**
     * @internal
     */
    clearSelectedValue() {
        this.resetSearch();
        this.optionSeleted.deselect();
        this._lastOptionSeleted = undefined;
        this.value = '';
        this._emitSelectChangeEvent();
    }
    /**
     * @internal
     */
    normalizeText(text) {
        return text && text.length > 0
            ? text
                .normalize('NFKD')
                .replace(/[\u0080-\uF8FF]/g, '')
                .toLocaleLowerCase()
            : '';
    }
    /**
     * @internal
     */
    setScrollPosition(option) {
        if (option && this.panel) {
            const positionScroll = option.option.nativeElement.offsetTop - this.panel.nativeElement.scrollTop;
            if (positionScroll >= this.panel.nativeElement.offsetHeight - 9) {
                option.option.nativeElement.scrollIntoView(false);
            }
            if (positionScroll < 0) {
                option.option.nativeElement.scrollIntoView(true);
            }
        }
        return;
    }
    /**
     * @internal
     */
    getAriaActiveDescendant() {
        if (this.panelOpen && this.optionSeleted) {
            return this.optionSeleted.optionId;
        }
        return null;
    }
    /**
     * @internal
     */
    _emitSelectChangeEvent() {
        this.change.emit(new IVclAutocompleteEvent(this, this.value));
    }
    /**
     * @internal
     */
    clearSearch() {
        if (this.optionSeleted) {
            this.clearSelectedValue();
        }
        else {
            this.resetSearch();
        }
        this.value = '';
        this.autocompleteInput.nativeElement.focus();
    }
}
VclAutocompleteComponent.ɵfac = function VclAutocompleteComponent_Factory(t) { return new (t || VclAutocompleteComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NgControl, 10), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.VoxelSegmentService), ɵngcc0.ɵɵdirectiveInject(ɵngcc4.LiveAnnouncer)); };
VclAutocompleteComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VclAutocompleteComponent, selectors: [["vcl-autocomplete"]], contentQueries: function VclAutocompleteComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, VclOptionComponent, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.options = _t);
    } }, viewQuery: function VclAutocompleteComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c10, 7);
        ɵngcc0.ɵɵviewQuery(_c11, 7);
        ɵngcc0.ɵɵviewQuery(_c12, 5);
        ɵngcc0.ɵɵviewQuery(CdkConnectedOverlay, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.autocomplete = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.autocompleteInput = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.panel = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.overlayDir = _t.first);
    } }, hostBindings: function VclAutocompleteComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function VclAutocompleteComponent_resize_HostBindingHandler() { return ctx.onInputResize(); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { id: "id", notFoundTitle: "notFoundTitle", notFoundMessage: "notFoundMessage", icon: "icon", rotateIcon: "rotateIcon", required: "required", placeholder: "placeholder", tabindex: "tabindex" }, outputs: { change: "change", focus: "focus", blur: "blur" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: VclFieldMixinBase,
                useExisting: forwardRef(() => VclAutocompleteComponent)
            }]), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c16, decls: 12, vars: 43, consts: [["cdkOverlayOrigin", ""], ["autocomplete", "", "origin", "cdkOverlayOrigin"], ["role", "combobox", "type", "text", "autocomplete", "off", "aria-haspopup", "listbox", 3, "id", "ngClass", "value", "disabled", "required", "tabindex", "placeholder", "click", "keydown", "focus", "blur", "autocomplete", "input"], ["autocompleteInput", ""], ["class", "vcl-autocomplete__clear-icon icon-itaufonts_fechar", 3, "click", 4, "ngIf"], ["class", "vcl-autocomplete__icon-separator", 4, "ngIf"], [3, "ngClass", "click"], ["cdkConnectedOverlay", "", "cdkConnectedOverlayLockPosition", "", "cdkConnectedOverlayHasBackdrop", "", "cdkConnectedOverlayBackdropClass", "cdk-overlay-transparent-backdrop", 3, "cdkConnectedOverlayOrigin", "cdkConnectedOverlayOpen", "cdkConnectedOverlayPositions", "cdkConnectedOverlayWidth", "cdkConnectedOverlayOffsetY", "backdropClick", "attach", "detach"], [1, "vcl-autocomplete__clear-icon", "icon-itaufonts_fechar", 3, "click"], [1, "vcl-autocomplete__icon-separator"], ["role", "listbox", 1, "vcl-autocomplete__panel-options", 3, "id", "keydown"], ["panel", ""], ["role", "alert", 3, "class", 4, "ngIf"], ["role", "alert"], [1, "vcl-autocomplete__not-options__wrapper"], [1, "vcl-autocomplete__not-options__wrapper__text", "voxel-text-m-bd"], [1, "vcl-autocomplete__not-options__wrapper__text", "voxel-text-m"]], template: function VclAutocompleteComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c13);
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵpipe(3, "async");
        ɵngcc0.ɵɵelementStart(4, "input", 2, 3);
        ɵngcc0.ɵɵlistener("click", function VclAutocompleteComponent_Template_input_click_4_listener() { return ctx.toggle(); })("keydown", function VclAutocompleteComponent_Template_input_keydown_4_listener($event) { return ctx.handleKeydown($event); })("focus", function VclAutocompleteComponent_Template_input_focus_4_listener() { return ctx.onFocus(); })("blur", function VclAutocompleteComponent_Template_input_blur_4_listener() { return ctx.onBlur(); })("autocomplete", function VclAutocompleteComponent_Template_input_autocomplete_4_listener($event) { return ctx.onSelect($event); })("input", function VclAutocompleteComponent_Template_input_input_4_listener($event) { return ctx.searchOptions($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, VclAutocompleteComponent_span_6_Template, 1, 0, "span", 4);
        ɵngcc0.ɵɵtemplate(7, VclAutocompleteComponent_div_7_Template, 1, 0, "div", 5);
        ɵngcc0.ɵɵelementStart(8, "voxel-icon", 6);
        ɵngcc0.ɵɵlistener("click", function VclAutocompleteComponent_Template_voxel_icon_click_8_listener() { return ctx.toggle(); });
        ɵngcc0.ɵɵpipe(9, "async");
        ɵngcc0.ɵɵtext(10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(11, VclAutocompleteComponent_ng_template_11_Template, 4, 4, "ng-template", 7);
        ɵngcc0.ɵɵlistener("backdropClick", function VclAutocompleteComponent_Template_ng_template_backdropClick_11_listener() { return ctx.close(); })("attach", function VclAutocompleteComponent_Template_ng_template_attach_11_listener() { return ctx.attached(); })("detach", function VclAutocompleteComponent_Template_ng_template_detach_11_listener() { return ctx.close(); });
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵclassMapInterpolate1("vcl-autocomplete ", ɵngcc0.ɵɵpipeBind1(3, 31, ctx.segment), "");
        ɵngcc0.ɵɵclassProp("vcl-autocomplete--disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("id", ctx.controlId)("ngClass", ɵngcc0.ɵɵpureFunction2(35, _c14, ctx.disabled, !ctx.disabled))("value", ctx.optionTextValue)("disabled", ctx.disabled)("required", ctx.required)("tabindex", ctx.tabindex)("placeholder", ctx.placeholder);
        ɵngcc0.ɵɵattribute("aria-required", ctx.required)("aria-disabled", ctx.disabled)("aria-expanded", ctx.panelOpen)("aria-describedby", ctx.controlDescribedBy)("aria-invalid", ctx.controlAriaInvalid)("aria-activedescendant", ctx.getAriaActiveDescendant())("aria-owns", ctx.panelId);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.autocompleteSearch || ctx.optionSeleted && ctx.panelOpen);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.autocompleteSearch || ctx.optionSeleted && ctx.panelOpen);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ɵngcc0.ɵɵpipeBind1(9, 33, ctx.segment));
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction4(38, _c15, ctx.disabled, ctx.disabled, ctx.panelOpen, ctx.rotateIcon));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.icon, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("cdkConnectedOverlayOrigin", _r1)("cdkConnectedOverlayOpen", ctx.panelOpen)("cdkConnectedOverlayPositions", ctx._positions)("cdkConnectedOverlayWidth", ctx.autocompleteWidth)("cdkConnectedOverlayOffsetY", 0);
    } }, directives: [ɵngcc5.CdkOverlayOrigin, ɵngcc2.NgClass, ɵngcc2.NgIf, ɵngcc1.VoxelIconComponent, ɵngcc5.CdkConnectedOverlay], pipes: [ɵngcc2.AsyncPipe], styles: [".cdk-overlay-container,.cdk-global-overlay-wrapper{pointer-events:none;top:0;left:0;height:100%;width:100%}.cdk-overlay-container{position:fixed;z-index:1000}.cdk-overlay-container:empty{display:none}.cdk-global-overlay-wrapper{display:flex;position:absolute;z-index:1000}.cdk-overlay-pane{position:absolute;pointer-events:auto;box-sizing:border-box;z-index:1000;display:flex;max-width:100%;max-height:100%}.cdk-overlay-backdrop{position:absolute;top:0;bottom:0;left:0;right:0;z-index:1000;pointer-events:auto;-webkit-tap-highlight-color:transparent;transition:opacity .4s cubic-bezier(.25,.8,.25,1);opacity:0}.cdk-overlay-backdrop.cdk-overlay-backdrop-showing{opacity:1}.cdk-high-contrast-active .cdk-overlay-backdrop.cdk-overlay-backdrop-showing{opacity:.6}.cdk-overlay-dark-backdrop{background:rgba(0,0,0,.32)}.cdk-overlay-transparent-backdrop,.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing{opacity:0}.cdk-overlay-connected-position-bounding-box{position:absolute;z-index:1000;display:flex;flex-direction:column;min-width:1px;min-height:1px}.cdk-global-scrollblock{position:fixed;width:100%;overflow-y:scroll}.cdk-visually-hidden{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;white-space:nowrap;outline:0;-webkit-appearance:none;-moz-appearance:none}:host{display:block;width:100%}.vcl-autocomplete{position:relative;display:flex;justify-content:space-between;align-items:center;background-color:transparent;padding-bottom:8px;line-height:2rem}.vcl-autocomplete--disabled{pointer-events:none}.vcl-autocomplete__text{width:100%;border:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;background-color:transparent;cursor:pointer}.vcl-autocomplete__text:disabled{background:none}.vcl-autocomplete__clear-icon{position:relative;z-index:1500;color:#56504c;cursor:pointer;padding-left:16px}.vcl-autocomplete__clear-icon:before{font-size:1rem}.vcl-autocomplete__icon-separator{width:1px;height:16px;margin:0 10px 0 14px;background-color:#efe9e5}.vcl-autocomplete__icon{transition:.2s linear;cursor:pointer}.vcl-autocomplete__icon--open.rotate{transform:rotateX(180deg)}.vcl-autocomplete__panel-options{border:.0625rem solid #efe9e5;box-shadow:0 .25rem .5rem #7a6d603d;border:none;background-color:#fff;width:100%;max-height:17.1rem;overflow-y:auto;border-radius:0 0 4px 4px;padding:.5rem 0}.vcl-autocomplete__not-options{display:flex;align-items:center;padding:1rem 1.5rem}.vcl-autocomplete__not-options__wrapper{display:block}.vcl-autocomplete__not-options__wrapper__text{display:block}.vcl-autocomplete__not-options__wrapper__text:first-child{padding-bottom:.5rem}.varejo.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled){color:#ec7000}.varejo.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled):disabled{color:#ff8a20}.personnalite.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled){color:#d0a967}.personnalite.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled):disabled{color:#dcbf8e}.uniclass.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled){color:#ec7000}.uniclass.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled):disabled{color:#ff8a20}.empresas.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled){color:#ec7000}.empresas.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled):disabled{color:#ff8a20}.itaucard.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled){color:#ec7000}.itaucard.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled):disabled{color:#ff8a20}.private.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled){color:#ec7000}.private.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled):disabled{color:#ff8a20}.parceiro-itaucard.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled){color:#ec7000}.parceiro-itaucard.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled):disabled{color:#ff8a20}.parceiro-credicard.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled){color:#0d456f}.parceiro-credicard.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled):disabled{color:#12619d}.parceiro-hipercard.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled){color:#ba1319}.parceiro-hipercard.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled):disabled{color:#e71920}.parceiro-magazine-luiza.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled){color:#0083ca}.parceiro-magazine-luiza.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled):disabled{color:#00a4fd}.personal-bank.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled){color:#ce9141}.personal-bank.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled):disabled{color:#d8a86a}.itau-bba.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled){color:#2449cc}.itau-bba.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled):disabled{color:#4567de}.personnalite.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled){color:#876632}\n"], encapsulation: 2 });
/**
 * @internal
 */
VclAutocompleteComponent.selector = 'vcl-autocomplete';
VclAutocompleteComponent.ctorParameters = () => [
    { type: NgControl, decorators: [{ type: Self }, { type: Optional }] },
    { type: ElementRef },
    { type: VoxelSegmentService },
    { type: LiveAnnouncer }
];
VclAutocompleteComponent.propDecorators = {
    options: [{ type: ContentChildren, args: [VclOptionComponent,] }],
    autocomplete: [{ type: ViewChild, args: ['autocomplete', { static: true },] }],
    autocompleteInput: [{ type: ViewChild, args: ['autocompleteInput', { static: true },] }],
    panel: [{ type: ViewChild, args: ['panel',] }],
    overlayDir: [{ type: ViewChild, args: [CdkConnectedOverlay, { static: true },] }],
    required: [{ type: Input }],
    id: [{ type: Input }],
    placeholder: [{ type: Input }],
    notFoundTitle: [{ type: Input }],
    notFoundMessage: [{ type: Input }],
    tabindex: [{ type: Input }],
    icon: [{ type: Input }],
    rotateIcon: [{ type: Input }],
    change: [{ type: Output }],
    focus: [{ type: Output }],
    blur: [{ type: Output }],
    onInputResize: [{ type: HostListener, args: ['window:resize',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclAutocompleteComponent, [{
        type: Component,
        args: [{
                selector: 'vcl-autocomplete',
                template: "<div\n  #autocomplete\n  class=\"vcl-autocomplete {{ segment | async }}\"\n  [class.vcl-autocomplete--disabled]=\"disabled\"\n  cdkOverlayOrigin\n  #origin=\"cdkOverlayOrigin\"\n>\n  <input\n    #autocompleteInput\n    [id]=\"controlId\"\n    role=\"combobox\"\n    type=\"text\"\n    autocomplete=\"off\"\n    [ngClass]=\"{\n      'vcl-autocomplete__text': true,\n      'voxel-txt-color-sand-200': disabled,\n      'voxel-txt-color-sand-900': !disabled,\n      'voxel-text-l': true\n    }\"\n    (click)=\"toggle()\"\n    (keydown)=\"handleKeydown($event)\"\n    [attr.aria-required]=\"required\"\n    [attr.aria-disabled]=\"disabled\"\n    [attr.aria-expanded]=\"panelOpen\"\n    [attr.aria-describedby]=\"controlDescribedBy\"\n    [attr.aria-invalid]=\"controlAriaInvalid\"\n    [attr.aria-activedescendant]=\"getAriaActiveDescendant()\"\n    [attr.aria-owns]=\"panelId\"\n    aria-haspopup=\"listbox\"\n    [value]=\"optionTextValue\"\n    [disabled]=\"disabled\"\n    [required]=\"required\"\n    [tabindex]=\"tabindex\"\n    [placeholder]=\"placeholder\"\n    (focus)=\"onFocus()\"\n    (blur)=\"onBlur()\"\n    (autocomplete)=\"onSelect($event)\"\n    (input)=\"searchOptions($event)\"\n  />\n\n  <span\n    *ngIf=\"autocompleteSearch || (optionSeleted && panelOpen)\"\n    class=\"vcl-autocomplete__clear-icon icon-itaufonts_fechar\"\n    (click)=\"clearSearch()\"></span>\n\n  <div *ngIf=\"autocompleteSearch || (optionSeleted && panelOpen)\" class=\"vcl-autocomplete__icon-separator\"></div>\n\n  <voxel-icon\n    class=\"{{ segment | async }}\"\n    [ngClass]=\"{\n      'vcl-autocomplete__icon': true,\n      'vcl-autocomplete__icon--disabled': disabled,\n      'voxel-txt-color-sand-200': disabled,\n      'vcl-autocomplete__icon--open': panelOpen,\n      'rotate': rotateIcon\n    }\"\n    (click)=\"toggle()\"\n  >\n    {{icon}}\n  </voxel-icon>\n</div>\n\n<ng-template\n  cdkConnectedOverlay\n  cdkConnectedOverlayLockPosition\n  cdkConnectedOverlayHasBackdrop\n  cdkConnectedOverlayBackdropClass=\"cdk-overlay-transparent-backdrop\"\n  [cdkConnectedOverlayOrigin]=\"origin\"\n  [cdkConnectedOverlayOpen]=\"panelOpen\"\n  [cdkConnectedOverlayPositions]=\"_positions\"\n  [cdkConnectedOverlayWidth] = \"autocompleteWidth\"\n  [cdkConnectedOverlayOffsetY]=\"0\"\n  (backdropClick)=\"close()\"\n  (attach)=\"attached()\"\n  (detach)=\"close()\"\n>\n  <div\n    #panel\n    [id]=\"panelId\"\n    class=\"vcl-autocomplete__panel-options\"\n    (keydown)=\"handleKeydown($event)\"\n    role=\"listbox\"\n    [attr.aria-labelledby]=\"labelId\"\n    [attr.aria-hidden]=\"!panelOpen\"\n  >\n    <ng-content select=\"vcl-option\"></ng-content>\n    <div\n      class=\"vcl-autocomplete__not-options {{ segment | async }}\"\n      *ngIf=\"!hasSearch && autocompleteSearch\"\n      role=\"alert\"\n    >\n      <div class=\"vcl-autocomplete__not-options__wrapper\">\n        <span class=\"vcl-autocomplete__not-options__wrapper__text voxel-text-m-bd\">{{notFoundTitle}}</span>\n        <span class=\" vcl-autocomplete__not-options__wrapper__text voxel-text-m\">{{notFoundMessage}}</span>\n      </div>\n    </div>\n  </div>\n</ng-template>\n",
                providers: [{
                        provide: VclFieldMixinBase,
                        useExisting: forwardRef(() => VclAutocompleteComponent)
                    }],
                encapsulation: ViewEncapsulation.None,
                styles: [".cdk-overlay-container,.cdk-global-overlay-wrapper{pointer-events:none;top:0;left:0;height:100%;width:100%}.cdk-overlay-container{position:fixed;z-index:1000}.cdk-overlay-container:empty{display:none}.cdk-global-overlay-wrapper{display:flex;position:absolute;z-index:1000}.cdk-overlay-pane{position:absolute;pointer-events:auto;box-sizing:border-box;z-index:1000;display:flex;max-width:100%;max-height:100%}.cdk-overlay-backdrop{position:absolute;top:0;bottom:0;left:0;right:0;z-index:1000;pointer-events:auto;-webkit-tap-highlight-color:transparent;transition:opacity .4s cubic-bezier(.25,.8,.25,1);opacity:0}.cdk-overlay-backdrop.cdk-overlay-backdrop-showing{opacity:1}.cdk-high-contrast-active .cdk-overlay-backdrop.cdk-overlay-backdrop-showing{opacity:.6}.cdk-overlay-dark-backdrop{background:rgba(0,0,0,.32)}.cdk-overlay-transparent-backdrop,.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing{opacity:0}.cdk-overlay-connected-position-bounding-box{position:absolute;z-index:1000;display:flex;flex-direction:column;min-width:1px;min-height:1px}.cdk-global-scrollblock{position:fixed;width:100%;overflow-y:scroll}.cdk-visually-hidden{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;white-space:nowrap;outline:0;-webkit-appearance:none;-moz-appearance:none}:host{display:block;width:100%}.vcl-autocomplete{position:relative;display:flex;justify-content:space-between;align-items:center;background-color:transparent;padding-bottom:8px;line-height:2rem}.vcl-autocomplete--disabled{pointer-events:none}.vcl-autocomplete__text{width:100%;border:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;background-color:transparent;cursor:pointer}.vcl-autocomplete__text:disabled{background:none}.vcl-autocomplete__clear-icon{position:relative;z-index:1500;color:#56504c;cursor:pointer;padding-left:16px}.vcl-autocomplete__clear-icon:before{font-size:1rem}.vcl-autocomplete__icon-separator{width:1px;height:16px;margin:0 10px 0 14px;background-color:#efe9e5}.vcl-autocomplete__icon{transition:.2s linear;cursor:pointer}.vcl-autocomplete__icon--open.rotate{transform:rotateX(180deg)}.vcl-autocomplete__panel-options{border:.0625rem solid #efe9e5;box-shadow:0 .25rem .5rem #7a6d603d;border:none;background-color:#fff;width:100%;max-height:17.1rem;overflow-y:auto;border-radius:0 0 4px 4px;padding:.5rem 0}.vcl-autocomplete__not-options{display:flex;align-items:center;padding:1rem 1.5rem}.vcl-autocomplete__not-options__wrapper{display:block}.vcl-autocomplete__not-options__wrapper__text{display:block}.vcl-autocomplete__not-options__wrapper__text:first-child{padding-bottom:.5rem}.varejo.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled){color:#ec7000}.varejo.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled):disabled{color:#ff8a20}.personnalite.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled){color:#d0a967}.personnalite.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled):disabled{color:#dcbf8e}.uniclass.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled){color:#ec7000}.uniclass.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled):disabled{color:#ff8a20}.empresas.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled){color:#ec7000}.empresas.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled):disabled{color:#ff8a20}.itaucard.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled){color:#ec7000}.itaucard.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled):disabled{color:#ff8a20}.private.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled){color:#ec7000}.private.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled):disabled{color:#ff8a20}.parceiro-itaucard.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled){color:#ec7000}.parceiro-itaucard.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled):disabled{color:#ff8a20}.parceiro-credicard.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled){color:#0d456f}.parceiro-credicard.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled):disabled{color:#12619d}.parceiro-hipercard.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled){color:#ba1319}.parceiro-hipercard.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled):disabled{color:#e71920}.parceiro-magazine-luiza.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled){color:#0083ca}.parceiro-magazine-luiza.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled):disabled{color:#00a4fd}.personal-bank.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled){color:#ce9141}.personal-bank.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled):disabled{color:#d8a86a}.itau-bba.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled){color:#2449cc}.itau-bba.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled):disabled{color:#4567de}.personnalite.vcl-autocomplete__icon:not(.vcl-autocomplete__icon--disabled){color:#876632}\n"]
            }]
    }], function () { return [{ type: ɵngcc3.NgControl, decorators: [{
                type: Self
            }, {
                type: Optional
            }] }, { type: ɵngcc0.ElementRef }, { type: ɵngcc1.VoxelSegmentService }, { type: ɵngcc4.LiveAnnouncer }]; }, { id: [{
            type: Input
        }], notFoundTitle: [{
            type: Input
        }], notFoundMessage: [{
            type: Input
        }], icon: [{
            type: Input
        }], rotateIcon: [{
            type: Input
        }], change: [{
            type: Output
        }], focus: [{
            type: Output
        }], blur: [{
            type: Output
        }], required: [{
            type: Input
        }], 
    /**
     * @internal
     */
    onInputResize: [{
            type: HostListener,
            args: ['window:resize']
        }], options: [{
            type: ContentChildren,
            args: [VclOptionComponent]
        }], autocomplete: [{
            type: ViewChild,
            args: ['autocomplete', { static: true }]
        }], autocompleteInput: [{
            type: ViewChild,
            args: ['autocompleteInput', { static: true }]
        }], panel: [{
            type: ViewChild,
            args: ['panel']
        }], overlayDir: [{
            type: ViewChild,
            args: [CdkConnectedOverlay, { static: true }]
        }], placeholder: [{
            type: Input
        }], tabindex: [{
            type: Input
        }] }); })();

class VclAutocompleteModule {
}
VclAutocompleteModule.ɵfac = function VclAutocompleteModule_Factory(t) { return new (t || VclAutocompleteModule)(); };
VclAutocompleteModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VclAutocompleteModule });
VclAutocompleteModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            OverlayModule,
            FormsModule,
            VoxelSegmentModule,
            VoxelIconModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclAutocompleteModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    OverlayModule,
                    FormsModule,
                    VoxelSegmentModule,
                    VoxelIconModule,
                ],
                declarations: [VclAutocompleteComponent, VclOptionComponent],
                exports: [VclAutocompleteComponent, VclOptionComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VclAutocompleteModule, { declarations: function () { return [VclAutocompleteComponent, VclOptionComponent]; }, imports: function () { return [CommonModule,
        OverlayModule,
        FormsModule,
        VoxelSegmentModule,
        VoxelIconModule]; }, exports: function () { return [VclAutocompleteComponent, VclOptionComponent]; } }); })();

/**
 * Um cartão que exibe conteúdo livre composto de cabeçalho, conteúdo, e rodapé
 *
 * *A card that displays free content made up from header, content, and footer*
 *
 * ### Acessible
 *
 * <acessible class="not-tested">Acessibilidade - Não testado</acessible>
 *
 * **Module:**
 *
 * `import { VclCardDropdownComponent } from '@voxel/community';`
 *
 * <example-url>../../demo/index.html#/portfolio/components/card-dropdown?componentOnly=true</example-url>
 *
 * @example card padrão
 *  <vcl-card-dropdown>
 *    <div role="header">header html</div>
 *    <div role="content">content html</div>
 *    <div role="footer">footer html</div>
 *  </vcl-card-dropdown>
 *
 */
class VclCardDropdownComponent {
    constructor() {
        /**
         * @internal
         */
        this._expanded = false;
    }
    /**
     * @internal
     */
    get expanded() {
        return this._expanded;
    }
    /**
     * Alterna o card entre expandido e recolhido
     *
     * *Toggles the card between expanded and retracted*
     */
    toggleExpansion() {
        this._expanded = !this.expanded;
    }
}
VclCardDropdownComponent.ɵfac = function VclCardDropdownComponent_Factory(t) { return new (t || VclCardDropdownComponent)(); };
VclCardDropdownComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VclCardDropdownComponent, selectors: [["vcl-card-dropdown"]], ngContentSelectors: _c18, decls: 12, vars: 3, consts: [[1, "card__wrapper"], [1, "card__container"], [1, "card__header"], [1, "card__expand-button", "voxel-text-s", 3, "click"], ["size", "S", "a11yLabel", "expandir/ocultar"], ["class", "card__content", 4, "ngIf"], [1, "card__footer"], [1, "card__content"]], template: function VclCardDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c17);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "section", 1);
        ɵngcc0.ɵɵelementStart(2, "section", 2);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵlistener("click", function VclCardDropdownComponent_Template_div_click_4_listener() { return ctx.toggleExpansion(); });
        ɵngcc0.ɵɵelementStart(5, "span");
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "voxel-icon", 4);
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, VclCardDropdownComponent_section_9_Template, 2, 1, "section", 5);
        ɵngcc0.ɵɵelementStart(10, "section", 6);
        ɵngcc0.ɵɵprojection(11, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate(ctx.expanded ? "ocultar" : "expandir");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.expanded ? "seta_cima" : "seta_baixo");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.expanded);
    } }, directives: [ɵngcc1.VoxelIconComponent, ɵngcc2.NgIf], styles: [".card__wrapper[_ngcontent-%COMP%]{width:100%;height:100%;background:#fff;border-radius:.5rem;border:solid 1px #d6d0cc;box-shadow:0 2px 8px #56504c2e,0 0 2px #56504c29}.card__header[_ngcontent-%COMP%], .card__content[_ngcontent-%COMP%], .card__footer[_ngcontent-%COMP%]{width:100%}.card__header[_ngcontent-%COMP%]{display:flex;flex-wrap:nowrap;position:relative;padding:2rem 1rem 0}@media only screen and (max-width: 767.98px){.card__header[_ngcontent-%COMP%]{padding:1.5rem 1.5rem 0}}.card__content[_ngcontent-%COMP%]{overflow:hidden;padding:0 1rem}@media only screen and (max-width: 767.98px){.card__content[_ngcontent-%COMP%]{padding:0 1.5rem}}.card__footer[_ngcontent-%COMP%]{padding:0 1rem 2rem}@media only screen and (max-width: 767.98px){.card__footer[_ngcontent-%COMP%]{padding:0 1.5rem 2rem}}.card__expand-button[_ngcontent-%COMP%]{cursor:pointer;display:flex;flex-wrap:nowrap;justify-content:flex-end;color:#56504c;line-height:1.71;position:absolute;top:2rem;right:1rem}@media only screen and (max-width: 767.98px){.card__expand-button[_ngcontent-%COMP%]{top:1.5rem;right:1.5rem}}[_nghost-%COMP%]     .card__expand-button .voxel-icon{width:1.5rem;height:1.5rem;text-align:center}"], data: { animation: [
            trigger('toggleExpansion', [
                state('true', style({ height: '*' })),
                state('void', style({ height: 0 })),
                transition(':enter', animate('250ms ease-in-out')),
                transition(':leave', animate('250ms ease-in-out')),
            ]),
        ] } });
/**
 * @internal
 */
VclCardDropdownComponent.selector = 'vcl-card-dropdown';
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclCardDropdownComponent, [{
        type: Component,
        args: [{
                selector: 'vcl-card-dropdown',
                template: "<div class=\"card__wrapper\">\n  <section class=\"card__container\">\n    <section class=\"card__header\">\n      <ng-content select=\"[role=header]\"></ng-content>\n      <div class=\"card__expand-button voxel-text-s\" (click)=\"toggleExpansion()\">\n        <span>{{ expanded ? 'ocultar' : 'expandir' }}</span>\n        <voxel-icon size=\"S\" a11yLabel=\"expandir/ocultar\">{{ expanded ? 'seta_cima' : 'seta_baixo' }}</voxel-icon>\n      </div>\n    </section>\n\n    <section *ngIf=\"expanded\" [@toggleExpansion]=\"expanded\" class=\"card__content\">\n      <ng-content select=\"[role=content]\"></ng-content>\n    </section>\n\n    <section class=\"card__footer\"><ng-content select=\"[role=footer]\"></ng-content></section>\n  </section>\n</div>\n",
                animations: [
                    trigger('toggleExpansion', [
                        state('true', style({ height: '*' })),
                        state('void', style({ height: 0 })),
                        transition(':enter', animate('250ms ease-in-out')),
                        transition(':leave', animate('250ms ease-in-out')),
                    ]),
                ],
                styles: [".card__wrapper{width:100%;height:100%;background:#fff;border-radius:.5rem;border:solid 1px #d6d0cc;box-shadow:0 2px 8px #56504c2e,0 0 2px #56504c29}.card__header,.card__content,.card__footer{width:100%}.card__header{display:flex;flex-wrap:nowrap;position:relative;padding:2rem 1rem 0}@media only screen and (max-width: 767.98px){.card__header{padding:1.5rem 1.5rem 0}}.card__content{overflow:hidden;padding:0 1rem}@media only screen and (max-width: 767.98px){.card__content{padding:0 1.5rem}}.card__footer{padding:0 1rem 2rem}@media only screen and (max-width: 767.98px){.card__footer{padding:0 1.5rem 2rem}}.card__expand-button{cursor:pointer;display:flex;flex-wrap:nowrap;justify-content:flex-end;color:#56504c;line-height:1.71;position:absolute;top:2rem;right:1rem}@media only screen and (max-width: 767.98px){.card__expand-button{top:1.5rem;right:1.5rem}}:host ::ng-deep .card__expand-button .voxel-icon{width:1.5rem;height:1.5rem;text-align:center}\n"]
            }]
    }], function () { return []; }, null); })();

class VclCardDropdownModule {
}
VclCardDropdownModule.ɵfac = function VclCardDropdownModule_Factory(t) { return new (t || VclCardDropdownModule)(); };
VclCardDropdownModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VclCardDropdownModule });
VclCardDropdownModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            VoxelIconModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclCardDropdownModule, [{
        type: NgModule,
        args: [{
                declarations: [VclCardDropdownComponent],
                imports: [
                    CommonModule,
                    VoxelIconModule,
                ],
                exports: [VclCardDropdownComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VclCardDropdownModule, { declarations: function () { return [VclCardDropdownComponent]; }, imports: function () { return [CommonModule,
        VoxelIconModule]; }, exports: function () { return [VclCardDropdownComponent]; } }); })();

// tslint:disable:directive-selector
// tslint:disable:max-classes-per-file
class VclCarouselItemDirective {
    constructor(tpl) {
        this.tpl = tpl;
    }
}
VclCarouselItemDirective.ɵfac = function VclCarouselItemDirective_Factory(t) { return new (t || VclCarouselItemDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
VclCarouselItemDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VclCarouselItemDirective, selectors: [["", "carouselItem", ""]] });
VclCarouselItemDirective.ctorParameters = () => [
    { type: TemplateRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclCarouselItemDirective, [{
        type: Directive,
        args: [{
                selector: '[carouselItem]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();
class VclCarouselElementDirective {
}
VclCarouselElementDirective.ɵfac = function VclCarouselElementDirective_Factory(t) { return new (t || VclCarouselElementDirective)(); };
VclCarouselElementDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VclCarouselElementDirective, selectors: [["", 8, "carousel-item"]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclCarouselElementDirective, [{
        type: Directive,
        args: [{
                selector: '.carousel-item'
            }]
    }], null, null); })();

/**
 * Permite que vários itens sejam exibidos na tela, um de cada vez, em sequência.
 * O número de itens é mostrado através dos marcadores e pode ser navegado usando a paginação.
 * Este componente deve ter no máximo cinco controles deslizantes.
 *
 * *Allows several items to be displayed on the screen, one at a time, in sequence.*
 * *The number of items is shown through the bullets and it can be navigated using the pagination.*
 * *This component must have a maximum of five slider.*
 *
 * ### Acessible
 *
 * <acessible class="not-tested">Acessibilidade - Não testado</acessible>
 *
 * **Module:**
 *
 * `import { VclCarouselComponent } from '@voxel/community';`
 *
 * <example-url>../../demo/index.html#/portfolio/components/carousel?componentOnly=true</example-url>
 *
 * @example carrossel sem card / carousel without card
 * <vcl-carousel
 *  textButtonNext="Próxima"
 *  textButtonPrev="Anterior"
 *  >
 *   <ng-container *carouselItem>
 *      Slide 1
 *    </ng-container>
 *    <ng-container *carouselItem>
 *      Slide 2
 *    </ng-container>
 *    <ng-container *carouselItem>
 *      Slide 3
 *     </ng-container>
 *   </vcl-carousel>
 *
 * @example carrossel com card / carousel with card
 * <vcl-carousel
 *  textButtonNext="Próxima"
 *  textButtonPrev="Anterior"
 *  >
 *    <ng-container *carouselItem>
 *       <vcl-card-template
 *         title="título do card em até duas linhas 1"
 *         paragraph="consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. "
 *         image='assets/img/img-gr.png'
 *       >
 *       </vcl-card-template>
 *     </ng-container>
 *     <ng-container *carouselItem>
 *       <vcl-card-template
 *         title="título do card em até duas linhas 2"
 *         paragraph="consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. "
 *         image='assets/img/img-gr.png'
 *       >
 *       </vcl-card-template>
 *     </ng-container>
 *     <ng-container *carouselItem>
 *       <vcl-card-template
 *         title="título do card em até duas linhas 3"
 *         paragraph="consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. "
 *         image='assets/img/img-gr.png'
 *       >
 *       </vcl-card-template>
 *     </ng-container>
 *   </vcl-carousel>
 *  *
 * @example carrossel sem card / carousel without card with autoplay
 * <vcl-carousel
 *  textButtonNext="Próxima"
 *  textButtonPrev="Anterior"
 *  [autoPlay]="true"
 *  [interval]="7000"
 *  >
 *   <ng-container *carouselItem>
 *     Slide 1
 *   </ng-container>
 *   <ng-container *carouselItem>
 *     Slide 2
 *   </ng-container>
 *   <ng-container *carouselItem>
 *     Slide 3
 *    </ng-container>
 *  </vcl-carousel>
 *
 * @example carrossel com apenas 1 slide / carousel with one slide
 * <vcl-carousel
 *  textButtonNext="Próxima"
 *  textButtonPrev="Anterior"
 *  [autoPlay]="true"
 *  [interval]="7000"
 *  >
 *   <ng-container *carouselItem>
 *      Slide 1
 *   </ng-container>
 * </vcl-carousel>
 */
class VclCarouselComponent {
    /**
     * @internal
     */
    constructor(builder, ref, renderer) {
        this.builder = builder;
        this.ref = ref;
        this.renderer = renderer;
        /**
         * Tempo de rolagem do controle deslizante
         *
         * *Slider scrolling time*
         */
        this.timing = '500ms ease-in';
        /**
         * Texto do próximo botão
         *
         * *Next button text*
         */
        this.textButtonNext = 'next';
        /**
         * Texto do botão anterior
         *
         * *Previous button text*
         */
        this.textButtonPrev = 'previous';
        /**
         * Flag para autoplay
         *
         * *Flag for autoplay*
         */
        this.autoPlay = false;
        /**
         * Tempo para alternar slides
         *
         * time for change slides
         */
        this.interval = 5000;
        /**
         * @internal
         */
        this.currentSlide = 0;
        /**
         * @internal
         */
        this.dom = this.ref.nativeElement;
    }
    /**
     * @internal
     */
    onResize() {
        this.itemWidth = this.getItemWidth;
        this.translateOffSet('0ms');
        this.player.play();
    }
    /**
     * @internal
     */
    ngAfterViewInit() {
        this.buildControls();
        this.itemWidth = this.getItemWidth;
        if (!this.autoPlay) {
            return;
        }
        this.transition = setInterval(() => {
            if (this.currentSlide + 1 === this.items.length) {
                this.currentSlide = -1;
            }
            this.next();
        }, this.interval);
    }
    /**
     * @internal
     */
    ngOnDestroy() {
        clearInterval(this.transition);
    }
    get getItemWidth() {
        return this.itemsElements.first.nativeElement.getBoundingClientRect().width;
    }
    /**
     * @internal
     */
    get nextButtonDisabled() {
        return this.currentSlide + 1 === this.items.length;
    }
    /**
     * @internal
     */
    get prevButtonDisabled() {
        return this.currentSlide === 0;
    }
    /**
     * @internal
     */
    next() {
        if (this.currentSlide + 1 === this.items.length) {
            return;
        }
        this.currentSlide++;
        this.animation();
        this.elementsControl = this.dom.querySelector('.controls li:nth-child(' + (this.currentSlide + 1) + ')');
        if (this.elementsControl) {
            const aux = this.elementsControl;
            this.renderer.addClass(aux, 'active');
        }
        else {
            this.currentSlide--;
        }
    }
    /**s
     * @internal
     */
    prev() {
        if (this.currentSlide === 0) {
            return;
        }
        this.currentSlide--;
        this.animation();
        this.elementsControl = this.dom.querySelector('.controls li:nth-child(' + (this.currentSlide + 1) + ')');
        if (this.elementsControl) {
            const aux = this.elementsControl;
            this.renderer.addClass(aux, 'active');
        }
        else {
            this.currentSlide++;
        }
    }
    /**
     * @internal
     */
    translateOffSet(timing = '') {
        const offset = this.currentSlide * this.itemWidth;
        const myAnimation = this.builder.build([
            animate(timing || this.timing, style({ transform: `translateX(-${offset}px)` })),
        ]);
        this.player = myAnimation.create(this.carousel.nativeElement);
    }
    /**
     * @internal
     */
    animation() {
        this.translateOffSet();
        this.player.play();
        this.resetIndicator();
    }
    /**
     * @internal
     */
    buildControls() {
        for (let i = 0; i < this.items.length; i++) {
            const control = this.renderer.createElement('li');
            this.renderer.setAttribute(control, 'id', 'control-' + i);
            if (i === 0) {
                this.renderer.addClass(control, 'active');
            }
            this.dom.querySelector('.controls ul').appendChild(control);
        }
    }
    /**
     * @internal
     */
    moveByButton(eve) {
        let id = eve.target.id;
        if (!id) {
            return;
        }
        id = id.split('-').pop();
        this.currentSlide = Number(id);
        this.animation();
        const index = this.currentSlide + 1;
        const aux1 = this.dom.querySelector('.controls li:nth-child(' + index + ')');
        this.renderer.addClass(aux1, 'active');
    }
    /**
     * @internal
     */
    resetIndicator() {
        const aux2 = this.dom.querySelector('.controls li.active');
        this.renderer.removeClass(aux2, 'active');
    }
    /**
     * @internal
     */
    handleKeyboardEvent(event) {
        if (event.key === 'ArrowLeft') {
            this.prev();
        }
        else if (event.key === 'ArrowRight') {
            this.next();
        }
    }
}
VclCarouselComponent.ɵfac = function VclCarouselComponent_Factory(t) { return new (t || VclCarouselComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.AnimationBuilder), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
VclCarouselComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VclCarouselComponent, selectors: [["vcl-carousel"]], contentQueries: function VclCarouselComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, VclCarouselItemDirective, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.items = _t);
    } }, viewQuery: function VclCarouselComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c19, 7);
        ɵngcc0.ɵɵviewQuery(VclCarouselElementDirective, 5, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.carousel = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.itemsElements = _t);
    } }, hostBindings: function VclCarouselComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function VclCarouselComponent_resize_HostBindingHandler() { return ctx.onResize(); }, false, ɵngcc0.ɵɵresolveWindow)("keydown", function VclCarouselComponent_keydown_HostBindingHandler($event) { return ctx.handleKeyboardEvent($event); });
    } }, inputs: { timing: "timing", textButtonNext: "textButtonNext", textButtonPrev: "textButtonPrev", autoPlay: "autoPlay", interval: "interval" }, decls: 5, vars: 2, consts: [[1, "carousel-wrapper", 3, "swipeleft", "swiperight"], [1, "carousel-inner"], ["carousel", ""], ["class", "carousel-item", 4, "ngFor", "ngForOf"], ["class", "button-content mt-28-px", 4, "ngIf"], [1, "carousel-item"], [3, "ngTemplateOutlet"], [1, "button-content", "mt-28-px"], [1, "three-column"], ["id", "button-previous", 1, "vcl-carousel__button", 3, "disabled", "voxelButtonContextual", "click"], [1, "controls", "three-column"], [3, "click"], ["id", "button-next", 1, "vcl-carousel__button", 3, "disabled", "voxelButtonContextual", "click"]], template: function VclCarouselComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "section", 0);
        ɵngcc0.ɵɵlistener("swipeleft", function VclCarouselComponent_Template_section_swipeleft_0_listener() { return ctx.next(); })("swiperight", function VclCarouselComponent_Template_section_swiperight_0_listener() { return ctx.prev(); });
        ɵngcc0.ɵɵelementStart(1, "ul", 1, 2);
        ɵngcc0.ɵɵtemplate(3, VclCarouselComponent_li_3_Template, 2, 1, "li", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, VclCarouselComponent_div_4_Template, 9, 6, "div", 4);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.items);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.items.length > 1);
    } }, directives: [ɵngcc2.NgForOf, ɵngcc2.NgIf, VclCarouselElementDirective, ɵngcc2.NgTemplateOutlet, ɵngcc1.VoxelButtonComponent], styles: [".vcl-carousel[_ngcontent-%COMP%]{overflow:auto}.vcl-carousel__button[_ngcontent-%COMP%]{width:80px;display:inline-block}.carousel-wrapper[_ngcontent-%COMP%]{overflow:hidden;width:100%;position:relative}.carousel-wrapper[_ngcontent-%COMP%]   .carousel-inner[_ngcontent-%COMP%]{white-space:nowrap;position:relative;left:0px}.carousel-wrapper[_ngcontent-%COMP%]   .carousel-inner[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{white-space:normal}.carousel-wrapper[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{width:100%;display:inline-block}.button-content[_ngcontent-%COMP%]{text-align:center;display:flex;max-width:320px;margin:auto}.controls[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{padding:0;text-align:center;bottom:1em;margin:0;z-index:5;display:inline-block}  .controls ul li{list-style-type:none;background-color:#56504c;width:4px;height:4px;border-radius:50%;margin-right:8px;display:inline-block;cursor:pointer;vertical-align:middle}  .controls ul li.active{background-color:#106eb0;width:8px;height:8px}.three-column[_ngcontent-%COMP%]{width:33.33%;float:left}.mt-28-px[_ngcontent-%COMP%]{margin-top:28px}"] });
/**
 * @internal
 */
VclCarouselComponent.selector = 'carousel';
VclCarouselComponent.ctorParameters = () => [
    { type: AnimationBuilder },
    { type: ElementRef },
    { type: Renderer2 }
];
VclCarouselComponent.propDecorators = {
    carousel: [{ type: ViewChild, args: ['carousel', { static: true },] }],
    timing: [{ type: Input }],
    textButtonNext: [{ type: Input }],
    textButtonPrev: [{ type: Input }],
    autoPlay: [{ type: Input }],
    interval: [{ type: Input }],
    items: [{ type: ContentChildren, args: [VclCarouselItemDirective,] }],
    itemsElements: [{ type: ViewChildren, args: [VclCarouselElementDirective, { read: ElementRef },] }],
    onResize: [{ type: HostListener, args: ['window:resize',] }],
    handleKeyboardEvent: [{ type: HostListener, args: ['keydown', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclCarouselComponent, [{
        type: Component,
        args: [{
                selector: 'vcl-carousel',
                template: "<section class=\"carousel-wrapper\"\n(swipeleft)=\"next()\"\n(swiperight)=\"prev()\"\n>\n  <ul class=\"carousel-inner\" #carousel>\n    <li *ngFor=\"let item of items;\" class=\"carousel-item\">\n      <ng-container [ngTemplateOutlet]=\"item.tpl\"></ng-container>\n    </li>\n  </ul>\n</section>\n\n<div class=\"button-content mt-28-px\" *ngIf=\"items.length > 1\">\n  <div class=\"three-column\">\n    <button\n      class=\"vcl-carousel__button\"\n      id=\"button-previous\"\n      [disabled]=\"prevButtonDisabled\"\n      [voxelButtonContextual]=\"true\"\n      (click)=\"prev()\">\n        {{textButtonPrev}}\n    </button>\n  </div>\n\n  <div\n  class=\"controls three-column\">\n    <ul (click)=\"moveByButton($event)\"></ul>\n  </div>\n\n  <div class=\"three-column\">\n    <button\n      class=\"vcl-carousel__button\"\n      id=\"button-next\"\n      [disabled]=\"nextButtonDisabled\"\n      [voxelButtonContextual]=\"true\"\n      (click)=\"next()\">\n        {{textButtonNext}}\n    </button>\n  </div>\n</div>\n",
                styles: [".vcl-carousel{overflow:auto}.vcl-carousel__button{width:80px;display:inline-block}.carousel-wrapper{overflow:hidden;width:100%;position:relative}.carousel-wrapper .carousel-inner{white-space:nowrap;position:relative;left:0px}.carousel-wrapper .carousel-inner *{white-space:normal}.carousel-wrapper ul li{width:100%;display:inline-block}.button-content{text-align:center;display:flex;max-width:320px;margin:auto}.controls ul{padding:0;text-align:center;bottom:1em;margin:0;z-index:5;display:inline-block}::ng-deep .controls ul li{list-style-type:none;background-color:#56504c;width:4px;height:4px;border-radius:50%;margin-right:8px;display:inline-block;cursor:pointer;vertical-align:middle}::ng-deep .controls ul li.active{background-color:#106eb0;width:8px;height:8px}.three-column{width:33.33%;float:left}.mt-28-px{margin-top:28px}\n"]
            }]
    }], function () { return [{ type: ɵngcc6.AnimationBuilder }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { timing: [{
            type: Input
        }], textButtonNext: [{
            type: Input
        }], textButtonPrev: [{
            type: Input
        }], autoPlay: [{
            type: Input
        }], interval: [{
            type: Input
        }], 
    /**
     * @internal
     */
    onResize: [{
            type: HostListener,
            args: ['window:resize']
        }], 
    /**
     * @internal
     */
    handleKeyboardEvent: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], carousel: [{
            type: ViewChild,
            args: ['carousel', { static: true }]
        }], items: [{
            type: ContentChildren,
            args: [VclCarouselItemDirective]
        }], itemsElements: [{
            type: ViewChildren,
            args: [VclCarouselElementDirective, { read: ElementRef }]
        }] }); })();

const carouselUtils = [
    VclCarouselComponent,
    VclCarouselElementDirective,
    VclCarouselItemDirective,
];
class VclCarouselModule {
}
VclCarouselModule.ɵfac = function VclCarouselModule_Factory(t) { return new (t || VclCarouselModule)(); };
VclCarouselModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VclCarouselModule });
VclCarouselModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            VoxelButtonModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclCarouselModule, [{
        type: NgModule,
        args: [{
                declarations: [carouselUtils],
                imports: [
                    CommonModule,
                    VoxelButtonModule,
                ],
                exports: [carouselUtils]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VclCarouselModule, { declarations: function () { return [VclCarouselComponent, VclCarouselElementDirective, VclCarouselItemDirective]; }, imports: function () { return [CommonModule,
        VoxelButtonModule]; }, exports: function () { return [VclCarouselComponent, VclCarouselElementDirective, VclCarouselItemDirective]; } }); })();

/**
 * As tabelas devem ser usadas para listas de dados ou informações para fornecer detalhes sobre um serviço ou produto.
 * Elas são projetados para contextos nos quais o usuário precisa consultar um grande número de tópicos sobre o mesmo conteúdo rapidamente.
 *
 * **Componente não testado para acessibilidade**
 *
 * *Tables should be used for lists of data or information to provide details about a service or product.
 *  They are designed for contexts in which the user needs to consult a large number of topics about the same content quickly.*
 *
 *
 * ### Acessible
 *
 * <acessible class="not-tested">Acessibilidade - Não testado</acessible>
 *
 * **Module:**
 *
 * `import { VclTableModule } from '@voxel/community';`
 *
 * <example-url>../../demo/index.html#/portfolio/components/table?componentOnly=true</example-url>
 *
 * @example tabela simples
 * <vcl-table>
 *   <table cdk-table [dataSource]="dataSource1">
 *     <!-- Position Column -->
 *     <ng-container cdkColumnDef="position">
 *       <th cdk-header-cell *cdkHeaderCellDef> no. </th>
 *       <td cdk-cell *cdkCellDef="let element"> {{element.position}} </td>
 *     </ng-container>
 *
 *     <!-- name Column -->
 *     <ng-container cdkColumnDef="name">
 *       <th cdk-header-cell *cdkHeaderCellDef> name </th>
 *       <td cdk-cell *cdkCellDef="let element"> {{element.name}} </td>
 *     </ng-container>
 *
 *     <!-- weight Column -->
 *     <ng-container cdkColumnDef="weight">
 *       <th cdk-header-cell *cdkHeaderCellDef> weight </th>
 *       <td cdk-cell *cdkCellDef="let element"> {{element.weight}} </td>
 *     </ng-container>
 *
 *     <!-- symbol Column -->
 *     <ng-container cdkColumnDef="symbol">
 *       <th cdk-header-cell *cdkHeaderCellDef> symbol </th>
 *       <td cdk-cell *cdkCellDef="let element"> {{element.symbol}} </td>
 *     </ng-container>
 *
 *     <tr cdk-header-row *cdkHeaderRowDef="displayedColumns"></tr>
 *     <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;"></tr>
 *   </table>
 * </vcl-table>
 *
 * @example tabela com sorting
 * <vcl-table>
 *   <table cdk-table [dataSource]="dataSource2" vclSort (sortData)="sortData($event)">
 *     <!-- Position Column -->
 *     <ng-container cdkColumnDef="position">
 *       <th cdk-header-cell *cdkHeaderCellDef vclSortColumn columnName="position"> no. </th>
 *       <td cdk-cell *cdkCellDef="let element"> {{element.position}} </td>
 *     </ng-container>
 *
 *     <!-- name Column -->
 *     <ng-container cdkColumnDef="name">
 *       <th cdk-header-cell *cdkHeaderCellDef vclSortColumn columnName="name"> name </th>
 *       <td cdk-cell *cdkCellDef="let element"> {{element.name}} </td>
 *     </ng-container>
 *
 *     <!-- weight Column -->
 *     <ng-container cdkColumnDef="weight">
 *       <th cdk-header-cell *cdkHeaderCellDef vclSortColumn columnName="weight"> weight </th>
 *       <td cdk-cell *cdkCellDef="let element"> {{element.weight}} </td>
 *     </ng-container>
 *
 *     <!-- symbol Column -->
 *     <ng-container cdkColumnDef="symbol">
 *       <th cdk-header-cell *cdkHeaderCellDef vclSortColumn columnName="symbol"> symbol </th>
 *       <td cdk-cell *cdkCellDef="let element"> {{element.symbol}} </td>
 *     </ng-container>
 *
 *     <tr cdk-header-row *cdkHeaderRowDef="displayedColumns"></tr>
 *     <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;"></tr>
 *   </table>
 * </vcl-table>
 *
 * @example tabela com sorting e paginação
 * <vcl-table>
 *   <table cdk-table [dataSource]="dataSource2" vclSort (sortData)="sortData($event)">
 *     <!-- Position Column -->
 *     <ng-container cdkColumnDef="position">
 *       <th cdk-header-cell *cdkHeaderCellDef vclSortColumn columnName="position"> no. </th>
 *       <td cdk-cell *cdkCellDef="let element"> {{element.position}} </td>
 *     </ng-container>
 *
 *     <!-- name Column -->
 *     <ng-container cdkColumnDef="name">
 *       <th cdk-header-cell *cdkHeaderCellDef vclSortColumn columnName="name"> name </th>
 *       <td cdk-cell *cdkCellDef="let element"> {{element.name}} </td>
 *     </ng-container>
 *
 *     <!-- weight Column -->
 *     <ng-container cdkColumnDef="weight">
 *       <th cdk-header-cell *cdkHeaderCellDef vclSortColumn columnName="weight"> weight </th>
 *       <td cdk-cell *cdkCellDef="let element"> {{element.weight}} </td>
 *     </ng-container>
 *
 *     <!-- symbol Column -->
 *     <ng-container cdkColumnDef="symbol">
 *       <th cdk-header-cell *cdkHeaderCellDef vclSortColumn columnName="symbol"> symbol </th>
 *       <td cdk-cell *cdkCellDef="let element"> {{element.symbol}} </td>
 *     </ng-container>
 *
 *     <tr cdk-header-row *cdkHeaderRowDef="displayedColumns"></tr>
 *     <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;"></tr>
 *   </table>
 *   <vcl-paginator
 *     (page)="onPageChange($event)"
 *     [length]="dataLength"
 *     [pageIndex]="pageIndex"
 *     [pageSize]="pageSize">
 *   </vcl-paginator>
 * </vcl-table>
 */
class VclTableComponent {
    constructor() {
        this.table = 'vcl-table';
    }
}
VclTableComponent.ɵfac = function VclTableComponent_Factory(t) { return new (t || VclTableComponent)(); };
VclTableComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VclTableComponent, selectors: [["vcl-table"]], hostVars: 1, hostBindings: function VclTableComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("class", ctx.table);
    } }, ngContentSelectors: _c3, decls: 1, vars: 0, template: function VclTableComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, styles: [".vcl-table .cdk-table{width:100%}.vcl-table .cdk-table .cdk-header-row{background-color:#fff}.vcl-table .cdk-table .cdk-header-row .cdk-header-cell{background-color:#56504c;color:#fff;border:1px solid #d6d0cc;min-height:2rem;padding:1rem 1.5rem;font-weight:700;display:table-cell;position:relative;vertical-align:middle}.vcl-table .cdk-table .cdk-header-row .cdk-header-cell .voxel-checkbox{padding:0}.vcl-table .cdk-table .cdk-header-row .cdk-header-cell .voxel-checkbox__icon{margin:0}.vcl-table .cdk-table .cdk-header-row .cdk-header-cell .voxel-checkbox__icon .voxel-icon{color:#fff}.vcl-table .cdk-table .cdk-header-row .cdk-header-cell .voxel-checkbox__text{color:#fff;font-weight:bold}.vcl-table .cdk-table .cdk-header-row .cdk-header-cell[class*=icon-]{padding-right:2rem}.vcl-table .cdk-table .cdk-header-row .cdk-header-cell[class*=icon-]:before{position:absolute;right:.3125rem;font-family:\"itau-icon\";font-size:1.5rem;font-style:normal;font-weight:normal;text-rendering:optimizeLegibility;margin:auto;letter-spacing:0;font-feature-settings:\"liga\",\"dlig\";font-variant-ligatures:discretionary-ligatures}.vcl-table .cdk-table .cdk-row{background-color:#fff}.vcl-table .cdk-table .cdk-row:nth-of-type(odd){background-color:#faf7f5}.vcl-table .cdk-table .cdk-row .cdk-cell{border:1px solid #d6d0cc;padding:1rem 1.5rem;vertical-align:middle}.vcl-table .cdk-table .cdk-row .cdk-cell .voxel-checkbox{padding:0}.vcl-table .cdk-table .cdk-row .cdk-cell .voxel-checkbox__icon{margin:0}.vcl-table .cdk-table .cdk-row .cdk-cell .voxel-radio__label{justify-content:center}.vcl-table .cdk-table .cdk-row .cdk-cell .voxel-radio__icon{margin:0}@media only screen and (max-width: 767.98px){.vcl-table .cdk-table{display:block;overflow-x:scroll}.vcl-table .cdk-table .cdk-cell,.vcl-table .cdk-table .cdk-header-cell{word-wrap:initial;display:table-cell;line-break:unset;width:1%;white-space:nowrap;overflow:hidden;vertical-align:middle}.vcl-table .cdk-table .cdk-row,.vcl-table .cdk-table .cdk-header-row{display:table-row}}\n"], encapsulation: 2 });
VclTableComponent.propDecorators = {
    table: [{ type: HostBinding, args: ['attr.class',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclTableComponent, [{
        type: Component,
        args: [{
                selector: 'vcl-table',
                template: '<ng-content></ng-content>',
                encapsulation: ViewEncapsulation.None,
                styles: [".vcl-table .cdk-table{width:100%}.vcl-table .cdk-table .cdk-header-row{background-color:#fff}.vcl-table .cdk-table .cdk-header-row .cdk-header-cell{background-color:#56504c;color:#fff;border:1px solid #d6d0cc;min-height:2rem;padding:1rem 1.5rem;font-weight:700;display:table-cell;position:relative;vertical-align:middle}.vcl-table .cdk-table .cdk-header-row .cdk-header-cell .voxel-checkbox{padding:0}.vcl-table .cdk-table .cdk-header-row .cdk-header-cell .voxel-checkbox__icon{margin:0}.vcl-table .cdk-table .cdk-header-row .cdk-header-cell .voxel-checkbox__icon .voxel-icon{color:#fff}.vcl-table .cdk-table .cdk-header-row .cdk-header-cell .voxel-checkbox__text{color:#fff;font-weight:bold}.vcl-table .cdk-table .cdk-header-row .cdk-header-cell[class*=icon-]{padding-right:2rem}.vcl-table .cdk-table .cdk-header-row .cdk-header-cell[class*=icon-]:before{position:absolute;right:.3125rem;font-family:\"itau-icon\";font-size:1.5rem;font-style:normal;font-weight:normal;text-rendering:optimizeLegibility;margin:auto;letter-spacing:0;font-feature-settings:\"liga\",\"dlig\";font-variant-ligatures:discretionary-ligatures}.vcl-table .cdk-table .cdk-row{background-color:#fff}.vcl-table .cdk-table .cdk-row:nth-of-type(odd){background-color:#faf7f5}.vcl-table .cdk-table .cdk-row .cdk-cell{border:1px solid #d6d0cc;padding:1rem 1.5rem;vertical-align:middle}.vcl-table .cdk-table .cdk-row .cdk-cell .voxel-checkbox{padding:0}.vcl-table .cdk-table .cdk-row .cdk-cell .voxel-checkbox__icon{margin:0}.vcl-table .cdk-table .cdk-row .cdk-cell .voxel-radio__label{justify-content:center}.vcl-table .cdk-table .cdk-row .cdk-cell .voxel-radio__icon{margin:0}@media only screen and (max-width: 767.98px){.vcl-table .cdk-table{display:block;overflow-x:scroll}.vcl-table .cdk-table .cdk-cell,.vcl-table .cdk-table .cdk-header-cell{word-wrap:initial;display:table-cell;line-break:unset;width:1%;white-space:nowrap;overflow:hidden;vertical-align:middle}.vcl-table .cdk-table .cdk-row,.vcl-table .cdk-table .cdk-header-row{display:table-row}}\n"]
            }]
    }], function () { return []; }, { table: [{
            type: HostBinding,
            args: ['attr.class']
        }] }); })();

/**
 * Componente para paginação de tabela
 *
 * *Component for table pagination*
 *
 * @example
 * <vcl-paginator
 *   (page)="onPageChange($event)"
 *   [length]="dataLength"
 *   [pageIndex]="pageIndex"
 *   [pageSize]="pageSize"
 *   [showPageSelect]="true">
 * </vcl-paginator>
 */
class VclPaginatorComponent {
    constructor() {
        /**
         * Linguagem do componente
         *
         * *Components language*
         */
        this.language = 'PT';
        /**
         * Número total de registros para paginação
         *
         * *Total number of records for pagination*
         */
        this.length = 0;
        /**
         * Quantidade de registros por página
         *
         * *Number of records per page*
         */
        this.pageSize = 10;
        /**
         * Opções de quantidade de registros por página
         *
         * *Number of records per page options*
         */
        this.pageSizeOptions = [10, 20, 30, 40, 50];
        /**
         * Opção para exibir a seleção de página
         *
         * *Show page select option*
         */
        this.showPageSelect = false;
        /**
         * Número de opções visíveis sem scroll nos selects
         *
         * *Number of visible select options without scroll*
         */
        this.numVisibleSelectOptions = 5;
        /**
         * Emite evento de paginação
         *
         * *Emits pagination event*
         */
        this.page = new EventEmitter();
        /**
         * Emite evento para estado de abertura no menu de seleção
         *
         * *Emits event for state of opening at menu of selection*
         */
        this.stateOpen = new EventEmitter();
        /**
         * @internal
         */
        this._pageIndex = 0;
    }
    /**
     * Índice da página atual
     *
     * *Current page index*
     */
    set pageIndex(pageIndex) {
        const resetPagination = this._pageIndex !== 0 && pageIndex === 0;
        this._pageIndex = pageIndex;
        if (resetPagination) {
            this.emitChange();
        }
    }
    get pageIndex() {
        return this._pageIndex;
    }
    /**
     * @internal
     */
    get firstVisibleItem() {
        return this._pageIndex === 0 ? 1 : this.pageSize * this._pageIndex + 1;
    }
    /**
     * @internal
     */
    get lastVisibleItem() {
        const lastItem = this.pageSize * (this._pageIndex + 1);
        return this._pageIndex === 0
            ? this.pageSize > this.length
                ? this.length
                : this.pageSize
            : lastItem <= this.length
                ? lastItem
                : this.length;
    }
    /**
     * @internal
     */
    get previousPageDisabled() {
        return this._pageIndex === 0;
    }
    /**
     * @internal
     */
    get nextPageDisabled() {
        return this.lastVisibleItem === this.length;
    }
    /**
     * @internal
     */
    get totalPages() {
        return Math.ceil(this.length / this.pageSize);
    }
    /**
     * @internal
     */
    get pageSelectOptions() {
        return Array.from(Array(this.totalPages), (_, i) => i + 1);
    }
    /**
     * @internal
     */
    get pageSelectCurrent() {
        return this.pageIndex + 1;
    }
    /**
     * @internal
     */
    nextPage() {
        if (this.nextPageDisabled) {
            return;
        }
        this._pageIndex++;
        this.emitChange();
    }
    /**
     * @internal
     */
    previousPage() {
        if (this.previousPageDisabled) {
            return;
        }
        this._pageIndex--;
        this.emitChange();
    }
    /**
     * @internal
     */
    pageSizeChange(pageSize) {
        this.pageSize = pageSize;
        this._pageIndex = 0;
        this.emitChange();
    }
    /**
     * @internal
     */
    pageSelectChange(pageSelect) {
        this._pageIndex = pageSelect - 1;
        this.emitChange();
    }
    /**
     * @internal
     */
    listStateChange(stateOpen) {
        this.stateOpen.emit(stateOpen);
    }
    /**
     * @internal
     */
    emitChange() {
        this._pageEvent = {
            length: this.length,
            pageIndex: this._pageIndex,
            pageSize: this.pageSize,
            previousPageIndex: this._pageIndex !== 0 ? this._pageIndex - 1 : 0,
        };
        this.page.emit(this._pageEvent);
    }
}
VclPaginatorComponent.ɵfac = function VclPaginatorComponent_Factory(t) { return new (t || VclPaginatorComponent)(); };
VclPaginatorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VclPaginatorComponent, selectors: [["vcl-paginator"]], inputs: { language: "language", length: "length", pageSize: "pageSize", pageSizeOptions: "pageSizeOptions", showPageSelect: "showPageSelect", numVisibleSelectOptions: "numVisibleSelectOptions", pageIndex: "pageIndex" }, outputs: { page: "page", stateOpen: "stateOpen" }, decls: 16, vars: 9, consts: [[1, "vcl-paginator"], [1, "page-size-select", "voxel-pr-m", "voxel-pv-m", "d-flex"], [1, "voxel-pl-s", 3, "selectedValue", "options", "numVisibleOptions", "selectedValueChange", "listOpenChange"], ["itemsCount", ""], ["class", "voxel-pv-m", 4, "ngIf"], [4, "ngIf"], [1, "voxel-pv-m", "d-flex"], ["aria-label", "p\u00E1gina anterior", 1, "vcl-paginator__button", 3, "disabled", "click"], ["aria-label", "pr\u00F3xima p\u00E1gina", 1, "vcl-paginator__button", 3, "disabled", "click"], [1, "hide-pipe-xs", "pipe-color", "voxel-pr-m"], [1, "voxel-pv-m"], [4, "ngTemplateOutlet"], [1, "voxel-ph-m", "page-size-pipe", "pipe-color"], [1, "hide-pipe-xs", "pipe-color", "voxel-pv-m", "voxel-pl-m", "voxel-pr-s"], [1, "voxel-pv-m", "voxel-pl-m"]], template: function VclPaginatorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementStart(3, "vcl-select", 2);
        ɵngcc0.ɵɵlistener("selectedValueChange", function VclPaginatorComponent_Template_vcl_select_selectedValueChange_3_listener($event) { return ctx.pageSizeChange($event); })("listOpenChange", function VclPaginatorComponent_Template_vcl_select_listOpenChange_3_listener($event) { return ctx.listStateChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, VclPaginatorComponent_ng_template_4_Template, 4, 4, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(6, VclPaginatorComponent_div_6_Template, 4, 1, "div", 4);
        ɵngcc0.ɵɵtemplate(7, VclPaginatorComponent_div_7_Template, 2, 1, "div", 4);
        ɵngcc0.ɵɵtemplate(8, VclPaginatorComponent_ng_container_8_Template, 9, 6, "ng-container", 5);
        ɵngcc0.ɵɵelementStart(9, "div", 6);
        ɵngcc0.ɵɵelementStart(10, "button", 7);
        ɵngcc0.ɵɵlistener("click", function VclPaginatorComponent_Template_button_click_10_listener() { return ctx.previousPage(); });
        ɵngcc0.ɵɵelementStart(11, "voxel-icon");
        ɵngcc0.ɵɵtext(12, " seta_esquerda ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "button", 8);
        ɵngcc0.ɵɵlistener("click", function VclPaginatorComponent_Template_button_click_13_listener() { return ctx.nextPage(); });
        ɵngcc0.ɵɵelementStart(14, "voxel-icon");
        ɵngcc0.ɵɵtext(15, " seta_direita ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.language === "PT" ? "Itens por p\u00E1gina:" : ctx.language === "ENG" ? "Items per page:" : "Elementos por p\u00E1gina:", " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("selectedValue", ctx.pageSize)("options", ctx.pageSizeOptions)("numVisibleOptions", ctx.numVisibleSelectOptions);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showPageSelect);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.showPageSelect);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showPageSelect);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("disabled", ctx.previousPageDisabled);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("disabled", ctx.nextPageDisabled);
    } }, directives: function () { return [VclSelectComponent$1, ɵngcc2.NgIf, ɵngcc1.VoxelIconComponent, ɵngcc2.NgTemplateOutlet]; }, styles: [".vcl-paginator[_ngcontent-%COMP%]{width:100%;display:flex;justify-content:flex-end;flex-flow:wrap-reverse}.vcl-paginator__button[_ngcontent-%COMP%]{background:none;color:inherit;border:none;margin-left:1.5rem}.vcl-paginator[_ngcontent-%COMP%]   .d-flex[_ngcontent-%COMP%]{display:flex}.vcl-paginator[_ngcontent-%COMP%]   .pipe-color[_ngcontent-%COMP%]{color:#d8d8d8}.vcl-paginator[_ngcontent-%COMP%]   .page-size-pipe[_ngcontent-%COMP%]{display:none}@media only screen and (max-width: 767.98px){.vcl-paginator[_ngcontent-%COMP%]   .hide-pipe-xs[_ngcontent-%COMP%]{display:none}.vcl-paginator[_ngcontent-%COMP%]   .page-size-block[_ngcontent-%COMP%]{flex-basis:100%;flex-flow:row}.vcl-paginator[_ngcontent-%COMP%]   .page-size-select[_ngcontent-%COMP%]{padding-right:0}.vcl-paginator[_ngcontent-%COMP%]   .page-size-pipe[_ngcontent-%COMP%]{display:inline}}"] });
VclPaginatorComponent.propDecorators = {
    language: [{ type: Input }],
    length: [{ type: Input }],
    pageSize: [{ type: Input }],
    pageSizeOptions: [{ type: Input }],
    showPageSelect: [{ type: Input }],
    numVisibleSelectOptions: [{ type: Input }],
    pageIndex: [{ type: Input }],
    page: [{ type: Output }],
    stateOpen: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclPaginatorComponent, [{
        type: Component,
        args: [{
                selector: 'vcl-paginator',
                template: "<div class=\"vcl-paginator\">\n\n  <div class=\"page-size-select voxel-pr-m voxel-pv-m d-flex\">\n\n    {{ language === 'PT' ? 'Itens por p\u00E1gina:' : language === 'ENG' ? \"Items per page:\" : \"Elementos por p\u00E1gina:\" }}\n    <vcl-select class=\"voxel-pl-s\" [selectedValue]=\"pageSize\" [options]=\"pageSizeOptions\" (selectedValueChange)=\"pageSizeChange($event)\" (listOpenChange)=\"listStateChange($event)\" [numVisibleOptions]=\"numVisibleSelectOptions\">\n    </vcl-select>\n  </div>\n\n  <ng-template #itemsCount>\n    <span class=\"hide-pipe-xs pipe-color voxel-pr-m\">|</span>\n    <span> {{ firstVisibleItem }} - {{ lastVisibleItem }} de {{ length }} {{ language === 'PT' ? 'Itens' : language === 'ENG' ? \"Items\" : \"Elementos\" }}</span>\n  </ng-template>\n\n  <div class=\"voxel-pv-m\" *ngIf=\"showPageSelect\">\n    <ng-container *ngTemplateOutlet=\"itemsCount\"></ng-container>\n    <span class=\"voxel-ph-m page-size-pipe pipe-color\">|</span>\n  </div>\n\n  <div class=\"voxel-pv-m\" *ngIf=\"!showPageSelect\">\n    <ng-container *ngTemplateOutlet=\"itemsCount\"></ng-container>\n  </div>\n\n  <ng-container *ngIf=\"showPageSelect\">\n    <span class=\"hide-pipe-xs pipe-color voxel-pv-m voxel-pl-m voxel-pr-s \">|</span>\n    <div class=\"voxel-pv-m d-flex\">\n      <vcl-select class=\"voxel-pl-s\" [selectedValue]=\"pageSelectCurrent\" [options]=\"pageSelectOptions\" (selectedValueChange)=\"pageSelectChange($event)\" (listOpenChange)=\"listStateChange($event)\" [numVisibleOptions]=\"numVisibleSelectOptions\">\n      </vcl-select>\n    </div>\n    <span class=\"voxel-pv-m voxel-pl-m\">\n      {{ language === 'PT' ? 'de' : language === 'ENG' ? \"of\" : \"de\" }} {{ totalPages }}\n      <ng-container>{{\n        language === \"PT\" ? (totalPages > 1 ? 'p\u00E1ginas' : 'p\u00E1gina')\n        : language === \"ENG\" ? (totalPages > 1 ? 'pages' : 'page')\n        : (totalPages > 1 ? 'p\u00E1ginas' : 'p\u00E1gina')\n        }}</ng-container>\n\n    </span>\n  </ng-container>\n\n  <div class=\"voxel-pv-m d-flex\">\n    <button\n      class=\"vcl-paginator__button\"\n      [disabled]=\"previousPageDisabled\"\n      (click)=\"previousPage()\"\n      aria-label=\"p\u00E1gina anterior\">\n      <voxel-icon>\n        seta_esquerda\n      </voxel-icon>\n    </button>\n    <button\n      class=\"vcl-paginator__button\"\n      [disabled]=\"nextPageDisabled\"\n      (click)=\"nextPage()\"\n      aria-label=\"pr\u00F3xima p\u00E1gina\">\n      <voxel-icon>\n        seta_direita\n      </voxel-icon>\n    </button>\n  </div>\n</div>\n",
                styles: [".vcl-paginator{width:100%;display:flex;justify-content:flex-end;flex-flow:wrap-reverse}.vcl-paginator__button{background:none;color:inherit;border:none;margin-left:1.5rem}.vcl-paginator .d-flex{display:flex}.vcl-paginator .pipe-color{color:#d8d8d8}.vcl-paginator .page-size-pipe{display:none}@media only screen and (max-width: 767.98px){.vcl-paginator .hide-pipe-xs{display:none}.vcl-paginator .page-size-block{flex-basis:100%;flex-flow:row}.vcl-paginator .page-size-select{padding-right:0}.vcl-paginator .page-size-pipe{display:inline}}\n"]
            }]
    }], function () { return []; }, { language: [{
            type: Input
        }], length: [{
            type: Input
        }], pageSize: [{
            type: Input
        }], pageSizeOptions: [{
            type: Input
        }], showPageSelect: [{
            type: Input
        }], numVisibleSelectOptions: [{
            type: Input
        }], page: [{
            type: Output
        }], stateOpen: [{
            type: Output
        }], pageIndex: [{
            type: Input
        }] }); })();

/**
 * Componente de seleção
 *
 * *Selection component*
 */
class VclSelectComponent$1 {
    /**
     * @internal
     */
    constructor(eleRef) {
        this.eleRef = eleRef;
        /**
         * Número de opções visíveis sem scroll
         *
         * *Number of visible options without scroll*
         */
        this.numVisibleOptions = 5;
        /**
         * Emite evento quando um novo valor é selecionado
         *
         * *Emits an event when a new value is selected*
         */
        this.selectedValueChange = new EventEmitter();
        /**
         * Emite evento quando a lista é aberta ou fechada
         *
         * *Emits an event when the list is open or closed*
         */
        this.listOpenChange = new EventEmitter();
        /**
         * @internal
         */
        this.showOptions = false;
        /**
         * @internal
         */
        this.listPosition = 'top';
    }
    /**
     * @internal
     */
    clickOutside(event) {
        if (!event.composedPath().includes(this.eleRef.nativeElement)) {
            this.showOptions = false;
            this.openClosed(this.showOptions);
        }
    }
    /**
     * @internal
     */
    onClick() {
        this.showOptions = !this.showOptions;
        this.openClosed(this.showOptions);
        if (!this.showOptions) {
            return;
        }
        // Gets font size
        const fontSize = getComputedStyle(document.documentElement).fontSize
            ? Number(getComputedStyle(document.documentElement).fontSize.replace('px', ''))
            : 16;
        // Calculates each option height: text height + padding (top and bottom)
        const optionHeight = (fontSize + 6) + (fontSize * 2);
        this.listPosition =
            document.documentElement.scrollTop -
                (this.eleRef.nativeElement.offsetTop - window.innerHeight) >=
                this.options.length * optionHeight
                ? 'bottom'
                : 'top';
    }
    /**
     * @internal
     */
    openClosed(state) {
        this.listOpenChange.emit(state);
    }
    /**
     * @internal
     */
    select(option) {
        this.selectedValue = option;
        this.selectedValueChange.emit(this.selectedValue);
        this.openClosed(this.showOptions);
    }
}
VclSelectComponent$1.ɵfac = function VclSelectComponent$1_Factory(t) { return new (t || VclSelectComponent$1)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
VclSelectComponent$1.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VclSelectComponent$1, selectors: [["vcl-select"]], hostBindings: function VclSelectComponent$1_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function VclSelectComponent_1_click_HostBindingHandler($event) { return ctx.clickOutside($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, inputs: { numVisibleOptions: "numVisibleOptions", selectedValue: "selectedValue", options: "options" }, outputs: { selectedValueChange: "selectedValueChange", listOpenChange: "listOpenChange" }, decls: 7, vars: 5, consts: [[1, "vcl-select", 3, "click"], [1, "vcl-select__selected-option"], [1, "voxel-pr-s"], ["size", "s", 1, "vcl-select__selected-option--icon", 3, "ngClass"], ["class", "vcl-select__options", 3, "ngClass", "max-height", 4, "ngIf"], [1, "vcl-select__options", 3, "ngClass"], ["class", "vcl-select__options--option", 3, "click", 4, "ngFor", "ngForOf"], [1, "vcl-select__options--option", 3, "click"]], template: function VclSelectComponent$1_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵlistener("click", function VclSelectComponent_1_Template_button_click_0_listener() { return ctx.onClick(); });
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "span", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "voxel-icon", 3);
        ɵngcc0.ɵɵtext(5, "seta_baixo");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, VclSelectComponent$1_div_6_Template, 2, 4, "div", 4);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.selectedValue, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c20, ctx.showOptions));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showOptions);
    } }, directives: [ɵngcc1.VoxelIconComponent, ɵngcc2.NgClass, ɵngcc2.NgIf, ɵngcc2.NgForOf], styles: [".vcl-select[_ngcontent-%COMP%]{position:relative;background:none;border:none}.vcl-select__selected-option[_ngcontent-%COMP%]{display:flex;cursor:pointer;align-items:center;color:#106eb0;font-weight:700}.vcl-select__selected-option--icon[_ngcontent-%COMP%]{transition:all .5s}.vcl-select__selected-option--icon--expanded[_ngcontent-%COMP%]{transform:rotate(180deg);transition:all .5s}.vcl-select__options[_ngcontent-%COMP%]{display:flex;flex-direction:column;position:absolute;z-index:1000;border-radius:4px;background-color:#fff;box-shadow:0 2px 8px #56504c2e,0 0 2px #56504c29;overflow-y:auto}.vcl-select__options.bottom[_ngcontent-%COMP%]{top:1.5rem}.vcl-select__options.top[_ngcontent-%COMP%]{bottom:1.5rem}.vcl-select__options--option[_ngcontent-%COMP%]{padding:1rem;line-height:1rem;cursor:pointer}.vcl-select__options--option[_ngcontent-%COMP%]:hover{background-color:#faf7f5}"] });
VclSelectComponent$1.ctorParameters = () => [
    { type: ElementRef }
];
VclSelectComponent$1.propDecorators = {
    selectedValue: [{ type: Input }],
    options: [{ type: Input }],
    numVisibleOptions: [{ type: Input }],
    selectedValueChange: [{ type: Output }],
    listOpenChange: [{ type: Output }],
    clickOutside: [{ type: HostListener, args: ['document:click', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclSelectComponent$1, [{
        type: Component,
        args: [{
                selector: 'vcl-select',
                template: "<button class=\"vcl-select\" (click)=\"onClick()\">\n  <div class=\"vcl-select__selected-option\">\n    <span class=\"voxel-pr-s\"> {{selectedValue}} </span>\n    <voxel-icon class=\"vcl-select__selected-option--icon\" [ngClass]=\"{'vcl-select__selected-option--icon--expanded': showOptions}\" size=\"s\">seta_baixo</voxel-icon>\n  </div>\n  <div *ngIf=\"showOptions\" class=\"vcl-select__options\" [ngClass]=\"listPosition\" [style.max-height.rem]=\"(48 / 16) * numVisibleOptions\">\n    <span\n      class=\"vcl-select__options--option\"\n      *ngFor=\"let option of options\"\n      (click)=\"select(option)\">{{option}}</span>\n  </div>\n</button>\n",
                styles: [".vcl-select{position:relative;background:none;border:none}.vcl-select__selected-option{display:flex;cursor:pointer;align-items:center;color:#106eb0;font-weight:700}.vcl-select__selected-option--icon{transition:all .5s}.vcl-select__selected-option--icon--expanded{transform:rotate(180deg);transition:all .5s}.vcl-select__options{display:flex;flex-direction:column;position:absolute;z-index:1000;border-radius:4px;background-color:#fff;box-shadow:0 2px 8px #56504c2e,0 0 2px #56504c29;overflow-y:auto}.vcl-select__options.bottom{top:1.5rem}.vcl-select__options.top{bottom:1.5rem}.vcl-select__options--option{padding:1rem;line-height:1rem;cursor:pointer}.vcl-select__options--option:hover{background-color:#faf7f5}\n"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { numVisibleOptions: [{
            type: Input
        }], selectedValueChange: [{
            type: Output
        }], listOpenChange: [{
            type: Output
        }], 
    /**
     * @internal
     */
    clickOutside: [{
            type: HostListener,
            args: ['document:click', ['$event']]
        }], selectedValue: [{
            type: Input
        }], options: [{
            type: Input
        }] }); })();

/**
 * Diretiva para declaração de colunas para ordenação
 *
 * *Column declaration directive for sorting*
 *
 * @example <th cdk-header-cell *cdkHeaderCellDef vclSortColumn columnName="position"> no. </th>
 */
class VclSortColumnDirective {
    constructor() {
        this.isSortAsc = false;
        this.isSortDesc = false;
        this.none = true;
        this.cursor = 'pointer';
        /**
         * @internal
         */
        this.elementOnFocus = false;
        /**
         * Emite eventos de ordenação captados pela VclSortDirective
         *
         * *Emits sorting events captured by VclSortDirective*
         */
        this.sort = new EventEmitter();
    }
    /**
     * @internal
     */
    pressingKeyEvent(event) {
        if (!this.elementOnFocus) {
            return;
        }
        if (event.code === 'Space' || event.code === 'Enter') {
            this.sorting();
        }
    }
    /**
     * @internal
     */
    onFocus() {
        this.elementOnFocus = true;
    }
    /**
     * @internal
     */
    focusOut() {
        this.elementOnFocus = false;
    }
    /**
     * @internal
     */
    click() {
        this.sorting();
    }
    /**
     * @internal
     */
    sorting() {
        if (!this.isSortAsc && !this.isSortDesc) {
            this.isSortAsc = true;
            this.none = false;
        }
        else if (this.isSortAsc) {
            this.isSortAsc = false;
            this.isSortDesc = true;
        }
        else {
            this.isSortAsc = false;
            this.isSortDesc = false;
            this.none = true;
        }
        this.sort.emit({
            columnName: this.columnName,
            direction: this.isSortAsc ? 'asc' : this.isSortDesc ? 'desc' : '',
        });
    }
}
VclSortColumnDirective.ɵfac = function VclSortColumnDirective_Factory(t) { return new (t || VclSortColumnDirective)(); };
VclSortColumnDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VclSortColumnDirective, selectors: [["", "vclSortColumn", ""]], hostVars: 8, hostBindings: function VclSortColumnDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keyup", function VclSortColumnDirective_keyup_HostBindingHandler($event) { return ctx.pressingKeyEvent($event); }, false, ɵngcc0.ɵɵresolveWindow)("focus", function VclSortColumnDirective_focus_HostBindingHandler($event) { return ctx.onFocus($event); })("focusout", function VclSortColumnDirective_focusout_HostBindingHandler($event) { return ctx.focusOut($event); })("click", function VclSortColumnDirective_click_HostBindingHandler() { return ctx.click(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("cursor", ctx.cursor);
        ɵngcc0.ɵɵclassProp("icon-itaufonts_outline_ordenar_crescente", ctx.isSortAsc)("icon-itaufonts_outline_ordenar_decrescente", ctx.isSortDesc)("icon-itaufonts_outline_ordenar", ctx.none);
    } }, inputs: { columnName: "columnName" }, outputs: { sort: "sort" } });
VclSortColumnDirective.propDecorators = {
    columnName: [{ type: Input }],
    isSortAsc: [{ type: HostBinding, args: ['class.icon-itaufonts_outline_ordenar_crescente',] }],
    isSortDesc: [{ type: HostBinding, args: ['class.icon-itaufonts_outline_ordenar_decrescente',] }],
    none: [{ type: HostBinding, args: ['class.icon-itaufonts_outline_ordenar',] }],
    cursor: [{ type: HostBinding, args: ['style.cursor',] }],
    sort: [{ type: Output }],
    pressingKeyEvent: [{ type: HostListener, args: ['window:keyup', ['$event'],] }],
    onFocus: [{ type: HostListener, args: ['focus', ['$event'],] }],
    focusOut: [{ type: HostListener, args: ['focusout', ['$event'],] }],
    click: [{ type: HostListener, args: ['click',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclSortColumnDirective, [{
        type: Directive,
        args: [{
                selector: '[vclSortColumn]'
            }]
    }], function () { return []; }, { isSortAsc: [{
            type: HostBinding,
            args: ['class.icon-itaufonts_outline_ordenar_crescente']
        }], isSortDesc: [{
            type: HostBinding,
            args: ['class.icon-itaufonts_outline_ordenar_decrescente']
        }], none: [{
            type: HostBinding,
            args: ['class.icon-itaufonts_outline_ordenar']
        }], cursor: [{
            type: HostBinding,
            args: ['style.cursor']
        }], sort: [{
            type: Output
        }], 
    /**
     * @internal
     */
    pressingKeyEvent: [{
            type: HostListener,
            args: ['window:keyup', ['$event']]
        }], 
    /**
     * @internal
     */
    onFocus: [{
            type: HostListener,
            args: ['focus', ['$event']]
        }], 
    /**
     * @internal
     */
    focusOut: [{
            type: HostListener,
            args: ['focusout', ['$event']]
        }], 
    /**
     * @internal
     */
    click: [{
            type: HostListener,
            args: ['click']
        }], columnName: [{
            type: Input
        }] }); })();

/**
 * Diretiva para ordenação de colunas
 *
 * *Column sorting directive*
 *
 * @example <table cdk-table [dataSource]="dataSourcePagination" vclSort (sortData)="sortData2($event)">
 */
class VclSortDirective {
    constructor() {
        /**
         * Emite events de ordenação
         *
         * *Emits sorting events*
         */
        this.sortData = new EventEmitter();
    }
    /**
     * @internal
     */
    ngAfterViewChecked() {
        if (this.sortColumn.toArray().length === 0 || this.subscription) {
            return;
        }
        this.sortColumn.changes.pipe(startWith(this.sortColumn)).subscribe(_changes => {
            if (!!this.subscription) {
                this.subscription.unsubscribe();
            }
            this.subscription = new Subscription();
            this.sortColumn.toArray().forEach(column => {
                this.subscription.add(column.sort.subscribe((sortEvent) => this.handleSorting(sortEvent)));
            });
        });
    }
    /**
     * @internal
     */
    handleSorting(sortEvent) {
        this.sortColumn.toArray().forEach(column => {
            if (column.columnName === sortEvent.columnName) {
                return;
            }
            column.isSortAsc = false;
            column.isSortDesc = false;
            column.none = true;
        });
        this.sortData.emit(sortEvent);
    }
    /**
     * @internal
     */
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
VclSortDirective.ɵfac = function VclSortDirective_Factory(t) { return new (t || VclSortDirective)(); };
VclSortDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VclSortDirective, selectors: [["", "vclSort", ""]], contentQueries: function VclSortDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, VclSortColumnDirective, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.sortColumn = _t);
    } }, outputs: { sortData: "sortData" } });
VclSortDirective.propDecorators = {
    sortColumn: [{ type: ContentChildren, args: [VclSortColumnDirective, { descendants: true },] }],
    sortData: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclSortDirective, [{
        type: Directive,
        args: [{
                selector: '[vclSort]'
            }]
    }], function () { return []; }, { sortData: [{
            type: Output
        }], sortColumn: [{
            type: ContentChildren,
            args: [VclSortColumnDirective, { descendants: true }]
        }] }); })();

class VclTableModule {
}
VclTableModule.ɵfac = function VclTableModule_Factory(t) { return new (t || VclTableModule)(); };
VclTableModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VclTableModule });
VclTableModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CdkTableModule,
            VoxelIconModule,
            CommonModule,
        ], CdkTableModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclTableModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CdkTableModule,
                    VoxelIconModule,
                    CommonModule,
                ],
                declarations: [
                    VclTableComponent,
                    VclPaginatorComponent,
                    VclSortDirective,
                    VclSortColumnDirective,
                    VclSelectComponent$1,
                ],
                exports: [
                    CdkTableModule,
                    VclTableComponent,
                    VclPaginatorComponent,
                    VclSortDirective,
                    VclSortColumnDirective,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VclTableModule, { declarations: function () { return [VclTableComponent, VclPaginatorComponent, VclSortDirective, VclSortColumnDirective, VclSelectComponent$1]; }, imports: function () { return [CdkTableModule,
        VoxelIconModule,
        CommonModule]; }, exports: function () { return [CdkTableModule, VclTableComponent, VclPaginatorComponent, VclSortDirective, VclSortColumnDirective]; } }); })();

/**
 * @internal
 */
let NEXT_ID$5 = 0;
/**
 * Componente/diretiva de mensagem de erro. Deve ser utilizado em conjunto com inputs.
 *
 * *Component/Directive of error message. Must be used in conjunction with input elements*
 *
 * @example basico
 * <span *ngIf="isFormInvalid" vcl-error-msg>
 *  Campo Obrigatório!
 * </span>
 *
 * <example-url>../../demo/index.html#/portfolio/input?componentOnly=true</example-url>
 */
class VclErrorMessageComponent {
    constructor() {
        this.errorMsgId = `vcl-error-msg-${NEXT_ID$5++}`;
        this.errorMsgClasses = 'vcl-error-message';
        this.errorMsgAriaLive = 'polite';
    }
}
VclErrorMessageComponent.ɵfac = function VclErrorMessageComponent_Factory(t) { return new (t || VclErrorMessageComponent)(); };
VclErrorMessageComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VclErrorMessageComponent, selectors: [["vcl-error-msg"], ["", "vcl-error-msg", ""], ["", "vclErrorMsg", ""]], hostVars: 3, hostBindings: function VclErrorMessageComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("id", ctx.errorMsgId)("class", ctx.errorMsgClasses)("aria-live", ctx.errorMsgAriaLive);
    } }, inputs: { errorMsgId: "errorMsgId", errorMsgClasses: "errorMsgClasses", errorMsgAriaLive: "errorMsgAriaLive" }, exportAs: ["vclErrorMsg"], ngContentSelectors: _c3, decls: 4, vars: 0, consts: [[1, "vcl-error-message-icon"], ["size", "S"]], template: function VclErrorMessageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "voxel-icon", 1);
        ɵngcc0.ɵɵtext(2, "aviso_outline");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(3);
    } }, directives: [ɵngcc1.VoxelIconComponent], styles: [".vcl-error-message{font-size:.875rem;line-height:1.5rem;font-family:\"Itau Text\";font-weight:400}.vcl-error-message{display:flex;color:#781b8e}.vcl-error-message voxel-icon{margin-right:.5rem}.vcl-error-message-icon{display:flex;margin-top:.25rem}\n"], encapsulation: 2, changeDetection: 0 });
VclErrorMessageComponent.propDecorators = {
    errorMsgId: [{ type: Input }, { type: HostBinding, args: ['attr.id',] }],
    errorMsgClasses: [{ type: Input }, { type: HostBinding, args: ['attr.class',] }],
    errorMsgAriaLive: [{ type: Input }, { type: HostBinding, args: ['attr.aria-live',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclErrorMessageComponent, [{
        type: Component,
        args: [{
                selector: 'vcl-error-msg, [vcl-error-msg], [vclErrorMsg]',
                exportAs: 'vclErrorMsg',
                template: '<div class="vcl-error-message-icon"><voxel-icon size="S">aviso_outline</voxel-icon></div><ng-content></ng-content>',
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".vcl-error-message{font-size:.875rem;line-height:1.5rem;font-family:\"Itau Text\";font-weight:400}.vcl-error-message{display:flex;color:#781b8e}.vcl-error-message voxel-icon{margin-right:.5rem}.vcl-error-message-icon{display:flex;margin-top:.25rem}\n"]
            }]
    }], function () { return []; }, { errorMsgId: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.id']
        }], errorMsgClasses: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.class']
        }], errorMsgAriaLive: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.aria-live']
        }] }); })();

/**
 * @internal
 */
let NEXT_ID$4 = 0;
/**
 * Componente/diretiva de mensagem de sucesso. Deve ser utilizado em conjunto com inputs.
 *
 * *Component/Directive of success message. Must be used in conjunction with input elements*
 *
 * @example basico
 * <span *ngIf="isFormInvalid" vcl-success-msg>
 *  Campo Sucesso!
 * </span>
 *
 * <example-url>../../demo/index.html#/portfolio/input?componentOnly=true</example-url>
 */
class VclSuccessMessageComponent {
    constructor() {
        this.successMsgId = `vcl-success-msg-${NEXT_ID$4++}`;
        this.successMsgClasses = 'vcl-success-message';
        this.successMsgAriaLive = 'polite';
    }
}
VclSuccessMessageComponent.ɵfac = function VclSuccessMessageComponent_Factory(t) { return new (t || VclSuccessMessageComponent)(); };
VclSuccessMessageComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VclSuccessMessageComponent, selectors: [["vcl-success-msg"], ["", "vcl-success-msg", ""], ["", "vclSuccessMsg", ""]], hostVars: 3, hostBindings: function VclSuccessMessageComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("id", ctx.successMsgId)("class", ctx.successMsgClasses)("aria-live", ctx.successMsgAriaLive);
    } }, inputs: { successMsgId: "successMsgId", successMsgClasses: "successMsgClasses", successMsgAriaLive: "successMsgAriaLive" }, exportAs: ["vclSuccessMsg"], ngContentSelectors: _c3, decls: 4, vars: 0, consts: [[1, "vcl-success-message-icon"], ["size", "S"]], template: function VclSuccessMessageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "voxel-icon", 1);
        ɵngcc0.ɵɵtext(2, "chat_enviado");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(3);
    } }, directives: [ɵngcc1.VoxelIconComponent], styles: [".vcl-success-message{font-size:.875rem;line-height:1.5rem;font-family:\"Itau Text\";font-weight:400}.vcl-success-message{display:flex;color:#007a47}.vcl-success-message voxel-icon{margin-right:.5rem}.vcl-success-message-icon{display:flex;margin-top:.25rem}\n"], encapsulation: 2, changeDetection: 0 });
VclSuccessMessageComponent.propDecorators = {
    successMsgId: [{ type: Input }, { type: HostBinding, args: ['attr.id',] }],
    successMsgClasses: [{ type: Input }, { type: HostBinding, args: ['attr.class',] }],
    successMsgAriaLive: [{ type: Input }, { type: HostBinding, args: ['attr.aria-live',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclSuccessMessageComponent, [{
        type: Component,
        args: [{
                selector: 'vcl-success-msg, [vcl-success-msg], [vclSuccessMsg]',
                exportAs: 'vclSuccessMsg',
                template: '<div class="vcl-success-message-icon"><voxel-icon size="S">chat_enviado</voxel-icon></div><ng-content></ng-content>',
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".vcl-success-message{font-size:.875rem;line-height:1.5rem;font-family:\"Itau Text\";font-weight:400}.vcl-success-message{display:flex;color:#007a47}.vcl-success-message voxel-icon{margin-right:.5rem}.vcl-success-message-icon{display:flex;margin-top:.25rem}\n"]
            }]
    }], function () { return []; }, { successMsgId: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.id']
        }], successMsgClasses: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.class']
        }], successMsgAriaLive: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.aria-live']
        }] }); })();

/**
 * @internal
 */
let NEXT_ID$3 = 0;
/**
 * Os formulários reativos fornecem uma abordagem orientada a modelo para lidar com entradas de formulário
 * cujo valores mudam ao longo do tempo. Este guia mostra como criar e atualizar um controle de formulário simples e
 * validar valores do formulário.
 *
 *
 * ### Acessible
 *
 * <acessible class="not-tested">Acessibilidade - Não testado</acessible>
 *
 *
 * **Module:**
 *
 * `import { VclFormFieldModule } from '@voxel/community';`
 *
 * Este modulo possui todas as diretivas de criação de formulários do tipo formulário reativo.
 *
 * `import { ReactiveFormsModule } from '@angular/forms';`
 *
 * **Component.ts:**
 *
 *  Este import disponibiliza os recursos Angular para criar o formulário reativo.
 *
 * `import { FormControl, Validators, FormGroup } from '@angular/forms';`
 *
 * <example-url>../../demo/index.html#/portfolio/components/input?componentOnly=true</example-url>
 *
 * @example component.ts
 *  form = new FormGroup({
 *    simple: new FormControl(''),
 *    withErrornHelper: new FormControl('', [Validators.required]),
 *    disabled: new FormControl({ value: '', disabled: true }),
 *    disabledWithValue: new FormControl({ value: 'teste', disabled: true }),
 *  });
 *
 */
class VclFormFieldComponent {
    /**
     * @internal
     */
    constructor(voxelSegmentService) {
        this.voxelSegmentService = voxelSegmentService;
        /**
         * @internal
         */
        this._showError = false;
        /**
         * @internal
         */
        this.COMPONENT_NOT_FOUND = 'VclComponents: Não foi possível encontrar o componente <vcl-select> dentro de <vcl-form-field>.';
        /**
         * @internal
         */
        this.selector = 'VclFormFieldComponent';
        /**
         * @internal
         */
        this.segment = this.voxelSegmentService.segment;
        /**
         * @internal
         */
        this.describedById = `vcl-describedby-${NEXT_ID$3}`;
        /**
         * Variavel que define o id do form field
         *
         * *Variable that define the id of form field*
         */
        this.formFieldId = `vcl-form-field-${NEXT_ID$3++}`;
        /**
         * label do campo
         *
         * *field label*
         */
        this.label = 'default';
        /**
         * limite que determina quando o polite estará ativo
         *
         * *threshold that states when the polite will be active*
         */
        this.a11yPoliteThresold = 15;
        /**
         * mensagem de erro para ser exibida quando o campo é inválido
         *
         * *error message to shown when the field to be invalid*
         */
        this.msgErr = `o preenchimento do [rótulo do campo] é obrigatório`;
        /**
         * Ativar / desativar  mensagem de sucesso
         *
         * *Enable/disable success message*
         */
        this.showSuccess = false;
        /**
         * mensagem de sucesso
         *
         * *success message*
         */
        this.msgSuccess = `success message`;
        /**
         * descrição do campo, utitizado para apoiar o preenchimento
         *
         * *field description, used to support to filling*
         */
        this.description = null;
        /**
         * Define o estilo do efeito input
         *
         * *Defines input's effect style*
         */
        this.generalStyle = 'dark';
        /**
         * Mensagem plural/singular para caracteres que faltam
         *
         * *Singular/Plural message for remaining characters*
         */
        this.charactersRemainingLabel = {
            singular: 'caracter restante',
            plural: 'caracteres restantes',
        };
    }
    get showError() {
        return this._showError;
    }
    set showError(value) {
        this._showError = value;
    }
    get labelClasses() {
        return this.field && this.generalStyle === 'dark' ? {
            'vcl-form-field__label': true,
            'voxel-text-s': true,
            'voxel-txt-color-sand-200': this.field.disabled && !this.field.value,
            'voxel-txt-color-sup-purple': this.showError,
            'voxel-txt-color-sup-green': this.showSuccess,
            'voxel-txt-color-sand-600': (!this.field.focused || this.field.disabled)
                && !this.showError
                && !this.showSuccess
                && !this.field.disabled,
            'voxel-text-s-bd': this.field.focused && !this.field.disabled || this.showError || this.showSuccess,
        } : {
            'vcl-form-field__label': true,
            'voxel-text-s': true,
            'voxel-txt-color-sand-0': this.field.disabled
                && !this.field.value
                && !this.field.focused
                && !this.showError
                && !this.showSuccess,
            'voxel-txt-color-sand-600': !this.field.focused || this.field.disabled,
            'vcl-form-field-color-error': this.showError,
            'vcl-form-field-color-success': this.showSuccess,
            'voxel-text-s-bd': this.field.focused && !this.field.disabled || this.showError || this.showSuccess,
        };
    }
    get formFielClasses() {
        return this.field && this.generalStyle === 'dark' ? {
            'voxel-pb-s': true,
            'vcl-form-field__container': true,
            'vcl-form-field__container--single': this.field.nativeElement.type !== 'textarea',
            'vcl-form-field__container--error': this.showError,
            'vcl-form-field__container--success': this.showSuccess,
            'vcl-form-field__container--focus': this.field.focused && !this.field.disabled,
            'vcl-form-field__container--disabled': this.field.disabled,
        } : {
            'voxel-pb-s': true,
            'vcl-form-field__container': true,
            'vcl-form-field__container--single': this.field.nativeElement.type !== 'textarea',
            'vcl-form-field__container--error--light': this.showError,
            'vcl-form-field__container--success--light': this.showSuccess,
            'vcl-form-field__container--focus': this.field.focused && !this.field.disabled,
            'vcl-form-field__container--disabled': this.field.disabled,
        };
    }
    /**
     * @internal
     */
    ariaHandler(charactersRemaining) {
        if (charactersRemaining <= this.a11yPoliteThresold) {
            this.ariaLive = 'polite';
        }
        else {
            this.ariaLive = 'off';
        }
    }
    /**
     * @internal
     */
    countCharacter() {
        const remainigCharacters = this.field.nativeElement.maxLength - this.field.value.length;
        const pluralLabel = `${remainigCharacters} ${this.charactersRemainingLabel.plural} `;
        const singularLabel = `${remainigCharacters} ${this.charactersRemainingLabel.singular} `;
        this.description = remainigCharacters > 1 ? pluralLabel : singularLabel;
        this.ariaHandler(remainigCharacters);
        return this.description;
    }
    /**
     * @internal
     */
    describedHandler() {
        return ((this.field.active || !this.field.focused) && (!this.showError || !this.showSuccess));
    }
    ngAfterContentInit() {
        if (!this.field) {
            throw new Error(this.COMPONENT_NOT_FOUND);
        }
        this.field.errorState.pipe(startWith(false)).subscribe(state => {
            this.showError = state;
            if (this.field.nativeElement.type === 'textarea' && this.field.nativeElement.maxLength >= 0) {
                this.countCharacter();
                this.field.onErrorStatusChange(!!this.description, this.describedById, state);
                this.field.a11yHandler(this.describedHandler(), this.describedById);
                return;
            }
            this.field.onErrorStatusChange(!!this.description, this.describedById, state);
        });
    }
}
VclFormFieldComponent.ɵfac = function VclFormFieldComponent_Factory(t) { return new (t || VclFormFieldComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.VoxelSegmentService)); };
VclFormFieldComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VclFormFieldComponent, selectors: [["vcl-form-field"]], contentQueries: function VclFormFieldComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, VclFieldMixinBase, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.field = _t.first);
    } }, inputs: { formFieldId: "formFieldId", label: "label", a11yPoliteThresold: "a11yPoliteThresold", msgErr: "msgErr", showSuccess: "showSuccess", msgSuccess: "msgSuccess", description: "description", generalStyle: "generalStyle", charactersRemainingLabel: "charactersRemainingLabel" }, ngContentSelectors: _c23, decls: 15, vars: 23, consts: [[1, "form-field", 3, "id"], [3, "ngClass"], [3, "for", "ngClass"], ["suffix", ""], ["vclErrorMsg", "", 3, "errorMsgId", 4, "ngIf", "ngIfElse"], ["vclSuccessMsg", "", 3, "successMsgId", 4, "ngIf"], ["descTemplate", ""], ["vclErrorMsg", "", 3, "errorMsgId"], ["vclSuccessMsg", "", 3, "successMsgId"], ["vclHintField", "", 3, "hintFieldId", "hintMsgAriaLive", 4, "ngIf"], ["vclHintField", "", 3, "hintFieldId", "hintMsgAriaLive"]], template: function VclFormFieldComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c21);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵpipe(2, "async");
        ɵngcc0.ɵɵelementStart(3, "label", 2);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 1);
        ɵngcc0.ɵɵprojection(6);
        ɵngcc0.ɵɵelementStart(7, "div", null, 3);
        ɵngcc0.ɵɵpipe(9, "async");
        ɵngcc0.ɵɵprojection(10, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(11, VclFormFieldComponent_span_11_Template, 2, 2, "span", 4);
        ɵngcc0.ɵɵtemplate(12, VclFormFieldComponent_span_12_Template, 2, 2, "span", 5);
        ɵngcc0.ɵɵtemplate(13, VclFormFieldComponent_ng_template_13_Template, 1, 1, "ng-template", null, 6, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(8);
        const _r3 = ɵngcc0.ɵɵreference(14);
        ɵngcc0.ɵɵproperty("id", ctx.formFieldId);
        ɵngcc0.ɵɵattribute("generalStyle", ctx.generalStyle);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ɵngcc0.ɵɵpipeBind1(2, 17, ctx.segment));
        ɵngcc0.ɵɵproperty("ngClass", ctx.formFielClasses);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("for", ctx.field == null ? null : ctx.field.controlId)("ngClass", ctx.labelClasses);
        ɵngcc0.ɵɵattribute("id", (ctx.field == null ? null : ctx.field.labelId) ? ctx.field == null ? null : ctx.field.labelId : null);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.label, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(21, _c22, _r0.innerHTML.trim() ? true : false));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassMapInterpolate1("", ɵngcc0.ɵɵpipeBind1(9, 19, ctx.segment), " vcl-form-field__suffix");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showError && !ctx.showSuccess)("ngIfElse", _r3);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showSuccess);
    } }, directives: function () { return [ɵngcc2.NgClass, ɵngcc2.NgIf, VclErrorMessageComponent, VclSuccessMessageComponent, VclHintFieldDirective]; }, pipes: function () { return [ɵngcc2.AsyncPipe]; }, styles: ["[_nghost-%COMP%]{display:block}  .vcl-input-color,   .voxel-input{color:#231d19}  .vcl-color-hint-field{color:#56504c}  div[generalStyle=light] .vcl-input-color,   div[generalStyle=light] .voxel-input,   div[generalStyle=light] .vcl-color-hint-field{color:#fff}div[generalStyle=light][_ngcontent-%COMP%]   .vcl-error-message[_ngcontent-%COMP%]{color:#bf6ed2}div[generalStyle=light][_ngcontent-%COMP%]   .vcl-success-message[_ngcontent-%COMP%]{color:#6cd0a6}div[generalStyle=light][_ngcontent-%COMP%]   .vcl-form-field__label[_ngcontent-%COMP%]{color:#fff}div[generalStyle=light][_ngcontent-%COMP%]   .vcl-form-field__container[_ngcontent-%COMP%]{border-bottom:.0625rem solid #fff}.vcl-form-field__label[_ngcontent-%COMP%]{display:block;width:100%}.vcl-form-field-color-error[_ngcontent-%COMP%]{color:#bf6ed2!important}.vcl-form-field-color-success[_ngcontent-%COMP%]{color:#6cd0a6!important}.vcl-form-field__content[_ngcontent-%COMP%]{position:relative}.vcl-form-field__content--suffix[_ngcontent-%COMP%]     .vcl-input{padding-right:2.5rem}.vcl-form-field__container[_ngcontent-%COMP%]{width:100%;border-bottom:.0625rem solid #706A66;box-sizing:border-box;position:relative}.vcl-form-field__container--error[_ngcontent-%COMP%]{border-bottom:.125rem solid #781b8e}.vcl-form-field__container--error--light[_ngcontent-%COMP%]{border-bottom:.125rem solid #bf6ed2!important}.vcl-form-field__container--success[_ngcontent-%COMP%]{border-bottom:.125rem solid #007a47}.vcl-form-field__container--success--light[_ngcontent-%COMP%]{border-bottom:.125rem solid #6cd0a6!important}.vcl-form-field__container--focus[_ngcontent-%COMP%]{border-width:.125rem}.vcl-form-field__container--disabled[_ngcontent-%COMP%]{border-color:#d6d0cc;color:#706a66}.vcl-form-field__container--single[_ngcontent-%COMP%]{height:3.75rem}.vcl-form-field__suffix[_ngcontent-%COMP%]{pointer-events:none;position:absolute;right:0;top:50%;transform:translateY(-50%)}.varejo.vcl-form-field__container.vcl-form-field__container--focus[_ngcontent-%COMP%]:not(.vcl-form-field__container--error).vcl-form-field__container--focus:not(.vcl-form-field__container--success){border-color:#ec7000}.personnalite.vcl-form-field__container.vcl-form-field__container--focus[_ngcontent-%COMP%]:not(.vcl-form-field__container--error).vcl-form-field__container--focus:not(.vcl-form-field__container--success){border-color:#d0a967}.uniclass.vcl-form-field__container.vcl-form-field__container--focus[_ngcontent-%COMP%]:not(.vcl-form-field__container--error).vcl-form-field__container--focus:not(.vcl-form-field__container--success){border-color:#ec7000}.empresas.vcl-form-field__container.vcl-form-field__container--focus[_ngcontent-%COMP%]:not(.vcl-form-field__container--error).vcl-form-field__container--focus:not(.vcl-form-field__container--success){border-color:#ec7000}.itaucard.vcl-form-field__container.vcl-form-field__container--focus[_ngcontent-%COMP%]:not(.vcl-form-field__container--error).vcl-form-field__container--focus:not(.vcl-form-field__container--success){border-color:#ec7000}.private.vcl-form-field__container.vcl-form-field__container--focus[_ngcontent-%COMP%]:not(.vcl-form-field__container--error).vcl-form-field__container--focus:not(.vcl-form-field__container--success){border-color:#ec7000}.parceiro-itaucard.vcl-form-field__container.vcl-form-field__container--focus[_ngcontent-%COMP%]:not(.vcl-form-field__container--error).vcl-form-field__container--focus:not(.vcl-form-field__container--success){border-color:#ec7000}.parceiro-credicard.vcl-form-field__container.vcl-form-field__container--focus[_ngcontent-%COMP%]:not(.vcl-form-field__container--error).vcl-form-field__container--focus:not(.vcl-form-field__container--success){border-color:#0d456f}.parceiro-hipercard.vcl-form-field__container.vcl-form-field__container--focus[_ngcontent-%COMP%]:not(.vcl-form-field__container--error).vcl-form-field__container--focus:not(.vcl-form-field__container--success){border-color:#ba1319}.parceiro-magazine-luiza.vcl-form-field__container.vcl-form-field__container--focus[_ngcontent-%COMP%]:not(.vcl-form-field__container--error).vcl-form-field__container--focus:not(.vcl-form-field__container--success){border-color:#0083ca}.personal-bank.vcl-form-field__container.vcl-form-field__container--focus[_ngcontent-%COMP%]:not(.vcl-form-field__container--error).vcl-form-field__container--focus:not(.vcl-form-field__container--success){border-color:#ce9141}.itau-bba.vcl-form-field__container.vcl-form-field__container--focus[_ngcontent-%COMP%]:not(.vcl-form-field__container--error).vcl-form-field__container--focus:not(.vcl-form-field__container--success){border-color:#2449cc}.varejo.vcl-form-field__suffix[_ngcontent-%COMP%]{color:#ec7000}.personnalite.vcl-form-field__suffix[_ngcontent-%COMP%]{color:#d0a967}.uniclass.vcl-form-field__suffix[_ngcontent-%COMP%]{color:#ec7000}.empresas.vcl-form-field__suffix[_ngcontent-%COMP%]{color:#ec7000}.itaucard.vcl-form-field__suffix[_ngcontent-%COMP%]{color:#ec7000}.private.vcl-form-field__suffix[_ngcontent-%COMP%]{color:#ec7000}.parceiro-itaucard.vcl-form-field__suffix[_ngcontent-%COMP%]{color:#ec7000}.parceiro-credicard.vcl-form-field__suffix[_ngcontent-%COMP%]{color:#0d456f}.parceiro-hipercard.vcl-form-field__suffix[_ngcontent-%COMP%]{color:#ba1319}.parceiro-magazine-luiza.vcl-form-field__suffix[_ngcontent-%COMP%]{color:#0083ca}.personal-bank.vcl-form-field__suffix[_ngcontent-%COMP%]{color:#ce9141}.itau-bba.vcl-form-field__suffix[_ngcontent-%COMP%]{color:#2449cc}.personnalite.vcl-form-field__container.vcl-form-field__container--focus[_ngcontent-%COMP%]:not(.vcl-form-field__container--error).vcl-form-field__container--focus:not(.vcl-form-field__container--success){border-color:#876632}"] });
VclFormFieldComponent.ctorParameters = () => [
    { type: VoxelSegmentService }
];
VclFormFieldComponent.propDecorators = {
    formFieldId: [{ type: Input }],
    label: [{ type: Input }],
    a11yPoliteThresold: [{ type: Input }],
    msgErr: [{ type: Input }],
    showSuccess: [{ type: Input }],
    msgSuccess: [{ type: Input }],
    description: [{ type: Input }],
    generalStyle: [{ type: Input }],
    field: [{ type: ContentChild, args: [VclFieldMixinBase, { static: true },] }],
    charactersRemainingLabel: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclFormFieldComponent, [{
        type: Component,
        args: [{
                selector: 'vcl-form-field',
                template: "<div class=\"form-field\" \n[id]=\"formFieldId\"\n[attr.generalStyle]=\"generalStyle\">\n  <div\n    [ngClass]=\"formFielClasses\"\n    class=\"{{ segment | async }}\"\n  >\n    <label\n      [for]=\"field?.controlId\"\n      [ngClass]=\"labelClasses\"\n      [attr.id]=\"field?.labelId ? field?.labelId : null\"\n    >\n      {{ label }}\n    </label>\n    <div\n    [ngClass]=\"{\n        'vcl-form-field__content': true,\n        'vcl-form-field__content--suffix': suffix.innerHTML.trim() ? true : false\n      }\"    \n    >\n      <ng-content></ng-content>\n      <div #suffix class=\"{{ segment | async }} vcl-form-field__suffix\">\n        <ng-content select=\"voxel-icon\"></ng-content>\n      </div> \n    </div>   \n  </div>\n  <span\n    *ngIf=\"showError && !showSuccess; else descTemplate\"\n    vclErrorMsg\n    [errorMsgId]=\"describedById\"\n  >\n    {{ msgErr }}\n  </span>\n  <span\n    *ngIf=\"showSuccess\"\n    vclSuccessMsg\n    [successMsgId]=\"describedById\"\n  >\n    {{ msgSuccess }}\n  </span>\n  <ng-template #descTemplate>\n    <span\n      *ngIf=\"description && !showSuccess\"\n      vclHintField\n      [hintFieldId]=\"describedById\"\n      [hintMsgAriaLive]=\"ariaLive\"\n    >\n      {{ description }}\n    </span>\n  </ng-template>\n</div>\n",
                styles: [":host{display:block}::ng-deep .vcl-input-color,::ng-deep .voxel-input{color:#231d19}::ng-deep .vcl-color-hint-field{color:#56504c}::ng-deep div[generalStyle=light] .vcl-input-color,::ng-deep div[generalStyle=light] .voxel-input,::ng-deep div[generalStyle=light] .vcl-color-hint-field{color:#fff}div[generalStyle=light] .vcl-error-message{color:#bf6ed2}div[generalStyle=light] .vcl-success-message{color:#6cd0a6}div[generalStyle=light] .vcl-form-field__label{color:#fff}div[generalStyle=light] .vcl-form-field__container{border-bottom:.0625rem solid #fff}.vcl-form-field__label{display:block;width:100%}.vcl-form-field-color-error{color:#bf6ed2!important}.vcl-form-field-color-success{color:#6cd0a6!important}.vcl-form-field__content{position:relative}.vcl-form-field__content--suffix ::ng-deep .vcl-input{padding-right:2.5rem}.vcl-form-field__container{width:100%;border-bottom:.0625rem solid #706A66;box-sizing:border-box;position:relative}.vcl-form-field__container--error{border-bottom:.125rem solid #781b8e}.vcl-form-field__container--error--light{border-bottom:.125rem solid #bf6ed2!important}.vcl-form-field__container--success{border-bottom:.125rem solid #007a47}.vcl-form-field__container--success--light{border-bottom:.125rem solid #6cd0a6!important}.vcl-form-field__container--focus{border-width:.125rem}.vcl-form-field__container--disabled{border-color:#d6d0cc;color:#706a66}.vcl-form-field__container--single{height:3.75rem}.vcl-form-field__suffix{pointer-events:none;position:absolute;right:0;top:50%;transform:translateY(-50%)}.varejo.vcl-form-field__container.vcl-form-field__container--focus:not(.vcl-form-field__container--error).vcl-form-field__container--focus:not(.vcl-form-field__container--success){border-color:#ec7000}.personnalite.vcl-form-field__container.vcl-form-field__container--focus:not(.vcl-form-field__container--error).vcl-form-field__container--focus:not(.vcl-form-field__container--success){border-color:#d0a967}.uniclass.vcl-form-field__container.vcl-form-field__container--focus:not(.vcl-form-field__container--error).vcl-form-field__container--focus:not(.vcl-form-field__container--success){border-color:#ec7000}.empresas.vcl-form-field__container.vcl-form-field__container--focus:not(.vcl-form-field__container--error).vcl-form-field__container--focus:not(.vcl-form-field__container--success){border-color:#ec7000}.itaucard.vcl-form-field__container.vcl-form-field__container--focus:not(.vcl-form-field__container--error).vcl-form-field__container--focus:not(.vcl-form-field__container--success){border-color:#ec7000}.private.vcl-form-field__container.vcl-form-field__container--focus:not(.vcl-form-field__container--error).vcl-form-field__container--focus:not(.vcl-form-field__container--success){border-color:#ec7000}.parceiro-itaucard.vcl-form-field__container.vcl-form-field__container--focus:not(.vcl-form-field__container--error).vcl-form-field__container--focus:not(.vcl-form-field__container--success){border-color:#ec7000}.parceiro-credicard.vcl-form-field__container.vcl-form-field__container--focus:not(.vcl-form-field__container--error).vcl-form-field__container--focus:not(.vcl-form-field__container--success){border-color:#0d456f}.parceiro-hipercard.vcl-form-field__container.vcl-form-field__container--focus:not(.vcl-form-field__container--error).vcl-form-field__container--focus:not(.vcl-form-field__container--success){border-color:#ba1319}.parceiro-magazine-luiza.vcl-form-field__container.vcl-form-field__container--focus:not(.vcl-form-field__container--error).vcl-form-field__container--focus:not(.vcl-form-field__container--success){border-color:#0083ca}.personal-bank.vcl-form-field__container.vcl-form-field__container--focus:not(.vcl-form-field__container--error).vcl-form-field__container--focus:not(.vcl-form-field__container--success){border-color:#ce9141}.itau-bba.vcl-form-field__container.vcl-form-field__container--focus:not(.vcl-form-field__container--error).vcl-form-field__container--focus:not(.vcl-form-field__container--success){border-color:#2449cc}.varejo.vcl-form-field__suffix{color:#ec7000}.personnalite.vcl-form-field__suffix{color:#d0a967}.uniclass.vcl-form-field__suffix{color:#ec7000}.empresas.vcl-form-field__suffix{color:#ec7000}.itaucard.vcl-form-field__suffix{color:#ec7000}.private.vcl-form-field__suffix{color:#ec7000}.parceiro-itaucard.vcl-form-field__suffix{color:#ec7000}.parceiro-credicard.vcl-form-field__suffix{color:#0d456f}.parceiro-hipercard.vcl-form-field__suffix{color:#ba1319}.parceiro-magazine-luiza.vcl-form-field__suffix{color:#0083ca}.personal-bank.vcl-form-field__suffix{color:#ce9141}.itau-bba.vcl-form-field__suffix{color:#2449cc}.personnalite.vcl-form-field__container.vcl-form-field__container--focus:not(.vcl-form-field__container--error).vcl-form-field__container--focus:not(.vcl-form-field__container--success){border-color:#876632}\n"]
            }]
    }], function () { return [{ type: ɵngcc1.VoxelSegmentService }]; }, { formFieldId: [{
            type: Input
        }], label: [{
            type: Input
        }], a11yPoliteThresold: [{
            type: Input
        }], msgErr: [{
            type: Input
        }], showSuccess: [{
            type: Input
        }], msgSuccess: [{
            type: Input
        }], description: [{
            type: Input
        }], generalStyle: [{
            type: Input
        }], charactersRemainingLabel: [{
            type: Input
        }], field: [{
            type: ContentChild,
            args: [VclFieldMixinBase, { static: true }]
        }] }); })();

/**
 * @internal
 */
let NEXT_ID$2 = 0;
class VclHintFieldDirective {
    constructor() {
        this.hintFieldId = `vcl-hint-field-${NEXT_ID$2++}`;
        this.hintFieldClasses = 'voxel-text-s vcl-color-hint-field';
        this.hintMsgAriaLive = 'off';
    }
}
VclHintFieldDirective.ɵfac = function VclHintFieldDirective_Factory(t) { return new (t || VclHintFieldDirective)(); };
VclHintFieldDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VclHintFieldDirective, selectors: [["vcl-hint-field"], ["", "vcl-hint-field", ""], ["", "vclHintField", ""]], hostVars: 3, hostBindings: function VclHintFieldDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("id", ctx.hintFieldId)("class", ctx.hintFieldClasses)("aria-live", ctx.hintMsgAriaLive);
    } }, inputs: { hintFieldId: "hintFieldId", hintFieldClasses: "hintFieldClasses", hintMsgAriaLive: "hintMsgAriaLive" }, exportAs: ["vclHintField"] });
VclHintFieldDirective.propDecorators = {
    hintFieldId: [{ type: Input }, { type: HostBinding, args: ['attr.id',] }],
    hintFieldClasses: [{ type: Input }, { type: HostBinding, args: ['attr.class',] }],
    hintMsgAriaLive: [{ type: Input }, { type: HostBinding, args: ['attr.aria-live',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclHintFieldDirective, [{
        type: Directive,
        args: [{
                selector: 'vcl-hint-field, [vcl-hint-field], [vclHintField]',
                exportAs: 'vclHintField'
            }]
    }], function () { return []; }, { hintFieldId: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.id']
        }], hintFieldClasses: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.class']
        }], hintMsgAriaLive: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.aria-live']
        }] }); })();

const formFieldComponents = [
    VclErrorMessageComponent,
    VclSuccessMessageComponent,
    VclFormFieldComponent,
    VclHintFieldDirective,
    VclFieldMixinBase,
];
class VclFormFieldModule {
}
VclFormFieldModule.ɵfac = function VclFormFieldModule_Factory(t) { return new (t || VclFormFieldModule)(); };
VclFormFieldModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VclFormFieldModule });
VclFormFieldModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            VoxelIconModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclFormFieldModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    VoxelIconModule,
                ],
                declarations: formFieldComponents,
                exports: formFieldComponents
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VclFormFieldModule, { declarations: function () { return [VclErrorMessageComponent, VclSuccessMessageComponent, VclFormFieldComponent, VclHintFieldDirective, VclFieldMixinBase]; }, imports: function () { return [CommonModule,
        VoxelIconModule]; }, exports: function () { return [VclErrorMessageComponent, VclSuccessMessageComponent, VclFormFieldComponent, VclHintFieldDirective, VclFieldMixinBase]; } }); })();

/**
 *
 * ### Acessible
 *
 * <acessible class="not-tested">Acessibilidade - Não testado</acessible>
 *
 * **Module:**
 *
 * `import { VclInternalSearchModule } from '@voxel/community';`
 *
 * <example-url>../../demo/index.html#/portfolio/components/internal-search?componentOnly=true</example-url>
 *
 * @example Exemplo de busca interna
 *   <vcl-internal-search placeholder="seu placeholder aqui"
 *   focus="seu foco aqui" [(stringSearch)]="stringSearch">
 *   </vcl-internal-search>
 *
 * @example Exemplo de busca interna desativado
 *   <vcl-internal-search placeholder="seu placeholder aqui"
 *   focus="seu foco aqui" disabled='true'>
 *   </vcl-internal-search>
 *
 * @example Exemplo de busca interna(tema escuro)
 *  <vcl-internal-search placeholder="seu placeholder aqui"
 *     focus="seu foco aqui" dark='true'>
 *     </vcl-internal-search>
 *
 * @example Exemplo de busca interna desativado(tema escuro)
 *  <vcl-internal-search placeholder="seu placeholder aqui"
 *     focus="seu foco aqui" dark='true' disabled='true'>
 *  </vcl-internal-search>
 *
 */
class VclInternalSearchComponent {
    /**
     * @internal
     */
    constructor(segmentService) {
        this.segmentService = segmentService;
        /**
         * Define o valor buscado pelo componente
         */
        this.stringSearch = '';
        /**
         * Define o placeholder buscado pelo componente
         */
        this.placeholder = '';
        /**
         * Define o placeholder buscado pelo componente
         */
        this.focus = '';
        /**
         * Desabilitar interação com o componente
         */
        this.disabled = false;
        /**
         * tema escuro
         */
        this.dark = false;
        /**
         * Evento disparado quando altera o valor do input
         */
        this.stringSearchChange = new EventEmitter();
        /**
         * @internal
         */
        this.segment = this.segmentService.segment;
    }
    /**
     * @internal
     */
    clearInput() {
        this.stringSearch = '';
        this.inputSearch.nativeElement.value = '';
        this.inputSearch.nativeElement.focus();
        this.stringSearchChange.emit('');
    }
    /**
     * @internal
     */
    onChangeValue(value) {
        this.stringSearchChange.emit(value);
    }
}
VclInternalSearchComponent.ɵfac = function VclInternalSearchComponent_Factory(t) { return new (t || VclInternalSearchComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.VoxelSegmentService)); };
VclInternalSearchComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VclInternalSearchComponent, selectors: [["vcl-internal-search"]], viewQuery: function VclInternalSearchComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c24, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputSearch = _t.first);
    } }, inputs: { stringSearch: "stringSearch", placeholder: "placeholder", focus: "focus", disabled: "disabled", dark: "dark" }, outputs: { stringSearchChange: "stringSearchChange" }, decls: 10, vars: 33, consts: [[3, "ngClass"], [3, "ngClass", "placeholder", "disabled", "ngModel", "readonly", "ngModelChange", "focus", "blur", "input", "keydown.esc"], ["inputSearch", ""], ["size", "s", "role", "button", 3, "ngClass", "hidden", "click", "keyup.enter"]], template: function VclInternalSearchComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵpipe(1, "async");
        ɵngcc0.ɵɵelementStart(2, "voxel-icon", 0);
        ɵngcc0.ɵɵpipe(3, "async");
        ɵngcc0.ɵɵtext(4, " busca_outline\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "input", 1, 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function VclInternalSearchComponent_Template_input_ngModelChange_5_listener($event) { return ctx.stringSearch = $event; })("focus", function VclInternalSearchComponent_Template_input_focus_5_listener() { ɵngcc0.ɵɵrestoreView(_r1); const _r0 = ɵngcc0.ɵɵreference(6); return _r0.placeholder = ctx.focus; })("blur", function VclInternalSearchComponent_Template_input_blur_5_listener() { ɵngcc0.ɵɵrestoreView(_r1); const _r0 = ɵngcc0.ɵɵreference(6); return _r0.placeholder = ctx.placeholder; })("input", function VclInternalSearchComponent_Template_input_input_5_listener($event) { return ctx.onChangeValue($event.target.value); })("keydown.esc", function VclInternalSearchComponent_Template_input_keydown_esc_5_listener() { return ctx.clearInput(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "voxel-icon", 3);
        ɵngcc0.ɵɵlistener("click", function VclInternalSearchComponent_Template_voxel_icon_click_7_listener() { return ctx.clearInput(); })("keyup.enter", function VclInternalSearchComponent_Template_voxel_icon_keyup_enter_7_listener() { return ctx.clearInput(); });
        ɵngcc0.ɵɵpipe(8, "async");
        ɵngcc0.ɵɵtext(9, " fechar\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("vcl-internal-search ", ɵngcc0.ɵɵpipeBind1(1, 19, ctx.segment), "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassMap(ɵngcc0.ɵɵpipeBind1(3, 21, ctx.segment));
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(25, _c25, ctx.dark, ctx.disabled));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵclassProp("is-filled", ctx.stringSearch);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(28, _c26, ctx.dark, ctx.disabled))("placeholder", ctx.placeholder)("disabled", ctx.disabled)("ngModel", ctx.stringSearch)("readonly", ctx.disabled);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassMap(ɵngcc0.ɵɵpipeBind1(8, 23, ctx.segment));
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(31, _c27, ctx.dark))("hidden", !ctx.stringSearch);
    } }, directives: [ɵngcc1.VoxelIconComponent, ɵngcc2.NgClass, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], pipes: [ɵngcc2.AsyncPipe], styles: [".vcl-internal-search[_ngcontent-%COMP%]{position:relative;display:flex}.vcl-internal-search__icon[_ngcontent-%COMP%]{font-size:1.875rem;position:absolute;height:2rem;left:0;top:50%;color:inherit;transform:translateY(-50%);pointer-events:none}.vcl-internal-search__icon--disabled[_ngcontent-%COMP%]{opacity:.5}.vcl-internal-search__icon--dark[_ngcontent-%COMP%]{color:#fff!important}.vcl-internal-search__input[_ngcontent-%COMP%]{font-family:\"Itau Text\";font-size:1.1875rem;border:none;line-height:2rem;height:2rem;width:100%;padding-left:2.5rem;transition:width .3s ease;outline:none;text-overflow:ellipsis}.vcl-internal-search__input[disabled][_ngcontent-%COMP%]{background:transparent}.vcl-internal-search__input[disabled][_ngcontent-%COMP%]::input-placeholder{font-size:\"19px\";color:#d9d3cf}.vcl-internal-search__input[disabled][_ngcontent-%COMP%]::placeholder{font-size:\"19px\";color:#d9d3cf;opacity:1}.vcl-internal-search__input[disabled][_ngcontent-%COMP%]:placeholder{font-size:\"19px\";color:#d9d3cf;opacity:1}.vcl-internal-search__input--dark[_ngcontent-%COMP%]{background:transparent;color:#fff}.vcl-internal-search__input--dark[_ngcontent-%COMP%]::input-placeholder{font-size:\"19px\";color:#fff}.vcl-internal-search__input--dark[_ngcontent-%COMP%]::placeholder{font-size:\"19px\";color:#fff;opacity:1}.vcl-internal-search__input--dark[_ngcontent-%COMP%]:placeholder{font-size:\"19px\";color:#fff;opacity:1}.vcl-internal-search__input--dark[_ngcontent-%COMP%]:focus::input-placeholder, .vcl-internal-search__input--dark.is-filled[_ngcontent-%COMP%]::input-placeholder{font-size:\"19px\";color:#fff}.vcl-internal-search__input--dark[_ngcontent-%COMP%]:focus::placeholder, .vcl-internal-search__input--dark.is-filled[_ngcontent-%COMP%]::placeholder{font-size:\"19px\";color:#fff;opacity:1}.vcl-internal-search__input--dark[_ngcontent-%COMP%]:focus:placeholder, .vcl-internal-search__input--dark.is-filled[_ngcontent-%COMP%]:placeholder{font-size:\"19px\";color:#fff;opacity:1}.vcl-internal-search__input--dark[disabled][_ngcontent-%COMP%]{background:transparent!important}.vcl-internal-search__input--dark[disabled][_ngcontent-%COMP%]::input-placeholder{font-size:\"19px\";color:#d9d3cf}.vcl-internal-search__input--dark[disabled][_ngcontent-%COMP%]::placeholder{font-size:\"19px\";color:#d9d3cf;opacity:1}.vcl-internal-search__input--dark[disabled][_ngcontent-%COMP%]:placeholder{font-size:\"19px\";color:#d9d3cf;opacity:1}.vcl-internal-search__input--dark--disabled[_ngcontent-%COMP%]{opacity:.5}.vcl-internal-search__clear-icon[_ngcontent-%COMP%]{position:relative;display:none;cursor:pointer;-webkit-appearance:none;appearance:none;border:0;background:none;padding:0;margin-left:1.25rem;font-size:1.5rem;display:inline-block;transform:translateY(.125rem)}.vcl-internal-search__clear-icon--dark[_ngcontent-%COMP%]{color:#fff!important}.vcl-internal-search__clear-icon[hidden][_ngcontent-%COMP%]{display:none}.varejo.vcl-internal-search__icon[_ngcontent-%COMP%]{color:#ec7000}.varejo.vcl-internal-search__icon[_ngcontent-%COMP%]:disabled{color:#ff8a20}.personnalite.vcl-internal-search__icon[_ngcontent-%COMP%]{color:#d0a967}.personnalite.vcl-internal-search__icon[_ngcontent-%COMP%]:disabled{color:#dcbf8e}.uniclass.vcl-internal-search__icon[_ngcontent-%COMP%]{color:#ec7000}.uniclass.vcl-internal-search__icon[_ngcontent-%COMP%]:disabled{color:#ff8a20}.empresas.vcl-internal-search__icon[_ngcontent-%COMP%]{color:#ec7000}.empresas.vcl-internal-search__icon[_ngcontent-%COMP%]:disabled{color:#ff8a20}.itaucard.vcl-internal-search__icon[_ngcontent-%COMP%]{color:#ec7000}.itaucard.vcl-internal-search__icon[_ngcontent-%COMP%]:disabled{color:#ff8a20}.private.vcl-internal-search__icon[_ngcontent-%COMP%]{color:#ec7000}.private.vcl-internal-search__icon[_ngcontent-%COMP%]:disabled{color:#ff8a20}.parceiro-itaucard.vcl-internal-search__icon[_ngcontent-%COMP%]{color:#ec7000}.parceiro-itaucard.vcl-internal-search__icon[_ngcontent-%COMP%]:disabled{color:#ff8a20}.parceiro-credicard.vcl-internal-search__icon[_ngcontent-%COMP%]{color:#0d456f}.parceiro-credicard.vcl-internal-search__icon[_ngcontent-%COMP%]:disabled{color:#12619d}.parceiro-hipercard.vcl-internal-search__icon[_ngcontent-%COMP%]{color:#ba1319}.parceiro-hipercard.vcl-internal-search__icon[_ngcontent-%COMP%]:disabled{color:#e71920}.parceiro-magazine-luiza.vcl-internal-search__icon[_ngcontent-%COMP%]{color:#0083ca}.parceiro-magazine-luiza.vcl-internal-search__icon[_ngcontent-%COMP%]:disabled{color:#00a4fd}.personal-bank.vcl-internal-search__icon[_ngcontent-%COMP%]{color:#ce9141}.personal-bank.vcl-internal-search__icon[_ngcontent-%COMP%]:disabled{color:#d8a86a}.itau-bba.vcl-internal-search__icon[_ngcontent-%COMP%]{color:#2449cc}.itau-bba.vcl-internal-search__icon[_ngcontent-%COMP%]:disabled{color:#4567de}.varejo.vcl-internal-search__clear-icon[_ngcontent-%COMP%]{color:#ec7000}.varejo.vcl-internal-search__clear-icon[_ngcontent-%COMP%]:disabled{color:#ff8a20}.personnalite.vcl-internal-search__clear-icon[_ngcontent-%COMP%]{color:#d0a967}.personnalite.vcl-internal-search__clear-icon[_ngcontent-%COMP%]:disabled{color:#dcbf8e}.uniclass.vcl-internal-search__clear-icon[_ngcontent-%COMP%]{color:#ec7000}.uniclass.vcl-internal-search__clear-icon[_ngcontent-%COMP%]:disabled{color:#ff8a20}.empresas.vcl-internal-search__clear-icon[_ngcontent-%COMP%]{color:#ec7000}.empresas.vcl-internal-search__clear-icon[_ngcontent-%COMP%]:disabled{color:#ff8a20}.itaucard.vcl-internal-search__clear-icon[_ngcontent-%COMP%]{color:#ec7000}.itaucard.vcl-internal-search__clear-icon[_ngcontent-%COMP%]:disabled{color:#ff8a20}.private.vcl-internal-search__clear-icon[_ngcontent-%COMP%]{color:#ec7000}.private.vcl-internal-search__clear-icon[_ngcontent-%COMP%]:disabled{color:#ff8a20}.parceiro-itaucard.vcl-internal-search__clear-icon[_ngcontent-%COMP%]{color:#ec7000}.parceiro-itaucard.vcl-internal-search__clear-icon[_ngcontent-%COMP%]:disabled{color:#ff8a20}.parceiro-credicard.vcl-internal-search__clear-icon[_ngcontent-%COMP%]{color:#0d456f}.parceiro-credicard.vcl-internal-search__clear-icon[_ngcontent-%COMP%]:disabled{color:#12619d}.parceiro-hipercard.vcl-internal-search__clear-icon[_ngcontent-%COMP%]{color:#ba1319}.parceiro-hipercard.vcl-internal-search__clear-icon[_ngcontent-%COMP%]:disabled{color:#e71920}.parceiro-magazine-luiza.vcl-internal-search__clear-icon[_ngcontent-%COMP%]{color:#0083ca}.parceiro-magazine-luiza.vcl-internal-search__clear-icon[_ngcontent-%COMP%]:disabled{color:#00a4fd}.personal-bank.vcl-internal-search__clear-icon[_ngcontent-%COMP%]{color:#ce9141}.personal-bank.vcl-internal-search__clear-icon[_ngcontent-%COMP%]:disabled{color:#d8a86a}.itau-bba.vcl-internal-search__clear-icon[_ngcontent-%COMP%]{color:#2449cc}.itau-bba.vcl-internal-search__clear-icon[_ngcontent-%COMP%]:disabled{color:#4567de}.personnalite.vcl-internal-search__icon[_ngcontent-%COMP%]{color:#876632}.personnalite.vcl-internal-search__clear-icon[_ngcontent-%COMP%]{color:#876632}"] });
/**
 * @internal
 */
VclInternalSearchComponent.selector = 'vcl-internal-search';
VclInternalSearchComponent.ctorParameters = () => [
    { type: VoxelSegmentService }
];
VclInternalSearchComponent.propDecorators = {
    stringSearch: [{ type: Input }],
    inputSearch: [{ type: ViewChild, args: ['inputSearch',] }],
    placeholder: [{ type: Input }],
    focus: [{ type: Input }],
    disabled: [{ type: Input }],
    dark: [{ type: Input }],
    stringSearchChange: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclInternalSearchComponent, [{
        type: Component,
        args: [{
                selector: 'vcl-internal-search',
                template: "<div\n  class=\"vcl-internal-search {{ segment | async }}\"\n>\n\n<voxel-icon\n[ngClass]=\"{\n  'vcl-internal-search__icon': true,\n  'vcl-internal-search__icon--dark': dark,\n  'vcl-internal-search__icon--disabled': disabled\n}\"\nclass=\"{{ segment | async }}\">\n    busca_outline\n</voxel-icon>\n\n<input\n  #inputSearch\n  [ngClass]=\"{\n    'vcl-internal-search__input': true,\n    'vcl-internal-search__input--dark': dark,\n    'vcl-internal-search__input--dark--disabled': disabled\n  }\"\n  [placeholder]=\"placeholder\"\n  [class.is-filled]=\"stringSearch\"\n  [disabled]=\"disabled\"\n  [(ngModel)]=\"stringSearch\"\n  [readonly]=\"disabled\"\n  (focus)=\"inputSearch.placeholder = focus\"\n  (blur)=\"inputSearch.placeholder = placeholder\"\n  (input)=\"onChangeValue($event.target.value)\"\n  (keydown.esc)=\"clearInput()\">\n\n<voxel-icon\n  [ngClass]=\"{\n  'vcl-internal-search__clear-icon': true,\n  'vcl-internal-search__clear-icon--dark': dark\n  }\"\n  class=\"{{ segment | async }}\"\n  size=\"s\"\n  [hidden]=\"!stringSearch\"\n  (click)=\"clearInput()\"\n  (keyup.enter)=\"clearInput()\"\n  role=\"button\">\n  fechar\n</voxel-icon>\n\n</div>\n",
                styles: [".vcl-internal-search{position:relative;display:flex}.vcl-internal-search__icon{font-size:1.875rem;position:absolute;height:2rem;left:0;top:50%;color:inherit;transform:translateY(-50%);pointer-events:none}.vcl-internal-search__icon--disabled{opacity:.5}.vcl-internal-search__icon--dark{color:#fff!important}.vcl-internal-search__input{font-family:\"Itau Text\";font-size:1.1875rem;border:none;line-height:2rem;height:2rem;width:100%;padding-left:2.5rem;transition:width .3s ease;outline:none;text-overflow:ellipsis}.vcl-internal-search__input[disabled]{background:transparent}.vcl-internal-search__input[disabled]::input-placeholder{font-size:\"19px\";color:#d9d3cf}.vcl-internal-search__input[disabled]::placeholder{font-size:\"19px\";color:#d9d3cf;opacity:1}.vcl-internal-search__input[disabled]:placeholder{font-size:\"19px\";color:#d9d3cf;opacity:1}.vcl-internal-search__input--dark{background:transparent;color:#fff}.vcl-internal-search__input--dark::input-placeholder{font-size:\"19px\";color:#fff}.vcl-internal-search__input--dark::placeholder{font-size:\"19px\";color:#fff;opacity:1}.vcl-internal-search__input--dark:placeholder{font-size:\"19px\";color:#fff;opacity:1}.vcl-internal-search__input--dark:focus::input-placeholder,.vcl-internal-search__input--dark.is-filled::input-placeholder{font-size:\"19px\";color:#fff}.vcl-internal-search__input--dark:focus::placeholder,.vcl-internal-search__input--dark.is-filled::placeholder{font-size:\"19px\";color:#fff;opacity:1}.vcl-internal-search__input--dark:focus:placeholder,.vcl-internal-search__input--dark.is-filled:placeholder{font-size:\"19px\";color:#fff;opacity:1}.vcl-internal-search__input--dark[disabled]{background:transparent!important}.vcl-internal-search__input--dark[disabled]::input-placeholder{font-size:\"19px\";color:#d9d3cf}.vcl-internal-search__input--dark[disabled]::placeholder{font-size:\"19px\";color:#d9d3cf;opacity:1}.vcl-internal-search__input--dark[disabled]:placeholder{font-size:\"19px\";color:#d9d3cf;opacity:1}.vcl-internal-search__input--dark--disabled{opacity:.5}.vcl-internal-search__clear-icon{position:relative;display:none;cursor:pointer;-webkit-appearance:none;appearance:none;border:0;background:none;padding:0;margin-left:1.25rem;font-size:1.5rem;display:inline-block;transform:translateY(.125rem)}.vcl-internal-search__clear-icon--dark{color:#fff!important}.vcl-internal-search__clear-icon[hidden]{display:none}.varejo.vcl-internal-search__icon{color:#ec7000}.varejo.vcl-internal-search__icon:disabled{color:#ff8a20}.personnalite.vcl-internal-search__icon{color:#d0a967}.personnalite.vcl-internal-search__icon:disabled{color:#dcbf8e}.uniclass.vcl-internal-search__icon{color:#ec7000}.uniclass.vcl-internal-search__icon:disabled{color:#ff8a20}.empresas.vcl-internal-search__icon{color:#ec7000}.empresas.vcl-internal-search__icon:disabled{color:#ff8a20}.itaucard.vcl-internal-search__icon{color:#ec7000}.itaucard.vcl-internal-search__icon:disabled{color:#ff8a20}.private.vcl-internal-search__icon{color:#ec7000}.private.vcl-internal-search__icon:disabled{color:#ff8a20}.parceiro-itaucard.vcl-internal-search__icon{color:#ec7000}.parceiro-itaucard.vcl-internal-search__icon:disabled{color:#ff8a20}.parceiro-credicard.vcl-internal-search__icon{color:#0d456f}.parceiro-credicard.vcl-internal-search__icon:disabled{color:#12619d}.parceiro-hipercard.vcl-internal-search__icon{color:#ba1319}.parceiro-hipercard.vcl-internal-search__icon:disabled{color:#e71920}.parceiro-magazine-luiza.vcl-internal-search__icon{color:#0083ca}.parceiro-magazine-luiza.vcl-internal-search__icon:disabled{color:#00a4fd}.personal-bank.vcl-internal-search__icon{color:#ce9141}.personal-bank.vcl-internal-search__icon:disabled{color:#d8a86a}.itau-bba.vcl-internal-search__icon{color:#2449cc}.itau-bba.vcl-internal-search__icon:disabled{color:#4567de}.varejo.vcl-internal-search__clear-icon{color:#ec7000}.varejo.vcl-internal-search__clear-icon:disabled{color:#ff8a20}.personnalite.vcl-internal-search__clear-icon{color:#d0a967}.personnalite.vcl-internal-search__clear-icon:disabled{color:#dcbf8e}.uniclass.vcl-internal-search__clear-icon{color:#ec7000}.uniclass.vcl-internal-search__clear-icon:disabled{color:#ff8a20}.empresas.vcl-internal-search__clear-icon{color:#ec7000}.empresas.vcl-internal-search__clear-icon:disabled{color:#ff8a20}.itaucard.vcl-internal-search__clear-icon{color:#ec7000}.itaucard.vcl-internal-search__clear-icon:disabled{color:#ff8a20}.private.vcl-internal-search__clear-icon{color:#ec7000}.private.vcl-internal-search__clear-icon:disabled{color:#ff8a20}.parceiro-itaucard.vcl-internal-search__clear-icon{color:#ec7000}.parceiro-itaucard.vcl-internal-search__clear-icon:disabled{color:#ff8a20}.parceiro-credicard.vcl-internal-search__clear-icon{color:#0d456f}.parceiro-credicard.vcl-internal-search__clear-icon:disabled{color:#12619d}.parceiro-hipercard.vcl-internal-search__clear-icon{color:#ba1319}.parceiro-hipercard.vcl-internal-search__clear-icon:disabled{color:#e71920}.parceiro-magazine-luiza.vcl-internal-search__clear-icon{color:#0083ca}.parceiro-magazine-luiza.vcl-internal-search__clear-icon:disabled{color:#00a4fd}.personal-bank.vcl-internal-search__clear-icon{color:#ce9141}.personal-bank.vcl-internal-search__clear-icon:disabled{color:#d8a86a}.itau-bba.vcl-internal-search__clear-icon{color:#2449cc}.itau-bba.vcl-internal-search__clear-icon:disabled{color:#4567de}.personnalite.vcl-internal-search__icon{color:#876632}.personnalite.vcl-internal-search__clear-icon{color:#876632}\n"]
            }]
    }], function () { return [{ type: ɵngcc1.VoxelSegmentService }]; }, { stringSearch: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], focus: [{
            type: Input
        }], disabled: [{
            type: Input
        }], dark: [{
            type: Input
        }], stringSearchChange: [{
            type: Output
        }], inputSearch: [{
            type: ViewChild,
            args: ['inputSearch']
        }] }); })();

class VclInternalSearchModule {
}
VclInternalSearchModule.ɵfac = function VclInternalSearchModule_Factory(t) { return new (t || VclInternalSearchModule)(); };
VclInternalSearchModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VclInternalSearchModule });
VclInternalSearchModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            VoxelIconModule,
            FormsModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclInternalSearchModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    VoxelIconModule,
                    FormsModule,
                ],
                declarations: [
                    VclInternalSearchComponent,
                    SearchPipe,
                ],
                exports: [
                    VclInternalSearchComponent,
                    SearchPipe,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VclInternalSearchModule, { declarations: function () { return [VclInternalSearchComponent, SearchPipe]; }, imports: function () { return [CommonModule,
        VoxelIconModule,
        FormsModule]; }, exports: function () { return [VclInternalSearchComponent, SearchPipe]; } }); })();

class VclMegaMenuService {
    constructor() {
        this.menuItem = new Subject();
    }
    setClickedItem(item) {
        this.menuItem.next(item);
    }
    getClickedItem() {
        return this.menuItem.asObservable();
    }
}
VclMegaMenuService.ɵfac = function VclMegaMenuService_Factory(t) { return new (t || VclMegaMenuService)(); };
VclMegaMenuService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: VclMegaMenuService, factory: VclMegaMenuService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclMegaMenuService, [{
        type: Injectable
    }], function () { return []; }, null); })();

/**
 * O cabeçalho é um componente de navegação cruzada que ativa. Este possui um componente denominado
 * 'Cabeçalho Combo' que permite ver o nome da empresa e do utilizador que se logou no portal, um botão
 * que permite sair ou terminar a sessão no portal e um menu que organiza todos os elementos do portal,
 * um para grupos de links e outros para link direto para página específica.
 *
 * **Componente não testado para acessibilidade**
 *
 * *The header is a cross-navigation component that enables. This has a component called 'Combo header'
 *  that allows you to see the name of the company and the user who loged in the portal, a button that allows
 *  you to exit or log out from the portal, and a menu that organizes all the elements of the portal, one for groups
 *  of links and others for direct link to specific page.*
 *
 * ### Acessible
 *
 * <acessible class="not-tested">Acessibilidade - Não testado</acessible>
 *
 * **Module:**
 *
 * `import { VclHeaderModule } from '@voxel/community';`
 *
 * <example-url>../../demo/index.html#/portfolio/components/header?componentOnly=true</example-url>
 *
 * @example
 * <vcl-header
 *   [userInfo]='userInfo'
 *   [menuItems]='menuItems'
 *   logoPath='./assets/img/itau_logo.svg'
 *   brandPath='./assets/img/itau_empresas.svg'
 *   language='PT'
 *   (menuItemClick)="onItemClick($event)"
 *   (logout)='onLogout($event)'>
 * </vcl-header>
 *
 */
class VclHeaderComponent {
    /**
     * @internal
     */
    constructor(voxelSegmentService, vclMegaMenuService) {
        this.voxelSegmentService = voxelSegmentService;
        this.vclMegaMenuService = vclMegaMenuService;
        /**
         * Items para exibição no mega menu
         *
         * *Items for display in the mega menu*
         */
        this.menuItems = [];
        /**
         * Linguagem do header. O valor padrão é 'PT' - Português. Opções possíveis são:
         * * 'PT' - Português
         * * 'ES' - Espanhol
         *
         * *Header language. Default value is 'PT' - Portuguese. Possible options are:*
         * * 'PT' - Portuguese
         * * 'ES' - Spanish
         */
        this.language = 'PT';
        /**
         * Evento emitido ao clicar no botão 'Sair / Salir'
         *
         * *Event emitted when clicking the 'Sair / Salir' button*
         */
        this.logout = new EventEmitter();
        this.menuItemClick = new EventEmitter();
        /**
         * @internal
         */
        this.showUserInfo = false;
        /**
         * @internal
         */
        this.segment = this.voxelSegmentService.segment;
        /**
         * @internal
         */
        this.subscription = new Subscription();
    }
    /**
     * @internal
     */
    clickOutside(event) {
        if (!this.comboHeaderRef.nativeElement.contains(event.target)) {
            this.showUserInfo = false;
        }
    }
    /**
     * @internal
     */
    ngOnInit() {
        this.watchItemsClick();
    }
    /**
     * @internal
     */
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    /**
     * @internal
     */
    watchItemsClick() {
        this.subscription.add(this.vclMegaMenuService
            .getClickedItem()
            .subscribe((item) => {
            this.menuItemClick.emit(item);
        }));
    }
    /**
     * @internal
     */
    onComboHeaderClick() {
        this.showUserInfo = !this.showUserInfo;
    }
    /**
     * @internal
     */
    onLogoutClick(event) {
        this.logout.emit(event);
    }
}
VclHeaderComponent.ɵfac = function VclHeaderComponent_Factory(t) { return new (t || VclHeaderComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.VoxelSegmentService), ɵngcc0.ɵɵdirectiveInject(VclMegaMenuService)); };
VclHeaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VclHeaderComponent, selectors: [["vcl-header"]], viewQuery: function VclHeaderComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c28, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.comboHeaderRef = _t.first);
    } }, hostBindings: function VclHeaderComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function VclHeaderComponent_click_HostBindingHandler($event) { return ctx.clickOutside($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, inputs: { menuItems: "menuItems", language: "language", logoPath: "logoPath", brandPath: "brandPath", userInfo: "userInfo" }, outputs: { logout: "logout", menuItemClick: "menuItemClick" }, decls: 30, vars: 40, consts: [[1, "vcl-header__top"], [1, "vcl-header__top__left-section"], [1, "vcl-header__top__left-section__logo"], ["alt", "logotipo", 1, "vcl-header__top__left-section__logo__image", 3, "src"], ["class", "vcl-header__top__left-section__brand", 4, "ngIf"], [1, "vcl-header__top__right-section"], [3, "click"], ["comboHeader", ""], [1, "vcl-header__top__right-section__combo-header__icon", 3, "ngClass"], ["class", "vcl-header__top__right-section__combo-header__list", 4, "ngIf"], [1, "vcl-header__top__right-section__logout__text"], ["size", "S", 1, "voxel-pl-s"], [3, "menuItems", "language", 4, "ngIf"], [1, "vcl-header__top__left-section__brand"], ["alt", "marca", 3, "src"], [1, "vcl-header__top__right-section__combo-header__list"], [1, "vcl-header__top__right-section__combo-header__list__user-name"], [3, "menuItems", "language"]], template: function VclHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵpipe(1, "async");
        ɵngcc0.ɵɵelementStart(2, "div", 0);
        ɵngcc0.ɵɵelementStart(3, "div", 1);
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelement(5, "img", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, VclHeaderComponent_div_6_Template, 2, 1, "div", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 5);
        ɵngcc0.ɵɵelementStart(8, "div", 6, 7);
        ɵngcc0.ɵɵlistener("click", function VclHeaderComponent_Template_div_click_8_listener() { return ctx.onComboHeaderClick(); });
        ɵngcc0.ɵɵpipe(10, "async");
        ɵngcc0.ɵɵelementStart(11, "div");
        ɵngcc0.ɵɵpipe(12, "async");
        ɵngcc0.ɵɵelementStart(13, "voxel-icon");
        ɵngcc0.ɵɵtext(14);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "span");
        ɵngcc0.ɵɵpipe(16, "async");
        ɵngcc0.ɵɵtext(17);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "voxel-icon", 8);
        ɵngcc0.ɵɵtext(19, " seta_baixo ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(20, VclHeaderComponent_div_20_Template, 6, 7, "div", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(21, "div");
        ɵngcc0.ɵɵpipe(22, "async");
        ɵngcc0.ɵɵelementStart(23, "div", 6);
        ɵngcc0.ɵɵlistener("click", function VclHeaderComponent_Template_div_click_23_listener($event) { return ctx.onLogoutClick($event); });
        ɵngcc0.ɵɵpipe(24, "async");
        ɵngcc0.ɵɵelementStart(25, "span", 10);
        ɵngcc0.ɵɵtext(26);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(27, "voxel-icon", 11);
        ɵngcc0.ɵɵtext(28, " sair ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(29, VclHeaderComponent_vcl_mega_menu_29_Template, 1, 2, "vcl-mega-menu", 12);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("vcl-header ", ɵngcc0.ɵɵpipeBind1(1, 26, ctx.segment), "");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵpropertyInterpolate("src", ctx.logoPath, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.brandPath);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassMapInterpolate1("vcl-header__top__right-section__combo-header ", ɵngcc0.ɵɵpipeBind1(10, 28, ctx.segment), "");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵclassMapInterpolate1("vcl-header__top__right-section__combo-header__logo ", ɵngcc0.ɵɵpipeBind1(12, 30, ctx.segment), "");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.userInfo == null ? null : ctx.userInfo.icon);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate1("vcl-header__top__right-section__combo-header__company-name ", ɵngcc0.ɵɵpipeBind1(16, 32, ctx.segment), "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.userInfo == null ? null : ctx.userInfo.companyName, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(38, _c29, ctx.showUserInfo));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showUserInfo);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate1("vcl-header__top__right-section__divisor ", ɵngcc0.ɵɵpipeBind1(22, 34, ctx.segment), "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassMapInterpolate1("vcl-header__top__right-section__logout ", ɵngcc0.ɵɵpipeBind1(24, 36, ctx.segment), "");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.language.toUpperCase() === "PT" ? "Sair" : "Salir", " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", (ctx.menuItems == null ? null : ctx.menuItems.length) > 0);
    } }, directives: function () { return [ɵngcc2.NgIf, ɵngcc1.VoxelIconComponent, ɵngcc2.NgClass, VclMegaMenuComponent]; }, pipes: function () { return [ɵngcc2.AsyncPipe]; }, styles: [".vcl-header__top[_ngcontent-%COMP%]{display:flex;width:100%;align-items:center;padding:0 1rem 0 1.5rem;height:3.5rem;justify-content:space-between;box-shadow:0 2px 8px #56504c2e,0 0 2px #56504c29}@media only screen and (min-width: 768px){.vcl-header__top[_ngcontent-%COMP%]{padding:0 1.5rem 0 2rem}}@media only screen and (min-width: 1024px){.vcl-header__top[_ngcontent-%COMP%]{height:5rem;padding:0 2rem}}.vcl-header__top__left-section[_ngcontent-%COMP%]{display:flex;height:100%}.vcl-header__top__left-section__logo[_ngcontent-%COMP%]{align-items:center;display:flex}.vcl-header__top__left-section__logo__image[_ngcontent-%COMP%]{width:2.5rem}@media only screen and (min-width: 1024px){.vcl-header__top__left-section__logo__image[_ngcontent-%COMP%]{width:3rem}}.vcl-header__top__left-section__brand[_ngcontent-%COMP%]{display:flex;padding-left:2rem}@media only screen and (max-width: 767.98px){.vcl-header__top__left-section__brand[_ngcontent-%COMP%]{display:none}}.vcl-header__top__left-section__brand[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:7rem}@media only screen and (min-width: 768px) and (max-width: 1023.98px){.vcl-header__top__left-section__brand[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:6rem}}.vcl-header__top__right-section[_ngcontent-%COMP%]{display:flex;height:100%}.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]{display:flex;align-items:center;height:100%;cursor:pointer;padding:1rem;color:#fff;position:relative}.vcl-header__top__right-section__combo-header__logo[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;background-color:#faf7f5;border-radius:50%;min-width:2.625rem;min-height:2.625rem;margin-right:.5rem}.vcl-header__top__right-section__combo-header__company-name[_ngcontent-%COMP%]{font-weight:700;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;padding-right:.5rem;word-break:break-word}.vcl-header__top__right-section__combo-header__icon[_ngcontent-%COMP%]{margin-left:auto;transition:.2s linear}.vcl-header__top__right-section__combo-header__icon.open[_ngcontent-%COMP%]{transform:rotateX(180deg)}@media only screen and (max-width: 767.98px){.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]{width:10rem;padding-right:.5rem}.vcl-header__top__right-section__combo-header__logo[_ngcontent-%COMP%]{min-width:2rem;min-height:2rem}.vcl-header__top__right-section__combo-header__company-name[_ngcontent-%COMP%]{font-size:.75rem;word-break:break-word}}@media only screen and (min-width: 768px) and (max-width: 1023.98px){.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]{width:15.25rem}.vcl-header__top__right-section__combo-header__logo[_ngcontent-%COMP%]{min-width:2rem;min-height:2rem}.vcl-header__top__right-section__combo-header__company-name[_ngcontent-%COMP%]{font-size:.875rem;word-break:break-word}}@media only screen and (min-width: 1024px) and (max-width: 1279.98px){.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]{width:16rem}}@media only screen and (min-width: 1280px) and (max-width: 1599.98px){.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]{width:17.75rem}}@media only screen and (min-width: 1600px){.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]{width:23.5rem}}.vcl-header__top__right-section__combo-header__list[_ngcontent-%COMP%]{position:absolute;background-color:#fff;width:100%;min-width:-moz-fit-content;min-width:fit-content;padding:1.5rem 1rem;border-radius:0 0 8px 8px;border:solid 1px #d6d0cc;top:3.5rem;left:0;z-index:1000;left:50%;transform:translate(-50%)}@media only screen and (min-width: 1024px){.vcl-header__top__right-section__combo-header__list[_ngcontent-%COMP%]{top:5rem}}.vcl-header__top__right-section__combo-header__list__company-name[_ngcontent-%COMP%]{font-weight:900;font-size:1.25rem;padding-bottom:1.125rem;word-break:break-word}.vcl-header__top__right-section__combo-header__list__user-name[_ngcontent-%COMP%]{font-weight:900;color:#231d19;word-break:break-word}.vcl-header__top__right-section__divisor[_ngcontent-%COMP%]{display:flex;align-self:center;width:2px;height:60%;background-color:#fff}@media only screen and (max-width: 767.98px){.vcl-header__top__right-section__divisor[_ngcontent-%COMP%]{display:none}}.vcl-header__top__right-section__logout[_ngcontent-%COMP%]{display:flex;align-items:center;padding:0 1rem 0 2rem;cursor:pointer;color:#fff}@media only screen and (max-width: 767.98px){.vcl-header__top__right-section__logout[_ngcontent-%COMP%]{padding:0 .5rem 0 .75rem}}@media only screen and (min-width: 768px) and (max-width: 1023.98px){.vcl-header__top__right-section__logout[_ngcontent-%COMP%]{padding:0 1rem}}.vcl-header__top__right-section__logout__text[_ngcontent-%COMP%]{font-weight:900}.varejo.vcl-header[_ngcontent-%COMP%]{background-color:#ec7000}.personnalite.vcl-header[_ngcontent-%COMP%]{background-color:#d0a967}.uniclass.vcl-header[_ngcontent-%COMP%]{background-color:#ec7000}.empresas.vcl-header[_ngcontent-%COMP%]{background-color:#ec7000}.itaucard.vcl-header[_ngcontent-%COMP%]{background-color:#ec7000}.private.vcl-header[_ngcontent-%COMP%]{background-color:#ec7000}.parceiro-itaucard.vcl-header[_ngcontent-%COMP%]{background-color:#ec7000}.parceiro-credicard.vcl-header[_ngcontent-%COMP%]{background-color:#0d456f}.parceiro-hipercard.vcl-header[_ngcontent-%COMP%]{background-color:#ba1319}.parceiro-magazine-luiza.vcl-header[_ngcontent-%COMP%]{background-color:#0083ca}.personal-bank.vcl-header[_ngcontent-%COMP%]{background-color:#ce9141}.itau-bba.vcl-header[_ngcontent-%COMP%]{background-color:#2449cc}.varejo.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]{background-color:#ec7000}.varejo.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]:disabled{color:#ff8a20}.varejo.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]:active, .varejo.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]:hover{background-color:#dd6100}.personnalite.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]{background-color:#d0a967}.personnalite.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]:disabled{color:#dcbf8e}.personnalite.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]:active, .personnalite.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]:hover{background-color:#ad8748}.uniclass.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]{background-color:#ec7000}.uniclass.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]:disabled{color:#ff8a20}.uniclass.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]:active, .uniclass.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]:hover{background-color:#dd6100}.empresas.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]{background-color:#ec7000}.empresas.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]:disabled{color:#ff8a20}.empresas.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]:active, .empresas.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]:hover{background-color:#dd6100}.itaucard.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]{background-color:#ec7000}.itaucard.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]:disabled{color:#ff8a20}.itaucard.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]:active, .itaucard.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]:hover{background-color:#dd6100}.private.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]{background-color:#ec7000}.private.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]:disabled{color:#ff8a20}.private.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]:active, .private.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]:hover{background-color:#dd6100}.parceiro-itaucard.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]{background-color:#ec7000}.parceiro-itaucard.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]:disabled{color:#ff8a20}.parceiro-itaucard.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]:active, .parceiro-itaucard.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]:hover{background-color:#dd6100}.parceiro-credicard.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]{background-color:#0d456f}.parceiro-credicard.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]:disabled{color:#12619d}.parceiro-credicard.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]:active, .parceiro-credicard.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]:hover{background-color:#001f43}.parceiro-hipercard.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]{background-color:#ba1319}.parceiro-hipercard.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]:disabled{color:#e71920}.parceiro-hipercard.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]:active, .parceiro-hipercard.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]:hover{background-color:#820000}.parceiro-magazine-luiza.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]{background-color:#0083ca}.parceiro-magazine-luiza.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]:disabled{color:#00a4fd}.parceiro-magazine-luiza.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]:active, .parceiro-magazine-luiza.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]:hover{background-color:#005799}.personal-bank.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]{background-color:#ce9141}.personal-bank.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]:disabled{color:#d8a86a}.personal-bank.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]:active, .personal-bank.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]:hover{background-color:#b88440}.itau-bba.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]{background-color:#2449cc}.itau-bba.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]:disabled{color:#4567de}.itau-bba.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]:active, .itau-bba.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]:hover{background-color:#192e76}.varejo.vcl-header__top__right-section__combo-header__logo[_ngcontent-%COMP%]{color:#ec7000}.personnalite.vcl-header__top__right-section__combo-header__logo[_ngcontent-%COMP%]{color:#d0a967}.uniclass.vcl-header__top__right-section__combo-header__logo[_ngcontent-%COMP%]{color:#ec7000}.empresas.vcl-header__top__right-section__combo-header__logo[_ngcontent-%COMP%]{color:#ec7000}.itaucard.vcl-header__top__right-section__combo-header__logo[_ngcontent-%COMP%]{color:#ec7000}.private.vcl-header__top__right-section__combo-header__logo[_ngcontent-%COMP%]{color:#ec7000}.parceiro-itaucard.vcl-header__top__right-section__combo-header__logo[_ngcontent-%COMP%]{color:#ec7000}.parceiro-credicard.vcl-header__top__right-section__combo-header__logo[_ngcontent-%COMP%]{color:#0d456f}.parceiro-hipercard.vcl-header__top__right-section__combo-header__logo[_ngcontent-%COMP%]{color:#ba1319}.parceiro-magazine-luiza.vcl-header__top__right-section__combo-header__logo[_ngcontent-%COMP%]{color:#0083ca}.personal-bank.vcl-header__top__right-section__combo-header__logo[_ngcontent-%COMP%]{color:#ce9141}.itau-bba.vcl-header__top__right-section__combo-header__logo[_ngcontent-%COMP%]{color:#2449cc}.varejo.vcl-header__top__right-section__combo-header__list__company-name[_ngcontent-%COMP%]{color:#ec7000}.personnalite.vcl-header__top__right-section__combo-header__list__company-name[_ngcontent-%COMP%]{color:#d0a967}.uniclass.vcl-header__top__right-section__combo-header__list__company-name[_ngcontent-%COMP%]{color:#ec7000}.empresas.vcl-header__top__right-section__combo-header__list__company-name[_ngcontent-%COMP%]{color:#ec7000}.itaucard.vcl-header__top__right-section__combo-header__list__company-name[_ngcontent-%COMP%]{color:#ec7000}.private.vcl-header__top__right-section__combo-header__list__company-name[_ngcontent-%COMP%]{color:#ec7000}.parceiro-itaucard.vcl-header__top__right-section__combo-header__list__company-name[_ngcontent-%COMP%]{color:#ec7000}.parceiro-credicard.vcl-header__top__right-section__combo-header__list__company-name[_ngcontent-%COMP%]{color:#0d456f}.parceiro-hipercard.vcl-header__top__right-section__combo-header__list__company-name[_ngcontent-%COMP%]{color:#ba1319}.parceiro-magazine-luiza.vcl-header__top__right-section__combo-header__list__company-name[_ngcontent-%COMP%]{color:#0083ca}.personal-bank.vcl-header__top__right-section__combo-header__list__company-name[_ngcontent-%COMP%]{color:#ce9141}.itau-bba.vcl-header__top__right-section__combo-header__list__company-name[_ngcontent-%COMP%]{color:#2449cc}.varejo.vcl-header__top__right-section__logout[_ngcontent-%COMP%]{background-color:#ec7000}.varejo.vcl-header__top__right-section__logout[_ngcontent-%COMP%]:disabled{color:#ff8a20}.varejo.vcl-header__top__right-section__logout[_ngcontent-%COMP%]:active, .varejo.vcl-header__top__right-section__logout[_ngcontent-%COMP%]:hover{background-color:#dd6100}.personnalite.vcl-header__top__right-section__logout[_ngcontent-%COMP%]{background-color:#d0a967}.personnalite.vcl-header__top__right-section__logout[_ngcontent-%COMP%]:disabled{color:#dcbf8e}.personnalite.vcl-header__top__right-section__logout[_ngcontent-%COMP%]:active, .personnalite.vcl-header__top__right-section__logout[_ngcontent-%COMP%]:hover{background-color:#ad8748}.uniclass.vcl-header__top__right-section__logout[_ngcontent-%COMP%]{background-color:#ec7000}.uniclass.vcl-header__top__right-section__logout[_ngcontent-%COMP%]:disabled{color:#ff8a20}.uniclass.vcl-header__top__right-section__logout[_ngcontent-%COMP%]:active, .uniclass.vcl-header__top__right-section__logout[_ngcontent-%COMP%]:hover{background-color:#dd6100}.empresas.vcl-header__top__right-section__logout[_ngcontent-%COMP%]{background-color:#ec7000}.empresas.vcl-header__top__right-section__logout[_ngcontent-%COMP%]:disabled{color:#ff8a20}.empresas.vcl-header__top__right-section__logout[_ngcontent-%COMP%]:active, .empresas.vcl-header__top__right-section__logout[_ngcontent-%COMP%]:hover{background-color:#dd6100}.itaucard.vcl-header__top__right-section__logout[_ngcontent-%COMP%]{background-color:#ec7000}.itaucard.vcl-header__top__right-section__logout[_ngcontent-%COMP%]:disabled{color:#ff8a20}.itaucard.vcl-header__top__right-section__logout[_ngcontent-%COMP%]:active, .itaucard.vcl-header__top__right-section__logout[_ngcontent-%COMP%]:hover{background-color:#dd6100}.private.vcl-header__top__right-section__logout[_ngcontent-%COMP%]{background-color:#ec7000}.private.vcl-header__top__right-section__logout[_ngcontent-%COMP%]:disabled{color:#ff8a20}.private.vcl-header__top__right-section__logout[_ngcontent-%COMP%]:active, .private.vcl-header__top__right-section__logout[_ngcontent-%COMP%]:hover{background-color:#dd6100}.parceiro-itaucard.vcl-header__top__right-section__logout[_ngcontent-%COMP%]{background-color:#ec7000}.parceiro-itaucard.vcl-header__top__right-section__logout[_ngcontent-%COMP%]:disabled{color:#ff8a20}.parceiro-itaucard.vcl-header__top__right-section__logout[_ngcontent-%COMP%]:active, .parceiro-itaucard.vcl-header__top__right-section__logout[_ngcontent-%COMP%]:hover{background-color:#dd6100}.parceiro-credicard.vcl-header__top__right-section__logout[_ngcontent-%COMP%]{background-color:#0d456f}.parceiro-credicard.vcl-header__top__right-section__logout[_ngcontent-%COMP%]:disabled{color:#12619d}.parceiro-credicard.vcl-header__top__right-section__logout[_ngcontent-%COMP%]:active, .parceiro-credicard.vcl-header__top__right-section__logout[_ngcontent-%COMP%]:hover{background-color:#001f43}.parceiro-hipercard.vcl-header__top__right-section__logout[_ngcontent-%COMP%]{background-color:#ba1319}.parceiro-hipercard.vcl-header__top__right-section__logout[_ngcontent-%COMP%]:disabled{color:#e71920}.parceiro-hipercard.vcl-header__top__right-section__logout[_ngcontent-%COMP%]:active, .parceiro-hipercard.vcl-header__top__right-section__logout[_ngcontent-%COMP%]:hover{background-color:#820000}.parceiro-magazine-luiza.vcl-header__top__right-section__logout[_ngcontent-%COMP%]{background-color:#0083ca}.parceiro-magazine-luiza.vcl-header__top__right-section__logout[_ngcontent-%COMP%]:disabled{color:#00a4fd}.parceiro-magazine-luiza.vcl-header__top__right-section__logout[_ngcontent-%COMP%]:active, .parceiro-magazine-luiza.vcl-header__top__right-section__logout[_ngcontent-%COMP%]:hover{background-color:#005799}.personal-bank.vcl-header__top__right-section__logout[_ngcontent-%COMP%]{background-color:#ce9141}.personal-bank.vcl-header__top__right-section__logout[_ngcontent-%COMP%]:disabled{color:#d8a86a}.personal-bank.vcl-header__top__right-section__logout[_ngcontent-%COMP%]:active, .personal-bank.vcl-header__top__right-section__logout[_ngcontent-%COMP%]:hover{background-color:#b88440}.itau-bba.vcl-header__top__right-section__logout[_ngcontent-%COMP%]{background-color:#2449cc}.itau-bba.vcl-header__top__right-section__logout[_ngcontent-%COMP%]:disabled{color:#4567de}.itau-bba.vcl-header__top__right-section__logout[_ngcontent-%COMP%]:active, .itau-bba.vcl-header__top__right-section__logout[_ngcontent-%COMP%]:hover{background-color:#192e76}.personnalite.vcl-header[_ngcontent-%COMP%]{color:#231d19}.personnalite.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]{color:#231d19}.personnalite.vcl-header__top__right-section__combo-header__logo[_ngcontent-%COMP%], .personnalite.vcl-header__top__right-section__combo-header__list__company-name[_ngcontent-%COMP%]{color:#876632}.personnalite.vcl-header__top__right-section__divisor[_ngcontent-%COMP%]{background-color:#231d19}.personnalite.vcl-header__top__right-section__logout[_ngcontent-%COMP%]{color:#231d19}.empresas.vcl-header[_ngcontent-%COMP%]{color:#231d19;background-color:#faf7f5}.empresas.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]{background-color:#faf7f5;color:#ec7000}.empresas.vcl-header__top__right-section__combo-header[_ngcontent-%COMP%]:hover{background-color:#efe9e5}.empresas.vcl-header__top__right-section__combo-header__logo[_ngcontent-%COMP%]{background-color:#003767;color:#fff}.empresas.vcl-header__top__right-section__combo-header__company-name[_ngcontent-%COMP%]{color:#231d19}.empresas.vcl-header__top__right-section__combo-header__list__company-name[_ngcontent-%COMP%]{color:#003767}.empresas.vcl-header__top__right-section__divisor[_ngcontent-%COMP%]{background-color:#231d19}.empresas.vcl-header__top__right-section__logout[_ngcontent-%COMP%]{background-color:#faf7f5;color:#231d19}.empresas.vcl-header__top__right-section__logout[_ngcontent-%COMP%]:hover{background-color:#efe9e5}"] });
VclHeaderComponent.ctorParameters = () => [
    { type: VoxelSegmentService },
    { type: VclMegaMenuService }
];
VclHeaderComponent.propDecorators = {
    comboHeaderRef: [{ type: ViewChild, args: ['comboHeader',] }],
    logoPath: [{ type: Input }],
    brandPath: [{ type: Input }],
    menuItems: [{ type: Input }],
    userInfo: [{ type: Input }],
    language: [{ type: Input }],
    logout: [{ type: Output }],
    menuItemClick: [{ type: Output }],
    clickOutside: [{ type: HostListener, args: ['document:click', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclHeaderComponent, [{
        type: Component,
        args: [{
                selector: 'vcl-header',
                template: "<div class=\"vcl-header {{ segment | async }}\">\n  <div class=\"vcl-header__top\">\n    <div class=\"vcl-header__top__left-section\">\n      <div class=\"vcl-header__top__left-section__logo\">\n        <img alt=\"logotipo\" class=\"vcl-header__top__left-section__logo__image\" src=\"{{ logoPath }}\">\n      </div>\n\n      <div\n        *ngIf=\"brandPath\"\n        class=\"vcl-header__top__left-section__brand\">\n        <img alt=\"marca\" src=\"{{ brandPath }}\">\n      </div>\n    </div>\n\n    <div class=\"vcl-header__top__right-section\">\n      <div\n        (click)=\"onComboHeaderClick()\"\n        #comboHeader\n        class=\"vcl-header__top__right-section__combo-header {{ segment | async }}\">\n        <div class=\"vcl-header__top__right-section__combo-header__logo {{ segment | async }}\">\n          <voxel-icon>{{ userInfo?.icon }}</voxel-icon>\n        </div>\n        <span class=\"vcl-header__top__right-section__combo-header__company-name {{ segment | async }}\">\n          {{ userInfo?.companyName }}\n        </span>\n        <voxel-icon\n          [ngClass]=\"{'open': showUserInfo}\"\n          class=\"vcl-header__top__right-section__combo-header__icon\">\n          seta_baixo\n        </voxel-icon>\n\n        <div\n          *ngIf=\"showUserInfo\"\n          class=\"vcl-header__top__right-section__combo-header__list\">\n          <div class=\"vcl-header__top__right-section__combo-header__list__company-name  {{ segment | async }}\">\n            {{ userInfo?.companyName }}\n          </div>\n\n          <div class=\"vcl-header__top__right-section__combo-header__list__user-name\">\n            {{ userInfo?.userName }}\n          </div>\n        </div>\n      </div>\n\n      <div class=\"vcl-header__top__right-section__divisor {{ segment | async }}\"></div>\n\n      <div\n        class=\"vcl-header__top__right-section__logout {{ segment | async }}\"\n        (click)=\"onLogoutClick($event)\">\n        <span class=\"vcl-header__top__right-section__logout__text\"> {{ language.toUpperCase() === 'PT' ? 'Sair' : 'Salir' }} </span> <voxel-icon class=\"voxel-pl-s\" size=\"S\"> sair </voxel-icon>\n      </div>\n    </div>\n  </div>\n\n\n  <vcl-mega-menu\n    *ngIf=\"menuItems?.length > 0\"\n    [menuItems]=\"menuItems\"\n    [language]=\"language\">\n  </vcl-mega-menu>\n</div>\n",
                styles: [".vcl-header__top{display:flex;width:100%;align-items:center;padding:0 1rem 0 1.5rem;height:3.5rem;justify-content:space-between;box-shadow:0 2px 8px #56504c2e,0 0 2px #56504c29}@media only screen and (min-width: 768px){.vcl-header__top{padding:0 1.5rem 0 2rem}}@media only screen and (min-width: 1024px){.vcl-header__top{height:5rem;padding:0 2rem}}.vcl-header__top__left-section{display:flex;height:100%}.vcl-header__top__left-section__logo{align-items:center;display:flex}.vcl-header__top__left-section__logo__image{width:2.5rem}@media only screen and (min-width: 1024px){.vcl-header__top__left-section__logo__image{width:3rem}}.vcl-header__top__left-section__brand{display:flex;padding-left:2rem}@media only screen and (max-width: 767.98px){.vcl-header__top__left-section__brand{display:none}}.vcl-header__top__left-section__brand img{width:7rem}@media only screen and (min-width: 768px) and (max-width: 1023.98px){.vcl-header__top__left-section__brand img{width:6rem}}.vcl-header__top__right-section{display:flex;height:100%}.vcl-header__top__right-section__combo-header{display:flex;align-items:center;height:100%;cursor:pointer;padding:1rem;color:#fff;position:relative}.vcl-header__top__right-section__combo-header__logo{display:flex;align-items:center;justify-content:center;background-color:#faf7f5;border-radius:50%;min-width:2.625rem;min-height:2.625rem;margin-right:.5rem}.vcl-header__top__right-section__combo-header__company-name{font-weight:700;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;padding-right:.5rem;word-break:break-word}.vcl-header__top__right-section__combo-header__icon{margin-left:auto;transition:.2s linear}.vcl-header__top__right-section__combo-header__icon.open{transform:rotateX(180deg)}@media only screen and (max-width: 767.98px){.vcl-header__top__right-section__combo-header{width:10rem;padding-right:.5rem}.vcl-header__top__right-section__combo-header__logo{min-width:2rem;min-height:2rem}.vcl-header__top__right-section__combo-header__company-name{font-size:.75rem;word-break:break-word}}@media only screen and (min-width: 768px) and (max-width: 1023.98px){.vcl-header__top__right-section__combo-header{width:15.25rem}.vcl-header__top__right-section__combo-header__logo{min-width:2rem;min-height:2rem}.vcl-header__top__right-section__combo-header__company-name{font-size:.875rem;word-break:break-word}}@media only screen and (min-width: 1024px) and (max-width: 1279.98px){.vcl-header__top__right-section__combo-header{width:16rem}}@media only screen and (min-width: 1280px) and (max-width: 1599.98px){.vcl-header__top__right-section__combo-header{width:17.75rem}}@media only screen and (min-width: 1600px){.vcl-header__top__right-section__combo-header{width:23.5rem}}.vcl-header__top__right-section__combo-header__list{position:absolute;background-color:#fff;width:100%;min-width:-moz-fit-content;min-width:fit-content;padding:1.5rem 1rem;border-radius:0 0 8px 8px;border:solid 1px #d6d0cc;top:3.5rem;left:0;z-index:1000;left:50%;transform:translate(-50%)}@media only screen and (min-width: 1024px){.vcl-header__top__right-section__combo-header__list{top:5rem}}.vcl-header__top__right-section__combo-header__list__company-name{font-weight:900;font-size:1.25rem;padding-bottom:1.125rem;word-break:break-word}.vcl-header__top__right-section__combo-header__list__user-name{font-weight:900;color:#231d19;word-break:break-word}.vcl-header__top__right-section__divisor{display:flex;align-self:center;width:2px;height:60%;background-color:#fff}@media only screen and (max-width: 767.98px){.vcl-header__top__right-section__divisor{display:none}}.vcl-header__top__right-section__logout{display:flex;align-items:center;padding:0 1rem 0 2rem;cursor:pointer;color:#fff}@media only screen and (max-width: 767.98px){.vcl-header__top__right-section__logout{padding:0 .5rem 0 .75rem}}@media only screen and (min-width: 768px) and (max-width: 1023.98px){.vcl-header__top__right-section__logout{padding:0 1rem}}.vcl-header__top__right-section__logout__text{font-weight:900}.varejo.vcl-header{background-color:#ec7000}.personnalite.vcl-header{background-color:#d0a967}.uniclass.vcl-header{background-color:#ec7000}.empresas.vcl-header{background-color:#ec7000}.itaucard.vcl-header{background-color:#ec7000}.private.vcl-header{background-color:#ec7000}.parceiro-itaucard.vcl-header{background-color:#ec7000}.parceiro-credicard.vcl-header{background-color:#0d456f}.parceiro-hipercard.vcl-header{background-color:#ba1319}.parceiro-magazine-luiza.vcl-header{background-color:#0083ca}.personal-bank.vcl-header{background-color:#ce9141}.itau-bba.vcl-header{background-color:#2449cc}.varejo.vcl-header__top__right-section__combo-header{background-color:#ec7000}.varejo.vcl-header__top__right-section__combo-header:disabled{color:#ff8a20}.varejo.vcl-header__top__right-section__combo-header:active,.varejo.vcl-header__top__right-section__combo-header:hover{background-color:#dd6100}.personnalite.vcl-header__top__right-section__combo-header{background-color:#d0a967}.personnalite.vcl-header__top__right-section__combo-header:disabled{color:#dcbf8e}.personnalite.vcl-header__top__right-section__combo-header:active,.personnalite.vcl-header__top__right-section__combo-header:hover{background-color:#ad8748}.uniclass.vcl-header__top__right-section__combo-header{background-color:#ec7000}.uniclass.vcl-header__top__right-section__combo-header:disabled{color:#ff8a20}.uniclass.vcl-header__top__right-section__combo-header:active,.uniclass.vcl-header__top__right-section__combo-header:hover{background-color:#dd6100}.empresas.vcl-header__top__right-section__combo-header{background-color:#ec7000}.empresas.vcl-header__top__right-section__combo-header:disabled{color:#ff8a20}.empresas.vcl-header__top__right-section__combo-header:active,.empresas.vcl-header__top__right-section__combo-header:hover{background-color:#dd6100}.itaucard.vcl-header__top__right-section__combo-header{background-color:#ec7000}.itaucard.vcl-header__top__right-section__combo-header:disabled{color:#ff8a20}.itaucard.vcl-header__top__right-section__combo-header:active,.itaucard.vcl-header__top__right-section__combo-header:hover{background-color:#dd6100}.private.vcl-header__top__right-section__combo-header{background-color:#ec7000}.private.vcl-header__top__right-section__combo-header:disabled{color:#ff8a20}.private.vcl-header__top__right-section__combo-header:active,.private.vcl-header__top__right-section__combo-header:hover{background-color:#dd6100}.parceiro-itaucard.vcl-header__top__right-section__combo-header{background-color:#ec7000}.parceiro-itaucard.vcl-header__top__right-section__combo-header:disabled{color:#ff8a20}.parceiro-itaucard.vcl-header__top__right-section__combo-header:active,.parceiro-itaucard.vcl-header__top__right-section__combo-header:hover{background-color:#dd6100}.parceiro-credicard.vcl-header__top__right-section__combo-header{background-color:#0d456f}.parceiro-credicard.vcl-header__top__right-section__combo-header:disabled{color:#12619d}.parceiro-credicard.vcl-header__top__right-section__combo-header:active,.parceiro-credicard.vcl-header__top__right-section__combo-header:hover{background-color:#001f43}.parceiro-hipercard.vcl-header__top__right-section__combo-header{background-color:#ba1319}.parceiro-hipercard.vcl-header__top__right-section__combo-header:disabled{color:#e71920}.parceiro-hipercard.vcl-header__top__right-section__combo-header:active,.parceiro-hipercard.vcl-header__top__right-section__combo-header:hover{background-color:#820000}.parceiro-magazine-luiza.vcl-header__top__right-section__combo-header{background-color:#0083ca}.parceiro-magazine-luiza.vcl-header__top__right-section__combo-header:disabled{color:#00a4fd}.parceiro-magazine-luiza.vcl-header__top__right-section__combo-header:active,.parceiro-magazine-luiza.vcl-header__top__right-section__combo-header:hover{background-color:#005799}.personal-bank.vcl-header__top__right-section__combo-header{background-color:#ce9141}.personal-bank.vcl-header__top__right-section__combo-header:disabled{color:#d8a86a}.personal-bank.vcl-header__top__right-section__combo-header:active,.personal-bank.vcl-header__top__right-section__combo-header:hover{background-color:#b88440}.itau-bba.vcl-header__top__right-section__combo-header{background-color:#2449cc}.itau-bba.vcl-header__top__right-section__combo-header:disabled{color:#4567de}.itau-bba.vcl-header__top__right-section__combo-header:active,.itau-bba.vcl-header__top__right-section__combo-header:hover{background-color:#192e76}.varejo.vcl-header__top__right-section__combo-header__logo{color:#ec7000}.personnalite.vcl-header__top__right-section__combo-header__logo{color:#d0a967}.uniclass.vcl-header__top__right-section__combo-header__logo{color:#ec7000}.empresas.vcl-header__top__right-section__combo-header__logo{color:#ec7000}.itaucard.vcl-header__top__right-section__combo-header__logo{color:#ec7000}.private.vcl-header__top__right-section__combo-header__logo{color:#ec7000}.parceiro-itaucard.vcl-header__top__right-section__combo-header__logo{color:#ec7000}.parceiro-credicard.vcl-header__top__right-section__combo-header__logo{color:#0d456f}.parceiro-hipercard.vcl-header__top__right-section__combo-header__logo{color:#ba1319}.parceiro-magazine-luiza.vcl-header__top__right-section__combo-header__logo{color:#0083ca}.personal-bank.vcl-header__top__right-section__combo-header__logo{color:#ce9141}.itau-bba.vcl-header__top__right-section__combo-header__logo{color:#2449cc}.varejo.vcl-header__top__right-section__combo-header__list__company-name{color:#ec7000}.personnalite.vcl-header__top__right-section__combo-header__list__company-name{color:#d0a967}.uniclass.vcl-header__top__right-section__combo-header__list__company-name{color:#ec7000}.empresas.vcl-header__top__right-section__combo-header__list__company-name{color:#ec7000}.itaucard.vcl-header__top__right-section__combo-header__list__company-name{color:#ec7000}.private.vcl-header__top__right-section__combo-header__list__company-name{color:#ec7000}.parceiro-itaucard.vcl-header__top__right-section__combo-header__list__company-name{color:#ec7000}.parceiro-credicard.vcl-header__top__right-section__combo-header__list__company-name{color:#0d456f}.parceiro-hipercard.vcl-header__top__right-section__combo-header__list__company-name{color:#ba1319}.parceiro-magazine-luiza.vcl-header__top__right-section__combo-header__list__company-name{color:#0083ca}.personal-bank.vcl-header__top__right-section__combo-header__list__company-name{color:#ce9141}.itau-bba.vcl-header__top__right-section__combo-header__list__company-name{color:#2449cc}.varejo.vcl-header__top__right-section__logout{background-color:#ec7000}.varejo.vcl-header__top__right-section__logout:disabled{color:#ff8a20}.varejo.vcl-header__top__right-section__logout:active,.varejo.vcl-header__top__right-section__logout:hover{background-color:#dd6100}.personnalite.vcl-header__top__right-section__logout{background-color:#d0a967}.personnalite.vcl-header__top__right-section__logout:disabled{color:#dcbf8e}.personnalite.vcl-header__top__right-section__logout:active,.personnalite.vcl-header__top__right-section__logout:hover{background-color:#ad8748}.uniclass.vcl-header__top__right-section__logout{background-color:#ec7000}.uniclass.vcl-header__top__right-section__logout:disabled{color:#ff8a20}.uniclass.vcl-header__top__right-section__logout:active,.uniclass.vcl-header__top__right-section__logout:hover{background-color:#dd6100}.empresas.vcl-header__top__right-section__logout{background-color:#ec7000}.empresas.vcl-header__top__right-section__logout:disabled{color:#ff8a20}.empresas.vcl-header__top__right-section__logout:active,.empresas.vcl-header__top__right-section__logout:hover{background-color:#dd6100}.itaucard.vcl-header__top__right-section__logout{background-color:#ec7000}.itaucard.vcl-header__top__right-section__logout:disabled{color:#ff8a20}.itaucard.vcl-header__top__right-section__logout:active,.itaucard.vcl-header__top__right-section__logout:hover{background-color:#dd6100}.private.vcl-header__top__right-section__logout{background-color:#ec7000}.private.vcl-header__top__right-section__logout:disabled{color:#ff8a20}.private.vcl-header__top__right-section__logout:active,.private.vcl-header__top__right-section__logout:hover{background-color:#dd6100}.parceiro-itaucard.vcl-header__top__right-section__logout{background-color:#ec7000}.parceiro-itaucard.vcl-header__top__right-section__logout:disabled{color:#ff8a20}.parceiro-itaucard.vcl-header__top__right-section__logout:active,.parceiro-itaucard.vcl-header__top__right-section__logout:hover{background-color:#dd6100}.parceiro-credicard.vcl-header__top__right-section__logout{background-color:#0d456f}.parceiro-credicard.vcl-header__top__right-section__logout:disabled{color:#12619d}.parceiro-credicard.vcl-header__top__right-section__logout:active,.parceiro-credicard.vcl-header__top__right-section__logout:hover{background-color:#001f43}.parceiro-hipercard.vcl-header__top__right-section__logout{background-color:#ba1319}.parceiro-hipercard.vcl-header__top__right-section__logout:disabled{color:#e71920}.parceiro-hipercard.vcl-header__top__right-section__logout:active,.parceiro-hipercard.vcl-header__top__right-section__logout:hover{background-color:#820000}.parceiro-magazine-luiza.vcl-header__top__right-section__logout{background-color:#0083ca}.parceiro-magazine-luiza.vcl-header__top__right-section__logout:disabled{color:#00a4fd}.parceiro-magazine-luiza.vcl-header__top__right-section__logout:active,.parceiro-magazine-luiza.vcl-header__top__right-section__logout:hover{background-color:#005799}.personal-bank.vcl-header__top__right-section__logout{background-color:#ce9141}.personal-bank.vcl-header__top__right-section__logout:disabled{color:#d8a86a}.personal-bank.vcl-header__top__right-section__logout:active,.personal-bank.vcl-header__top__right-section__logout:hover{background-color:#b88440}.itau-bba.vcl-header__top__right-section__logout{background-color:#2449cc}.itau-bba.vcl-header__top__right-section__logout:disabled{color:#4567de}.itau-bba.vcl-header__top__right-section__logout:active,.itau-bba.vcl-header__top__right-section__logout:hover{background-color:#192e76}.personnalite.vcl-header{color:#231d19}.personnalite.vcl-header__top__right-section__combo-header{color:#231d19}.personnalite.vcl-header__top__right-section__combo-header__logo,.personnalite.vcl-header__top__right-section__combo-header__list__company-name{color:#876632}.personnalite.vcl-header__top__right-section__divisor{background-color:#231d19}.personnalite.vcl-header__top__right-section__logout{color:#231d19}.empresas.vcl-header{color:#231d19;background-color:#faf7f5}.empresas.vcl-header__top__right-section__combo-header{background-color:#faf7f5;color:#ec7000}.empresas.vcl-header__top__right-section__combo-header:hover{background-color:#efe9e5}.empresas.vcl-header__top__right-section__combo-header__logo{background-color:#003767;color:#fff}.empresas.vcl-header__top__right-section__combo-header__company-name{color:#231d19}.empresas.vcl-header__top__right-section__combo-header__list__company-name{color:#003767}.empresas.vcl-header__top__right-section__divisor{background-color:#231d19}.empresas.vcl-header__top__right-section__logout{background-color:#faf7f5;color:#231d19}.empresas.vcl-header__top__right-section__logout:hover{background-color:#efe9e5}\n"]
            }]
    }], function () { return [{ type: ɵngcc1.VoxelSegmentService }, { type: VclMegaMenuService }]; }, { menuItems: [{
            type: Input
        }], language: [{
            type: Input
        }], logout: [{
            type: Output
        }], menuItemClick: [{
            type: Output
        }], 
    /**
     * @internal
     */
    clickOutside: [{
            type: HostListener,
            args: ['document:click', ['$event']]
        }], comboHeaderRef: [{
            type: ViewChild,
            args: ['comboHeader']
        }], logoPath: [{
            type: Input
        }], brandPath: [{
            type: Input
        }], userInfo: [{
            type: Input
        }] }); })();

class VclMegaMenuComponent {
    /**
     * @internal
     */
    constructor(voxelSegmentService, vclMegaMenuService, elRef) {
        this.voxelSegmentService = voxelSegmentService;
        this.vclMegaMenuService = vclMegaMenuService;
        this.elRef = elRef;
        /**
         * @internal
         */
        this.menuItems = [];
        /**
         * @internal
         */
        this.language = 'PT';
        /**
         * @internal
         */
        this.visibleItems = [];
        /**
         * @internal
         */
        // Initializes with dummy data so 'more items' div width can be calculated
        this.hiddenItems = [{ label: 'dummy' }];
        /**
         * @internal
         */
        this.segment = this.voxelSegmentService.segment;
    }
    /**
     * @internal
     */
    onResize() {
        this.closeItemsList();
        this.distributeMenuItems();
    }
    /**
     * @internal
     */
    clickOutside(event) {
        if (!this.elRef.nativeElement.contains(event.target)) {
            this.closeItemsList();
        }
    }
    /**
     * @internal
     */
    ngOnInit() {
        this.addToVisibleItemsArray();
    }
    /**
     * @internal
     */
    ngAfterViewInit() {
        this.setItemsWidth();
        this.distributeMenuItems();
    }
    /**
     * @internal
     */
    addToVisibleItemsArray() {
        this.menuItems.forEach((item) => {
            this.visibleItems.push(item);
        });
    }
    /**
     * @internal
     */
    setItemsWidth() {
        this.menuItemsRef.forEach((item, i) => {
            this.menuItems[i].width = item.nativeElement.offsetWidth;
        });
    }
    /**
     * @internal
     */
    distributeMenuItems() {
        const menuMoreWidth = this.menuMoreRef ? this.menuMoreRef.nativeElement.offsetWidth : 0;
        const availableWidth = this.menuWrapperRef.nativeElement.offsetWidth - menuMoreWidth - 32 * 2;
        // Timeout to avoid '...has changed after it was checked' error
        setTimeout(() => {
            let usedWidth = 0;
            this.visibleItems = [];
            this.hiddenItems = [];
            this.menuItems.forEach((item, i) => {
                const nextWidth = usedWidth + item.width;
                nextWidth < availableWidth
                    ? this.visibleItems.push(this.menuItems[i])
                    : this.hiddenItems.push(this.menuItems[i]);
                usedWidth = usedWidth + item.width;
            });
        });
    }
    /**
     * @internal
     */
    onItemClick(item, index) {
        if (!item.subItems) {
            this.itemIdx = index;
            this.vclMegaMenuService.setClickedItem({
                label: item.label,
                path: item.path,
            });
            return;
        }
        this.setItemIndex(index);
    }
    /**
     * @internal
     */
    onSubItemClick(item) {
        this.closeItemsList();
        this.vclMegaMenuService.setClickedItem({
            label: item.label,
            path: item.path,
        });
    }
    /**
     * @internal
     */
    onMoreClick() {
        this.setItemIndex(-1);
    }
    /**
     * @internal
     */
    onMoreItemClick(item) {
        if ((item === null || item === void 0 ? void 0 : item.path) === undefined) {
            return;
        }
        this.closeItemsList();
        this.vclMegaMenuService.setClickedItem({
            label: item.label,
            path: item.path,
        });
    }
    setItemIndex(index) {
        if (this.itemIdx !== index) {
            this.itemIdx = index;
        }
        else {
            this.closeItemsList();
        }
    }
    /**
     * @internal
     */
    closeItemsList() {
        this.itemIdx = undefined;
    }
}
VclMegaMenuComponent.ɵfac = function VclMegaMenuComponent_Factory(t) { return new (t || VclMegaMenuComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.VoxelSegmentService), ɵngcc0.ɵɵdirectiveInject(VclMegaMenuService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
VclMegaMenuComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VclMegaMenuComponent, selectors: [["vcl-mega-menu"]], viewQuery: function VclMegaMenuComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c30, 5);
        ɵngcc0.ɵɵviewQuery(_c31, 5);
        ɵngcc0.ɵɵviewQuery(_c32, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.menuWrapperRef = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.menuMoreRef = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.menuItemsRef = _t);
    } }, hostBindings: function VclMegaMenuComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function VclMegaMenuComponent_resize_HostBindingHandler() { return ctx.onResize(); }, false, ɵngcc0.ɵɵresolveWindow)("click", function VclMegaMenuComponent_click_HostBindingHandler($event) { return ctx.clickOutside($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, inputs: { menuItems: "menuItems", language: "language" }, decls: 16, vars: 10, consts: [[1, "vcl-mega-menu"], ["menuWrapper", ""], [1, "vcl-mega-menu__menu__items"], ["class", "vcl-mega-menu__menu__items__item", 3, "click", 4, "ngFor", "ngForOf"], ["class", "vcl-mega-menu__menu__more", 3, "click", 4, "ngIf"], [4, "ngIf", "ngIfThen", "ngIfElse"], ["subItems", ""], ["moreItems", ""], ["groupDivisor", ""], ["shadeEffect", ""], [1, "vcl-mega-menu__menu__items__item", 3, "click"], ["menuItems", ""], ["class", "vcl-mega-menu__menu__items__item__icon", "size", "S", 3, "ngClass", 4, "ngIf"], [3, "ngClass"], ["size", "S", 1, "vcl-mega-menu__menu__items__item__icon", 3, "ngClass"], [1, "vcl-mega-menu__menu__more", 3, "click"], ["menuMore", ""], ["size", "L", 1, "voxel-pl-s"], [4, "ngIf"], [1, "vcl-mega-menu__list"], ["class", "vcl-mega-menu__list__group", 4, "ngFor", "ngForOf"], [3, "ngTemplateOutlet"], [1, "vcl-mega-menu__list__group"], [1, "vcl-mega-menu__list__group__title"], ["class", "vcl-mega-menu__list__group__item", 3, "click", 4, "ngFor", "ngForOf"], [1, "vcl-mega-menu__list__group__item", 3, "click"], [1, "vcl-mega-menu__list__group__title", 3, "ngClass", "click"], [4, "ngFor", "ngForOf"], [1, "vcl-mega-menu__list__group__subtitle"], [1, "vcl-mega-menu__list__group__divisor"], [1, "vcl-mega-menu__list__group__shade"]], template: function VclMegaMenuComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", null, 1);
        ɵngcc0.ɵɵpipe(3, "async");
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵtemplate(5, VclMegaMenuComponent_div_5_Template, 6, 12, "div", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, VclMegaMenuComponent_div_6_Template, 7, 7, "div", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, VclMegaMenuComponent_ng_container_7_Template, 1, 0, "ng-container", 5);
        ɵngcc0.ɵɵtemplate(8, VclMegaMenuComponent_ng_template_8_Template, 1, 1, "ng-template", null, 6, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(10, VclMegaMenuComponent_ng_template_10_Template, 1, 1, "ng-template", null, 7, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(12, VclMegaMenuComponent_ng_template_12_Template, 1, 0, "ng-template", null, 8, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(14, VclMegaMenuComponent_ng_template_14_Template, 1, 0, "ng-template", null, 9, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r4 = ɵngcc0.ɵɵreference(9);
        const _r6 = ɵngcc0.ɵɵreference(11);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate1("vcl-mega-menu__menu ", ɵngcc0.ɵɵpipeBind1(3, 8, ctx.segment), "");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.visibleItems);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hiddenItems.length > 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.itemIdx >= 0)("ngIfThen", _r4)("ngIfElse", _r6);
    } }, directives: [ɵngcc2.NgForOf, ɵngcc2.NgIf, ɵngcc2.NgClass, ɵngcc1.VoxelIconComponent, ɵngcc2.NgTemplateOutlet], pipes: [ɵngcc2.AsyncPipe], styles: [".vcl-mega-menu__menu[_ngcontent-%COMP%]{font-family:\"Itau Display\";font-weight:700;display:flex;width:100%;max-height:3.375rem;justify-content:space-between;background-color:#faf7f5;color:#231d19;box-shadow:0 2px 8px #56504c33,0 2px 2px #56504c33;padding:0 2rem}.vcl-mega-menu__menu__items[_ngcontent-%COMP%]{display:flex}.vcl-mega-menu__menu__items__item[_ngcontent-%COMP%]{cursor:pointer;display:flex;position:relative;align-items:center;white-space:nowrap;padding:.9rem 1.25rem 1.1rem}.vcl-mega-menu__menu__items__item[_ngcontent-%COMP%]:first-child{padding-left:0}.vcl-mega-menu__menu__items__item__icon[_ngcontent-%COMP%]{transition:.2s linear;padding-left:.3125rem;width:0}.vcl-mega-menu__menu__items__item__icon.active[_ngcontent-%COMP%]{transform:rotateX(180deg)}.vcl-mega-menu__menu__items__item.active-bar[_ngcontent-%COMP%]{position:absolute;width:calc(100% - 2.5rem);height:.1875rem;padding:0;background-color:#231d19;bottom:0;transition:.2s linear}.vcl-mega-menu__menu__items__item.active-bar.first-el[_ngcontent-%COMP%]{width:100%}.vcl-mega-menu__menu__items__item.active-bar.has-subitems[_ngcontent-%COMP%]:not(.first-el){width:calc(100% - 1.5rem)}.vcl-mega-menu__menu__items__item.active-bar[active=false][_ngcontent-%COMP%]{opacity:0}.vcl-mega-menu__menu__items__item.active-bar[active=true][_ngcontent-%COMP%]{opacity:1}.vcl-mega-menu__menu__items__item[_ngcontent-%COMP%]:hover   .active-bar[_ngcontent-%COMP%]{opacity:1}.vcl-mega-menu__menu__more[_ngcontent-%COMP%]{cursor:pointer;display:flex;position:relative;align-items:center;padding:.8125rem 0 1.1875rem 1.25rem}.vcl-mega-menu__menu__more.active[_ngcontent-%COMP%]{position:absolute;width:calc(100% - 1.25rem);height:.1875rem;padding:0;background-color:#231d19;bottom:0;opacity:0;transition:.2s linear}.vcl-mega-menu__menu__more.active[active=false][_ngcontent-%COMP%]{opacity:0}.vcl-mega-menu__menu__more.active[active=true][_ngcontent-%COMP%]{opacity:1}.vcl-mega-menu__menu__more[_ngcontent-%COMP%]:hover   .active[_ngcontent-%COMP%]{opacity:1}.vcl-mega-menu__list[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;width:100%;position:absolute;z-index:1000;padding:3rem 1rem;background-color:#fff;border-radius:4px;box-shadow:0 3px 8px #919ba666}@media only screen and (min-width: 1024px){.vcl-mega-menu__list[_ngcontent-%COMP%]{max-height:calc(80% - 8.875rem);overflow-y:scroll;padding-bottom:0}}.vcl-mega-menu__list__group[_ngcontent-%COMP%]{padding:1rem}@media only screen and (max-width: 767.98px){.vcl-mega-menu__list__group[_ngcontent-%COMP%]{width:19.5rem}}@media only screen and (min-width: 768px) and (max-width: 1023.98px){.vcl-mega-menu__list__group[_ngcontent-%COMP%]{width:21rem}}@media only screen and (min-width: 1024px) and (max-width: 1279.98px){.vcl-mega-menu__list__group[_ngcontent-%COMP%]{width:13rem}}@media only screen and (min-width: 1280px) and (max-width: 1599.98px){.vcl-mega-menu__list__group[_ngcontent-%COMP%]{width:17.5rem}}@media only screen and (min-width: 1600px){.vcl-mega-menu__list__group[_ngcontent-%COMP%]{width:20.5rem}}.vcl-mega-menu__list__group__title[_ngcontent-%COMP%]{font-size:1.25rem;font-family:\"Itau Display\";font-weight:900}.vcl-mega-menu__list__group__title.clickable[_ngcontent-%COMP%]{cursor:pointer}.vcl-mega-menu__list__group__title.clickable[_ngcontent-%COMP%]:hover{text-decoration:underline}.vcl-mega-menu__list__group__subtitle[_ngcontent-%COMP%]{color:#56504c;font-family:\"Itau Display\";font-weight:900;padding:.5rem 0}.vcl-mega-menu__list__group__item[_ngcontent-%COMP%]{cursor:pointer;padding:.5rem 0}.vcl-mega-menu__list__group__item[_ngcontent-%COMP%]:hover{text-decoration:underline}.vcl-mega-menu__list__group__divisor[_ngcontent-%COMP%]{width:100%;height:.0625rem;margin:.5rem 0;background-color:#efe9e5}.vcl-mega-menu__list__group__shade[_ngcontent-%COMP%]{display:none;width:calc(100% - 1.25rem);height:5rem;background-image:linear-gradient(to top,#fff,rgba(255,255,255,.5) 23%);position:sticky;bottom:0}@media only screen and (min-width: 1024px){.vcl-mega-menu__list__group__shade[_ngcontent-%COMP%]{display:inline}}.empresas.vcl-mega-menu__menu[_ngcontent-%COMP%]{background-color:#003767;color:#fff}.empresas.vcl-mega-menu__menu__items__item.active-bar[_ngcontent-%COMP%]{background-color:#fff}.empresas.vcl-mega-menu__menu__more.active[_ngcontent-%COMP%]{background-color:#fff}"] });
VclMegaMenuComponent.ctorParameters = () => [
    { type: VoxelSegmentService },
    { type: VclMegaMenuService },
    { type: ElementRef }
];
VclMegaMenuComponent.propDecorators = {
    menuWrapperRef: [{ type: ViewChild, args: ['menuWrapper',] }],
    menuItemsRef: [{ type: ViewChildren, args: ['menuItems',] }],
    menuMoreRef: [{ type: ViewChild, args: ['menuMore',] }],
    menuItems: [{ type: Input }],
    language: [{ type: Input }],
    onResize: [{ type: HostListener, args: ['window:resize',] }],
    clickOutside: [{ type: HostListener, args: ['document:click', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclMegaMenuComponent, [{
        type: Component,
        args: [{
                selector: 'vcl-mega-menu',
                template: "<div class=\"vcl-mega-menu\">\n  <div #menuWrapper class=\"vcl-mega-menu__menu {{ segment | async }}\">\n    <div class=\"vcl-mega-menu__menu__items\">\n      <div\n        #menuItems\n        class=\"vcl-mega-menu__menu__items__item\"\n        *ngFor=\"let item of visibleItems; let i = index;\"\n        (click)=\"onItemClick(item, i)\">\n        {{item.label}}  <voxel-icon\n                          *ngIf=\"item.subItems\"\n                          [ngClass]=\"{'active': item.label === visibleItems[itemIdx]?.label}\"\n                          class=\"vcl-mega-menu__menu__items__item__icon\"\n                          size=\"S\">\n                          seta_baixo\n                        </voxel-icon>\n        <div\n          [attr.active]=\"item.label === visibleItems[itemIdx]?.label\"\n          [ngClass]=\"{'first-el': item.label === visibleItems[0]?.label, 'has-subitems': item.subItems }\"\n          class=\"vcl-mega-menu__menu__items__item active-bar {{ segment | async }}\">\n        </div>\n      </div>\n    </div>\n    <div\n      #menuMore\n      *ngIf=\"hiddenItems.length > 0\"\n      class=\"vcl-mega-menu__menu__more\"\n      (click)=\"onMoreClick()\">\n      {{ language.toUpperCase() === 'PT' ? 'Mais' : 'M\u00E1s' }} <voxel-icon class=\"voxel-pl-s\" size=\"L\"> outros </voxel-icon>\n      <div\n        [attr.active]=\"itemIdx === -1\"\n        class=\"vcl-mega-menu__menu__more active {{ segment | async }}\">\n      </div>\n    </div>\n  </div>\n\n  <ng-container *ngIf=\"itemIdx >= 0; then subItems; else moreItems\"></ng-container>\n\n  <ng-template #subItems>\n    <ng-container *ngIf=\"visibleItems[itemIdx].subItems\">\n      <div class=\"vcl-mega-menu__list\">\n        <div *ngFor=\"let subItem of visibleItems[itemIdx].subItems\" class=\"vcl-mega-menu__list__group\">\n          <div class=\"vcl-mega-menu__list__group__title\">\n            {{ subItem.title }}\n          </div>\n\n          <ng-container [ngTemplateOutlet]=\"groupDivisor\"></ng-container>\n\n          <div *ngFor=\"let item of subItem.items\" class=\"vcl-mega-menu__list__group__item\" (click)=\"onSubItemClick(item)\">\n            {{ item.label }}\n          </div>\n        </div>\n\n        <ng-container [ngTemplateOutlet]=\"shadeEffect\"></ng-container>\n      </div>\n    </ng-container>\n  </ng-template>\n\n  <ng-template #moreItems>\n    <ng-container *ngIf=\"itemIdx === -1\">\n      <div class=\"vcl-mega-menu__list\">\n        <div *ngFor=\"let hiddenItem of hiddenItems\" class=\"vcl-mega-menu__list__group\">\n          <div class=\"vcl-mega-menu__list__group__title\" [ngClass]=\"{ 'clickable': !hiddenItem.subItems }\" (click)=\"onMoreItemClick(hiddenItem.subItems ? undefined : hiddenItem)\">\n            {{ hiddenItem.label }}\n          </div>\n\n          <ng-container [ngTemplateOutlet]=\"groupDivisor\"></ng-container>\n\n          <div *ngFor=\"let subItem of hiddenItem.subItems\">\n            <div class=\"vcl-mega-menu__list__group__subtitle\">\n              {{ subItem.title }}\n            </div>\n\n            <div *ngFor=\"let item of subItem.items\" class=\"vcl-mega-menu__list__group__item\" (click)=\"onMoreItemClick(item)\">\n              {{ item.label }}\n            </div>\n          </div>\n        </div>\n\n        <ng-container [ngTemplateOutlet]=\"shadeEffect\"></ng-container>\n      </div>\n    </ng-container>\n\n  </ng-template>\n\n  <ng-template #groupDivisor>\n    <div class=\"vcl-mega-menu__list__group__divisor\"></div>\n  </ng-template>\n\n  <ng-template #shadeEffect>\n    <div class=\"vcl-mega-menu__list__group__shade\"></div>\n  </ng-template>\n</div>\n",
                styles: [".vcl-mega-menu__menu{font-family:\"Itau Display\";font-weight:700;display:flex;width:100%;max-height:3.375rem;justify-content:space-between;background-color:#faf7f5;color:#231d19;box-shadow:0 2px 8px #56504c33,0 2px 2px #56504c33;padding:0 2rem}.vcl-mega-menu__menu__items{display:flex}.vcl-mega-menu__menu__items__item{cursor:pointer;display:flex;position:relative;align-items:center;white-space:nowrap;padding:.9rem 1.25rem 1.1rem}.vcl-mega-menu__menu__items__item:first-child{padding-left:0}.vcl-mega-menu__menu__items__item__icon{transition:.2s linear;padding-left:.3125rem;width:0}.vcl-mega-menu__menu__items__item__icon.active{transform:rotateX(180deg)}.vcl-mega-menu__menu__items__item.active-bar{position:absolute;width:calc(100% - 2.5rem);height:.1875rem;padding:0;background-color:#231d19;bottom:0;transition:.2s linear}.vcl-mega-menu__menu__items__item.active-bar.first-el{width:100%}.vcl-mega-menu__menu__items__item.active-bar.has-subitems:not(.first-el){width:calc(100% - 1.5rem)}.vcl-mega-menu__menu__items__item.active-bar[active=false]{opacity:0}.vcl-mega-menu__menu__items__item.active-bar[active=true]{opacity:1}.vcl-mega-menu__menu__items__item:hover .active-bar{opacity:1}.vcl-mega-menu__menu__more{cursor:pointer;display:flex;position:relative;align-items:center;padding:.8125rem 0 1.1875rem 1.25rem}.vcl-mega-menu__menu__more.active{position:absolute;width:calc(100% - 1.25rem);height:.1875rem;padding:0;background-color:#231d19;bottom:0;opacity:0;transition:.2s linear}.vcl-mega-menu__menu__more.active[active=false]{opacity:0}.vcl-mega-menu__menu__more.active[active=true]{opacity:1}.vcl-mega-menu__menu__more:hover .active{opacity:1}.vcl-mega-menu__list{display:flex;flex-wrap:wrap;width:100%;position:absolute;z-index:1000;padding:3rem 1rem;background-color:#fff;border-radius:4px;box-shadow:0 3px 8px #919ba666}@media only screen and (min-width: 1024px){.vcl-mega-menu__list{max-height:calc(80% - 8.875rem);overflow-y:scroll;padding-bottom:0}}.vcl-mega-menu__list__group{padding:1rem}@media only screen and (max-width: 767.98px){.vcl-mega-menu__list__group{width:19.5rem}}@media only screen and (min-width: 768px) and (max-width: 1023.98px){.vcl-mega-menu__list__group{width:21rem}}@media only screen and (min-width: 1024px) and (max-width: 1279.98px){.vcl-mega-menu__list__group{width:13rem}}@media only screen and (min-width: 1280px) and (max-width: 1599.98px){.vcl-mega-menu__list__group{width:17.5rem}}@media only screen and (min-width: 1600px){.vcl-mega-menu__list__group{width:20.5rem}}.vcl-mega-menu__list__group__title{font-size:1.25rem;font-family:\"Itau Display\";font-weight:900}.vcl-mega-menu__list__group__title.clickable{cursor:pointer}.vcl-mega-menu__list__group__title.clickable:hover{text-decoration:underline}.vcl-mega-menu__list__group__subtitle{color:#56504c;font-family:\"Itau Display\";font-weight:900;padding:.5rem 0}.vcl-mega-menu__list__group__item{cursor:pointer;padding:.5rem 0}.vcl-mega-menu__list__group__item:hover{text-decoration:underline}.vcl-mega-menu__list__group__divisor{width:100%;height:.0625rem;margin:.5rem 0;background-color:#efe9e5}.vcl-mega-menu__list__group__shade{display:none;width:calc(100% - 1.25rem);height:5rem;background-image:linear-gradient(to top,#fff,rgba(255,255,255,.5) 23%);position:sticky;bottom:0}@media only screen and (min-width: 1024px){.vcl-mega-menu__list__group__shade{display:inline}}.empresas.vcl-mega-menu__menu{background-color:#003767;color:#fff}.empresas.vcl-mega-menu__menu__items__item.active-bar{background-color:#fff}.empresas.vcl-mega-menu__menu__more.active{background-color:#fff}\n"]
            }]
    }], function () { return [{ type: ɵngcc1.VoxelSegmentService }, { type: VclMegaMenuService }, { type: ɵngcc0.ElementRef }]; }, { menuItems: [{
            type: Input
        }], language: [{
            type: Input
        }], 
    /**
     * @internal
     */
    onResize: [{
            type: HostListener,
            args: ['window:resize']
        }], 
    /**
     * @internal
     */
    clickOutside: [{
            type: HostListener,
            args: ['document:click', ['$event']]
        }], menuWrapperRef: [{
            type: ViewChild,
            args: ['menuWrapper']
        }], menuItemsRef: [{
            type: ViewChildren,
            args: ['menuItems']
        }], menuMoreRef: [{
            type: ViewChild,
            args: ['menuMore']
        }] }); })();

class VclHeaderModule {
}
VclHeaderModule.ɵfac = function VclHeaderModule_Factory(t) { return new (t || VclHeaderModule)(); };
VclHeaderModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VclHeaderModule });
VclHeaderModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [VclMegaMenuService], imports: [[
            CommonModule,
            VoxelSegmentModule,
            RouterModule,
            VoxelIconModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclHeaderModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    VoxelSegmentModule,
                    RouterModule,
                    VoxelIconModule,
                ],
                declarations: [
                    VclHeaderComponent,
                    VclMegaMenuComponent,
                ],
                providers: [VclMegaMenuService],
                exports: [VclHeaderComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VclHeaderModule, { declarations: function () { return [VclHeaderComponent, VclMegaMenuComponent]; }, imports: function () { return [CommonModule,
        VoxelSegmentModule,
        RouterModule,
        VoxelIconModule]; }, exports: function () { return [VclHeaderComponent]; } }); })();

/**
 * Componente para geração de código qr a partir de uma string informada
 *
 * *Component for generating qr code from a given string*
 *
 * ### Acessible
 *
 * <acessible class="not-tested">Acessibilidade - Não testado</acessible>
 *
 * **Module:**
 *
 * `import { VclQrCodeModule } from '@voxel/community';`
 *
 * <example-url>../../demo/index.html#/portfolio/components/qr-code?componentOnly=true</example-url>
 *
 * @example com botão principal
 * <vcl-qr-code
 *   *ngIf="showQrCode"
 *   [qrdata]="qrdata"
 *   [elementType]="elementType"
 *   (imageBase64)="setImage($event)"
 *   ></vcl-qr-code>
 */
class VclQrCodeComponent {
    /**
     *
     * @internal
     */
    constructor(elementRef) {
        this.elementRef = elementRef;
        /**
         * Width (also defines the height) of the component in pixels
         *
         * **
         */
        this.width = 256;
        /**
         * Nível de correção de erro do código gerado
         *
         * *Error correction level of the generated code*
         */
        this.errorCorrectionLevel = 'M';
        /**
         * Tipo do elemento HTML onde será gerado o código qr
         *
         * *Type of the HTML element where the qr code will be generated*
         */
        this.elementType = 'canvas';
        /**
         * Permite que seja informada um texto vazio
         *
         * *Allows empty text to be entered*
         */
        this.allowEmptyString = true;
        /**
         * Fator de escala. Um valor de 1 significa 1px por módulos (pontos pretos).
         *
         * *Scale factor. A value of 1 means 1px per modules (black dots).*
         */
        this.scale = 4;
        /**
         * Define a largura que a zona silenciosa deve ter.
         *
         * *Define how much wide the quiet zone should be.*
         */
        this.margin = 4;
        /**
         * Evento emitido ao gerar um qr code utilizando a tag img (é possível compartilhar o base64 gerado)
         *
         * *Event issued when generating a qr code using the img tag (it is possible to share the generated base64)*
         */
        this.imageBase64 = new EventEmitter();
    }
    /**
     *
     * @internal
     */
    ngOnChanges() {
        if (this.elementType.toLowerCase() !== 'img') {
            return;
        }
        setTimeout(() => {
            var _a, _b, _c;
            this.imageBase64.emit((_c = (_b = (_a = this.elementRef.nativeElement.children[0]) === null || _a === void 0 ? void 0 : _a.children[0]) === null || _b === void 0 ? void 0 : _b.children[0]) === null || _c === void 0 ? void 0 : _c.currentSrc);
        });
    }
}
VclQrCodeComponent.ɵfac = function VclQrCodeComponent_Factory(t) { return new (t || VclQrCodeComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
VclQrCodeComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VclQrCodeComponent, selectors: [["vcl-qr-code"]], inputs: { width: "width", errorCorrectionLevel: "errorCorrectionLevel", elementType: "elementType", allowEmptyString: "allowEmptyString", scale: "scale", margin: "margin", qrdata: "qrdata" }, outputs: { imageBase64: "imageBase64" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 7, consts: [[3, "qrdata", "width", "errorCorrectionLevel", "elementType", "allowEmptyString", "scale", "margin"]], template: function VclQrCodeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "qrcode", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("qrdata", ctx.qrdata)("width", ctx.width)("errorCorrectionLevel", ctx.errorCorrectionLevel.toUpperCase())("elementType", ctx.elementType.toLowerCase())("allowEmptyString", ctx.allowEmptyString)("scale", ctx.scale)("margin", ctx.margin);
    } }, directives: [ɵngcc7.QRCodeComponent], encapsulation: 2 });
VclQrCodeComponent.ctorParameters = () => [
    { type: ElementRef }
];
VclQrCodeComponent.propDecorators = {
    qrdata: [{ type: Input }],
    width: [{ type: Input }],
    errorCorrectionLevel: [{ type: Input }],
    elementType: [{ type: Input }],
    allowEmptyString: [{ type: Input }],
    scale: [{ type: Input }],
    margin: [{ type: Input }],
    imageBase64: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclQrCodeComponent, [{
        type: Component,
        args: [{
                selector: 'vcl-qr-code',
                template: "<qrcode\n  [qrdata]=\"qrdata\"\n  [width]=\"width\"\n  [errorCorrectionLevel]=\"errorCorrectionLevel.toUpperCase()\"\n  [elementType]=\"elementType.toLowerCase()\"\n  [allowEmptyString]=\"allowEmptyString\"\n  [scale]=\"scale\"\n  [margin]=\"margin\">\n</qrcode>\n"
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { width: [{
            type: Input
        }], errorCorrectionLevel: [{
            type: Input
        }], elementType: [{
            type: Input
        }], allowEmptyString: [{
            type: Input
        }], scale: [{
            type: Input
        }], margin: [{
            type: Input
        }], imageBase64: [{
            type: Output
        }], qrdata: [{
            type: Input
        }] }); })();

class VclQrCodeModule {
}
VclQrCodeModule.ɵfac = function VclQrCodeModule_Factory(t) { return new (t || VclQrCodeModule)(); };
VclQrCodeModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VclQrCodeModule });
VclQrCodeModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[QRCodeModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclQrCodeModule, [{
        type: NgModule,
        args: [{
                imports: [QRCodeModule],
                declarations: [VclQrCodeComponent],
                exports: [VclQrCodeComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VclQrCodeModule, { declarations: function () { return [VclQrCodeComponent]; }, imports: function () { return [QRCodeModule]; }, exports: function () { return [VclQrCodeComponent]; } }); })();

/**
 * @internal
 */
let NEXT_ID$1 = 0;
/**
 *  @internal
 *  Componente base para select.
 *
 * *Base component to select.*
 */
class VclSelectOptionComponent {
    /**
     * @internal
     */
    constructor(segmentService, _element) {
        this.segmentService = segmentService;
        this._element = _element;
        this._selected = false;
        this._disabled = false;
        this._showing = true;
        /**
         *  Identificação única da opção.
         *
         * *Unique option identification.*
         */
        this.optionId = `vcl-select-option-${NEXT_ID$1++}`;
        this.group = false;
        this.groupTitle = false;
        /**
         * Evento disparado quando ouver mudança na opção.
         *
         * *Event fired when you hear a change in option.*
         */
        this.change = new EventEmitter();
        /**
         * @internal
         */
        this.segment = this.segmentService.segment;
    }
    /**
     * Indica se a opção ficara desabilitato.
     *
     * *Indicates whether the option will be disabled.*
     */
    get disabled() { return this._disabled; }
    set disabled(value) { this._disabled = enforceBoolean$1(value); }
    /**
     * Indica se a opção esta selecionada.
     *
     * *Indicates whether the option is selected.*
     */
    get selected() { return this._selected; }
    set selected(value) { this._selected = enforceBoolean$1(value); }
    /**
     * @internal
     */
    get showing() {
        return this._showing;
    }
    /**
     * @internal
     */
    get optionValue() {
        return (this._element.nativeElement.querySelector('.vcl-select-option__wrapper__text').textContent || '').trim();
    }
    /**
     * @internal
     */
    get optionIcon() {
        return this._element.nativeElement.querySelector('.voxel-icon')
            ? this._element.nativeElement
                .querySelector('.voxel-icon')
                .textContent.trim()
            : '';
    }
    /**
     * @internal
     */
    get getOptionClasses() {
        return {
            'vcl-select-option--selected': this.selected,
            'vcl-select-option--disabled': this.disabled,
            'vcl-select-option--hide': !this.showing,
            'vcl-select-option--group': this.group,
            'vcl-select-option--group-title': this.groupTitle,
            'vcl-select-option--has-icon': this.icon,
            'vcl-select-option': true,
            'voxel-txt-color-sand-900': true,
            'voxel-ph-lg': true,
        };
    }
    /**
     * @internal
     */
    getTabIndex() {
        return this.disabled ? '-1' : '0';
    }
    /**
     * @internal
     */
    select(close = false) {
        if (this.disabled) {
            return;
        }
        this._selected = true;
        this._emitOptionChangeEvent(close);
    }
    /**
     * @internal
     */
    deselect() {
        this._selected = false;
        this._emitOptionChangeEvent();
    }
    /**
     * @internal
     */
    show() {
        this._showing = true;
    }
    /**
     * @internal
     */
    hide() {
        this._showing = false;
    }
    /**
     * @internal
     */
    _emitOptionChangeEvent(_close) {
        this.change.emit({ option: this, close: _close });
    }
}
VclSelectOptionComponent.ɵfac = function VclSelectOptionComponent_Factory(t) { return new (t || VclSelectOptionComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.VoxelSegmentService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
VclSelectOptionComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VclSelectOptionComponent, selectors: [["vcl-select-option"]], viewQuery: function VclSelectOptionComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c9, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.option = _t.first);
    } }, hostAttrs: ["tabindex", "-1"], inputs: { optionId: "optionId", group: "group", groupTitle: "groupTitle", disabled: "disabled", selected: "selected", value: "value", icon: "icon" }, outputs: { change: "change" }, ngContentSelectors: _c3, decls: 7, vars: 12, consts: [["role", "option", 3, "ngClass", "tabindex", "id", "click"], ["option", ""], [1, "vcl-select-option__wrapper"], ["class", "voxel-pr-s", 4, "ngIf"], [1, "vcl-select-option__wrapper__text", 3, "ngClass"], [1, "voxel-pr-s"]], template: function VclSelectOptionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵlistener("click", function VclSelectOptionComponent_Template_div_click_0_listener() { return ctx.select(true); });
        ɵngcc0.ɵɵpipe(2, "async");
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵtemplate(4, VclSelectOptionComponent_voxel_icon_4_Template, 2, 1, "voxel-icon", 3);
        ɵngcc0.ɵɵelementStart(5, "span", 4);
        ɵngcc0.ɵɵprojection(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ɵngcc0.ɵɵpipeBind1(2, 10, ctx.segment));
        ɵngcc0.ɵɵproperty("ngClass", ctx.getOptionClasses)("tabindex", ctx.getTabIndex())("id", ctx.optionId);
        ɵngcc0.ɵɵattribute("aria-selected", ctx.selected)("aria-disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.icon);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.selected ? "voxel-text-m-bd" : "voxel-text-m");
    } }, directives: [ɵngcc2.NgClass, ɵngcc2.NgIf, ɵngcc1.VoxelIconComponent], pipes: [ɵngcc2.AsyncPipe], styles: ["[_nghost-%COMP%]{display:block}.vcl-select-option[_ngcontent-%COMP%]{height:3rem;display:flex;align-items:center;padding:0 1.5rem;cursor:pointer}.vcl-select-option--group[_ngcontent-%COMP%]:not(.vcl-select-option--group-title){padding-left:2.5rem}.vcl-select-option--group[_ngcontent-%COMP%]:not(.vcl-select-option--group-title).vcl-select-option--selected{padding-left:2.25rem}.vcl-select-option--group-title[_ngcontent-%COMP%]{pointer-events:none}.vcl-select-option--group-title.vcl-select-option--has-icon[_ngcontent-%COMP%]{padding-left:.75rem}.vcl-select-option--group-title[_ngcontent-%COMP%]   .vcl-select-option__wrapper[_ngcontent-%COMP%]{border:none}.vcl-select-option--group-title[_ngcontent-%COMP%]   .vcl-select-option__wrapper__text[_ngcontent-%COMP%]{font-weight:900}.vcl-select-option__wrapper[_ngcontent-%COMP%]{width:100%;height:100%;display:flex;align-items:center;border-bottom:1px solid #efe9e5}.vcl-select-option__wrapper__text[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.vcl-select-option[_ngcontent-%COMP%]:hover{background-color:#efe9e5}.vcl-select-option--selected[_ngcontent-%COMP%]{border-left:.25rem solid;padding-left:1.25rem}.vcl-select-option--hide[_ngcontent-%COMP%]{display:none}.vcl-select-option--disabled[_ngcontent-%COMP%]{color:#d6d0cc;pointer-events:none}.varejo.vcl-select-option[_ngcontent-%COMP%]{border-color:#ec7000}.personnalite.vcl-select-option[_ngcontent-%COMP%]{border-color:#d0a967}.uniclass.vcl-select-option[_ngcontent-%COMP%]{border-color:#ec7000}.empresas.vcl-select-option[_ngcontent-%COMP%]{border-color:#ec7000}.itaucard.vcl-select-option[_ngcontent-%COMP%]{border-color:#ec7000}.private.vcl-select-option[_ngcontent-%COMP%]{border-color:#ec7000}.parceiro-itaucard.vcl-select-option[_ngcontent-%COMP%]{border-color:#ec7000}.parceiro-credicard.vcl-select-option[_ngcontent-%COMP%]{border-color:#0d456f}.parceiro-hipercard.vcl-select-option[_ngcontent-%COMP%]{border-color:#ba1319}.parceiro-magazine-luiza.vcl-select-option[_ngcontent-%COMP%]{border-color:#0083ca}.personal-bank.vcl-select-option[_ngcontent-%COMP%]{border-color:#ce9141}.itau-bba.vcl-select-option[_ngcontent-%COMP%]{border-color:#2449cc}.varejo.vcl-select-option--selected[_ngcontent-%COMP%]{color:#ec7000}.personnalite.vcl-select-option--selected[_ngcontent-%COMP%]{color:#d0a967}.uniclass.vcl-select-option--selected[_ngcontent-%COMP%]{color:#ec7000}.empresas.vcl-select-option--selected[_ngcontent-%COMP%]{color:#ec7000}.itaucard.vcl-select-option--selected[_ngcontent-%COMP%]{color:#ec7000}.private.vcl-select-option--selected[_ngcontent-%COMP%]{color:#ec7000}.parceiro-itaucard.vcl-select-option--selected[_ngcontent-%COMP%]{color:#ec7000}.parceiro-credicard.vcl-select-option--selected[_ngcontent-%COMP%]{color:#0d456f}.parceiro-hipercard.vcl-select-option--selected[_ngcontent-%COMP%]{color:#ba1319}.parceiro-magazine-luiza.vcl-select-option--selected[_ngcontent-%COMP%]{color:#0083ca}.personal-bank.vcl-select-option--selected[_ngcontent-%COMP%]{color:#ce9141}.itau-bba.vcl-select-option--selected[_ngcontent-%COMP%]{color:#2449cc}.personnalite.vcl-select-option[_ngcontent-%COMP%]{border-color:#876632}"] });
VclSelectOptionComponent.ctorParameters = () => [
    { type: VoxelSegmentService },
    { type: ElementRef }
];
VclSelectOptionComponent.propDecorators = {
    optionId: [{ type: Input }],
    value: [{ type: Input }],
    disabled: [{ type: Input }],
    selected: [{ type: Input }],
    group: [{ type: Input }],
    groupTitle: [{ type: Input }],
    icon: [{ type: Input }],
    change: [{ type: Output }],
    option: [{ type: ViewChild, args: ['option', { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclSelectOptionComponent, [{
        type: Component,
        args: [{
                selector: 'vcl-select-option',
                template: "<div\n  #option\n  class=\"{{ segment | async }}\"\n  [ngClass]=\"getOptionClasses\"\n  [tabindex]=\"getTabIndex()\"\n  (click)=\"select(true)\"\n  role=\"option\"\n  [attr.aria-selected]=\"selected\"\n  [attr.aria-disabled]=\"disabled\"\n  [id]=\"optionId\"\n>\n  <div class=\"vcl-select-option__wrapper\">\n    <voxel-icon *ngIf=\"icon\" class=\"voxel-pr-s\">{{icon}}</voxel-icon>\n    <span class=\"vcl-select-option__wrapper__text\" [ngClass]=\"selected ? 'voxel-text-m-bd' : 'voxel-text-m'\">\n      <ng-content></ng-content>\n    </span>\n  </div>\n</div>\n",
                // tslint:disable-next-line: no-host-metadata-property
                host: {
                    tabindex: '-1'
                },
                styles: [":host{display:block}.vcl-select-option{height:3rem;display:flex;align-items:center;padding:0 1.5rem;cursor:pointer}.vcl-select-option--group:not(.vcl-select-option--group-title){padding-left:2.5rem}.vcl-select-option--group:not(.vcl-select-option--group-title).vcl-select-option--selected{padding-left:2.25rem}.vcl-select-option--group-title{pointer-events:none}.vcl-select-option--group-title.vcl-select-option--has-icon{padding-left:.75rem}.vcl-select-option--group-title .vcl-select-option__wrapper{border:none}.vcl-select-option--group-title .vcl-select-option__wrapper__text{font-weight:900}.vcl-select-option__wrapper{width:100%;height:100%;display:flex;align-items:center;border-bottom:1px solid #efe9e5}.vcl-select-option__wrapper__text{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.vcl-select-option:hover{background-color:#efe9e5}.vcl-select-option--selected{border-left:.25rem solid;padding-left:1.25rem}.vcl-select-option--hide{display:none}.vcl-select-option--disabled{color:#d6d0cc;pointer-events:none}.varejo.vcl-select-option{border-color:#ec7000}.personnalite.vcl-select-option{border-color:#d0a967}.uniclass.vcl-select-option{border-color:#ec7000}.empresas.vcl-select-option{border-color:#ec7000}.itaucard.vcl-select-option{border-color:#ec7000}.private.vcl-select-option{border-color:#ec7000}.parceiro-itaucard.vcl-select-option{border-color:#ec7000}.parceiro-credicard.vcl-select-option{border-color:#0d456f}.parceiro-hipercard.vcl-select-option{border-color:#ba1319}.parceiro-magazine-luiza.vcl-select-option{border-color:#0083ca}.personal-bank.vcl-select-option{border-color:#ce9141}.itau-bba.vcl-select-option{border-color:#2449cc}.varejo.vcl-select-option--selected{color:#ec7000}.personnalite.vcl-select-option--selected{color:#d0a967}.uniclass.vcl-select-option--selected{color:#ec7000}.empresas.vcl-select-option--selected{color:#ec7000}.itaucard.vcl-select-option--selected{color:#ec7000}.private.vcl-select-option--selected{color:#ec7000}.parceiro-itaucard.vcl-select-option--selected{color:#ec7000}.parceiro-credicard.vcl-select-option--selected{color:#0d456f}.parceiro-hipercard.vcl-select-option--selected{color:#ba1319}.parceiro-magazine-luiza.vcl-select-option--selected{color:#0083ca}.personal-bank.vcl-select-option--selected{color:#ce9141}.itau-bba.vcl-select-option--selected{color:#2449cc}.personnalite.vcl-select-option{border-color:#876632}\n"]
            }]
    }], function () { return [{ type: ɵngcc1.VoxelSegmentService }, { type: ɵngcc0.ElementRef }]; }, { optionId: [{
            type: Input
        }], group: [{
            type: Input
        }], groupTitle: [{
            type: Input
        }], change: [{
            type: Output
        }], disabled: [{
            type: Input
        }], selected: [{
            type: Input
        }], value: [{
            type: Input
        }], icon: [{
            type: Input
        }], option: [{
            type: ViewChild,
            args: ['option', { static: true }]
        }] }); })();

/**
 * Dados dos eventos do Select
 *
 * *Select event data*
 */
class IVclSelectEvent {
    /**
     * @internal
     */
    constructor(source, value) {
        this.source = source;
        this.value = value;
    }
}
/**
 * @internal
 */
let NEXT_ID = 0;
/**
 * Select é um tipo de input utilizado em formulários, no qual o usuário tem a possibilidade de filtrar
 * fazer uma escolha dentre uma lista de opções (4 ou mais), que são exibidas após o clique no componente.
 *
 * *Select is a type of input used in forms, in which the user has the possibility to filter and make
 * a choice from a list of options (4 or more), which are displayed after clicking on the component.*
 *
 * ### Acessible
 *
 * <acessible class="not-tested">Acessibilidade - Não testado</acessible>
 *
 * <example-url>../../demo/index.html#/portfolio/components/select?componentOnly=true</example-url>
 * @example simples
 * <vcl-select
 *  placeholder="Simples"
 * >
 *  <vcl-select-option value="Label1">Label 1</vcl-select-option>
 *  <vcl-select-option value="Label2" disabled>Label 2</vcl-select-option>
 *  <vcl-select-option value="Label3">Label 3</vcl-select-option>
 * </vcl-select>
 *
 * @example desabilitado
 * <vcl-select
 *  placeholder="Simples"
 *  disabled
 * >
 *  <vcl-select-option value="Label1">Label 1</vcl-select-option>
 *  <vcl-select-option value="Label2">Label 2</vcl-select-option>
 *  <vcl-select-option value="Label3" selected>Label 3</vcl-select-option>
 * </vcl-select>
 *
 * @example simples
 * <vcl-select
 *  placeholder="Simples"
 *  required
 * >
 *  <vcl-select-option value="Label1">Label 1</vcl-select-option>
 *  <vcl-select-option value="Label2">Label 2</vcl-select-option>
 *  <vcl-select-option value="Label3">Label 3</vcl-select-option>
 * </vcl-select>
 */
class VclSelectComponent extends VclFieldMixinBase {
    /**
     * @internal
     */
    constructor(ngControl, elementRef, segmentService) {
        super(ngControl, elementRef) /* istanbul ignore next */;
        this.ngControl = ngControl;
        this.elementRef = elementRef;
        this.segmentService = segmentService;
        /**
         *  Identificação única do Select.
         *
         *  *Unique Select identification.*
         */
        this.id = `vcl-select-${NEXT_ID++}`;
        /**
         * Ícone do Select
         *
         * *Select icon*
         */
        this.icon = 'seta_baixo';
        /**
         * Define se o ícone irá girar 180 graus ao abrir/fechar
         *
         * *Defines if the icon will rotate 180 degrees when open/close*
         */
        this.rotateIcon = true;
        /**
         * Evento disparado com a mudança no Select.
         *
         * *Event triggered with the change in the Select.*
         */
        this.change = new EventEmitter();
        /**
         * Evento disparado com o focus no Select.
         *
         * *Event triggered with focus on Select.*
         */
        this.focus = new EventEmitter();
        /**
         * Evento disparado com o blur no Select.
         *
         * *Event triggered with blur on Select.*
         */
        this.blur = new EventEmitter();
        /**
         * @internal
         */
        this._panelOpen = false;
        /**
         * @internal
         */
        this._destroy = new Subject();
        /**
         * @internal
         */
        this._panelId = `vcl-select__panel-options-${NEXT_ID}`;
        /**
         * @internal
         */
        this.controlId = `vcl-select__input-${NEXT_ID}`;
        /**
         * @internal
         */
        this.labelId = `vcl-select-label-${NEXT_ID}`;
        /**
         * @internal
         */
        this.selectSearch = false;
        /**
         * @internal
         */
        this.selectInSearch = false;
        /**
         * @internal
         */
        this.segment = this.segmentService.segment;
        /**
         * @internal
         */
        this._positions = [
            {
                originX: 'start',
                originY: 'bottom',
                overlayX: 'start',
                overlayY: 'top',
            },
            {
                originX: 'start',
                originY: 'top',
                overlayX: 'start',
                overlayY: 'bottom',
            },
        ];
        /** @internal */
        this._optionSelectionChanges = defer(() => {
            const options = this.options;
            return options === null || options === void 0 ? void 0 : options.changes.pipe(startWith(options), switchMap(() => merge(...options.map(option => option.change))));
        });
    }
    /**
     * Indica se o Select é obrigatório.
     *
     * *Indicates whether Select is mandatory.*
     */
    set required(value) { this._required = enforceBoolean$1(value); }
    get required() { return this._required; }
    /**
     * @internal
     */
    get panelOpen() {
        return this._panelOpen;
    }
    /**
     * @internal
     */
    get selectWidth() {
        return this._selectWidth;
    }
    /**
     * @internal
     */
    get panelId() {
        return this._panelId;
    }
    /**
     * @internal
     */
    get optionSeleted() {
        return this._lastOptionSeleted;
    }
    /**
     * @internal
     */
    get arrayOption() {
        return this.options.toArray();
    }
    /**
     * @internal
     */
    get enableOption() {
        return this.arrayOption.filter(item => !item.disabled && item.showing);
    }
    /**
     * @internal
     */
    get optionTextValue() {
        if (!this.selectSearch) {
            return this.optionSeleted ? this.optionSeleted.optionValue : '';
        }
        return this.searchNoResults;
    }
    /**
     * @internal
     */
    get optionIcon() {
        return this.optionSeleted ? this.optionSeleted.optionIcon : '';
    }
    /**
     * @internal
     */
    get maxHeight() {
        if (!!this.maxHeightVh) {
            return `${this.maxHeightVh}vh`;
        }
        if (!!this.maxHeightRem) {
            return `${this.maxHeightRem}rem`;
        }
        // 5.7 * 48 rem
        return `${(5.7 * 48) / 16}rem`;
    }
    /**
     * @internal
     */
    onInputResize() {
        this._selectWidth = this.select.nativeElement.offsetWidth;
    }
    /**
     * @internal
     */
    ngAfterContentInit() {
        this.handleOptionChanging();
        this.handleNgControlChanging();
    }
    /**
     * @internal
     */
    handleOptionChanging() {
        this.options.changes.pipe(startWith(false), takeUntil(this._destroy)).subscribe(() => {
            this.resetOptions();
        });
        this.initializeSelection();
    }
    /**
     * @internal
     */
    resetOptions() {
        const changedOrDestroyed = merge(this.options.changes, this._destroy);
        this._optionSelectionChanges.pipe(takeUntil(changedOrDestroyed)).subscribe(event => {
            this.selectOption(event.option, event.close);
        });
    }
    /**
     * @internal
     */
    handleNgControlChanging() {
        var _a;
        (_a = this.ngControl) === null || _a === void 0 ? void 0 : _a.valueChanges.subscribe(value => {
            this.value = value;
            if (this.value === undefined || this.value === null || this.value === '') {
                this.clearSelectedValue();
                return;
            }
            this.initializeSelection();
        });
    }
    /**
     * @internal
     */
    ngOnDestroy() {
        this._destroy.next();
        this._destroy.complete();
    }
    /**
     * @internal
     */
    initializeSelection() {
        Promise.resolve().then(() => {
            const value = this.ngControl ? this.ngControl.value : this.value;
            const optionSelected = this.enableOption.find(opt => opt.value === value);
            const initialSelect = this.arrayOption.filter(opt => opt.selected);
            if (initialSelect.length > 0 && (!optionSelected || value === '')) {
                this.selectOption(initialSelect[initialSelect.length - 1]);
                return;
            }
            if (!optionSelected) {
                return;
            }
            optionSelected.select();
            this.selectOption(optionSelected);
        });
    }
    /**
     * @internal
     */
    onFocus() {
        this.formAcessorHandleFocus();
        this.focus.emit(new IVclSelectEvent(this, this.value));
    }
    /**
     * @internal
     */
    onBlur() {
        this.formAcessorHandleBlur();
        this.blur.emit(new IVclSelectEvent(this, this.value));
    }
    /**
     * @internal
     */
    toggle() {
        this.panelOpen ? this.close() : this.open();
    }
    /**
     * @internal
     */
    open() {
        this._panelOpen = true;
        this.onInputResize();
        this.onFocus();
    }
    /**
     * @internal
     */
    attached() {
        this.overlayDir.positionChange.pipe(take(1)).subscribe(() => {
            this.setScrollPosition(this.optionSeleted);
        });
    }
    /**
     * @internal
     */
    close() {
        this._panelOpen = false;
        this.onBlur();
        if (this.selectSearch) {
            this.resetSearch();
        }
    }
    /**
     * @internal
     */
    updateValueSelect(selectOption) {
        if (!this._lastOptionSeleted || !(this._lastOptionSeleted.value === selectOption.value)) {
            this.value = selectOption.value;
        }
        this._emitSelectChangeEvent();
        this._lastOptionSeleted = selectOption;
    }
    /**
     * @internal
     */
    selectOption(selectOption, close) {
        if (this.optionSeleted && !(this.optionSeleted.value === selectOption.value)) {
            this.optionSeleted.deselect();
        }
        if (close) {
            this.close();
        }
        this.updateValueSelect(selectOption);
        this.setScrollPosition(selectOption);
    }
    /**
     * @internal
     */
    setSelectOptionByIndex(index = 1) {
        const optionSelected = this._lastOptionSeleted ? this.enableOption.findIndex(opt => opt.selected) : -1;
        if (this.enableOption[optionSelected + index] && !this.selectSearch) {
            this.enableOption[optionSelected + index].select();
        }
        if (this.selectSearch && this.hasSearch && this.enableOption[optionSelected + index]) {
            this.enableOption[optionSelected + index].select();
        }
    }
    /**
     * @internal
     */
    handleKeydown(_event) {
        this.panelOpen ? this.handleOpenKeydown(_event) : this.handleClosedKeydown(_event);
    }
    /**
     * @internal
     */
    handleClosedKeydown(_event) {
        const isOpenKey = _event.code === 'Enter' || _event.code === 'NumpadEnter' || _event.code === 'Space';
        const isArrowKey = _event.code === 'ArrowUp' || _event.code === 'ArrowDown' ||
            _event.code === 'ArrowLeft' || _event.code === 'ArrowRight';
        if (isOpenKey && !this.selectInSearch || (_event.altKey && isArrowKey)) {
            _event.preventDefault();
            this.open();
        }
        if (_event.code === 'Home') {
            _event.preventDefault();
            this.enableOption[0].select();
        }
        if (_event.code === 'End') {
            _event.preventDefault();
            this.enableOption[this.enableOption.length - 1].select();
        }
        if ((_event.code === 'ArrowUp' || _event.code === 'ArrowLeft') && !_event.altKey) {
            _event.preventDefault();
            this.setSelectOptionByIndex(-1);
        }
        if ((_event.code === 'ArrowDown' || _event.code === 'ArrowRight') && !_event.altKey) {
            _event.preventDefault();
            this.setSelectOptionByIndex(1);
        }
        return;
    }
    /**
     * @internal
     */
    handleOpenKeydown(_event) {
        const isEnterKey = _event.code === 'Enter' || _event.code === 'NumpadEnter';
        const isArrowKey = _event.code === 'ArrowUp' || _event.code === 'ArrowDown';
        if (_event.shiftKey && !this.focused) {
            this.selectInput.nativeElement.focus();
        }
        if (isEnterKey ||
            _event.code === 'Tab' ||
            _event.code === 'Escape' ||
            (isArrowKey && _event.altKey) ||
            (_event.code === 'Space' && !this.selectInSearch)) {
            _event.preventDefault();
            this.close();
        }
        if (_event.code === 'Home') {
            _event.preventDefault();
            this.selectOption(this.enableOption[0]);
        }
        if (_event.code === 'End') {
            _event.preventDefault();
            this.selectOption(this.enableOption[this.enableOption.length - 1]);
        }
        if (_event.code === 'ArrowUp' && !_event.altKey) {
            _event.preventDefault();
            this.setSelectOptionByIndex(-1);
            this.selectInSearch = false;
        }
        if (_event.code === 'ArrowDown' && !_event.altKey) {
            _event.preventDefault();
            this.setSelectOptionByIndex(1);
            this.selectInSearch = false;
        }
        return;
    }
    /**
     * @internal
     */
    resetSearch() {
        this.selectSearch = false;
        this.selectInSearch = false;
        this.searchNoResults = '';
    }
    /**
     * @internal
     */
    clearSelectedValue() {
        var _a;
        this.resetSearch();
        (_a = this.optionSeleted) === null || _a === void 0 ? void 0 : _a.deselect();
        this._lastOptionSeleted = undefined;
        this.value = '';
        this._emitSelectChangeEvent();
    }
    /**
     * @internal
     */
    normalizeText(text) {
        return text && text.length > 0
            ? text
                .normalize('NFKD')
                .replace(/[\u0080-\uF8FF]/g, '')
                .toLocaleLowerCase()
            : '';
    }
    /**
     * @internal
     */
    setScrollPosition(option) {
        if (option && this.panel) {
            const positionScroll = option.option.nativeElement.offsetTop - this.panel.nativeElement.scrollTop;
            if (positionScroll >= this.panel.nativeElement.offsetHeight - 9) {
                option.option.nativeElement.scrollIntoView(false);
            }
            if (positionScroll < 0) {
                option.option.nativeElement.scrollIntoView(true);
            }
        }
        return;
    }
    /**
     * @internal
     */
    getAriaActiveDescendant() {
        if (this.panelOpen && this.optionSeleted) {
            return this.optionSeleted.optionId;
        }
        return null;
    }
    /**
     * @internal
     */
    _emitSelectChangeEvent() {
        this.change.emit(new IVclSelectEvent(this, this.value));
    }
    /**
     * @internal
     */
    clearSearch() {
        if (this.optionSeleted) {
            this.clearSelectedValue();
        }
        else {
            this.resetSearch();
        }
        this.value = '';
        this.selectInput.nativeElement.focus();
    }
}
VclSelectComponent.ɵfac = function VclSelectComponent_Factory(t) { return new (t || VclSelectComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NgControl, 10), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.VoxelSegmentService)); };
VclSelectComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VclSelectComponent, selectors: [["vcl-select"]], contentQueries: function VclSelectComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, VclSelectOptionComponent, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.options = _t);
    } }, viewQuery: function VclSelectComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c36, 7);
        ɵngcc0.ɵɵviewQuery(_c37, 7);
        ɵngcc0.ɵɵviewQuery(_c12, 5);
        ɵngcc0.ɵɵviewQuery(CdkConnectedOverlay, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.select = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.selectInput = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.panel = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.overlayDir = _t.first);
    } }, hostBindings: function VclSelectComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function VclSelectComponent_resize_HostBindingHandler() { return ctx.onInputResize(); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { id: "id", icon: "icon", rotateIcon: "rotateIcon", required: "required", placeholder: "placeholder", tabindex: "tabindex", maxHeightRem: "maxHeightRem", maxHeightVh: "maxHeightVh" }, outputs: { change: "change", focus: "focus", blur: "blur" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: VclFieldMixinBase,
                useExisting: forwardRef(() => VclSelectComponent)
            }]), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c41, decls: 14, vars: 47, consts: [["class", "backdrop", 3, "click", 4, "ngIf"], ["cdkOverlayOrigin", ""], ["select", "", "origin", "cdkOverlayOrigin"], [4, "ngIf"], ["role", "combobox", "type", "text", "autocomplete", "off", "aria-haspopup", "listbox", "readonly", "true", 3, "id", "ngClass", "value", "disabled", "required", "tabindex", "placeholder", "click", "keydown", "focus", "blur"], ["selectInput", ""], ["class", "vcl-select__clear-icon icon-itaufonts_fechar", 3, "click", 4, "ngIf"], ["class", "vcl-select__icon-separator", 4, "ngIf"], [3, "ngClass", "click"], ["cdkConnectedOverlay", "", "cdkConnectedOverlayLockPosition", "", 3, "cdkConnectedOverlayHasBackdrop", "cdkConnectedOverlayOrigin", "cdkConnectedOverlayOpen", "cdkConnectedOverlayPositions", "cdkConnectedOverlayWidth", "cdkConnectedOverlayOffsetY", "attach", "detach"], [1, "backdrop", 3, "click"], [1, "vcl-select__clear-icon", "icon-itaufonts_fechar", 3, "click"], [1, "vcl-select__icon-separator"], ["role", "listbox", 1, "vcl-select__panel-options", 3, "id", "keydown"], ["panel", ""]], template: function VclSelectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c38);
        ɵngcc0.ɵɵtemplate(0, VclSelectComponent_div_0_Template, 1, 1, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1, 2);
        ɵngcc0.ɵɵpipe(4, "async");
        ɵngcc0.ɵɵtemplate(5, VclSelectComponent_voxel_icon_5_Template, 2, 1, "voxel-icon", 3);
        ɵngcc0.ɵɵelementStart(6, "input", 4, 5);
        ɵngcc0.ɵɵlistener("click", function VclSelectComponent_Template_input_click_6_listener() { return ctx.toggle(); })("keydown", function VclSelectComponent_Template_input_keydown_6_listener($event) { return ctx.handleKeydown($event); })("focus", function VclSelectComponent_Template_input_focus_6_listener() { return ctx.onFocus(); })("blur", function VclSelectComponent_Template_input_blur_6_listener() { return ctx.onBlur(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, VclSelectComponent_span_8_Template, 1, 0, "span", 6);
        ɵngcc0.ɵɵtemplate(9, VclSelectComponent_div_9_Template, 1, 0, "div", 7);
        ɵngcc0.ɵɵelementStart(10, "voxel-icon", 8);
        ɵngcc0.ɵɵlistener("click", function VclSelectComponent_Template_voxel_icon_click_10_listener() { return ctx.toggle(); });
        ɵngcc0.ɵɵpipe(11, "async");
        ɵngcc0.ɵɵtext(12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(13, VclSelectComponent_ng_template_13_Template, 3, 5, "ng-template", 9);
        ɵngcc0.ɵɵlistener("attach", function VclSelectComponent_Template_ng_template_attach_13_listener() { return ctx.attached(); })("detach", function VclSelectComponent_Template_ng_template_detach_13_listener() { return ctx.close(); });
    } if (rf & 2) {
        const _r2 = ɵngcc0.ɵɵreference(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.panelOpen);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate1("vcl-select ", ɵngcc0.ɵɵpipeBind1(4, 34, ctx.segment), "");
        ɵngcc0.ɵɵclassProp("vcl-select--disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.optionIcon);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("id", ctx.controlId)("ngClass", ɵngcc0.ɵɵpureFunction3(38, _c39, ctx.disabled, !ctx.disabled, ctx.optionIcon))("value", ctx.optionTextValue)("disabled", ctx.disabled)("required", ctx.required)("tabindex", ctx.tabindex)("placeholder", ctx.placeholder);
        ɵngcc0.ɵɵattribute("aria-required", ctx.required)("aria-disabled", ctx.disabled)("aria-expanded", ctx.panelOpen)("aria-describedby", ctx.controlDescribedBy)("aria-invalid", ctx.controlAriaInvalid)("aria-activedescendant", ctx.getAriaActiveDescendant())("aria-owns", ctx.panelId);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.selectSearch || ctx.optionSeleted && ctx.panelOpen);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.selectSearch || ctx.optionSeleted && ctx.panelOpen);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ɵngcc0.ɵɵpipeBind1(11, 36, ctx.segment));
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction4(42, _c40, ctx.disabled, ctx.disabled, ctx.panelOpen, ctx.rotateIcon));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.icon, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("cdkConnectedOverlayHasBackdrop", false)("cdkConnectedOverlayOrigin", _r2)("cdkConnectedOverlayOpen", ctx.panelOpen)("cdkConnectedOverlayPositions", ctx._positions)("cdkConnectedOverlayWidth", ctx.selectWidth)("cdkConnectedOverlayOffsetY", 0);
    } }, directives: [ɵngcc2.NgIf, ɵngcc5.CdkOverlayOrigin, ɵngcc2.NgClass, ɵngcc1.VoxelIconComponent, ɵngcc5.CdkConnectedOverlay], pipes: [ɵngcc2.AsyncPipe], styles: [".cdk-overlay-container,.cdk-global-overlay-wrapper{pointer-events:none;top:0;left:0;height:100%;width:100%}.cdk-overlay-container{position:fixed;z-index:1000}.cdk-overlay-container:empty{display:none}.cdk-global-overlay-wrapper{display:flex;position:absolute;z-index:1000}.cdk-overlay-pane{position:absolute;pointer-events:auto;box-sizing:border-box;z-index:1000;display:flex;max-width:100%;max-height:100%}.cdk-overlay-backdrop{position:absolute;top:0;bottom:0;left:0;right:0;z-index:1000;pointer-events:auto;-webkit-tap-highlight-color:transparent;transition:opacity .4s cubic-bezier(.25,.8,.25,1);opacity:0}.cdk-overlay-backdrop.cdk-overlay-backdrop-showing{opacity:1}.cdk-high-contrast-active .cdk-overlay-backdrop.cdk-overlay-backdrop-showing{opacity:.6}.cdk-overlay-dark-backdrop{background:rgba(0,0,0,.32)}.cdk-overlay-transparent-backdrop,.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing{opacity:0}.cdk-overlay-connected-position-bounding-box{position:absolute;z-index:1000;display:flex;flex-direction:column;min-width:1px;min-height:1px}.cdk-global-scrollblock{position:fixed;width:100%;overflow-y:scroll}.cdk-visually-hidden{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;white-space:nowrap;outline:0;-webkit-appearance:none;-moz-appearance:none}:host{display:block;width:100%}.backdrop{position:fixed;left:0;top:0;width:100%;height:100%;z-index:1000}.vcl-select{position:relative;display:flex;justify-content:space-between;background-color:transparent;padding-bottom:8px}.vcl-select--disabled{pointer-events:none}.vcl-select--disabled input::input-placeholder{font-size:1rem;color:#d6d0cc}.vcl-select--disabled input::placeholder{font-size:1rem;color:#d6d0cc;opacity:1}.vcl-select--disabled input:placeholder{font-size:1rem;color:#d6d0cc;opacity:1}.vcl-select__text{width:100%;border:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;background-color:transparent;cursor:pointer}.vcl-select__text:disabled{background:none}.vcl-select__text--has-icon{margin-left:.5rem}.vcl-select__clear-icon{position:relative;z-index:1500;color:#56504c;cursor:pointer;padding-left:16px;align-self:center}.vcl-select__clear-icon:before{font-size:1rem}.vcl-select__icon-separator{width:1px;height:16px;margin:0 10px 0 14px;align-self:center;background-color:#efe9e5}.vcl-select__icon{transition:.2s linear;cursor:pointer}.vcl-select__icon--open.rotate{transform:rotateX(180deg)}.vcl-select__panel-options{border:.0625rem solid #efe9e5;box-shadow:0 .25rem .5rem #7a6d603d;border:none;background-color:#fff;width:100%;overflow-y:auto;border-radius:0 0 4px 4px;padding:.5rem 0}.vcl-select__not-options{display:flex;align-items:center;padding:1rem 1.5rem}.vcl-select__not-options__wrapper{display:block}.vcl-select__not-options__wrapper__text{display:block}.vcl-select__not-options__wrapper__text:first-child{padding-bottom:.5rem}.varejo.vcl-select__icon:not(.vcl-select__icon--disabled){color:#ec7000}.varejo.vcl-select__icon:not(.vcl-select__icon--disabled):disabled{color:#ff8a20}.personnalite.vcl-select__icon:not(.vcl-select__icon--disabled){color:#d0a967}.personnalite.vcl-select__icon:not(.vcl-select__icon--disabled):disabled{color:#dcbf8e}.uniclass.vcl-select__icon:not(.vcl-select__icon--disabled){color:#ec7000}.uniclass.vcl-select__icon:not(.vcl-select__icon--disabled):disabled{color:#ff8a20}.empresas.vcl-select__icon:not(.vcl-select__icon--disabled){color:#ec7000}.empresas.vcl-select__icon:not(.vcl-select__icon--disabled):disabled{color:#ff8a20}.itaucard.vcl-select__icon:not(.vcl-select__icon--disabled){color:#ec7000}.itaucard.vcl-select__icon:not(.vcl-select__icon--disabled):disabled{color:#ff8a20}.private.vcl-select__icon:not(.vcl-select__icon--disabled){color:#ec7000}.private.vcl-select__icon:not(.vcl-select__icon--disabled):disabled{color:#ff8a20}.parceiro-itaucard.vcl-select__icon:not(.vcl-select__icon--disabled){color:#ec7000}.parceiro-itaucard.vcl-select__icon:not(.vcl-select__icon--disabled):disabled{color:#ff8a20}.parceiro-credicard.vcl-select__icon:not(.vcl-select__icon--disabled){color:#0d456f}.parceiro-credicard.vcl-select__icon:not(.vcl-select__icon--disabled):disabled{color:#12619d}.parceiro-hipercard.vcl-select__icon:not(.vcl-select__icon--disabled){color:#ba1319}.parceiro-hipercard.vcl-select__icon:not(.vcl-select__icon--disabled):disabled{color:#e71920}.parceiro-magazine-luiza.vcl-select__icon:not(.vcl-select__icon--disabled){color:#0083ca}.parceiro-magazine-luiza.vcl-select__icon:not(.vcl-select__icon--disabled):disabled{color:#00a4fd}.personal-bank.vcl-select__icon:not(.vcl-select__icon--disabled){color:#ce9141}.personal-bank.vcl-select__icon:not(.vcl-select__icon--disabled):disabled{color:#d8a86a}.itau-bba.vcl-select__icon:not(.vcl-select__icon--disabled){color:#2449cc}.itau-bba.vcl-select__icon:not(.vcl-select__icon--disabled):disabled{color:#4567de}.personnalite.vcl-select__icon:not(.vcl-select__icon--disabled){color:#876632}\n"], encapsulation: 2 });
/**
 * @internal
 */
VclSelectComponent.selector = 'vcl-select';
VclSelectComponent.ctorParameters = () => [
    { type: NgControl, decorators: [{ type: Self }, { type: Optional }] },
    { type: ElementRef },
    { type: VoxelSegmentService }
];
VclSelectComponent.propDecorators = {
    options: [{ type: ContentChildren, args: [VclSelectOptionComponent,] }],
    select: [{ type: ViewChild, args: ['select', { static: true },] }],
    selectInput: [{ type: ViewChild, args: ['selectInput', { static: true },] }],
    panel: [{ type: ViewChild, args: ['panel',] }],
    overlayDir: [{ type: ViewChild, args: [CdkConnectedOverlay, { static: true },] }],
    required: [{ type: Input }],
    id: [{ type: Input }],
    placeholder: [{ type: Input }],
    tabindex: [{ type: Input }],
    icon: [{ type: Input }],
    rotateIcon: [{ type: Input }],
    maxHeightRem: [{ type: Input }],
    maxHeightVh: [{ type: Input }],
    change: [{ type: Output }],
    focus: [{ type: Output }],
    blur: [{ type: Output }],
    onInputResize: [{ type: HostListener, args: ['window:resize',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclSelectComponent, [{
        type: Component,
        args: [{
                selector: 'vcl-select',
                template: "<div \n  *ngIf=\"panelOpen\"\n  class=\"backdrop\" \n  [attr.aria-hidden]=\"!panelOpen\"\n  (click)=\"close()\">\n</div>\n<div\n  #select\n  class=\"vcl-select {{ segment | async }}\"\n  [class.vcl-select--disabled]=\"disabled\"\n  cdkOverlayOrigin\n  #origin=\"cdkOverlayOrigin\"\n>\n  <voxel-icon *ngIf=\"optionIcon\">{{optionIcon}}</voxel-icon>\n  <input\n    #selectInput\n    [id]=\"controlId\"\n    role=\"combobox\"\n    type=\"text\"\n    autocomplete=\"off\"\n    [ngClass]=\"{\n      'vcl-select__text': true,\n      'voxel-txt-color-sand-200': disabled,\n      'voxel-txt-color-sand-900': !disabled,\n      'voxel-text-l': true,\n      'vcl-select__text--has-icon': optionIcon\n    }\"\n    (click)=\"toggle()\"\n    (keydown)=\"handleKeydown($event)\"\n    [attr.aria-required]=\"required\"\n    [attr.aria-disabled]=\"disabled\"\n    [attr.aria-expanded]=\"panelOpen\"\n    [attr.aria-describedby]=\"controlDescribedBy\"\n    [attr.aria-invalid]=\"controlAriaInvalid\"\n    [attr.aria-activedescendant]=\"getAriaActiveDescendant()\"\n    [attr.aria-owns]=\"panelId\"\n    aria-haspopup=\"listbox\"\n    [value]=\"optionTextValue\"\n    [disabled]=\"disabled\"\n    readonly=\"true\"\n    [required]=\"required\"\n    [tabindex]=\"tabindex\"\n    [placeholder]=\"placeholder\"\n    (focus)=\"onFocus()\"\n    (blur)=\"onBlur()\"\n  />\n\n  <span\n    *ngIf=\"selectSearch || (optionSeleted && panelOpen)\"\n    class=\"vcl-select__clear-icon icon-itaufonts_fechar\"\n    (click)=\"clearSearch()\"></span>\n\n  <div *ngIf=\"selectSearch || (optionSeleted && panelOpen)\" class=\"vcl-select__icon-separator\"></div>\n\n  <voxel-icon\n    class=\"{{ segment | async }}\"\n    [ngClass]=\"{\n      'vcl-select__icon': true,\n      'vcl-select__icon--disabled': disabled,\n      'voxel-txt-color-sand-200': disabled,\n      'vcl-select__icon--open': panelOpen,\n      'rotate': rotateIcon\n    }\"\n    (click)=\"toggle()\"\n  >\n    {{icon}}\n  </voxel-icon>\n</div>\n\n<ng-template\n  cdkConnectedOverlay\n  cdkConnectedOverlayLockPosition\n  [cdkConnectedOverlayHasBackdrop]=\"false\"\n  [cdkConnectedOverlayOrigin]=\"origin\"\n  [cdkConnectedOverlayOpen]=\"panelOpen\"\n  [cdkConnectedOverlayPositions]=\"_positions\"\n  [cdkConnectedOverlayWidth] = \"selectWidth\"\n  [cdkConnectedOverlayOffsetY]=\"0\"\n  (attach)=\"attached()\"\n  (detach)=\"close()\"\n>\n  <div\n    #panel\n    [id]=\"panelId\"\n    class=\"vcl-select__panel-options\"\n    (keydown)=\"handleKeydown($event)\"\n    role=\"listbox\"\n    [attr.aria-labelledby]=\"labelId\"\n    [attr.aria-hidden]=\"!panelOpen\"\n    [style.max-height]=\"maxHeight\"\n  >\n    <ng-content select=\"vcl-select-option\"></ng-content>\n  </div>\n</ng-template>\n",
                providers: [{
                        provide: VclFieldMixinBase,
                        useExisting: forwardRef(() => VclSelectComponent)
                    }],
                encapsulation: ViewEncapsulation.None,
                styles: [".cdk-overlay-container,.cdk-global-overlay-wrapper{pointer-events:none;top:0;left:0;height:100%;width:100%}.cdk-overlay-container{position:fixed;z-index:1000}.cdk-overlay-container:empty{display:none}.cdk-global-overlay-wrapper{display:flex;position:absolute;z-index:1000}.cdk-overlay-pane{position:absolute;pointer-events:auto;box-sizing:border-box;z-index:1000;display:flex;max-width:100%;max-height:100%}.cdk-overlay-backdrop{position:absolute;top:0;bottom:0;left:0;right:0;z-index:1000;pointer-events:auto;-webkit-tap-highlight-color:transparent;transition:opacity .4s cubic-bezier(.25,.8,.25,1);opacity:0}.cdk-overlay-backdrop.cdk-overlay-backdrop-showing{opacity:1}.cdk-high-contrast-active .cdk-overlay-backdrop.cdk-overlay-backdrop-showing{opacity:.6}.cdk-overlay-dark-backdrop{background:rgba(0,0,0,.32)}.cdk-overlay-transparent-backdrop,.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing{opacity:0}.cdk-overlay-connected-position-bounding-box{position:absolute;z-index:1000;display:flex;flex-direction:column;min-width:1px;min-height:1px}.cdk-global-scrollblock{position:fixed;width:100%;overflow-y:scroll}.cdk-visually-hidden{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;white-space:nowrap;outline:0;-webkit-appearance:none;-moz-appearance:none}:host{display:block;width:100%}.backdrop{position:fixed;left:0;top:0;width:100%;height:100%;z-index:1000}.vcl-select{position:relative;display:flex;justify-content:space-between;background-color:transparent;padding-bottom:8px}.vcl-select--disabled{pointer-events:none}.vcl-select--disabled input::input-placeholder{font-size:1rem;color:#d6d0cc}.vcl-select--disabled input::placeholder{font-size:1rem;color:#d6d0cc;opacity:1}.vcl-select--disabled input:placeholder{font-size:1rem;color:#d6d0cc;opacity:1}.vcl-select__text{width:100%;border:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;background-color:transparent;cursor:pointer}.vcl-select__text:disabled{background:none}.vcl-select__text--has-icon{margin-left:.5rem}.vcl-select__clear-icon{position:relative;z-index:1500;color:#56504c;cursor:pointer;padding-left:16px;align-self:center}.vcl-select__clear-icon:before{font-size:1rem}.vcl-select__icon-separator{width:1px;height:16px;margin:0 10px 0 14px;align-self:center;background-color:#efe9e5}.vcl-select__icon{transition:.2s linear;cursor:pointer}.vcl-select__icon--open.rotate{transform:rotateX(180deg)}.vcl-select__panel-options{border:.0625rem solid #efe9e5;box-shadow:0 .25rem .5rem #7a6d603d;border:none;background-color:#fff;width:100%;overflow-y:auto;border-radius:0 0 4px 4px;padding:.5rem 0}.vcl-select__not-options{display:flex;align-items:center;padding:1rem 1.5rem}.vcl-select__not-options__wrapper{display:block}.vcl-select__not-options__wrapper__text{display:block}.vcl-select__not-options__wrapper__text:first-child{padding-bottom:.5rem}.varejo.vcl-select__icon:not(.vcl-select__icon--disabled){color:#ec7000}.varejo.vcl-select__icon:not(.vcl-select__icon--disabled):disabled{color:#ff8a20}.personnalite.vcl-select__icon:not(.vcl-select__icon--disabled){color:#d0a967}.personnalite.vcl-select__icon:not(.vcl-select__icon--disabled):disabled{color:#dcbf8e}.uniclass.vcl-select__icon:not(.vcl-select__icon--disabled){color:#ec7000}.uniclass.vcl-select__icon:not(.vcl-select__icon--disabled):disabled{color:#ff8a20}.empresas.vcl-select__icon:not(.vcl-select__icon--disabled){color:#ec7000}.empresas.vcl-select__icon:not(.vcl-select__icon--disabled):disabled{color:#ff8a20}.itaucard.vcl-select__icon:not(.vcl-select__icon--disabled){color:#ec7000}.itaucard.vcl-select__icon:not(.vcl-select__icon--disabled):disabled{color:#ff8a20}.private.vcl-select__icon:not(.vcl-select__icon--disabled){color:#ec7000}.private.vcl-select__icon:not(.vcl-select__icon--disabled):disabled{color:#ff8a20}.parceiro-itaucard.vcl-select__icon:not(.vcl-select__icon--disabled){color:#ec7000}.parceiro-itaucard.vcl-select__icon:not(.vcl-select__icon--disabled):disabled{color:#ff8a20}.parceiro-credicard.vcl-select__icon:not(.vcl-select__icon--disabled){color:#0d456f}.parceiro-credicard.vcl-select__icon:not(.vcl-select__icon--disabled):disabled{color:#12619d}.parceiro-hipercard.vcl-select__icon:not(.vcl-select__icon--disabled){color:#ba1319}.parceiro-hipercard.vcl-select__icon:not(.vcl-select__icon--disabled):disabled{color:#e71920}.parceiro-magazine-luiza.vcl-select__icon:not(.vcl-select__icon--disabled){color:#0083ca}.parceiro-magazine-luiza.vcl-select__icon:not(.vcl-select__icon--disabled):disabled{color:#00a4fd}.personal-bank.vcl-select__icon:not(.vcl-select__icon--disabled){color:#ce9141}.personal-bank.vcl-select__icon:not(.vcl-select__icon--disabled):disabled{color:#d8a86a}.itau-bba.vcl-select__icon:not(.vcl-select__icon--disabled){color:#2449cc}.itau-bba.vcl-select__icon:not(.vcl-select__icon--disabled):disabled{color:#4567de}.personnalite.vcl-select__icon:not(.vcl-select__icon--disabled){color:#876632}\n"]
            }]
    }], function () { return [{ type: ɵngcc3.NgControl, decorators: [{
                type: Self
            }, {
                type: Optional
            }] }, { type: ɵngcc0.ElementRef }, { type: ɵngcc1.VoxelSegmentService }]; }, { id: [{
            type: Input
        }], icon: [{
            type: Input
        }], rotateIcon: [{
            type: Input
        }], change: [{
            type: Output
        }], focus: [{
            type: Output
        }], blur: [{
            type: Output
        }], required: [{
            type: Input
        }], 
    /**
     * @internal
     */
    onInputResize: [{
            type: HostListener,
            args: ['window:resize']
        }], options: [{
            type: ContentChildren,
            args: [VclSelectOptionComponent]
        }], select: [{
            type: ViewChild,
            args: ['select', { static: true }]
        }], selectInput: [{
            type: ViewChild,
            args: ['selectInput', { static: true }]
        }], panel: [{
            type: ViewChild,
            args: ['panel']
        }], overlayDir: [{
            type: ViewChild,
            args: [CdkConnectedOverlay, { static: true }]
        }], placeholder: [{
            type: Input
        }], tabindex: [{
            type: Input
        }], maxHeightRem: [{
            type: Input
        }], maxHeightVh: [{
            type: Input
        }] }); })();

class VclSelectModule {
}
VclSelectModule.ɵfac = function VclSelectModule_Factory(t) { return new (t || VclSelectModule)(); };
VclSelectModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VclSelectModule });
VclSelectModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            OverlayModule,
            FormsModule,
            VoxelSegmentModule,
            VoxelIconModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclSelectModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    OverlayModule,
                    FormsModule,
                    VoxelSegmentModule,
                    VoxelIconModule,
                ],
                declarations: [VclSelectComponent, VclSelectOptionComponent],
                exports: [VclSelectComponent, VclSelectOptionComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VclSelectModule, { declarations: function () { return [VclSelectComponent, VclSelectOptionComponent]; }, imports: function () { return [CommonModule,
        OverlayModule,
        FormsModule,
        VoxelSegmentModule,
        VoxelIconModule]; }, exports: function () { return [VclSelectComponent, VclSelectOptionComponent]; } }); })();

/**
 * É a seção inferior das páginas da web, inclui links de navegação
 * e indica coisas como direitos autorais e quem supervisiona a
 * entidade e o logotipo da empresa / banco
 *
 * *It's the bottom section of the webpages, includes navigation links and
 * indicates things like copyright and who oversees the entity
 * and the company/bank logo*
 *
 * ### Acessible
 *
 * <acessible class="not-tested">Acessibilidade - Não testado</acessible>
 *
 * **Module:**
 * `import { VclFooterTwoModule } from '@voxel/community';`
 *
 * <example-url>../../demo/index.html#/portfolio/components/footer-two?componentOnly=true</example-url>
 *
 * @example apenas rodapé / only footer
 * <vcl-footer-two
 *   [itauLogoPath]="'./assets/img/logo.svg'"
 *   [copyrightMessage]="'© 2020 Itaú CorpBanca Colombia S.A.'"
 *   [supervisorLogoPath]="'./assets/img/logo-superintendencia.svg'"
 * >
 * </vcl-footer-two>
 *
 * @example rodapé com ícones de mídia social / footer with social media icons
 * <vcl-footer-two
 *  [itauLogoPath]="'./assets/img/logo.svg'"
 *  [copyrightMessage]="'© 2020 Itaú CorpBanca Colombia S.A.'"
 *  [supervisorLogoPath]="'./assets/img/logo-superintendencia.svg'"
 *  [socialMediaData]="socialMediaData"
 * >
 * </vcl-footer-two>
 *
 */
class VclFooterTwoComponent {
}
VclFooterTwoComponent.ɵfac = function VclFooterTwoComponent_Factory(t) { return new (t || VclFooterTwoComponent)(); };
VclFooterTwoComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VclFooterTwoComponent, selectors: [["vcl-footer-two"]], inputs: { itauLogoPath: "itauLogoPath", copyrightMessage: "copyrightMessage", supervisorLogoPath: "supervisorLogoPath", socialMediaItems: "socialMediaItems" }, decls: 10, vars: 4, consts: [["id", "footer"], [1, "footer__section--1"], [1, "footer__section--1__images"], ["alt", "itaulogo", "class", "itau-logo", "id", "itaulogo", 3, "src", 4, "ngIf"], ["class", "social-icons", 4, "ngIf"], [1, "footer__section--2"], [1, "footer__section--2__images"], [1, "reserved"], ["alt", "supervisorlogo", "class", "footer-supervisor-icon", "id", "supervisorlogo", 3, "src", 4, "ngIf"], ["alt", "itaulogo", "id", "itaulogo", 1, "itau-logo", 3, "src"], [1, "social-icons"], ["target", "_blank", "role", "button", "rel", "nofollow", 3, "class", "href", "id", 4, "ngFor", "ngForOf"], ["target", "_blank", "role", "button", "rel", "nofollow", 3, "href", "id"], ["alt", "supervisorlogo", "id", "supervisorlogo", 1, "footer-supervisor-icon", 3, "src"]], template: function VclFooterTwoComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "footer", 0);
        ɵngcc0.ɵɵelementStart(1, "section", 1);
        ɵngcc0.ɵɵelementStart(2, "article", 2);
        ɵngcc0.ɵɵtemplate(3, VclFooterTwoComponent_img_3_Template, 1, 1, "img", 3);
        ɵngcc0.ɵɵtemplate(4, VclFooterTwoComponent_div_4_Template, 2, 1, "div", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "section", 5);
        ɵngcc0.ɵɵelementStart(6, "article", 6);
        ɵngcc0.ɵɵelementStart(7, "p", 7);
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, VclFooterTwoComponent_img_9_Template, 1, 1, "img", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.itauLogoPath);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.socialMediaItems && ctx.socialMediaItems.length > 0);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.copyrightMessage, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.supervisorLogoPath);
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgForOf], styles: ["#footer[_ngcontent-%COMP%]{width:100%;background-color:#605751}.footer__section--1[_ngcontent-%COMP%]{display:flex;padding:4rem 3rem 2.5rem}.itau-logo[_ngcontent-%COMP%]{height:2.5rem}.footer__section--1__images[_ngcontent-%COMP%]{display:flex;width:100%;align-items:center;justify-content:space-between}.footer__section--2[_ngcontent-%COMP%]{width:100%;background-color:#544d47;padding:1.125rem 3rem}.footer__section--2__images[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:space-between}@media (min-width: 1599.98px){.footer__section--1[_ngcontent-%COMP%], .footer__section--2[_ngcontent-%COMP%]{padding-left:6rem;padding-right:6rem}}.reserved[_ngcontent-%COMP%]{color:#fff;font-size:1rem;font-family:\"Itau Display\";letter-spacing:0;line-height:1.5rem;opacity:.6}.social-icons[_ngcontent-%COMP%]{display:flex;align-items:center;grid-column-gap:1.5rem;column-gap:1.5rem;text-align:left}.social-icons[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{color:#d2d2d2}.footer-supervisor-icon[_ngcontent-%COMP%]{height:1rem}@media (max-width: 767.98px){.footer__section--1[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;padding:3rem 3rem 3.5625rem}.footer__section--2[_ngcontent-%COMP%]{padding:1.5rem 2.4375rem 1.75rem 2.875rem}.footer__section--1__images[_ngcontent-%COMP%]{flex-direction:column}.footer__section--2__images[_ngcontent-%COMP%]{flex-direction:column;justify-content:space-evenly;grid-row-gap:1rem;row-gap:1rem}.social-icons[_ngcontent-%COMP%]{margin-top:1.5625rem}}"] });
/**
 * @internal
 */
VclFooterTwoComponent.selector = 'vcl-footer-two';
VclFooterTwoComponent.propDecorators = {
    itauLogoPath: [{ type: Input }],
    copyrightMessage: [{ type: Input }],
    supervisorLogoPath: [{ type: Input }],
    socialMediaItems: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclFooterTwoComponent, [{
        type: Component,
        args: [{
                selector: 'vcl-footer-two',
                template: "<footer id=\"footer\">\n  <section class=\"footer__section--1\">\n    <article class=\"footer__section--1__images\">\n      <img\n        *ngIf=\"itauLogoPath\"\n        [src]=\"itauLogoPath\"\n        alt=\"itaulogo\"\n        class=\"itau-logo\"\n        id=\"itaulogo\">\n        <div class=\"social-icons\" *ngIf=\"socialMediaItems && socialMediaItems.length > 0\">\n          <a\n            *ngFor=\"let item of socialMediaItems\"\n            class=\"{{item.icon}}\"\n            href=\"{{item.url}}\"\n            target=\"_blank\"\n            role=\"button\"\n            rel=\"nofollow\"\n            id=\"{{item.id}}\">\n          </a>\n    </div>\n    </article>\n  </section>\n  <section class=\"footer__section--2\">\n    <article class=\"footer__section--2__images\">\n      <p class=\"reserved\">\n        {{copyrightMessage}}\n      </p>\n      <img\n        *ngIf=\"supervisorLogoPath\"\n        [src]=\"supervisorLogoPath\"\n        alt=\"supervisorlogo\"\n        class=\"footer-supervisor-icon\"\n        id=\"supervisorlogo\">\n    </article>\n  </section>\n</footer>\n\n",
                styles: ["#footer{width:100%;background-color:#605751}.footer__section--1{display:flex;padding:4rem 3rem 2.5rem}.itau-logo{height:2.5rem}.footer__section--1__images{display:flex;width:100%;align-items:center;justify-content:space-between}.footer__section--2{width:100%;background-color:#544d47;padding:1.125rem 3rem}.footer__section--2__images{display:flex;align-items:center;justify-content:space-between}@media (min-width: 1599.98px){.footer__section--1,.footer__section--2{padding-left:6rem;padding-right:6rem}}.reserved{color:#fff;font-size:1rem;font-family:\"Itau Display\";letter-spacing:0;line-height:1.5rem;opacity:.6}.social-icons{display:flex;align-items:center;grid-column-gap:1.5rem;column-gap:1.5rem;text-align:left}.social-icons>a{color:#d2d2d2}.footer-supervisor-icon{height:1rem}@media (max-width: 767.98px){.footer__section--1{display:flex;align-items:center;justify-content:center;padding:3rem 3rem 3.5625rem}.footer__section--2{padding:1.5rem 2.4375rem 1.75rem 2.875rem}.footer__section--1__images{flex-direction:column}.footer__section--2__images{flex-direction:column;justify-content:space-evenly;grid-row-gap:1rem;row-gap:1rem}.social-icons{margin-top:1.5625rem}}\n"]
            }]
    }], null, { itauLogoPath: [{
            type: Input
        }], copyrightMessage: [{
            type: Input
        }], supervisorLogoPath: [{
            type: Input
        }], socialMediaItems: [{
            type: Input
        }] }); })();

class VclFooterTwoModule {
}
VclFooterTwoModule.ɵfac = function VclFooterTwoModule_Factory(t) { return new (t || VclFooterTwoModule)(); };
VclFooterTwoModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VclFooterTwoModule });
VclFooterTwoModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclFooterTwoModule, [{
        type: NgModule,
        args: [{
                declarations: [VclFooterTwoComponent],
                imports: [
                    CommonModule,
                ],
                exports: [
                    VclFooterTwoComponent,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VclFooterTwoModule, { declarations: function () { return [VclFooterTwoComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [VclFooterTwoComponent]; } }); })();

/**
 *
 * Tipos de resposta do NPS
 *
 * *NPS response types*
 *
 * @export
 * @enum {string}
 */
var NpsResponseTypes;
(function (NpsResponseTypes) {
    /**
     * Usuário submeteu uma nota
     *
     * *User submitted a score*
     */
    NpsResponseTypes["submit"] = "submit";
    /**
     * Usuário cancelou
     *
     * *User cancelled*
     */
    NpsResponseTypes["cancel"] = "cancel";
})(NpsResponseTypes || (NpsResponseTypes = {}));
/**
 * NPS é um elemento que exibe um questionário NPS para o usuário.
 * Use o NPS quando se deseja mensurar o grau de satisfação dos clientes com o produto ou parte dele.
 *
 * *NPS is a component that presents a NPS quiz for the user.*
 * *Use NPS when you want to measure the degree of customer satisfaction with the product or part of it.*
 *
 * ### Acessible
 *
 * <acessible class="not-tested">Acessibilidade - Não testado</acessible>
 *
 * **Module:**
 *
 * `import { VclNpsModule } from '@voxel/community';`
 *
 * <example-url>../../demo/index.html#/portfolio/components/nps?componentOnly=true</example-url>
 *
 *
 */
class VclNpsComponent {
    /**
     * @internal
     */
    constructor(voxelSegmentService) {
        this.voxelSegmentService = voxelSegmentService;
        /**
         * @internal
         */
        this.NpsResponseTypes = NpsResponseTypes;
        /**
         * Exibe e oculta o NPS. Usar com two way data binding `[(showNps)]` para o funcionamento correto
         *
         * *Shows and hides NPS. Use with two way data binding `[(showNps)]` to work properly*
         */
        this.showNps = false;
        /**
         * @internal
         */
        this.showNpsChange = new EventEmitter();
        /**
         * @internal
         */
        this.defaultParameters = {
            enableTextareaDetractor: true,
            enableTextareaPassive: false,
            enableTextareaPromoter: false,
            enableInputName: false,
            enableInputSquad: false,
            introTitle: 'Gostaria de avaliar a sua experiência digital com o Itaú?',
            introText: 'Ao nos avaliar, você ajuda a gente a melhorar os nossos canais.',
            introButtonPositiveLabel: 'sim, quero avaliar',
            introButtonNegativeLabel: 'prefiro não avaliar',
            scoreTitle: 'Conta para a gente:',
            scoreText: 'Com base na sua experiência digital com o Itaú, de 0 a 10, o quanto você nos recomenda para um amigo ou familiar?',
            scoreTextareaDetractorLabel: 'O que podemos melhorar? (opcional)',
            scoreTextareaPassiveLabel: 'O que podemos melhorar? (opcional)',
            scoreTextareaPromoterLabel: 'O que podemos melhorar? (opcional)',
            scoreButtonNextLabel: 'concluir avaliação',
            finishTitle: 'Muito obrigado, sua avaliação foi enviada com sucesso.',
            finishText: 'Analisaremos tudo para propocionar a melhor experiência digital para você.',
            finishButtonLabel: 'finalizar',
            showFirstScreen: true,
        };
        /**
         * @internal
         */
        this._parameters = Object.assign({}, JSON.parse(JSON.stringify(this.defaultParameters)));
        /**
         * Valor da propriedade de estilo `z-index` do wrapper do NPS
         *
         * *NPS wrapper's `z-index` css property*
         */
        this.zIndex = '10';
        /**
         * Evento disparado no clique dos botões do nps
         *
         * *Event triggered by the nps buttons clicks*
         */
        this.npsFinish = new EventEmitter();
        /**
         * @internal
         */
        this.segment = this.voxelSegmentService.segment;
        /**
         * @internal
         */
        this.scoreOptions = Array(11)
            .fill(null)
            .map((_x, i) => i);
    }
    /**
     * Parâmetros do NPS
     *
     * *NPS parameters*
     * @memberof VoxelNpsComponent
     */
    get parameters() {
        return this._parameters;
    }
    set parameters(value) {
        this._parameters = Object.assign(Object.assign({}, JSON.parse(JSON.stringify(this.defaultParameters))), value);
    }
    /**
     * @internal
     */
    ngOnInit() {
        this.currentStep = this.parameters.showFirstScreen ? 1 : 2;
        this.form = new FormGroup({
            score: new FormControl(null, [Validators.required]),
            comment: new FormControl({ value: '', disabled: true }, [Validators.maxLength(140)]),
            name: new FormControl({ value: '', disabled: true }, [Validators.required]),
            squad: new FormControl({ value: '', disabled: true }, [Validators.required]),
        });
        this.form.controls.score.valueChanges.subscribe(value => {
            value === null || !this.parameters.enableInputName ?
                this.form.controls.name.disable() :
                this.form.controls.name.enable();
            value === null || !this.parameters.enableInputSquad ?
                this.form.controls.squad.disable() :
                this.form.controls.squad.enable();
            if (value === null ||
                (value <= 6 && !this.parameters.enableTextareaDetractor) ||
                (value >= 7 && value <= 8 && !this.parameters.enableTextareaPassive) ||
                (value >= 9 && !this.parameters.enableTextareaPromoter)) {
                this.form.controls.comment.disable();
                return;
            }
            this.form.controls.comment.enable();
        });
    }
    /**
     * @internal
     */
    ngOnChanges(changes) {
        const npsChanged = !!changes.showNps && !!changes.showNps.currentValue && !changes.showNps.previousValue;
        const npsStartScreenChanged = !!changes.parameters;
        if (npsChanged || npsStartScreenChanged) {
            // Reset values to show again
            this.ngOnInit();
        }
    }
    /**
     * @internal
     */
    get commentLabel() {
        const score = this.form.value.score;
        if (score <= 6) {
            return this.parameters.scoreTextareaDetractorLabel;
        }
        if (score >= 7 && score <= 8) {
            return this.parameters.scoreTextareaPassiveLabel;
        }
        if (score >= 9) {
            return this.parameters.scoreTextareaPromoterLabel;
        }
        return '';
    }
    /**
     * @internal
     */
    step1PositiveClick() {
        this.currentStep = 2;
    }
    /**
     * @internal
     */
    step1NegativeClick() {
        this.closeNps(false);
    }
    /**
     * @internal
     */
    step2NextClick() {
        this.currentStep = 3;
    }
    /**
     * @internal
     */
    step3DoneClick() {
        this.closeNps(true, this.form.value.score, this.form.value.comment, this.form.value.name, this.form.value.squad);
    }
    /**
     * @internal
     */
    optionClick(option) {
        if (option !== this.form.value.score) {
            return;
        }
        setTimeout(() => {
            this.form.controls.score.reset();
        });
    }
    /**
     * @internal
     */
    closeClick() {
        if (this.currentStep === 3) {
            this.step3DoneClick();
            return;
        }
        this.closeNps(false);
    }
    /**
     * @internal
     */
    closeNps(submitted, score, comment, name, squad) {
        this.showNps = false;
        this.showNpsChange.emit(false);
        const event = {
            type: submitted ? NpsResponseTypes.submit : NpsResponseTypes.cancel,
        };
        if (submitted) {
            event.response = {
                score,
                comment: !!comment && !!comment.trim() ? comment.trim() : null,
                name: !!name && !!name.trim() ? name.trim() : null,
                squad: !!squad && !!squad.trim() ? squad.trim() : null,
            };
        }
        this.npsFinish.emit(event);
    }
}
VclNpsComponent.ɵfac = function VclNpsComponent_Factory(t) { return new (t || VclNpsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.VoxelSegmentService)); };
VclNpsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VclNpsComponent, selectors: [["vcl-nps"]], inputs: { showNps: "showNps", zIndex: "zIndex", parameters: "parameters", id: "id" }, outputs: { showNpsChange: "showNpsChange", npsFinish: "npsFinish" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 10, vars: 16, consts: [[1, "overlay", 3, "hidden", "ngStyle"], [1, "dialog-wrapper"], ["aria-nps", "true", 1, "nps"], [1, "close-button-wrapper"], ["attr.aria-label", "fechar", 3, "id", "click"], [3, "ngSwitch"], [4, "ngSwitchCase"], [1, "content"], [1, "voxel-txt-color-sup-orange", "voxel-mb-l", "icon-56"], [1, "title"], [1, "title__text"], [1, "voxel-mt-s", 3, "id"], [1, "actions"], ["voxelButton", "", "aria-label", "botao avaliar", 1, "primary", 3, "id", "disabled", "click"], ["voxelButton", "", "aria-label", "botao n\u00E3o avaliar", "buttonStyle", "secondary", 1, "secondary", 3, "id", "disabled", "click"], [1, "voxel-mv-s", 3, "id"], [1, "nps-form", "voxel-mt-l", 3, "formGroup"], [1, "radio-score-wrapper"], ["class", "radio-score", 4, "ngFor", "ngForOf"], ["label", "Nome", "description", "informe o nome completo", "msgErr", "o preenchimento do nome \u00E9 obrigat\u00F3rio"], ["voxelInput", "", "formControlName", "name"], ["label", "Squad", "description", "informe a Squad", "msgErr", "o preenchimento da Squad \u00E9 obrigat\u00F3rio"], ["voxelInput", "", "formControlName", "squad"], [3, "label"], ["voxelInput", "", "formControlName", "comment", "maxlength", "140"], ["voxelButton", "", "aria-label", "botao concluir avalia\u00E7\u00E3o", 3, "id", "disabled", "click"], [1, "radio-score"], ["type", "radio", "formControlName", "score", 3, "id", "value", "click"], [3, "for"], [1, "voxel-txt-color-sup-green", "voxel-mb-l", "icon-56-border"], [1, "title", "voxel-pt-m"], [1, "voxel-mt-s", "voxel-mb-m", 3, "id"], ["voxelButton", "", "aria-label", "botao finalizar", 3, "id", "disabled", "click"]], template: function VclNpsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "dialog", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "button", 4);
        ɵngcc0.ɵɵlistener("click", function VclNpsComponent_Template_button_click_4_listener() { return ctx.closeClick(); });
        ɵngcc0.ɵɵpipe(5, "async");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementContainerStart(6, 5);
        ɵngcc0.ɵɵtemplate(7, VclNpsComponent_ng_container_7_Template, 14, 10, "ng-container", 6);
        ɵngcc0.ɵɵtemplate(8, VclNpsComponent_ng_container_8_Template, 19, 16, "ng-container", 6);
        ɵngcc0.ɵɵtemplate(9, VclNpsComponent_ng_container_9_Template, 12, 7, "ng-container", 6);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hidden", !ctx.showNps)("ngStyle", ɵngcc0.ɵɵpureFunction1(14, _c1, ctx.zIndex));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵattribute("id", "nps-" + ctx.id)("open", ctx.showNps ? "" : null);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassMapInterpolate1("", ɵngcc0.ɵɵpipeBind1(5, 12, ctx.segment), " close-button button__transparent icon-itaufonts_fechar");
        ɵngcc0.ɵɵproperty("id", "nps-close-button-" + ctx.id);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngSwitch", ctx.currentStep);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", 1);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", 2);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", 3);
    } }, directives: [ɵngcc2.NgStyle, ɵngcc2.NgSwitch, ɵngcc2.NgSwitchCase, ɵngcc1.VoxelIconComponent, ɵngcc1.VoxelButtonComponent, ɵngcc3.ɵNgNoValidate, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc2.NgForOf, ɵngcc1.VoxelFormFieldComponent, ɵngcc3.DefaultValueAccessor, ɵngcc1.VoxelInputDirective, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc3.MaxLengthValidator, ɵngcc3.RadioControlValueAccessor], pipes: [ɵngcc2.AsyncPipe], styles: [".overlay[_ngcontent-%COMP%]{overflow:auto;position:fixed;top:0;right:0;bottom:0;left:0;background-color:#000c}.overlay[_ngcontent-%COMP%]   .dialog-wrapper[_ngcontent-%COMP%]{width:100%;height:100%;display:flex;justify-content:center;align-items:center}.nps[_ngcontent-%COMP%]{border:0;padding:0 1rem 1rem;display:flex;flex-direction:column;margin:auto;border-radius:4px;background-color:#fff}.close-button-wrapper[_ngcontent-%COMP%]{width:100%;height:3rem;text-align:right}.close-button[_ngcontent-%COMP%]{height:3rem;background-color:Transparent;border:none;cursor:pointer;margin-right:-.4rem}.title[_ngcontent-%COMP%]{display:flex;width:100%;justify-content:space-between;align-items:center;margin:.3125rem 0 .9375rem}.title__text[_ngcontent-%COMP%]{font-family:\"Itau Display\";font-size:1.5rem;font-weight:900}.content[_ngcontent-%COMP%]{flex:1;overflow-y:scroll;padding-bottom:1rem;line-height:1.5rem;margin-right:-7px;display:flex;flex-direction:column;justify-content:flex-end}.actions[_ngcontent-%COMP%]{margin-top:1rem;background-color:#fffc;z-index:2;display:flex;flex-direction:row}.nps-form[_ngcontent-%COMP%]{overflow-x:hidden}.radio-score-wrapper[_ngcontent-%COMP%]{display:flex;justify-content:center;flex-wrap:wrap;margin-left:-.25rem;margin-right:-.25rem;margin-bottom:1rem}.radio-score[_ngcontent-%COMP%]{margin:.25rem}.radio-score[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{display:inline-block;width:3rem;height:3rem;padding:.625rem;border:1px solid #106eb0;border-radius:50%;background-color:#fff;color:#106eb0;font-size:1.125rem;text-align:center}.radio-score[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]:hover{background-color:#e4f5fc}.radio-score[_ngcontent-%COMP%]   input[type=radio][_ngcontent-%COMP%]{opacity:0;position:fixed;width:0}.radio-score[_ngcontent-%COMP%]   input[type=radio][_ngcontent-%COMP%]:checked + label[_ngcontent-%COMP%]{background-color:#106eb0;color:#fff;font-weight:900}.invisible[_ngcontent-%COMP%]{visibility:hidden}[_ngcontent-%COMP%]::-webkit-scrollbar{-webkit-appearance:none;width:7px}[_ngcontent-%COMP%]::-webkit-scrollbar-thumb{border-radius:4px;background-color:#00000080;box-shadow:0 0 1px #ffffff80}@media only screen and (min-width: 0){.nps[_ngcontent-%COMP%]{width:100%;height:100%;border-radius:0}.actions[_ngcontent-%COMP%]{flex-direction:column}.actions[_ngcontent-%COMP%]   .primary[_ngcontent-%COMP%]{margin-bottom:.5rem}}@media only screen and (min-width: 768px){.nps[_ngcontent-%COMP%]{padding:0 1.5rem 1.5rem;width:376px;height:auto;min-height:448px;max-height:90%}.close-button[_ngcontent-%COMP%]{margin-right:-.8rem}}@media only screen and (min-width: 1024px){.nps[_ngcontent-%COMP%]{width:629px;min-height:414px}.radio-score[_ngcontent-%COMP%]{margin:.15625rem}.actions[_ngcontent-%COMP%]{flex-direction:row-reverse;justify-content:flex-end}.actions[_ngcontent-%COMP%]   .secondary[_ngcontent-%COMP%]{margin-right:1rem}}@media only screen and (min-width: 1600px){.nps[_ngcontent-%COMP%]{width:700px}.radio-score[_ngcontent-%COMP%]{margin:.375rem}}.varejo.close-button[_ngcontent-%COMP%]{color:#ec7000}.personnalite.close-button[_ngcontent-%COMP%]{color:#d0a967}.uniclass.close-button[_ngcontent-%COMP%]{color:#ec7000}.empresas.close-button[_ngcontent-%COMP%]{color:#ec7000}.itaucard.close-button[_ngcontent-%COMP%]{color:#ec7000}.private.close-button[_ngcontent-%COMP%]{color:#ec7000}.parceiro-itaucard.close-button[_ngcontent-%COMP%]{color:#ec7000}.parceiro-credicard.close-button[_ngcontent-%COMP%]{color:#0d456f}.parceiro-hipercard.close-button[_ngcontent-%COMP%]{color:#ba1319}.parceiro-magazine-luiza.close-button[_ngcontent-%COMP%]{color:#0083ca}.personal-bank.close-button[_ngcontent-%COMP%]{color:#ce9141}.itau-bba.close-button[_ngcontent-%COMP%]{color:#2449cc}.personnalite.close-button[_ngcontent-%COMP%]{color:#876632}[_nghost-%COMP%]     .actions button{font-size:1rem!important;padding-left:2rem!important;padding-right:2rem!important}[_nghost-%COMP%]     voxel-icon.icon-56 span{font-size:3.5rem;line-height:3.5rem;width:3.5rem;height:3.5rem}[_nghost-%COMP%]     voxel-icon.icon-56-border span{font-size:2.25rem;line-height:3.5rem;width:3.5rem;height:3.5rem;border:2px solid;border-radius:50%;padding:.5rem}@media only screen and (min-width: 1280px){[_nghost-%COMP%]     .actions button{font-size:1.25rem!important}}"] });
/**
 * @internal
 */
VclNpsComponent.selector = 'vcl-nps';
VclNpsComponent.ctorParameters = () => [
    { type: VoxelSegmentService }
];
VclNpsComponent.propDecorators = {
    id: [{ type: Input }],
    showNps: [{ type: Input }],
    showNpsChange: [{ type: Output }],
    parameters: [{ type: Input }],
    zIndex: [{ type: Input }],
    npsFinish: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclNpsComponent, [{
        type: Component,
        args: [{
                selector: 'vcl-nps',
                template: "<div class=\"overlay\" [hidden]=\"!showNps\" [ngStyle]=\"{ 'z-index': zIndex }\">\n  <div class=\"dialog-wrapper\">\n    <dialog\n      [attr.id]=\"'nps-' + id\"\n      aria-nps=\"true\"\n      class=\"nps\"\n      [attr.open]=\"showNps ? '' : null\"\n    >\n      <div class=\"close-button-wrapper\">\n        <button\n          [id]=\"'nps-close-button-' + id\"\n          class=\"{{\n            segment | async\n          }} close-button button__transparent icon-itaufonts_fechar\"\n          attr.aria-label=\"fechar\"\n          (click)=\"closeClick()\"\n        ></button>\n      </div>\n\n      <ng-container [ngSwitch]=\"currentStep\">\n        <ng-container *ngSwitchCase=\"1\">\n          <div class=\"content\">\n            <voxel-icon class=\"voxel-txt-color-sup-orange voxel-mb-l icon-56\"\n              >feedback_outline</voxel-icon\n            >\n\n            <div class=\"title\">\n              <h2 [attr.id]=\"'nps--intro-title-' + id\" class=\"title__text\">\n                {{ parameters.introTitle }}\n              </h2>\n            </div>\n\n            <p [id]=\"'nps-intro-text-' + id\" class=\"voxel-mt-s\">\n              {{ parameters.introText }}\n            </p>\n          </div>\n\n          <div class=\"actions\">\n            <button\n              voxelButton\n              [id]=\"'nps-intro-positive-' + id\"\n              class=\"primary\"\n              aria-label=\"botao avaliar\"\n              [disabled]=\"false\"\n              (click)=\"step1PositiveClick()\"\n            >\n              {{parameters.introButtonPositiveLabel}}\n            </button>\n\n            <button\n              voxelButton\n              [id]=\"'nps-intro-negative-' + id\"\n              class=\"secondary\"\n              aria-label=\"botao n\u00E3o avaliar\"\n              buttonStyle=\"secondary\"\n              [disabled]=\"false\"\n              (click)=\"step1NegativeClick()\"\n            >\n              {{parameters.introButtonNegativeLabel}}\n            </button>\n          </div>\n        </ng-container>\n\n        <ng-container *ngSwitchCase=\"2\">\n          <div class=\"content\">\n            <div class=\"title\">\n              <h2 [attr.id]=\"'nps-score-title-' + id\" class=\"title__text\">\n                {{ parameters.scoreTitle }}\n              </h2>\n            </div>\n\n            <p [id]=\"'nps-score-text-' + id\" class=\"voxel-mv-s\">\n              {{ parameters.scoreText }}\n            </p>\n\n            <form [formGroup]=\"form\" class=\"nps-form voxel-mt-l\">\n              <div class=\"radio-score-wrapper\">\n                <div *ngFor=\"let option of scoreOptions\" class=\"radio-score\">\n                  <input\n                    [id]=\"'nps-score-option-' + option + '-' + id\"\n                    type=\"radio\"\n                    [value]=\"option\"\n                    formControlName=\"score\"\n                    (click)=\"optionClick(option)\"\n                  />\n                  <label [for]=\"'nps-score-option-' + option + '-' + id\">{{\n                    option\n                  }}</label>\n                </div>\n              </div>\n\n              <voxel-form-field\n                label=\"Nome\"\n                description=\"informe o nome completo\"\n                msgErr=\"o preenchimento do nome \u00E9 obrigat\u00F3rio\"\n                [class.invisible]=\"form.controls.name.disabled\"\n              >\n                <input voxelInput formControlName=\"name\" />\n              </voxel-form-field>\n\n              <voxel-form-field\n                label=\"Squad\"\n                description=\"informe a Squad\"\n                msgErr=\"o preenchimento da Squad \u00E9 obrigat\u00F3rio\"\n                [class.invisible]=\"form.controls.squad.disabled\"\n              >\n                <input voxelInput formControlName=\"squad\" />\n              </voxel-form-field>\n\n              <voxel-form-field\n                [label]=\"commentLabel\"\n                [class.invisible]=\"form.controls.comment.disabled\"\n              >\n                <textarea voxelInput formControlName=\"comment\" maxlength=\"140\"></textarea>\n              </voxel-form-field>\n            </form>\n          </div>\n\n          <div class=\"actions\">\n            <button\n              voxelButton\n              [id]=\"'nps-score-next-' + id\"\n              aria-label=\"botao concluir avalia\u00E7\u00E3o\"\n              [disabled]=\"!this.form.valid\"\n              (click)=\"step2NextClick()\"\n            >\n              {{parameters.scoreButtonNextLabel}}\n            </button>\n          </div>\n        </ng-container>\n\n        <ng-container *ngSwitchCase=\"3\">\n          <div class=\"content\">\n            <voxel-icon\n              class=\"voxel-txt-color-sup-green voxel-mb-l icon-56-border\"\n              >check</voxel-icon\n            >\n\n            <div class=\"title voxel-pt-m\">\n              <h2 [attr.id]=\"'nps-finish-title-' + id\" class=\"title__text\">\n                {{ parameters.finishTitle }}\n              </h2>\n            </div>\n\n            <p [id]=\"'nps-finish-text-' + id\" class=\"voxel-mt-s voxel-mb-m\">\n              {{ parameters.finishText }}\n            </p>\n          </div>\n\n          <div class=\"actions\">\n            <button\n              voxelButton\n              [id]=\"'nps-finish-done-' + id\"\n              aria-label=\"botao finalizar\"\n              [disabled]=\"false\"\n              (click)=\"step3DoneClick()\"\n            >\n              {{parameters.finishButtonLabel}}\n            </button>\n          </div>\n        </ng-container>\n      </ng-container>\n    </dialog>\n  </div>\n</div>\n",
                styles: [".overlay{overflow:auto;position:fixed;top:0;right:0;bottom:0;left:0;background-color:#000c}.overlay .dialog-wrapper{width:100%;height:100%;display:flex;justify-content:center;align-items:center}.nps{border:0;padding:0 1rem 1rem;display:flex;flex-direction:column;margin:auto;border-radius:4px;background-color:#fff}.close-button-wrapper{width:100%;height:3rem;text-align:right}.close-button{height:3rem;background-color:Transparent;border:none;cursor:pointer;margin-right:-.4rem}.title{display:flex;width:100%;justify-content:space-between;align-items:center;margin:.3125rem 0 .9375rem}.title__text{font-family:\"Itau Display\";font-size:1.5rem;font-weight:900}.content{flex:1;overflow-y:scroll;padding-bottom:1rem;line-height:1.5rem;margin-right:-7px;display:flex;flex-direction:column;justify-content:flex-end}.actions{margin-top:1rem;background-color:#fffc;z-index:2;display:flex;flex-direction:row}.nps-form{overflow-x:hidden}.radio-score-wrapper{display:flex;justify-content:center;flex-wrap:wrap;margin-left:-.25rem;margin-right:-.25rem;margin-bottom:1rem}.radio-score{margin:.25rem}.radio-score label{display:inline-block;width:3rem;height:3rem;padding:.625rem;border:1px solid #106eb0;border-radius:50%;background-color:#fff;color:#106eb0;font-size:1.125rem;text-align:center}.radio-score label:hover{background-color:#e4f5fc}.radio-score input[type=radio]{opacity:0;position:fixed;width:0}.radio-score input[type=radio]:checked+label{background-color:#106eb0;color:#fff;font-weight:900}.invisible{visibility:hidden}::-webkit-scrollbar{-webkit-appearance:none;width:7px}::-webkit-scrollbar-thumb{border-radius:4px;background-color:#00000080;box-shadow:0 0 1px #ffffff80}@media only screen and (min-width: 0){.nps{width:100%;height:100%;border-radius:0}.actions{flex-direction:column}.actions .primary{margin-bottom:.5rem}}@media only screen and (min-width: 768px){.nps{padding:0 1.5rem 1.5rem;width:376px;height:auto;min-height:448px;max-height:90%}.close-button{margin-right:-.8rem}}@media only screen and (min-width: 1024px){.nps{width:629px;min-height:414px}.radio-score{margin:.15625rem}.actions{flex-direction:row-reverse;justify-content:flex-end}.actions .secondary{margin-right:1rem}}@media only screen and (min-width: 1600px){.nps{width:700px}.radio-score{margin:.375rem}}.varejo.close-button{color:#ec7000}.personnalite.close-button{color:#d0a967}.uniclass.close-button{color:#ec7000}.empresas.close-button{color:#ec7000}.itaucard.close-button{color:#ec7000}.private.close-button{color:#ec7000}.parceiro-itaucard.close-button{color:#ec7000}.parceiro-credicard.close-button{color:#0d456f}.parceiro-hipercard.close-button{color:#ba1319}.parceiro-magazine-luiza.close-button{color:#0083ca}.personal-bank.close-button{color:#ce9141}.itau-bba.close-button{color:#2449cc}.personnalite.close-button{color:#876632}:host ::ng-deep .actions button{font-size:1rem!important;padding-left:2rem!important;padding-right:2rem!important}:host ::ng-deep voxel-icon.icon-56 span{font-size:3.5rem;line-height:3.5rem;width:3.5rem;height:3.5rem}:host ::ng-deep voxel-icon.icon-56-border span{font-size:2.25rem;line-height:3.5rem;width:3.5rem;height:3.5rem;border:2px solid;border-radius:50%;padding:.5rem}@media only screen and (min-width: 1280px){:host ::ng-deep .actions button{font-size:1.25rem!important}}\n"]
            }]
    }], function () { return [{ type: ɵngcc1.VoxelSegmentService }]; }, { showNps: [{
            type: Input
        }], showNpsChange: [{
            type: Output
        }], zIndex: [{
            type: Input
        }], npsFinish: [{
            type: Output
        }], parameters: [{
            type: Input
        }], id: [{
            type: Input
        }] }); })();

class VclNpsModule {
}
VclNpsModule.ɵfac = function VclNpsModule_Factory(t) { return new (t || VclNpsModule)(); };
VclNpsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VclNpsModule });
VclNpsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            ReactiveFormsModule,
            CommonModule,
            VoxelSegmentModule,
            VoxelButtonModule,
            VoxelIconModule,
            VoxelInputModule,
            VoxelFormFieldModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclNpsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    ReactiveFormsModule,
                    CommonModule,
                    VoxelSegmentModule,
                    VoxelButtonModule,
                    VoxelIconModule,
                    VoxelInputModule,
                    VoxelFormFieldModule,
                ],
                declarations: [VclNpsComponent],
                exports: [VclNpsComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VclNpsModule, { declarations: function () { return [VclNpsComponent]; }, imports: function () { return [ReactiveFormsModule,
        CommonModule,
        VoxelSegmentModule,
        VoxelButtonModule,
        VoxelIconModule,
        VoxelInputModule,
        VoxelFormFieldModule]; }, exports: function () { return [VclNpsComponent]; } }); })();

/**
 * A tag é o componente que permite organizar informações, aplicar filtros ou agrupar elementos.
 * Possui duas interações principais, um X para remover a tag caso ela seja usada por outro
 * componente e um link para redirecionar o usuário para outro conteúdo.
 *
 * *The tag is the component that allows you to organize information, apply filters or group elements.
 * It has two main interactions, an X to remove the tag in case it is used by another component and a
 * link to redirect the user to other content.*
 *
 * **Module:**
 *
 * `import { VclTagModule } from '@voxel/community';`
 *
 * <example-url>../../demo/index.html#/portfolio/components/tag</example-url>
 *
 * @example padrão
 *
 * <vcl-tag label="Tag text"></vcl-tag>
 *
 * @example desabilitado
 *
 * <vcl-tag
 *   label="Tag text"
 *   [disabled]="true">
 * </vcl-tag>
 *
 * @example com link
 *
 * <vcl-tag
 *  label="Tag text"
 *  link="https://www.itau.com.br/empresas/tarifas/">
 * </vcl-tag>
 *
 * @example com link desabilitado
 *
 * <vcl-tag
 *  label="Tag text"
 *  link="https://www.itau.com.br/empresas/tarifas/"
 *  disabled="true">
 * </vcl-tag>
 *
 * @example removível
 *
 * <vcl-tag
 *  label="Tag text"
 *  [removable]="true">
 * </vcl-tag>
 *
 * @example removível e desabilitado
 *
 * <vcl-tag
 *  label="Tag text"
 *  [disabled]="true"
 *  [removable]="true"></vcl-tag>
 *
 * @example com link e removível
 *
 * <vcl-tag
 *  label="Tag text"
 *  link="https://www.itau.com.br/empresas/tarifas/"
 *  [close]="true">
 * </vcl-tag>
 *
 * @example com link, removível e desabilitado
 *
 * <vcl-tag
 *  label="Tag text"
 *  link="https://www.itau.com.br/empresas/tarifas/"
 *  [disabled]="true"
 *  [removable]="true">
 * </vcl-tag>
 *
 * @example com ícone
 *
 * <vcl-tag
 *  label="Tag text"
 *  [removable]="true"
 *  icon="itaufonts_usuario_perfil">
 * </vcl-tag>
 *
 * @example com ícone e desabilitado
 *
 * <vcl-tag
 *  label="Tag text"
 *  [disabled]="true"
 *  [removable]="true"
 *  icon="itaufonts_usuario_perfil">
 * </vcl-tag>
 *
 * @example com ícone e link
 *
 * <vcl-tag
 *  label="Tag text"
 *  link="https://www.itau.com.br/empresas/tarifas/"
 *  [removable]="true"
 *  icon="itaufonts_usuario_perfil">
 * </vcl-tag>
 *
 * @example icon link disable
 *
 * <vcl-tag
 *  label="Tag text"
 *  link="https://www.itau.com.br/empresas/tarifas/"
 *  [disabled]="true"
 *  [removable]="true"
 *  icon="itaufonts_usuario_perfil">
 * </vcl-tag>
 */
class VclTagComponent {
    constructor() {
        /**
         * @internal
         */
        this.lastMaxWidth = null;
        /**
         * Exibe ou oculta o tag. Usar com two way data binding `[(showTag)]` para o funcionamento correto
         *
         * *Shows or hides the tag. Use with two way data binding `[(showTag)]` to work properly*
         */
        this.showTag = true;
        /**
         * Evento disparado ocorre uma mudança nas propriedades do componente
         *
         * *Event triggered when a change in component properties occurs*
         */
        this.showTagChange = new EventEmitter();
        /**
         * Indica se o componente ficará desabilitado.
         *
         * *Indicates if the component will be disabled.*
         */
        this.disabled = false;
        /**
         * Tamanho do ícone.
         *
         * *Icon size*
         */
        this.iconSize = 'S';
        /**
         * Mostra o botão de fechar a tag
         *
         * *It shows the close tag button*
         */
        this.close = false;
    }
    /**
     * Largura máxima padrão em rem.
     *
     * *Default max width in rem*
     */
    set maxWidth(maxWidth) {
        if (Number(maxWidth) < 18.2 || maxWidth > window.innerWidth) {
            this.tagMaxWidth = null;
        }
        else {
            this.tagMaxWidth = maxWidth;
        }
        this.lastMaxWidth = Number(maxWidth);
    }
    /**
     * @internal
     */
    resetMaxWidth() {
        this.maxWidth = this.lastMaxWidth;
    }
    /**
     * @internal
     */
    closeTag() {
        if (this.disabled) {
            return;
        }
        this.showTag = false;
        this.showTagChange.emit(true);
    }
}
VclTagComponent.ɵfac = function VclTagComponent_Factory(t) { return new (t || VclTagComponent)(); };
VclTagComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VclTagComponent, selectors: [["vcl-tag"]], hostBindings: function VclTagComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function VclTagComponent_resize_HostBindingHandler() { return ctx.resetMaxWidth(); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { showTag: "showTag", disabled: "disabled", iconSize: "iconSize", close: "close", maxWidth: "maxWidth", label: "label", icon: "icon", link: "link" }, outputs: { showTagChange: "showTagChange" }, decls: 1, vars: 1, consts: [["class", "vcl-tag voxel-text-m-bd", 3, "ngClass", "ngStyle", 4, "ngIf"], [1, "vcl-tag", "voxel-text-m-bd", 3, "ngClass", "ngStyle"], ["class", "tag-icon-container", 4, "ngIf"], ["aria-label", "title", "class", "vcl-tag-text", 3, "title", 4, "ngIf"], ["class", "vcl-tag-text", 3, "href", 4, "ngIf"], ["class", "close-button icon-itaufonts_fechar", "name", "close button", 3, "click", 4, "ngIf"], [1, "tag-icon-container"], [1, "vcl-tag-icon", 3, "size"], ["aria-label", "title", 1, "vcl-tag-text", 3, "title"], [1, "vcl-tag-text", 3, "href"], ["name", "close button", 1, "close-button", "icon-itaufonts_fechar", 3, "click"]], template: function VclTagComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, VclTagComponent_div_0_Template, 5, 9, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.showTag);
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgClass, ɵngcc2.NgStyle, ɵngcc1.VoxelIconComponent], styles: [".vcl-tag[_ngcontent-%COMP%]{display:flex;border:1px solid #106eb0;border-radius:1rem;background:white;height:2rem;justify-content:center;align-items:center;grid-column-gap:.5rem;column-gap:.5rem;padding:.5rem 1rem;max-width:18.1875rem}@media (max-width: 767.98px){.vcl-tag[_ngcontent-%COMP%]{max-width:19.5rem}}@media (min-width: 767.98px){.vcl-tag[_ngcontent-%COMP%]{max-width:21rem}}.vcl-tag[_ngcontent-%COMP%]   .vcl-tag-text[_ngcontent-%COMP%]{color:#106eb0;display:inline-block;font-size:.875em;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;height:1.25rem;line-height:1.25rem}.vcl-tag[_ngcontent-%COMP%]   .close-button[_ngcontent-%COMP%]{background:none;border:none;color:#106eb0;cursor:pointer;font-weight:800;font-size:1rem;height:1rem;width:1rem;padding:0;line-height:.5rem}.vcl-tag[_ngcontent-%COMP%]   .close-button[_ngcontent-%COMP%]:before{font-size:1rem;font-weight:800;line-height:1rem}.vcl-tag[_ngcontent-%COMP%]:hover{background:#e7f0f7}.vcl-tag[_ngcontent-%COMP%]   .tag-icon-container[_ngcontent-%COMP%]{line-height:1rem}.vcl-tag[_ngcontent-%COMP%]   .tag-icon-container[_ngcontent-%COMP%]   .vcl-tag-icon[_ngcontent-%COMP%]{color:#106eb0;font-size:1rem;font-weight:800;margin:0;height:1rem;width:1rem}.vcl-tag[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{cursor:pointer;font-weight:700;text-decoration:underline}.vcl-tag.disabled[_ngcontent-%COMP%]{border:.0625rem solid #89837f;color:#89837f}.vcl-tag.disabled[_ngcontent-%COMP%]:hover{background:white}.vcl-tag.disabled[_ngcontent-%COMP%]   .vcl-tag-text[_ngcontent-%COMP%]{margin:0}.vcl-tag.disabled[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{cursor:default;pointer-events:none;text-decoration:underline}.vcl-tag.disabled[_ngcontent-%COMP%]   .tag-icon-container[_ngcontent-%COMP%]   .vcl-tag-icon[_ngcontent-%COMP%], .vcl-tag.disabled[_ngcontent-%COMP%]   .close-button[_ngcontent-%COMP%], .vcl-tag.disabled[_ngcontent-%COMP%]   .vcl-tag-text[_ngcontent-%COMP%], .vcl-tag.disabled[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#89837f}"] });
/**
 * @internal
 */
VclTagComponent.selector = 'vcl-tag';
VclTagComponent.propDecorators = {
    maxWidth: [{ type: Input }],
    label: [{ type: Input }],
    showTag: [{ type: Input }],
    showTagChange: [{ type: Output }],
    disabled: [{ type: Input }],
    icon: [{ type: Input }],
    iconSize: [{ type: Input }],
    link: [{ type: Input }],
    close: [{ type: Input }],
    resetMaxWidth: [{ type: HostListener, args: ['window:resize',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclTagComponent, [{
        type: Component,
        args: [{
                selector: 'vcl-tag',
                template: "<div\n    *ngIf=\"showTag\"\n    class=\"vcl-tag voxel-text-m-bd\"\n    [ngClass]=\"disabled ? 'disabled': ''\"\n    [attr.aria-disabled]=\"disabled\"\n    [ngStyle]=\"{'max-width.rem': tagMaxWidth}\">\n    <span *ngIf=\"icon\" class=\"tag-icon-container\">\n        <voxel-icon class=\"vcl-tag-icon\" [size]=\"iconSize\">{{ icon }}</voxel-icon>\n    </span>\n\n    <label\n        aria-label=\"title\"\n        *ngIf=\"!link\"\n        class=\"vcl-tag-text\"\n        [title]=\"label\">{{label}}\n    </label>\n\n    <a *ngIf=\"link\" [href]=\"link\" class=\"vcl-tag-text\">{{ label }}</a>\n\n    <button\n        *ngIf=\"close\"\n        class=\"close-button icon-itaufonts_fechar\"\n        name=\"close button\"\n        [attr.disabled]=\"disabled ? true : null\"\n        (click)=\"closeTag()\">\n    </button>\n</div>\n",
                styles: [".vcl-tag{display:flex;border:1px solid #106eb0;border-radius:1rem;background:white;height:2rem;justify-content:center;align-items:center;grid-column-gap:.5rem;column-gap:.5rem;padding:.5rem 1rem;max-width:18.1875rem}@media (max-width: 767.98px){.vcl-tag{max-width:19.5rem}}@media (min-width: 767.98px){.vcl-tag{max-width:21rem}}.vcl-tag .vcl-tag-text{color:#106eb0;display:inline-block;font-size:.875em;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;height:1.25rem;line-height:1.25rem}.vcl-tag .close-button{background:none;border:none;color:#106eb0;cursor:pointer;font-weight:800;font-size:1rem;height:1rem;width:1rem;padding:0;line-height:.5rem}.vcl-tag .close-button:before{font-size:1rem;font-weight:800;line-height:1rem}.vcl-tag:hover{background:#e7f0f7}.vcl-tag .tag-icon-container{line-height:1rem}.vcl-tag .tag-icon-container .vcl-tag-icon{color:#106eb0;font-size:1rem;font-weight:800;margin:0;height:1rem;width:1rem}.vcl-tag a{cursor:pointer;font-weight:700;text-decoration:underline}.vcl-tag.disabled{border:.0625rem solid #89837f;color:#89837f}.vcl-tag.disabled:hover{background:white}.vcl-tag.disabled .vcl-tag-text{margin:0}.vcl-tag.disabled a{cursor:default;pointer-events:none;text-decoration:underline}.vcl-tag.disabled .tag-icon-container .vcl-tag-icon,.vcl-tag.disabled .close-button,.vcl-tag.disabled .vcl-tag-text,.vcl-tag.disabled a{color:#89837f}\n"]
            }]
    }], function () { return []; }, { showTag: [{
            type: Input
        }], showTagChange: [{
            type: Output
        }], disabled: [{
            type: Input
        }], iconSize: [{
            type: Input
        }], close: [{
            type: Input
        }], maxWidth: [{
            type: Input
        }], 
    /**
     * @internal
     */
    resetMaxWidth: [{
            type: HostListener,
            args: ['window:resize']
        }], label: [{
            type: Input
        }], icon: [{
            type: Input
        }], link: [{
            type: Input
        }] }); })();

class VclTagModule {
}
VclTagModule.ɵfac = function VclTagModule_Factory(t) { return new (t || VclTagModule)(); };
VclTagModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VclTagModule });
VclTagModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, VoxelIconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclTagModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, VoxelIconModule],
                declarations: [VclTagComponent],
                exports: [VclTagComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VclTagModule, { declarations: function () { return [VclTagComponent]; }, imports: function () { return [CommonModule, VoxelIconModule]; }, exports: function () { return [VclTagComponent]; } }); })();

/**
 * mostra o passo a passo, destacando o oval em verde espesso na etapa atual,
 * etapas resolvidas são marcadas oval em verde fino e etapas ausentes são exibidas em cinza.
 * a barra progressiva é alongada até o passo atual.
 *
 * *shows the step by step, highlighting the oval in thick green at the current step,*
 * *resolved steps are marked oval in thin green, and missing steps are displayed in gray.*
 * *the progressive bar lengthens to the present step.*
 *
 * **Module:**
 *
 * `import { VclStepperModule } from '@voxel/community';`
 *
 * <example-url>../../demo/index.html#/portfolio/components/stepper?componentOnly=true</example-url>
 *
 * @example stepper sem descrições dos passos
 * <vcl-stepper
 *  id="stepper"
 *  [currentStep]="1"
 *  [listSteps]="stepsList">
 * </vcl-stepper>
 *
 * @example stepper com descrições dos passos expansíveis em telas mobile
 * <vcl-stepper
 *  id="stepper"
 *  [currentStep]="1"
 *  [listSteps]="stepsList"
 *  [expansible]="true"
 *  [descriptionsList]="descriptionsList">
 * </vcl-stepper>
 *
 * @example stepper com descrições dos passos compactas
 * <vcl-stepper
 *  id="stepper"
 *  [currentStep]="1"
 *  [listSteps]="stepsList"
 *  [descriptionsList]="descriptionsList">
 * </vcl-stepper>
 */
class VclStepperComponent {
    /**
     * @internal
     */
    constructor(changeDedectionRef) {
        this.changeDedectionRef = changeDedectionRef;
        /**
         * Lista de passos
         *
         * *Steps list*
         */
        this.listSteps = [];
        /**
         * Lista de descrições dos respectivos passos
         *
         * *List of descriptions of the respective steps*
         */
        this.descriptionsList = [];
        /**
         * Define o passo atual do stepper
         *
         * *It sets the current step*
         */
        this.currentStep = 1;
        /**
         *  Define se as descrições do stepper são expansíveis ou não.
         *
         *  *It sets if steps descriptions are expandable or not.*
         */
        this.expansible = false;
        /**
         * @internal
         */
        this.change = false;
        /**
         * @internal
         */
        this.offSetLeftFirst = 0;
        /**
         * @internal
         */
        this.descriptionBoxOpen = false;
    }
    /**
     * @internal
     */
    ngOnInit() {
        this.stepMaxWidth = `${100 / this.listSteps.length}%`;
    }
    /**
     * @internal
     */
    ngAfterViewInit() {
        this.progresBar();
        this.changeDedectionRef.detectChanges();
    }
    /**
     * @internal
     */
    ngOnChanges() {
        if (this.change) {
            this.progresBar();
        }
        this.change = true;
        this.changeDedectionRef.detectChanges();
    }
    /**
     * @internal
     */
    onStepperResize() {
        this.progresBar();
    }
    /**
     * @internal
     */
    toggleDescriptionBox() {
        this.descriptionBoxOpen = !this.descriptionBoxOpen;
    }
    /**
     * @internal
     */
    setupCurrentStep(currentStep) {
        const steppersMapping = {
            first: currentStep === 1,
            last: currentStep >= this.listSteps.length,
            notFirstNeitherLast: currentStep > 1 && currentStep < this.listSteps.length,
        };
        const steppersMappingFn = {
            first: () => {
                this.offSetLeftFirst = this.stepLeftSize - 10;
                this.greenWidth = `${this.stepSize}px`;
            },
            last: () => {
                this.currentStep = this.listSteps.length;
                this.greenWidth = '100%';
            },
            notFirstNeitherLast: () => {
                this.greenWidth = `${this.stepLeftSize - 12 - this.offSetLeftFirst + this.stepSize}px`;
            },
        };
        const [key] = Object.entries(steppersMapping).filter(([_, value]) => value)[0];
        return steppersMappingFn[key];
    }
    /**
     * @internal
     */
    progresBar() {
        this.steps.filter((_element, index) => (index + 1) === this.currentStep).forEach((element) => {
            this.stepLeftSize = element.nativeElement.offsetLeft;
            this.stepSize = element.nativeElement.offsetWidth;
        });
        const setupProgressBar = this.setupCurrentStep(this.currentStep);
        setupProgressBar();
        this.greenWidthMobile = '100%';
        if (this.currentStep < this.listSteps.length) {
            this.greenWidthMobile = `${((100 / this.listSteps.length) * this.currentStep)}%`;
        }
    }
}
VclStepperComponent.ɵfac = function VclStepperComponent_Factory(t) { return new (t || VclStepperComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
VclStepperComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VclStepperComponent, selectors: [["vcl-stepper"]], viewQuery: function VclStepperComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c43, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.steps = _t);
    } }, hostBindings: function VclStepperComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function VclStepperComponent_resize_HostBindingHandler() { return ctx.onStepperResize(); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { listSteps: "listSteps", descriptionsList: "descriptionsList", currentStep: "currentStep", expansible: "expansible", id: "id" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 14, vars: 11, consts: [[3, "ngClass"], [1, "default-stepper"], [1, "vcl-stepper"], [1, "vcl-stepper-green"], [1, "vcl-step"], ["class", "vcl-step-check", 3, "max-width", 4, "ngFor", "ngForOf"], [1, "compact-stepper"], ["class", "vcl-step-check", 4, "ngFor", "ngForOf"], [1, "bar-green-gray-m"], ["class", "description", 4, "ngIf"], ["class", "expansible-box", 4, "ngIf"], [1, "vcl-step-check"], [1, "step", 3, "ngClass"], [1, "step-oval"], ["steps", ""], [1, "oval", 3, "ngClass"], [1, "icon", 3, "ngClass"], [1, "tittle-step"], ["class", "description", 3, "ngClass", 4, "ngIf"], [1, "description", 3, "ngClass"], ["class", "step", 4, "ngIf"], ["class", "no-expansible-container", 4, "ngIf"], ["class", "expansible-icons-container", 4, "ngIf"], [1, "step"], [1, "no-expansible-container"], ["class", "current", 4, "ngIf"], [1, "current"], [1, "expansible-icons-container"], [3, "ngClass", "click", 4, "ngIf"], [3, "ngClass", "click"], [1, "description"], [4, "ngFor", "ngForOf"], [1, "text"], [1, "expansible-box"]], template: function VclStepperComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "section", 1);
        ɵngcc0.ɵɵelement(2, "div", 2);
        ɵngcc0.ɵɵelement(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵtemplate(5, VclStepperComponent_div_5_Template, 10, 17, "div", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "section", 6);
        ɵngcc0.ɵɵelementStart(7, "header", 4);
        ɵngcc0.ɵɵtemplate(8, VclStepperComponent_div_8_Template, 4, 3, "div", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 8);
        ɵngcc0.ɵɵelement(10, "div", 2);
        ɵngcc0.ɵɵelement(11, "div", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(12, VclStepperComponent_footer_12_Template, 2, 1, "footer", 9);
        ɵngcc0.ɵɵtemplate(13, VclStepperComponent_div_13_Template, 3, 1, "div", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(9, _c48, !(ctx.descriptionsList == null ? null : ctx.descriptionsList.length)));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵstyleProp("width", ctx.greenWidth);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.listSteps);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.listSteps);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵstyleProp("width", ctx.greenWidthMobile);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", (ctx.descriptionsList == null ? null : ctx.descriptionsList.length) > 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.descriptionBoxOpen);
    } }, directives: [ɵngcc2.NgClass, ɵngcc2.NgForOf, ɵngcc2.NgIf], styles: [".pr0[_ngcontent-%COMP%]{padding-right:0!important}progress[_ngcontent-%COMP%]{-webkit-appearance:none}.vcl-stepper-container[_ngcontent-%COMP%]   .default-stepper[_ngcontent-%COMP%]{width:100%;color:#232d19;position:relative}@media screen and (max-width: 1023.98px){.vcl-stepper-container[_ngcontent-%COMP%]   .default-stepper[_ngcontent-%COMP%]{display:none}}.vcl-stepper-container[_ngcontent-%COMP%]   .default-stepper[_ngcontent-%COMP%]   .vcl-step[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:space-between}.vcl-stepper-container[_ngcontent-%COMP%]   .default-stepper[_ngcontent-%COMP%]   .vcl-step[_ngcontent-%COMP%]   .vcl-step-check[_ngcontent-%COMP%]{display:flex;flex-direction:column}.vcl-stepper-container[_ngcontent-%COMP%]   .default-stepper[_ngcontent-%COMP%]   .vcl-step[_ngcontent-%COMP%]   .vcl-step-check[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]{display:block;padding-right:2rem;white-space:nowrap;overflow:hidden}.vcl-stepper-container[_ngcontent-%COMP%]   .default-stepper[_ngcontent-%COMP%]   .vcl-step[_ngcontent-%COMP%]   .vcl-step-check[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]   .step-oval[_ngcontent-%COMP%]{display:flex;justify-content:space-around}.vcl-stepper-container[_ngcontent-%COMP%]   .default-stepper[_ngcontent-%COMP%]   .vcl-step[_ngcontent-%COMP%]   .vcl-step-check[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]   .step-oval[_ngcontent-%COMP%]   .oval-active[_ngcontent-%COMP%]{border:solid .1875rem #00885a;width:1.25rem;height:1.25rem;margin:.125rem .5rem .125rem 0;border-radius:50%;display:flex;flex-direction:row;justify-content:center;align-content:center}.vcl-stepper-container[_ngcontent-%COMP%]   .default-stepper[_ngcontent-%COMP%]   .vcl-step[_ngcontent-%COMP%]   .vcl-step-check[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]   .step-oval[_ngcontent-%COMP%]   .oval[_ngcontent-%COMP%]{min-width:1.25rem;width:1.25rem;height:1.25rem;margin:.125rem .5rem .125rem 0;border-radius:50%;display:flex;flex-direction:row;justify-content:center;align-content:center;position:relative}.vcl-stepper-container[_ngcontent-%COMP%]   .default-stepper[_ngcontent-%COMP%]   .vcl-step[_ngcontent-%COMP%]   .vcl-step-check[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]   .step-oval[_ngcontent-%COMP%]   .oval[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{position:absolute;top:-.3125rem}.vcl-stepper-container[_ngcontent-%COMP%]   .default-stepper[_ngcontent-%COMP%]   .vcl-step[_ngcontent-%COMP%]   .vcl-step-check[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]   .step-oval[_ngcontent-%COMP%]   .oval[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]:before{font-size:.5rem;color:#007a47;font-weight:900}.vcl-stepper-container[_ngcontent-%COMP%]   .default-stepper[_ngcontent-%COMP%]   .vcl-step[_ngcontent-%COMP%]   .vcl-step-check[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]   .step-oval[_ngcontent-%COMP%]   .tittle-step[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.vcl-stepper-container[_ngcontent-%COMP%]   .default-stepper[_ngcontent-%COMP%]   .vcl-step[_ngcontent-%COMP%]   .vcl-step-check[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]   .progress-bar[_ngcontent-%COMP%]{margin-top:1rem;width:100%;height:.25rem;border-radius:.125rem;background:#d6d0cc;position:relative;border:.125rem solid #007a47;background-color:#007a47}.vcl-stepper-container[_ngcontent-%COMP%]   .default-stepper[_ngcontent-%COMP%]   .vcl-step[_ngcontent-%COMP%]   .vcl-step-check[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]   .progress-bar-gray[_ngcontent-%COMP%]{margin-top:1rem;width:100%;height:.25rem;border:.125rem solid #d6d0cc;border-radius:.125rem;background:#d6d0cc;position:relative}.vcl-stepper-container[_ngcontent-%COMP%]   .default-stepper[_ngcontent-%COMP%]   .vcl-step[_ngcontent-%COMP%]   .vcl-step-check[_ngcontent-%COMP%]   .description[_ngcontent-%COMP%]{color:#89837f;word-wrap:break-word;padding-right:2rem;margin-top:2rem}.vcl-stepper-container[_ngcontent-%COMP%]   .default-stepper[_ngcontent-%COMP%]   .vcl-stepper[_ngcontent-%COMP%]{width:100%;height:.3125rem;border:.125rem solid #d6d0cc;border-radius:.125rem;background:#d6d0cc;position:absolute;top:2.275rem;z-index:1}.vcl-stepper-container[_ngcontent-%COMP%]   .default-stepper[_ngcontent-%COMP%]   .vcl-stepper-green[_ngcontent-%COMP%]{height:.0625rem;border:.125rem solid #007a47;border-radius:.125rem;background-color:#007a47;position:absolute;top:2.28125rem;z-index:2}.no-description-container[_ngcontent-%COMP%]{padding-bottom:1rem}.oval-inactive[_ngcontent-%COMP%]{border:solid .0625rem #89837f}.oval-ok[_ngcontent-%COMP%]{border:solid .0625rem #00885a}.text[_ngcontent-%COMP%]{font-weight:normal;height:2.3125rem}.text-bold[_ngcontent-%COMP%]{font-weight:bold;height:2.3125rem}.compact-stepper[_ngcontent-%COMP%]{display:none}.expasible[_ngcontent-%COMP%]{display:none}.progress-bar[_ngcontent-%COMP%]{margin-top:1rem;width:100%;height:.3125rem;border-radius:.125rem;background:#d6d0cc;border:.125rem solid #007a47;background-color:#007a47;z-index:3}.progress-bar-gray[_ngcontent-%COMP%]{margin-top:1rem;width:100%;height:.25rem;border:.125rem solid #d6d0cc;border-radius:.125rem;background:#d6d0cc}@media screen and (max-width: 1023.98px){.compact-stepper[_ngcontent-%COMP%]{display:block}.compact-stepper[_ngcontent-%COMP%]   .vcl-step[_ngcontent-%COMP%]   .vcl-step-check[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:space-between}.compact-stepper[_ngcontent-%COMP%]   .vcl-step[_ngcontent-%COMP%]   .vcl-step-check[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]{display:flex;flex-direction:row}.compact-stepper[_ngcontent-%COMP%]   .vcl-step[_ngcontent-%COMP%]   .vcl-step-check[_ngcontent-%COMP%]   .vcl-step-description[_ngcontent-%COMP%]{margin-top:0}.compact-stepper[_ngcontent-%COMP%]   .bar-green-gray-m[_ngcontent-%COMP%]{margin-top:1rem;margin-bottom:.75rem}.compact-stepper[_ngcontent-%COMP%]   .bar-green-gray-m[_ngcontent-%COMP%]   .vcl-stepper[_ngcontent-%COMP%]{width:100%;height:.25rem;border:.125rem solid #d6d0cc;border-radius:.125rem;background:#d6d0cc}.compact-stepper[_ngcontent-%COMP%]   .bar-green-gray-m[_ngcontent-%COMP%]   .vcl-stepper-green[_ngcontent-%COMP%]{height:.25rem;border:.125rem solid #007a47;border-radius:.125rem;background:#007a47;margin-top:-.25rem}.compact-stepper[_ngcontent-%COMP%]   .description[_ngcontent-%COMP%]{color:#89837f;grid-column-start:2}.compact-stepper[_ngcontent-%COMP%]   .expansible-box[_ngcontent-%COMP%]{margin-top:1rem}.compact-stepper[_ngcontent-%COMP%]   .expansible-box[_ngcontent-%COMP%]   .vcl-step[_ngcontent-%COMP%]   .vcl-step-check[_ngcontent-%COMP%]{display:grid;grid-template-columns:1.75rem 97%;justify-items:flex-start;margin-bottom:1rem}.compact-stepper[_ngcontent-%COMP%]   .expansible-box[_ngcontent-%COMP%]   .vcl-step[_ngcontent-%COMP%]   .vcl-step-check[_ngcontent-%COMP%]   .oval-active[_ngcontent-%COMP%]{border:solid .1875rem #00885a;width:1.25rem;height:1.25rem;margin:.125rem .5rem .125rem 0;border-radius:50%;display:flex;flex-direction:row;justify-content:center;align-content:center}.compact-stepper[_ngcontent-%COMP%]   .expansible-box[_ngcontent-%COMP%]   .vcl-step[_ngcontent-%COMP%]   .vcl-step-check[_ngcontent-%COMP%]   .oval[_ngcontent-%COMP%]{min-width:1.25rem;width:1.25rem;height:1.25rem;border-radius:50%;display:flex;flex-direction:row;justify-content:center;align-content:center}.compact-stepper[_ngcontent-%COMP%]   .expansible-box[_ngcontent-%COMP%]   .vcl-step[_ngcontent-%COMP%]   .vcl-step-check[_ngcontent-%COMP%]   .oval[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{margin-top:-.3125rem}.compact-stepper[_ngcontent-%COMP%]   .expansible-box[_ngcontent-%COMP%]   .vcl-step[_ngcontent-%COMP%]   .vcl-step-check[_ngcontent-%COMP%]   .oval[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]:before{font-size:.5rem;color:#007a47;font-weight:900}.compact-stepper[_ngcontent-%COMP%]   .expansible-box[_ngcontent-%COMP%]   .vcl-step[_ngcontent-%COMP%]   .vcl-step-check[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{margin-top:-.0625rem;font-size:1rem}.compact-stepper[_ngcontent-%COMP%]   .expansible-box[_ngcontent-%COMP%]   .vcl-step[_ngcontent-%COMP%]   .vcl-step-check[_ngcontent-%COMP%]   .description[_ngcontent-%COMP%]{color:#89837f}}"], changeDetection: 0 });
/**
 * @internal
 */
VclStepperComponent.selector = 'vcl-stepper';
VclStepperComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
VclStepperComponent.propDecorators = {
    id: [{ type: Input }],
    listSteps: [{ type: Input }],
    descriptionsList: [{ type: Input }],
    currentStep: [{ type: Input }],
    expansible: [{ type: Input }],
    steps: [{ type: ViewChildren, args: ['steps',] }],
    onStepperResize: [{ type: HostListener, args: ['window:resize',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclStepperComponent, [{
        type: Component,
        args: [{
                selector: 'vcl-stepper',
                template: "<div [ngClass]=\"{\n        'vcl-stepper-container': true,\n        'no-description-container': !descriptionsList?.length}\">\n    <section class=\"default-stepper\">\n        <div class=\"vcl-stepper\"></div>\n        <div class=\"vcl-stepper-green\" [style.width]=\"greenWidth\"></div>\n        <div class=\"vcl-step\">\n            <div class=\"vcl-step-check\" *ngFor=\"let item of listSteps; let i = index\" [style.max-width]=\"stepMaxWidth\">\n                <header [ngClass]=\"{'pr0': i == listSteps.length - 1 }\" class=\"step\">\n                    <div #steps class=\"step-oval\">\n                        <div\n                            class=\"oval\"\n                            [ngClass]=\"{\n                                'oval-active': i == currentStep - 1,\n                                'oval-ok': currentStep - 1 > i,\n                                'oval-inactive': i > currentStep - 1\n                            }\">\n\n                            <i class=\"icon\" [ngClass]=\"{'icon-itaufonts_check': currentStep - 1 > i }\"></i>\n                        </div>\n\n                        <div class=\"tittle-step\">\n                            <span [ngClass]=\"i == currentStep - 1 ? 'text-bold': 'text'\">0{{i+1}}. {{item}}</span>\n                        </div>\n\n                    </div>\n                </header>\n                <footer class=\"description\" *ngIf=\"descriptionsList?.length > 0\" [ngClass]=\"{'pr0': i == listSteps.length - 1 }\">\n                    <span> {{descriptionsList[i]}} </span>\n                </footer>\n            </div>\n        </div>\n    </section>\n\n    <section class=\"compact-stepper\">\n        <header class=\"vcl-step\">\n            <div class=\"vcl-step-check\" *ngFor=\"let item of listSteps; let i = index\">\n                <div #steps class=\"step\" *ngIf=\"i == currentStep - 1\">\n                    <span [ngClass]=\"i == currentStep - 1 ? 'textBold': 'text'\">\n                        {{item}}\n                    </span>\n                </div>\n                <div *ngIf=\"!expansible\" class=\"no-expansible-container\">\n                    <label class=\"current\" *ngIf=\"i == currentStep - 1\">\n                        etapa {{i+1}} de {{listSteps.length}}\n                    </label>\n                </div>\n                <div *ngIf=\"expansible\" class=\"expansible-icons-container\">\n                    <span [ngClass]=\"{\n                         'icon-itaufonts_seta_down': !descriptionBoxOpen,\n                         'icon-itaufonts_seta_up': descriptionBoxOpen\n                        }\" *ngIf=\"i == currentStep - 1\" (click)=\"toggleDescriptionBox()\">\n                    </span>\n                </div>\n            </div>\n        </header>\n\n        <div class=\"bar-green-gray-m\">\n            <div class=\"vcl-stepper\"></div>\n            <div class=\"vcl-stepper-green\" [style.width]=\"greenWidthMobile\"></div>\n        </div>\n\n        <footer *ngIf=\"descriptionsList?.length > 0\" class=\"description\">\n            <div *ngFor=\"let item of descriptionsList; let i = index\">\n                <div class=\"description\" *ngIf=\"i == currentStep - 1\">\n                    <span class=\"text\">{{item}}</span>\n                </div>\n            </div>\n        </footer>\n\n        <div class=\"expansible-box\" *ngIf=\"descriptionBoxOpen\">\n            <div class=\"vcl-step\">\n                <div class=\"vcl-step-check\" *ngFor=\"let item of listSteps; let i = index\">\n                    <div class=\"oval\"\n                        [ngClass]=\"{\n                            'oval-active': i == currentStep - 1,\n                            'oval-ok': currentStep - 1 > i,\n                            'oval-inactive': i > currentStep - 1\n                        }\">\n\n                        <i class=\"icon\" [ngClass]=\"{'icon-itaufonts_check': currentStep - 1 > i }\"></i>\n                    </div>\n\n                    <span [ngClass]=\"i == currentStep - 1 ? 'textBold': 'text'\">\n                        0{{i+1}}.{{item}}\n                    </span>\n\n                    <footer class=\"description\" *ngIf=\"descriptionsList?.length > 0\">\n                        <span class=\"text\">{{descriptionsList[i]}}</span>\n                    </footer>\n                </div>\n            </div>\n        </div>\n    </section>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".pr0{padding-right:0!important}progress{-webkit-appearance:none}.vcl-stepper-container .default-stepper{width:100%;color:#232d19;position:relative}@media screen and (max-width: 1023.98px){.vcl-stepper-container .default-stepper{display:none}}.vcl-stepper-container .default-stepper .vcl-step{display:flex;flex-direction:row;justify-content:space-between}.vcl-stepper-container .default-stepper .vcl-step .vcl-step-check{display:flex;flex-direction:column}.vcl-stepper-container .default-stepper .vcl-step .vcl-step-check .step{display:block;padding-right:2rem;white-space:nowrap;overflow:hidden}.vcl-stepper-container .default-stepper .vcl-step .vcl-step-check .step .step-oval{display:flex;justify-content:space-around}.vcl-stepper-container .default-stepper .vcl-step .vcl-step-check .step .step-oval .oval-active{border:solid .1875rem #00885a;width:1.25rem;height:1.25rem;margin:.125rem .5rem .125rem 0;border-radius:50%;display:flex;flex-direction:row;justify-content:center;align-content:center}.vcl-stepper-container .default-stepper .vcl-step .vcl-step-check .step .step-oval .oval{min-width:1.25rem;width:1.25rem;height:1.25rem;margin:.125rem .5rem .125rem 0;border-radius:50%;display:flex;flex-direction:row;justify-content:center;align-content:center;position:relative}.vcl-stepper-container .default-stepper .vcl-step .vcl-step-check .step .step-oval .oval .icon{position:absolute;top:-.3125rem}.vcl-stepper-container .default-stepper .vcl-step .vcl-step-check .step .step-oval .oval .icon:before{font-size:.5rem;color:#007a47;font-weight:900}.vcl-stepper-container .default-stepper .vcl-step .vcl-step-check .step .step-oval .tittle-step{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.vcl-stepper-container .default-stepper .vcl-step .vcl-step-check .step .progress-bar{margin-top:1rem;width:100%;height:.25rem;border-radius:.125rem;background:#d6d0cc;position:relative;border:.125rem solid #007a47;background-color:#007a47}.vcl-stepper-container .default-stepper .vcl-step .vcl-step-check .step .progress-bar-gray{margin-top:1rem;width:100%;height:.25rem;border:.125rem solid #d6d0cc;border-radius:.125rem;background:#d6d0cc;position:relative}.vcl-stepper-container .default-stepper .vcl-step .vcl-step-check .description{color:#89837f;word-wrap:break-word;padding-right:2rem;margin-top:2rem}.vcl-stepper-container .default-stepper .vcl-stepper{width:100%;height:.3125rem;border:.125rem solid #d6d0cc;border-radius:.125rem;background:#d6d0cc;position:absolute;top:2.275rem;z-index:1}.vcl-stepper-container .default-stepper .vcl-stepper-green{height:.0625rem;border:.125rem solid #007a47;border-radius:.125rem;background-color:#007a47;position:absolute;top:2.28125rem;z-index:2}.no-description-container{padding-bottom:1rem}.oval-inactive{border:solid .0625rem #89837f}.oval-ok{border:solid .0625rem #00885a}.text{font-weight:normal;height:2.3125rem}.text-bold{font-weight:bold;height:2.3125rem}.compact-stepper{display:none}.expasible{display:none}.progress-bar{margin-top:1rem;width:100%;height:.3125rem;border-radius:.125rem;background:#d6d0cc;border:.125rem solid #007a47;background-color:#007a47;z-index:3}.progress-bar-gray{margin-top:1rem;width:100%;height:.25rem;border:.125rem solid #d6d0cc;border-radius:.125rem;background:#d6d0cc}@media screen and (max-width: 1023.98px){.compact-stepper{display:block}.compact-stepper .vcl-step .vcl-step-check{display:flex;flex-direction:row;justify-content:space-between}.compact-stepper .vcl-step .vcl-step-check .step{display:flex;flex-direction:row}.compact-stepper .vcl-step .vcl-step-check .vcl-step-description{margin-top:0}.compact-stepper .bar-green-gray-m{margin-top:1rem;margin-bottom:.75rem}.compact-stepper .bar-green-gray-m .vcl-stepper{width:100%;height:.25rem;border:.125rem solid #d6d0cc;border-radius:.125rem;background:#d6d0cc}.compact-stepper .bar-green-gray-m .vcl-stepper-green{height:.25rem;border:.125rem solid #007a47;border-radius:.125rem;background:#007a47;margin-top:-.25rem}.compact-stepper .description{color:#89837f;grid-column-start:2}.compact-stepper .expansible-box{margin-top:1rem}.compact-stepper .expansible-box .vcl-step .vcl-step-check{display:grid;grid-template-columns:1.75rem 97%;justify-items:flex-start;margin-bottom:1rem}.compact-stepper .expansible-box .vcl-step .vcl-step-check .oval-active{border:solid .1875rem #00885a;width:1.25rem;height:1.25rem;margin:.125rem .5rem .125rem 0;border-radius:50%;display:flex;flex-direction:row;justify-content:center;align-content:center}.compact-stepper .expansible-box .vcl-step .vcl-step-check .oval{min-width:1.25rem;width:1.25rem;height:1.25rem;border-radius:50%;display:flex;flex-direction:row;justify-content:center;align-content:center}.compact-stepper .expansible-box .vcl-step .vcl-step-check .oval .icon{margin-top:-.3125rem}.compact-stepper .expansible-box .vcl-step .vcl-step-check .oval .icon:before{font-size:.5rem;color:#007a47;font-weight:900}.compact-stepper .expansible-box .vcl-step .vcl-step-check span{margin-top:-.0625rem;font-size:1rem}.compact-stepper .expansible-box .vcl-step .vcl-step-check .description{color:#89837f}}\n"]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { listSteps: [{
            type: Input
        }], descriptionsList: [{
            type: Input
        }], currentStep: [{
            type: Input
        }], expansible: [{
            type: Input
        }], 
    /**
     * @internal
     */
    onStepperResize: [{
            type: HostListener,
            args: ['window:resize']
        }], id: [{
            type: Input
        }], steps: [{
            type: ViewChildren,
            args: ['steps']
        }] }); })();

class VclStepperModule {
}
VclStepperModule.ɵfac = function VclStepperModule_Factory(t) { return new (t || VclStepperModule)(); };
VclStepperModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VclStepperModule });
VclStepperModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclStepperModule, [{
        type: NgModule,
        args: [{
                declarations: [VclStepperComponent],
                imports: [
                    CommonModule,
                ],
                exports: [VclStepperComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VclStepperModule, { declarations: function () { return [VclStepperComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [VclStepperComponent]; } }); })();

/**
 * Componente de carregamento com card
 *
 * *Loading card Component*
 *
 * ### Acessible
 *
 * <acessible class="not-tested">Acessibilidade - Não testado</acessible>
 *
 *
 * **Module:**
 *
 * `import { VoxelLoadingCardModule } from '@voxel/community';`
 *
 * <example-url>../../demo/index.html#/portfolio/loading-card?componentOnly=true</example-url>
 *
 * @example simples
 * <vcl-loading-card
 *  *ngIf="loading">
 * </vcl-loading-card>
 *
 * @example com label customizado
 * <vcl-loading-card
 *  *ngIf="loading"
 *  label="label customizado">
 * </vcl-loading-card>
 */
class VclLoadingCardComponent {
    constructor() {
        /**
         * Define se o loading estará dentro de um card
         */
        this.card = true;
        /**
         * texto de acessibilidade
         */
        this.a11yText = 'aguarde, carregando';
        /**
         * Define se a acessibilidade irá focar no loading quando o mesmo aparecer na tela
         */
        this.autoFocus = true;
    }
    ngOnInit() {
        if (!this.focusOnExit) {
            this.focusElement = document.activeElement;
        }
        this.loadingContainer = !this.label ? 'loading-container' : 'loading-container_text';
        this.loadingComponent = 'loading-component';
        this.cardBox = !this.label ? 'card-box' : 'card-box_text';
    }
    ngOnDestroy() {
        if (this.focusOnExit) {
            const el = document.querySelector(this.focusOnExit);
            console.log(el);
            if (el) {
                el.setAttribute('tabindex', '0');
                el.focus();
            }
        }
        else if (this.autoFocus) {
            this.focusElement.setAttribute('tabindex', '0');
            this.focusElement.focus();
        }
    }
    ngAfterViewInit() {
        timer().subscribe(() => {
            if (!this.autoFocus) {
                return;
            }
            const el = document.getElementById('loadingFocus');
            if (!el) {
                return;
            }
            el.setAttribute('tabindex', '0');
            el.focus();
        });
    }
}
VclLoadingCardComponent.ɵfac = function VclLoadingCardComponent_Factory(t) { return new (t || VclLoadingCardComponent)(); };
VclLoadingCardComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VclLoadingCardComponent, selectors: [["vcl-loading-card"]], inputs: { card: "card", a11yText: "a11yText", autoFocus: "autoFocus", label: "label", focusOnExit: "focusOnExit" }, decls: 7, vars: 12, consts: [["id", "customLoading", 1, "loading-background", "background-filter"], ["id", "loadingFocus", "aria-live", "assertive"], [1, "center-middle"], ["aria-hidden", "true"], [3, "loadingTitle"], ["aria-hidden", "true", "class", "loading-text", 4, "ngIf"], ["aria-hidden", "true", 1, "loading-text"]], template: function VclLoadingCardComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div");
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵelement(5, "voxel-loading-circle", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, VclLoadingCardComponent_span_6_Template, 2, 1, "span", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.loadingContainer);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.card ? ctx.cardBox : "");
        ɵngcc0.ɵɵattribute("aria-label", ctx.a11yText);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassMapInterpolate2("", ctx.loadingComponent, " ", ctx.label ? "size-little" : "", "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("loadingTitle", ctx.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.label);
    } }, directives: [ɵngcc1.VoxelLoadingCircleComponent, ɵngcc2.NgIf], styles: [".loading-background[_ngcontent-%COMP%]{z-index:1000;position:fixed;top:0%;bottom:0%;left:0%;right:0%;width:100vw;height:100vh;pointer-events:none}.center-middle[_ngcontent-%COMP%]{position:absolute;right:.5rem;left:.5rem;top:50%;transform:translateY(-50%)}.loading-text[_ngcontent-%COMP%]{font-family:\"Itau Text\";font-weight:bold;font-size:.875rem}.background-filter[_ngcontent-%COMP%]{background-color:#00000059;animation-name:darken;animation-timing-function:cubic-bezier(.075,.82,.165,1);animation-duration:.25s}.size-little[_ngcontent-%COMP%]{transform:scale(.8)}.loading-container[_ngcontent-%COMP%], .loading-container_text[_ngcontent-%COMP%]{position:absolute;top:calc(50vh - 3.45rem);left:calc(50vw - 3.45rem);right:calc(50vw - 3.45rem);animation-name:scaleUp;animation-timing-function:cubic-bezier(.075,.82,.165,1);animation-duration:.25s}.loading-container_text[_ngcontent-%COMP%]{top:calc(50vh - 3.9rem);left:calc(50vw - 3.9rem);right:calc(50vw - 3.9rem)}.loading-component[_ngcontent-%COMP%]{margin-top:0}.card-box[_ngcontent-%COMP%], .card-box_text[_ngcontent-%COMP%]{background:white;box-shadow:0 1px 1px #7a6d603d;border-radius:.5rem;padding:.5rem;width:6.9rem;height:6.9rem;text-align:center;line-height:1.125rem}.card-box_text[_ngcontent-%COMP%]{width:7.8rem;height:7.8rem}@keyframes darken{0%{background-color:#0000}to{background-color:#00000059}}@keyframes scaleUp{0%{transform:scale(0)}to{transform:scale(1)}}"] });
VclLoadingCardComponent.selector = 'vcl-loading-card';
VclLoadingCardComponent.propDecorators = {
    card: [{ type: Input }],
    label: [{ type: Input }],
    a11yText: [{ type: Input }],
    focusOnExit: [{ type: Input }],
    autoFocus: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclLoadingCardComponent, [{
        type: Component,
        args: [{
                selector: 'vcl-loading-card',
                template: "<div id=\"customLoading\" class=\"loading-background background-filter\">\n  <div [class]=\"loadingContainer\">\n    <div id=\"loadingFocus\" aria-live=\"assertive\" attr.aria-label=\"{{a11yText}}\" class=\"{{card? cardBox : ''}}\">\n      <div class=\"center-middle\">\n        <div aria-hidden=\"true\" class=\"{{loadingComponent}} {{label? 'size-little' : ''}}\">\n          <voxel-loading-circle [loadingTitle]=\"label\">\n          </voxel-loading-circle>\n        </div>\n        <span aria-hidden=\"true\" class=\"loading-text\" *ngIf=\"label\">{{label}}</span>\n      </div>\n    </div>\n  </div>\n</div>",
                styles: [".loading-background{z-index:1000;position:fixed;top:0%;bottom:0%;left:0%;right:0%;width:100vw;height:100vh;pointer-events:none}.center-middle{position:absolute;right:.5rem;left:.5rem;top:50%;transform:translateY(-50%)}.loading-text{font-family:\"Itau Text\";font-weight:bold;font-size:.875rem}.background-filter{background-color:#00000059;animation-name:darken;animation-timing-function:cubic-bezier(.075,.82,.165,1);animation-duration:.25s}.size-little{transform:scale(.8)}.loading-container,.loading-container_text{position:absolute;top:calc(50vh - 3.45rem);left:calc(50vw - 3.45rem);right:calc(50vw - 3.45rem);animation-name:scaleUp;animation-timing-function:cubic-bezier(.075,.82,.165,1);animation-duration:.25s}.loading-container_text{top:calc(50vh - 3.9rem);left:calc(50vw - 3.9rem);right:calc(50vw - 3.9rem)}.loading-component{margin-top:0}.card-box,.card-box_text{background:white;box-shadow:0 1px 1px #7a6d603d;border-radius:.5rem;padding:.5rem;width:6.9rem;height:6.9rem;text-align:center;line-height:1.125rem}.card-box_text{width:7.8rem;height:7.8rem}@keyframes darken{0%{background-color:#0000}to{background-color:#00000059}}@keyframes scaleUp{0%{transform:scale(0)}to{transform:scale(1)}}\n"]
            }]
    }], function () { return []; }, { card: [{
            type: Input
        }], a11yText: [{
            type: Input
        }], autoFocus: [{
            type: Input
        }], label: [{
            type: Input
        }], focusOnExit: [{
            type: Input
        }] }); })();

class VclLoadingCardModule {
}
VclLoadingCardModule.ɵfac = function VclLoadingCardModule_Factory(t) { return new (t || VclLoadingCardModule)(); };
VclLoadingCardModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VclLoadingCardModule });
VclLoadingCardModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            VoxelLoadingCircleModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclLoadingCardModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    VoxelLoadingCircleModule,
                ],
                declarations: [VclLoadingCardComponent],
                exports: [VclLoadingCardComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VclLoadingCardModule, { declarations: function () { return [VclLoadingCardComponent]; }, imports: function () { return [CommonModule,
        VoxelLoadingCircleModule]; }, exports: function () { return [VclLoadingCardComponent]; } }); })();

/**
 * Componente para leitura de código QR a partir de uma imagem lida pela câmera do dispositivo
 *
 * *Component for reading QR code from an image read by the device's camera*
 *
 * ### Acessible
 *
 * <acessible class="not-tested">Acessibilidade - Não testado</acessible>
 *
 *
 * **Module:**
 *
 * `import { VclQrCodeScannerModule } from '@voxel/community-mobile';`
 *
 * <example-url>../../demo/index.html#/portfolio/qr-code-scanner?componentOnly=true</example-url>
 *
 * @example
 * <vcl-qr-code-scanner
 *   (qrResultString)="onResult($event)"
 *   (hasPermission)="onHasPermission($event)"
 *   (torchAvailable)="onTorchAvailable($event)"
 *   [showLayover]="true">
 * </vcl-qr-code-scanner>
 */
class VclQrCodeScannerComponent {
    constructor() {
        /**
         * Define se deve existir o layer de foco por cima da imagem da câmera para focar o QrCode
         *
         * *Defines whether should exist a layer over the camera image to focus QrCode*
         */
        this.showLayover = false;
        /**
         * Define se deve ligar a iluminação (flash) do dispositivo
         *
         * *Defines whether to turn on the device's (flash) lighting*
         */
        this.torchEnabled = false;
        /**
         * Define se deve ligar a flag 'tryHarder'
         *
         * *Defines whether to turn on the 'tryHarder' flag*
         */
        this.tryHarder = false;
        /**
         * Evento emitido ao ler um código na tela
         *
         * *Event emitted when reading a code on the screen*
         */
        this.qrResultString = new EventEmitter();
        /**
         * Evento emitido ao receber alteração na propriedade 'hasPermission'
         *
         * *Event emitted when receiving change in the 'hasPermission' property*
         */
        this.hasPermission = new EventEmitter();
        /**
         * Evento emitido ao receber alteração na propriedade 'torchAvailable'
         *
         * *Event emitted when receiving change in the 'torchAvailable' property*
         */
        this.torchAvailable = new EventEmitter();
        /**
         * Evento emitido ao fechar o leitor
         *
         * *Event emitted when close the scanner*
         */
        this.close = new EventEmitter();
        /**
         * @internal
         */
        this.currentDevice = null;
        /**
         * @internal
         */
        this.formatsEnabled = [
            BarcodeFormat.CODE_128,
            BarcodeFormat.DATA_MATRIX,
            BarcodeFormat.EAN_13,
            BarcodeFormat.QR_CODE,
        ];
        /**
         * @internal
         */
        this.torchAvailable$ = new BehaviorSubject(false);
    }
    /**
     * @internal
     */
    onCamerasFound(devices) {
        this.availableDevices = devices;
        this.hasDevices = Boolean(devices && devices.length);
    }
    /**
     * @internal
     */
    onCodeResult(resultString) {
        this.qrResultString.emit(resultString);
    }
    /**
     * @internal
     */
    onHasPermission(has) {
        this._hasPermission = has;
        this.hasPermission.emit(this._hasPermission);
    }
    /**
     * @internal
     */
    onTorchCompatible(isCompatible) {
        this.torchAvailable$.next(isCompatible || false);
        this.torchAvailable.emit(this.torchAvailable$.value);
    }
    /**
     * @internal
     */
    closeScanner() {
        this.close.emit(true);
    }
}
VclQrCodeScannerComponent.ɵfac = function VclQrCodeScannerComponent_Factory(t) { return new (t || VclQrCodeScannerComponent)(); };
VclQrCodeScannerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VclQrCodeScannerComponent, selectors: [["vcl-qr-code-scanner"]], inputs: { showLayover: "showLayover", torchEnabled: "torchEnabled", tryHarder: "tryHarder" }, outputs: { qrResultString: "qrResultString", hasPermission: "hasPermission", torchAvailable: "torchAvailable", close: "close" }, decls: 7, vars: 5, consts: [[1, "qr-container"], [3, "torch", "device", "formats", "tryHarder", "deviceChange", "scanSuccess", "permissionResponse", "camerasFound", "torchCompatible"], ["aria-label", "fechar", 1, "btn-close"], [1, "voxel-txt-color-sand-0", 3, "click"], ["id", "layover", "class", "layover", 4, "ngIf"], ["id", "layover", 1, "layover"], ["layover", ""], [1, "inner-div"], [1, "voxel-txt-color-sand-0"], [1, "qr-target-guide"], [1, "qr-target-top"], [1, "qr-target-bottom"]], template: function VclQrCodeScannerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "zxing-scanner", 1);
        ɵngcc0.ɵɵlistener("deviceChange", function VclQrCodeScannerComponent_Template_zxing_scanner_deviceChange_1_listener($event) { return ctx.currentDevice = $event; })("scanSuccess", function VclQrCodeScannerComponent_Template_zxing_scanner_scanSuccess_1_listener($event) { return ctx.onCodeResult($event); })("permissionResponse", function VclQrCodeScannerComponent_Template_zxing_scanner_permissionResponse_1_listener($event) { return ctx.onHasPermission($event); })("camerasFound", function VclQrCodeScannerComponent_Template_zxing_scanner_camerasFound_1_listener($event) { return ctx.onCamerasFound($event); })("torchCompatible", function VclQrCodeScannerComponent_Template_zxing_scanner_torchCompatible_1_listener($event) { return ctx.onTorchCompatible($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "header");
        ɵngcc0.ɵɵelementStart(3, "button", 2);
        ɵngcc0.ɵɵelementStart(4, "voxel-icon", 3);
        ɵngcc0.ɵɵlistener("click", function VclQrCodeScannerComponent_Template_voxel_icon_click_4_listener() { return ctx.closeScanner(); });
        ɵngcc0.ɵɵtext(5, "fechar");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, VclQrCodeScannerComponent_div_6_Template, 8, 0, "div", 4);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("torch", ctx.torchEnabled)("device", ctx.currentDevice)("formats", ctx.formatsEnabled)("tryHarder", ctx.tryHarder);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showLayover);
    } }, directives: [ɵngcc8.ZXingScannerComponent, ɵngcc1.VoxelIconComponent, ɵngcc2.NgIf], styles: [".qr-container[_ngcontent-%COMP%]{position:relative;height:150vw;min-height:100vh;display:flex;flex-direction:column;justify-content:center}.qr-container[_ngcontent-%COMP%]   header[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:flex-end;position:absolute;top:0;width:100%;z-index:1;padding:.9375rem}.qr-container[_ngcontent-%COMP%]   header[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{background-color:transparent;border:0;height:1.5625rem;width:1.5625rem;outline:0}.qr-container[_ngcontent-%COMP%]   .layover[_ngcontent-%COMP%]{min-height:100vh;height:150vw;width:100%;position:absolute;padding:.9375rem;top:0;left:0;overflow:hidden;display:flex;flex-direction:column;justify-content:center}.qr-container[_ngcontent-%COMP%]   .layover[_ngcontent-%COMP%]:after{content:\"\";box-shadow:0 0 0 200vh #000000b3;display:block;width:100%;height:calc(53vw * 1.6)}.qr-container[_ngcontent-%COMP%]   .layover[_ngcontent-%COMP%]   .inner-div[_ngcontent-%COMP%]{width:100%;position:relative}.qr-container[_ngcontent-%COMP%]   .layover[_ngcontent-%COMP%]   .inner-div[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{font-family:\"Itau Text\",\"Itau Display\";font-weight:300;font-size:1.375rem;margin:-2.5rem auto 1.5625rem;display:block;width:100%;color:#fff;padding-right:1rem}.qr-container[_ngcontent-%COMP%]   .layover[_ngcontent-%COMP%]   .inner-div[_ngcontent-%COMP%]   .qr-target-guide[_ngcontent-%COMP%]{width:100%;display:flex;flex-direction:column;justify-content:space-between;height:calc(53vw * 1.6);position:absolute}.qr-container[_ngcontent-%COMP%]   .layover[_ngcontent-%COMP%]   .inner-div[_ngcontent-%COMP%]   .qr-target-guide[_ngcontent-%COMP%]   .qr-target-top[_ngcontent-%COMP%], .qr-container[_ngcontent-%COMP%]   .layover[_ngcontent-%COMP%]   .inner-div[_ngcontent-%COMP%]   .qr-target-guide[_ngcontent-%COMP%]   .qr-target-bottom[_ngcontent-%COMP%]{width:100%;display:flex;justify-content:space-between;padding:.75rem;border-color:#ec7000}.qr-container[_ngcontent-%COMP%]   .layover[_ngcontent-%COMP%]   .inner-div[_ngcontent-%COMP%]   .qr-target-guide[_ngcontent-%COMP%]   .qr-target-top[_ngcontent-%COMP%]:before, .qr-container[_ngcontent-%COMP%]   .layover[_ngcontent-%COMP%]   .inner-div[_ngcontent-%COMP%]   .qr-target-guide[_ngcontent-%COMP%]   .qr-target-top[_ngcontent-%COMP%]:after, .qr-container[_ngcontent-%COMP%]   .layover[_ngcontent-%COMP%]   .inner-div[_ngcontent-%COMP%]   .qr-target-guide[_ngcontent-%COMP%]   .qr-target-bottom[_ngcontent-%COMP%]:before, .qr-container[_ngcontent-%COMP%]   .layover[_ngcontent-%COMP%]   .inner-div[_ngcontent-%COMP%]   .qr-target-guide[_ngcontent-%COMP%]   .qr-target-bottom[_ngcontent-%COMP%]:after{content:\"\";height:3rem;width:3rem;border-color:inherit;border-width:.1875rem}.qr-container[_ngcontent-%COMP%]   .layover[_ngcontent-%COMP%]   .inner-div[_ngcontent-%COMP%]   .qr-target-guide[_ngcontent-%COMP%]   .qr-target-top[_ngcontent-%COMP%]:before{border-top-style:solid;border-left-style:solid}.qr-container[_ngcontent-%COMP%]   .layover[_ngcontent-%COMP%]   .inner-div[_ngcontent-%COMP%]   .qr-target-guide[_ngcontent-%COMP%]   .qr-target-top[_ngcontent-%COMP%]:after{border-top-style:solid;border-right-style:solid}.qr-container[_ngcontent-%COMP%]   .layover[_ngcontent-%COMP%]   .inner-div[_ngcontent-%COMP%]   .qr-target-guide[_ngcontent-%COMP%]   .qr-target-bottom[_ngcontent-%COMP%]:before{border-bottom-style:solid;border-left-style:solid}.qr-container[_ngcontent-%COMP%]   .layover[_ngcontent-%COMP%]   .inner-div[_ngcontent-%COMP%]   .qr-target-guide[_ngcontent-%COMP%]   .qr-target-bottom[_ngcontent-%COMP%]:after{border-bottom-style:solid;border-right-style:solid}zxing-scanner[_ngcontent-%COMP%]{max-width:100%}"] });
VclQrCodeScannerComponent.propDecorators = {
    showLayover: [{ type: Input }],
    torchEnabled: [{ type: Input }],
    tryHarder: [{ type: Input }],
    qrResultString: [{ type: Output }],
    hasPermission: [{ type: Output }],
    torchAvailable: [{ type: Output }],
    close: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclQrCodeScannerComponent, [{
        type: Component,
        args: [{
                selector: 'vcl-qr-code-scanner',
                template: "<div class=\"qr-container\">\n    <zxing-scanner [torch]=\"torchEnabled\" [(device)]=\"currentDevice\" (scanSuccess)=\"onCodeResult($event)\"\n      [formats]=\"formatsEnabled\" [tryHarder]=\"tryHarder\" (permissionResponse)=\"onHasPermission($event)\"\n      (camerasFound)=\"onCamerasFound($event)\" (torchCompatible)=\"onTorchCompatible($event)\">\n    </zxing-scanner>\n  \n    <header>\n      <button aria-label=\"fechar\" class=\"btn-close\">\n        <voxel-icon class=\"voxel-txt-color-sand-0\" (click)=\"closeScanner()\">fechar</voxel-icon>\n      </button>\n    </header>\n  \n    <div id=\"layover\" class=\"layover\" *ngIf=\"showLayover\" #layover>\n  \n      <div class=\"inner-div\">\n  \n        <h1 class=\"voxel-txt-color-sand-0\">Apunta tu c\u00E1mara al c\u00F3digo QR y espera unos segundos</h1>\n  \n        <div class=\"qr-target-guide\">\n          <div class=\"qr-target-top\"></div>\n          <div class=\"qr-target-bottom\"></div>\n        </div>\n      </div>\n    </div>\n  \n  </div>\n  ",
                styles: [".qr-container{position:relative;height:150vw;min-height:100vh;display:flex;flex-direction:column;justify-content:center}.qr-container header{display:flex;align-items:center;justify-content:flex-end;position:absolute;top:0;width:100%;z-index:1;padding:.9375rem}.qr-container header button{background-color:transparent;border:0;height:1.5625rem;width:1.5625rem;outline:0}.qr-container .layover{min-height:100vh;height:150vw;width:100%;position:absolute;padding:.9375rem;top:0;left:0;overflow:hidden;display:flex;flex-direction:column;justify-content:center}.qr-container .layover:after{content:\"\";box-shadow:0 0 0 200vh #000000b3;display:block;width:100%;height:calc(53vw * 1.6)}.qr-container .layover .inner-div{width:100%;position:relative}.qr-container .layover .inner-div h1{font-family:\"Itau Text\",\"Itau Display\";font-weight:300;font-size:1.375rem;margin:-2.5rem auto 1.5625rem;display:block;width:100%;color:#fff;padding-right:1rem}.qr-container .layover .inner-div .qr-target-guide{width:100%;display:flex;flex-direction:column;justify-content:space-between;height:calc(53vw * 1.6);position:absolute}.qr-container .layover .inner-div .qr-target-guide .qr-target-top,.qr-container .layover .inner-div .qr-target-guide .qr-target-bottom{width:100%;display:flex;justify-content:space-between;padding:.75rem;border-color:#ec7000}.qr-container .layover .inner-div .qr-target-guide .qr-target-top:before,.qr-container .layover .inner-div .qr-target-guide .qr-target-top:after,.qr-container .layover .inner-div .qr-target-guide .qr-target-bottom:before,.qr-container .layover .inner-div .qr-target-guide .qr-target-bottom:after{content:\"\";height:3rem;width:3rem;border-color:inherit;border-width:.1875rem}.qr-container .layover .inner-div .qr-target-guide .qr-target-top:before{border-top-style:solid;border-left-style:solid}.qr-container .layover .inner-div .qr-target-guide .qr-target-top:after{border-top-style:solid;border-right-style:solid}.qr-container .layover .inner-div .qr-target-guide .qr-target-bottom:before{border-bottom-style:solid;border-left-style:solid}.qr-container .layover .inner-div .qr-target-guide .qr-target-bottom:after{border-bottom-style:solid;border-right-style:solid}zxing-scanner{max-width:100%}\n"]
            }]
    }], function () { return []; }, { showLayover: [{
            type: Input
        }], torchEnabled: [{
            type: Input
        }], tryHarder: [{
            type: Input
        }], qrResultString: [{
            type: Output
        }], hasPermission: [{
            type: Output
        }], torchAvailable: [{
            type: Output
        }], close: [{
            type: Output
        }] }); })();

class VclQrCodeScannerModule {
}
VclQrCodeScannerModule.ɵfac = function VclQrCodeScannerModule_Factory(t) { return new (t || VclQrCodeScannerModule)(); };
VclQrCodeScannerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VclQrCodeScannerModule });
VclQrCodeScannerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            ZXingScannerModule,
            VoxelIconModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclQrCodeScannerModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    ZXingScannerModule,
                    VoxelIconModule
                ],
                declarations: [VclQrCodeScannerComponent],
                exports: [VclQrCodeScannerComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VclQrCodeScannerModule, { declarations: function () { return [VclQrCodeScannerComponent]; }, imports: function () { return [CommonModule,
        ZXingScannerModule,
        VoxelIconModule]; }, exports: function () { return [VclQrCodeScannerComponent]; } }); })();

class VclBackdropComponent {
    constructor(renderer) {
        this.renderer = renderer;
    }
    ngOnInit() {
        this.renderer.addClass(document.body, 'no-scroll');
    }
    ngOnDestroy() {
        this.renderer.removeClass(document.body, 'no-scroll');
    }
}
VclBackdropComponent.ɵfac = function VclBackdropComponent_Factory(t) { return new (t || VclBackdropComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
VclBackdropComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VclBackdropComponent, selectors: [["vcl-backdrop"]], hostVars: 1, hostBindings: function VclBackdropComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵsyntheticHostProperty("@fadeInOut", ctx._);
    } }, decls: 0, vars: 0, template: function VclBackdropComponent_Template(rf, ctx) { }, styles: ["[_nghost-%COMP%]{position:fixed;display:block;z-index:11;left:0;right:0;top:0;bottom:0;-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px);background-color:#00000052}"], data: { animation: [
            trigger('fadeInOut', [
                state('void', style({
                    opacity: 0
                })),
                transition('void <=> *', animate(300)),
            ]),
        ] } });
VclBackdropComponent.ctorParameters = () => [
    { type: Renderer2 }
];
VclBackdropComponent.propDecorators = {
    _: [{ type: HostBinding, args: ['@fadeInOut',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclBackdropComponent, [{
        type: Component,
        args: [{
                selector: 'vcl-backdrop',
                template: '',
                animations: [
                    trigger('fadeInOut', [
                        state('void', style({
                            opacity: 0
                        })),
                        transition('void <=> *', animate(300)),
                    ]),
                ],
                styles: [":host{position:fixed;display:block;z-index:11;left:0;right:0;top:0;bottom:0;-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px);background-color:#00000052}\n"]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }]; }, { _: [{
            type: HostBinding,
            args: ['@fadeInOut']
        }] }); })();

/**
 * O Action Sheet é um caixa de diálogo que exibe um conjunto de opções.
 * Ele aparece na parte inferior do conteúdo da tela e deve ser descartado manualmente pelo usuário
 *
 * *An Action Sheet is a dialog that displays a set of options.*
 * *It appears on bottom of the screen content, and must be manually dismissed by the user*
 *
 * ### Acessible
 *
 * <acessible class="not-tested">Acessibilidade - Não testado</acessible>
 *
 * **Module:**
 *
 * `import { VclActionSheetModule } from '@voxel/community';`
 *
 * <example-url>../../demo/index.html#/portfolio/action-sheet?componentOnly=true</example-url>
 *
 * @example
 *  <div class="vcl-p-m">
 *   <button
 *     voxelButton
 *     id="btn-action-sheet"
 *     (click)="showDialog = !showDialog"
 *   >
 *    Abrir ActionSheet
 *   </button>
 *  </div>
 *
 *  <vcl-action-sheet
 *    [title]="title"
 *    [(showActionSheet)]="showDialog"
 *    (itemClick)="onOptionClick($event.option)"
 *    [options]="options">
 *  </vcl-action-sheet>
 */
class VclActionSheetComponent {
    /**
     * @internal
     */
    constructor(voxelSegmentService) {
        this.voxelSegmentService = voxelSegmentService;
        /**
         * Evento que emitirá o valor de alternância entre verdadeiro e falso para o action sheet
         *
         * *Event that will emit the toggle value between true and false for the show's action sheet*
         */
        this.showActionSheetChange = new EventEmitter();
        /**
         * Evento que emitirá para o componente pai o valor da opção clicada
         *
         * *Event that will emit the value of the clicked option to the parent component*
         */
        this.itemClick = new EventEmitter();
        /**
         * @internal
         */
        this.segment$ = this.voxelSegmentService.segment;
    }
    /**
     * @internal
     */
    onBdClick() {
        this.setShowActionSheet(false);
    }
    /**
     * @internal
     */
    onItemClick($event, option) {
        this.setShowActionSheet(false);
        this.itemClick.emit({ $event, option });
    }
    /**
     * @internal
     */
    setShowActionSheet(_showActionSheet) {
        this.showActionSheet = _showActionSheet;
        this.showActionSheetChange.emit(_showActionSheet);
    }
}
VclActionSheetComponent.ɵfac = function VclActionSheetComponent_Factory(t) { return new (t || VclActionSheetComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.VoxelSegmentService)); };
VclActionSheetComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VclActionSheetComponent, selectors: [["vcl-action-sheet"]], inputs: { showActionSheet: "showActionSheet", id: "id", title: "title", options: "options" }, outputs: { showActionSheetChange: "showActionSheetChange", itemClick: "itemClick" }, decls: 3, vars: 3, consts: [[3, "click", 4, "ngIf"], [3, "vclA11YAriaRegion"], ["open", "", "class", "action-sheet-container", "aria-modal", "true", 3, "vclA11YFocus", "focusTarget", 4, "ngIf"], [3, "click"], ["open", "", "aria-modal", "true", 1, "action-sheet-container", 3, "vclA11YFocus", "focusTarget"], ["voxelHeaderTitle", ""], ["voxelHeaderActionButton", "", "aria-label", "fechar", 3, "click"], ["role", "list", 1, "list-wrapper"], ["class", "item voxel-p-l", "role", "button", 3, "click", 4, "ngFor", "ngForOf"], ["role", "button", 1, "item", "voxel-p-l", 3, "click"], ["aria-hidden", "true"], ["aria-hidden", "true", 1, "pr-3"]], template: function VclActionSheetComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, VclActionSheetComponent_vcl_backdrop_0_Template, 1, 0, "vcl-backdrop", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, VclActionSheetComponent_dialog_2_Template, 9, 6, "dialog", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.showActionSheet);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("vclA11YAriaRegion", ctx.showActionSheet);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showActionSheet);
    } }, directives: [ɵngcc2.NgIf, VclA11YAriaRegionDirective, VclBackdropComponent, VclA11YFocusDirective, ɵngcc1.VoxelHeaderComponent, ɵngcc1.VoxelHeaderTitleDirective, ɵngcc1.VoxelHeaderActionButtonDirective, ɵngcc1.VoxelIconComponent, ɵngcc2.NgForOf], pipes: [ɵngcc2.AsyncPipe], styles: [".action-sheet-container[_ngcontent-%COMP%]{position:fixed;bottom:0;width:100%;padding:0;z-index:1000;background-color:#fff;border-radius:4px 4px 0 0;border:0}.action-sheet-container[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:last-child{padding-bottom:2rem}.action-sheet-container[_ngcontent-%COMP%]   .pr-3[_ngcontent-%COMP%]{padding-right:3rem}  header{border-radius:4px 4px 0 0}"], data: { animation: [
            trigger('slideInOut', [
                transition(':enter', [
                    style({ transform: 'translateY(100%)' }),
                    animate('300ms cubic-bezier(0.25, 0.46, 0.45, 0.94)', style({ transform: 'translateY(0%)' })),
                ]),
                transition(':leave', [
                    animate('300ms ease-out', style({ transform: 'translateY(100%)' })),
                ]),
            ]),
        ] } });
VclActionSheetComponent.selector = 'vcl-action-sheet';
VclActionSheetComponent.ctorParameters = () => [
    { type: VoxelSegmentService }
];
VclActionSheetComponent.propDecorators = {
    id: [{ type: Input }],
    title: [{ type: Input }],
    options: [{ type: Input }],
    showActionSheet: [{ type: Input }],
    showActionSheetChange: [{ type: Output }],
    itemClick: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclActionSheetComponent, [{
        type: Component,
        args: [{
                selector: 'vcl-action-sheet',
                template: "<vcl-backdrop (click)=\"onBdClick()\" *ngIf=\"showActionSheet\"></vcl-backdrop>\n\n<div [vclA11YAriaRegion]=\"showActionSheet\">\n\n  <dialog\n    open class=action-sheet-container\n    aria-modal=\"true\"\n    *ngIf=\"showActionSheet\"\n    [attr.id]=\"'action-sheet-' + id\"\n    [vclA11YFocus]=\"showActionSheet\"\n    [focusTarget]=\"'container'\"\n    [@slideInOut]>\n\n    <voxel-header>\n      <h1 voxelHeaderTitle>{{title}}</h1>\n      <button\n        voxelHeaderActionButton\n        aria-label=\"fechar\"\n        (click)=\"onBdClick()\"\n      >\n        <voxel-icon>fechar</voxel-icon>\n      </button>\n    </voxel-header>\n\n    <ul class=\"list-wrapper\" role=\"list\">\n      <li class=\"item voxel-p-l\" role=\"button\"\n        *ngFor=\"let option of options\"\n        (click)=\"onItemClick($event, option)\"\n        [attr.aria-label]=\"option.title + ',' + option.description\">\n        <h3 class=\"voxel-pb-s voxel-text-l-bd color-{{ segment$ | async }}\" aria-hidden=\"true\"> {{ option.title }} </h3>\n        <p class=pr-3 aria-hidden=\"true\"> {{ option.description }} </p>\n      </li>\n    </ul>\n  </dialog>\n\n</div>\n\n",
                animations: [
                    trigger('slideInOut', [
                        transition(':enter', [
                            style({ transform: 'translateY(100%)' }),
                            animate('300ms cubic-bezier(0.25, 0.46, 0.45, 0.94)', style({ transform: 'translateY(0%)' })),
                        ]),
                        transition(':leave', [
                            animate('300ms ease-out', style({ transform: 'translateY(100%)' })),
                        ]),
                    ]),
                ],
                styles: [".action-sheet-container{position:fixed;bottom:0;width:100%;padding:0;z-index:1000;background-color:#fff;border-radius:4px 4px 0 0;border:0}.action-sheet-container ul li:last-child{padding-bottom:2rem}.action-sheet-container .pr-3{padding-right:3rem}::ng-deep header{border-radius:4px 4px 0 0}\n"]
            }]
    }], function () { return [{ type: ɵngcc1.VoxelSegmentService }]; }, { showActionSheetChange: [{
            type: Output
        }], itemClick: [{
            type: Output
        }], showActionSheet: [{
            type: Input
        }], id: [{
            type: Input
        }], title: [{
            type: Input
        }], options: [{
            type: Input
        }] }); })();

class VclActionSheetModule {
}
VclActionSheetModule.ɵfac = function VclActionSheetModule_Factory(t) { return new (t || VclActionSheetModule)(); };
VclActionSheetModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VclActionSheetModule });
VclActionSheetModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            VoxelHeaderModule,
            VoxelIconModule,
            VclA11YUtilsModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclActionSheetModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    VoxelHeaderModule,
                    VoxelIconModule,
                    VclA11YUtilsModule,
                ],
                declarations: [
                    VclActionSheetComponent,
                    VclBackdropComponent,
                ],
                exports: [
                    VclActionSheetComponent,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VclActionSheetModule, { declarations: function () { return [VclActionSheetComponent, VclBackdropComponent]; }, imports: function () { return [CommonModule,
        VoxelHeaderModule,
        VoxelIconModule, VclA11YUtilsModule]; }, exports: function () { return [VclActionSheetComponent]; } }); })();

/**
 * O Header exibe informações e ações relacionadas à página atual.
 * Possibilita o cliente se indentificar, buscar e ser atendido no app (exceto em casos de fluxos) e,
 * quando necessário, pode conter ações adicionais.
 *
 * *The Header displays information and actions related to the current page.*
 * *Makes it possible for the client to identify, search and be attended in the app (excepet in flow cases) and,*
 * *when necessary, can have additional actions.*
 *
 * ### Acessible
 *
 * <acessible class="not-tested">Acessibilidade - Não testado</acessible>
 *
 *
 * **Module:**
 *
 * `import { VclVoxelHeaderModule } from '@voxel/community-mobile';`
 *
 * <example-url>../../demo/index.html#/portfolio/stepped-header?componentOnly=true</example-url>
 *
 * @example
 *  Com botão voltar e sem botão adicional
 *  <vcl-stepped-header
 *    id="header"
 *    [headerTitle]="title"
 *    headerAccessibility="voltar"
 *    [fixed]="'true'"
 *    [displayBackButton]="true"
 *    (headerBackClick)="goBackClick()"
 *    [currentStep]="2"
 *    [steps]="3"
 *  ></vcl-stepped-header>
 *
 *  Sem botão voltar e sem botão adicional
 *  <vcl-stepped-header
 *    id="header2"
 *    [headerTitle]="title"
 *    [displayBackButton]="false"
 *    [fixed]="'true'"
 *    [currentStep]="2"
 *    [steps]="3"
 *  ></vcl-stepped-header>
 *
 *  Sem botão voltar e com botão adiconal
 *  <vcl-stepped-header
 *    id="header3"
 *    [headerTitle]="title"
 *    [displayBackButton]="false"
 *    [fixed]="'true'"
 *    [currentStep]="2"
 *    [steps]="3"
 *    additionalButtonAccessibility="botão adicional"
 *    additionaIcon="icon-itaufonts_full_seguranca"
 *    (headerAdditionalButtonClick)="goAdicionalClick()"
 *  ></vcl-stepped-header>
 *
 *  Com botão voltar e com botão adiconal
 *  <vcl-stepped-header
 *    id="header4"
 *    [headerTitle]="title"
 *    [displayBackButton]="false"
 *    [currentStep]="currentStep"
 *    [fixed]="'true'"
 *    [steps]="3"
 *    headerAccessibility="voltar"
 *    [displayBackButton]="true"
 *    (headerBackClick)="goBackClick()"
 *    additionalButtonAccessibility="botão adicional"
 *    additionaIcon="icon-itaufonts_sms_mensagem_chat"
 *    (headerAdditionalButtonClick)="goAdicionalClick()"
 *  ></vcl-stepped-header>
 */
class VclSteppedHeaderComponent {
    /**
     * @internal
     */
    constructor(voxelSegmentService, builder) {
        this.voxelSegmentService = voxelSegmentService;
        this.builder = builder;
        /**
         * Valor usado para decidir a visibilidade do botão voltar
         *
         * *Value used to determine the return button visibility*
         */
        this.displayBackButton = true;
        /**
         * Atributo para fixar o topo na tela
         *
         * *Attribute to fixate the top on the screen*
         */
        this.fixed = false;
        /**
         * Quantidade de Etapas
         */
        this.steps = 2;
        /**
         * Etapa Atual
         */
        this.currentStep = 1;
        /**
         * Etapa anterior à etapa atual
         */
        this.previousStep = 0;
        /**
         * Evento disparado ao clicar no botão back
         *
         * *Event triggered when clicking on the back button*
         */
        this.headerBackClick = new EventEmitter();
        /**
         * Evento disparado ao clicar no botão adicional
         *
         * *Event triggered when clicking on the additional button*
         */
        this.headerAdditionalButtonClick = new EventEmitter();
        /**
         * @internal
         */
        this.segment = this.voxelSegmentService.segment;
    }
    ngAfterViewInit() {
        this.updateProgressBar();
    }
    ngOnChanges() {
        this.updateProgressBar();
    }
    /**
     * @internal
     */
    goBack(_event) {
        this.headerBackClick.emit({
            _event,
        });
    }
    /**
     * @internal
     */
    goAdditional(_event) {
        this.headerAdditionalButtonClick.emit({
            _event,
        });
    }
    /**
     * @internal
     */
    updateProgressBar() {
        if (this.currentStep > this.steps) {
            this.currentStep = this.steps;
        }
        if (this.previousStep === this.currentStep) {
            return;
        }
        if (!this.loadingBar) {
            return;
        }
        const factoryIncrement = this.builder.build([
            style({ width: `${this.getInitialProgressValue(this.currentStep)}%` }),
            animate('400ms 0ms ease-out', style({
                width: `${this.getFinalProgressValue(this.currentStep)}%`,
            })),
        ]);
        const factoryDecrement = this.builder.build([
            style({ width: `${this.getFinalProgressValue(this.previousStep)}%` }),
            animate('400ms 0ms ease-out', style({
                width: `${this.getFinalProgressValue(this.currentStep)}%`,
            })),
        ]);
        let player;
        if (this.previousStep <= this.currentStep) {
            player = factoryIncrement.create(this.loadingBar.nativeElement, {});
        }
        else {
            player = factoryDecrement.create(this.loadingBar.nativeElement, {});
        }
        this.previousStep = this.currentStep;
        player.play();
    }
    /**
     * @internal
     */
    getInitialProgressValue(step) {
        return ((step - 1) * 100) / this.steps;
    }
    /**
     * @internal
     */
    getFinalProgressValue(step) {
        return (step * 100) / this.steps;
    }
}
VclSteppedHeaderComponent.ɵfac = function VclSteppedHeaderComponent_Factory(t) { return new (t || VclSteppedHeaderComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.VoxelSegmentService), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.AnimationBuilder)); };
VclSteppedHeaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VclSteppedHeaderComponent, selectors: [["vcl-stepped-header"]], viewQuery: function VclSteppedHeaderComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c49, 7, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.loadingBar = _t.first);
    } }, inputs: { displayBackButton: "displayBackButton", fixed: "fixed", steps: "steps", currentStep: "currentStep", previousStep: "previousStep", headerTitle: "headerTitle", headerAccessibility: "headerAccessibility", additionalButtonAccessibility: "additionalButtonAccessibility", additionaIcon: "additionaIcon" }, outputs: { headerBackClick: "headerBackClick", headerAdditionalButtonClick: "headerAdditionalButtonClick" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 13, vars: 13, consts: [[3, "ngClass"], ["class", "voxel-header__div-btn", 4, "ngIf"], [1, "voxel-header__title"], [1, "voxel-text-m", "voxel-pt-s", "voxel-txt-color-sand-900", "header__title"], [1, "voxel-header__title__steps-info"], ["aria-hidden", "true", 1, "voxel-header__title__progress"], [1, "voxel-header__title__progress--filled"], ["loadingBar", ""], [1, "voxel-header__div-btn"], [1, "voxel-header__btn", "voxel-header__btn-back", 3, "click"], [1, "voxel-header__btn", "voxel-header__btn-additional", 3, "click"]], template: function VclSteppedHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "header", 0);
        ɵngcc0.ɵɵpipe(1, "async");
        ɵngcc0.ɵɵtemplate(2, VclSteppedHeaderComponent_div_2_Template, 4, 1, "div", 1);
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵelementStart(4, "h1", 3);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "p", 4);
        ɵngcc0.ɵɵelementStart(7, "span");
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 5);
        ɵngcc0.ɵɵelement(10, "div", 6, 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(12, VclSteppedHeaderComponent_div_12_Template, 3, 4, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("", ɵngcc0.ɵɵpipeBind1(1, 9, ctx.segment), " voxel-bg-color-sand-0");
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(11, _c50, ctx.fixed));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.displayBackButton);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.headerTitle);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate2("passo ", ctx.currentStep, " de ", ctx.steps, "");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.additionaIcon);
    } }, directives: [ɵngcc2.NgClass, ɵngcc2.NgIf, ɵngcc1.VoxelIconComponent], pipes: [ɵngcc2.AsyncPipe], styles: [".voxel-header__btn[_ngcontent-%COMP%]{border:none;background-color:transparent}[_nghost-%COMP%]{display:block}.voxel-header[_ngcontent-%COMP%]{height:4.6875rem;display:flex;align-items:center;box-shadow:0 .0625rem .0625rem #796d5f3d}.voxel-header--fixed[_ngcontent-%COMP%]{position:fixed;top:0;left:0;width:100%;z-index:10}.voxel-header__title[_ngcontent-%COMP%]{flex:1;text-align:center;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding:0 .5rem}.voxel-header__title__steps-info[_ngcontent-%COMP%]{color:#605751;font-size:.875rem;line-height:1.25rem;margin-bottom:.5rem}.voxel-header__title__progress[_ngcontent-%COMP%]{border:solid .125rem #faf7f5;border-radius:.9375rem;margin-bottom:.625rem;height:.125rem;position:relative}.voxel-header__title__progress--filled[_ngcontent-%COMP%]{background-color:#ec7000;border-radius:.9375rem;height:.25rem;top:-.125rem;position:absolute}.voxel-header__btn[_ngcontent-%COMP%]{width:3rem;height:3rem;display:flex;justify-content:center;align-items:center;padding:0}.voxel-header__actions[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;align-items:center;width:5.5rem}.voxel-header__div-btn[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center}.voxel-header__icon[_ngcontent-%COMP%]{width:3rem;height:3rem}.varejo.voxel-header[_ngcontent-%COMP%]   .voxel-header__title[_ngcontent-%COMP%]   .voxel-header__title__progress[_ngcontent-%COMP%]   .voxel-header__title__progress--filled[_ngcontent-%COMP%]{background-color:#ec7000}.personnalite.voxel-header[_ngcontent-%COMP%]   .voxel-header__title[_ngcontent-%COMP%]   .voxel-header__title__progress[_ngcontent-%COMP%]   .voxel-header__title__progress--filled[_ngcontent-%COMP%]{background-color:#d0a967}.uniclass.voxel-header[_ngcontent-%COMP%]   .voxel-header__title[_ngcontent-%COMP%]   .voxel-header__title__progress[_ngcontent-%COMP%]   .voxel-header__title__progress--filled[_ngcontent-%COMP%]{background-color:#ec7000}.empresas.voxel-header[_ngcontent-%COMP%]   .voxel-header__title[_ngcontent-%COMP%]   .voxel-header__title__progress[_ngcontent-%COMP%]   .voxel-header__title__progress--filled[_ngcontent-%COMP%]{background-color:#ec7000}.itaucard.voxel-header[_ngcontent-%COMP%]   .voxel-header__title[_ngcontent-%COMP%]   .voxel-header__title__progress[_ngcontent-%COMP%]   .voxel-header__title__progress--filled[_ngcontent-%COMP%]{background-color:#ec7000}.private.voxel-header[_ngcontent-%COMP%]   .voxel-header__title[_ngcontent-%COMP%]   .voxel-header__title__progress[_ngcontent-%COMP%]   .voxel-header__title__progress--filled[_ngcontent-%COMP%]{background-color:#ec7000}.parceiro-itaucard.voxel-header[_ngcontent-%COMP%]   .voxel-header__title[_ngcontent-%COMP%]   .voxel-header__title__progress[_ngcontent-%COMP%]   .voxel-header__title__progress--filled[_ngcontent-%COMP%]{background-color:#ec7000}.parceiro-credicard.voxel-header[_ngcontent-%COMP%]   .voxel-header__title[_ngcontent-%COMP%]   .voxel-header__title__progress[_ngcontent-%COMP%]   .voxel-header__title__progress--filled[_ngcontent-%COMP%]{background-color:#0d456f}.parceiro-hipercard.voxel-header[_ngcontent-%COMP%]   .voxel-header__title[_ngcontent-%COMP%]   .voxel-header__title__progress[_ngcontent-%COMP%]   .voxel-header__title__progress--filled[_ngcontent-%COMP%]{background-color:#ba1319}.parceiro-magazine-luiza.voxel-header[_ngcontent-%COMP%]   .voxel-header__title[_ngcontent-%COMP%]   .voxel-header__title__progress[_ngcontent-%COMP%]   .voxel-header__title__progress--filled[_ngcontent-%COMP%]{background-color:#0083ca}.personal-bank.voxel-header[_ngcontent-%COMP%]   .voxel-header__title[_ngcontent-%COMP%]   .voxel-header__title__progress[_ngcontent-%COMP%]   .voxel-header__title__progress--filled[_ngcontent-%COMP%]{background-color:#ce9141}.itau-bba.voxel-header[_ngcontent-%COMP%]   .voxel-header__title[_ngcontent-%COMP%]   .voxel-header__title__progress[_ngcontent-%COMP%]   .voxel-header__title__progress--filled[_ngcontent-%COMP%]{background-color:#2449cc}.varejo.voxel-header[_ngcontent-%COMP%]   .voxel-header__btn[_ngcontent-%COMP%]{color:#ec7000}.personnalite.voxel-header[_ngcontent-%COMP%]   .voxel-header__btn[_ngcontent-%COMP%]{color:#d0a967}.uniclass.voxel-header[_ngcontent-%COMP%]   .voxel-header__btn[_ngcontent-%COMP%]{color:#ec7000}.empresas.voxel-header[_ngcontent-%COMP%]   .voxel-header__btn[_ngcontent-%COMP%]{color:#ec7000}.itaucard.voxel-header[_ngcontent-%COMP%]   .voxel-header__btn[_ngcontent-%COMP%]{color:#ec7000}.private.voxel-header[_ngcontent-%COMP%]   .voxel-header__btn[_ngcontent-%COMP%]{color:#ec7000}.parceiro-itaucard.voxel-header[_ngcontent-%COMP%]   .voxel-header__btn[_ngcontent-%COMP%]{color:#ec7000}.parceiro-credicard.voxel-header[_ngcontent-%COMP%]   .voxel-header__btn[_ngcontent-%COMP%]{color:#0d456f}.parceiro-hipercard.voxel-header[_ngcontent-%COMP%]   .voxel-header__btn[_ngcontent-%COMP%]{color:#ba1319}.parceiro-magazine-luiza.voxel-header[_ngcontent-%COMP%]   .voxel-header__btn[_ngcontent-%COMP%]{color:#0083ca}.personal-bank.voxel-header[_ngcontent-%COMP%]   .voxel-header__btn[_ngcontent-%COMP%]{color:#ce9141}.itau-bba.voxel-header[_ngcontent-%COMP%]   .voxel-header__btn[_ngcontent-%COMP%]{color:#2449cc}.personnalite.voxel-header[_ngcontent-%COMP%]   .voxel-header__btn[_ngcontent-%COMP%]{color:#876632}"] });
VclSteppedHeaderComponent.selector = 'vcl-stepped-header';
VclSteppedHeaderComponent.ctorParameters = () => [
    { type: VoxelSegmentService },
    { type: AnimationBuilder }
];
VclSteppedHeaderComponent.propDecorators = {
    loadingBar: [{ type: ViewChild, args: ['loadingBar', {
                    read: ElementRef,
                    static: true
                },] }],
    headerTitle: [{ type: Input }],
    headerAccessibility: [{ type: Input }],
    additionalButtonAccessibility: [{ type: Input }],
    additionaIcon: [{ type: Input }],
    displayBackButton: [{ type: Input }],
    fixed: [{ type: Input }],
    steps: [{ type: Input }],
    currentStep: [{ type: Input }],
    previousStep: [{ type: Input }],
    headerBackClick: [{ type: Output }],
    headerAdditionalButtonClick: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclSteppedHeaderComponent, [{
        type: Component,
        args: [{
                selector: 'vcl-stepped-header',
                template: "<header class=\"{{ segment | async }} voxel-bg-color-sand-0\" [ngClass]=\"{\n  'voxel-header': true,\n  'voxel-header--fixed' : fixed\n}\">\n\n  <div class=\"voxel-header__div-btn\" *ngIf=\"displayBackButton\">\n    <button class=\"voxel-header__btn voxel-header__btn-back\"\n      [attr.aria-label]=\"headerAccessibility\" (click)=\"goBack($event)\">\n      <voxel-icon>seta_esquerda_outline</voxel-icon>\n    </button>\n  </div>\n\n  <div class=\"voxel-header__title\">\n    <h1 class=\"voxel-text-m voxel-pt-s voxel-txt-color-sand-900 header__title\">{{ headerTitle }}</h1>\n\n    <p class=\"voxel-header__title__steps-info\">\n      <span>passo {{ currentStep }} de {{ steps }}</span>\n    </p>\n\n    <div class=\"voxel-header__title__progress\" aria-hidden=\"true\">\n      <div class=\"voxel-header__title__progress--filled\" #loadingBar></div>\n    </div>\n  </div>\n\n  <div class=\"voxel-header__div-btn\" *ngIf=\"additionaIcon\">\n    <button class=\"voxel-header__btn voxel-header__btn-additional\"\n      [attr.aria-label]=\"additionalButtonAccessibility\" (click)=\"goAdditional($event)\">\n      <span class=\"{{additionaIcon}}\"></span>\n    </button>\n  </div>\n</header>",
                styles: [".voxel-header__btn{border:none;background-color:transparent}:host{display:block}.voxel-header{height:4.6875rem;display:flex;align-items:center;box-shadow:0 .0625rem .0625rem #796d5f3d}.voxel-header--fixed{position:fixed;top:0;left:0;width:100%;z-index:10}.voxel-header__title{flex:1;text-align:center;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding:0 .5rem}.voxel-header__title__steps-info{color:#605751;font-size:.875rem;line-height:1.25rem;margin-bottom:.5rem}.voxel-header__title__progress{border:solid .125rem #faf7f5;border-radius:.9375rem;margin-bottom:.625rem;height:.125rem;position:relative}.voxel-header__title__progress--filled{background-color:#ec7000;border-radius:.9375rem;height:.25rem;top:-.125rem;position:absolute}.voxel-header__btn{width:3rem;height:3rem;display:flex;justify-content:center;align-items:center;padding:0}.voxel-header__actions{display:flex;justify-content:flex-end;align-items:center;width:5.5rem}.voxel-header__div-btn{display:flex;justify-content:center;align-items:center}.voxel-header__icon{width:3rem;height:3rem}.varejo.voxel-header .voxel-header__title .voxel-header__title__progress .voxel-header__title__progress--filled{background-color:#ec7000}.personnalite.voxel-header .voxel-header__title .voxel-header__title__progress .voxel-header__title__progress--filled{background-color:#d0a967}.uniclass.voxel-header .voxel-header__title .voxel-header__title__progress .voxel-header__title__progress--filled{background-color:#ec7000}.empresas.voxel-header .voxel-header__title .voxel-header__title__progress .voxel-header__title__progress--filled{background-color:#ec7000}.itaucard.voxel-header .voxel-header__title .voxel-header__title__progress .voxel-header__title__progress--filled{background-color:#ec7000}.private.voxel-header .voxel-header__title .voxel-header__title__progress .voxel-header__title__progress--filled{background-color:#ec7000}.parceiro-itaucard.voxel-header .voxel-header__title .voxel-header__title__progress .voxel-header__title__progress--filled{background-color:#ec7000}.parceiro-credicard.voxel-header .voxel-header__title .voxel-header__title__progress .voxel-header__title__progress--filled{background-color:#0d456f}.parceiro-hipercard.voxel-header .voxel-header__title .voxel-header__title__progress .voxel-header__title__progress--filled{background-color:#ba1319}.parceiro-magazine-luiza.voxel-header .voxel-header__title .voxel-header__title__progress .voxel-header__title__progress--filled{background-color:#0083ca}.personal-bank.voxel-header .voxel-header__title .voxel-header__title__progress .voxel-header__title__progress--filled{background-color:#ce9141}.itau-bba.voxel-header .voxel-header__title .voxel-header__title__progress .voxel-header__title__progress--filled{background-color:#2449cc}.varejo.voxel-header .voxel-header__btn{color:#ec7000}.personnalite.voxel-header .voxel-header__btn{color:#d0a967}.uniclass.voxel-header .voxel-header__btn{color:#ec7000}.empresas.voxel-header .voxel-header__btn{color:#ec7000}.itaucard.voxel-header .voxel-header__btn{color:#ec7000}.private.voxel-header .voxel-header__btn{color:#ec7000}.parceiro-itaucard.voxel-header .voxel-header__btn{color:#ec7000}.parceiro-credicard.voxel-header .voxel-header__btn{color:#0d456f}.parceiro-hipercard.voxel-header .voxel-header__btn{color:#ba1319}.parceiro-magazine-luiza.voxel-header .voxel-header__btn{color:#0083ca}.personal-bank.voxel-header .voxel-header__btn{color:#ce9141}.itau-bba.voxel-header .voxel-header__btn{color:#2449cc}.personnalite.voxel-header .voxel-header__btn{color:#876632}\n"]
            }]
    }], function () { return [{ type: ɵngcc1.VoxelSegmentService }, { type: ɵngcc6.AnimationBuilder }]; }, { displayBackButton: [{
            type: Input
        }], fixed: [{
            type: Input
        }], steps: [{
            type: Input
        }], currentStep: [{
            type: Input
        }], previousStep: [{
            type: Input
        }], headerBackClick: [{
            type: Output
        }], headerAdditionalButtonClick: [{
            type: Output
        }], loadingBar: [{
            type: ViewChild,
            args: ['loadingBar', {
                    read: ElementRef,
                    static: true
                }]
        }], headerTitle: [{
            type: Input
        }], headerAccessibility: [{
            type: Input
        }], additionalButtonAccessibility: [{
            type: Input
        }], additionaIcon: [{
            type: Input
        }] }); })();

class VclSteppedHeaderModule {
}
VclSteppedHeaderModule.ɵfac = function VclSteppedHeaderModule_Factory(t) { return new (t || VclSteppedHeaderModule)(); };
VclSteppedHeaderModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VclSteppedHeaderModule });
VclSteppedHeaderModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            VoxelSegmentModule,
            VoxelIconModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VclSteppedHeaderModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    VoxelSegmentModule,
                    VoxelIconModule,
                ],
                declarations: [VclSteppedHeaderComponent],
                exports: [VclSteppedHeaderComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VclSteppedHeaderModule, { declarations: function () { return [VclSteppedHeaderComponent]; }, imports: function () { return [CommonModule,
        VoxelSegmentModule,
        VoxelIconModule]; }, exports: function () { return [VclSteppedHeaderComponent]; } }); })();

/*
 * Directives
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DialogButtonTypes, IVclAutocompleteEvent, IVclSelectEvent, ModalButtonTypes, NpsResponseTypes, SearchPipe, SnackBarConfig, VclA11YAriaRegionDirective, VclA11YFocusDirective, VclA11YUtilsModule, VclActionSheetComponent, VclActionSheetModule, VclAutocompleteComponent, VclAutocompleteModule, VclCardDropdownComponent, VclCardDropdownModule, VclCarouselComponent, VclCarouselElementDirective, VclCarouselItemDirective, VclCarouselModule, VclDialogComponent, VclDialogModule, VclErrorMessageComponent, VclFieldMixinBase, VclFooterTwoComponent, VclFooterTwoModule, VclFormFieldComponent, VclFormFieldModule, VclHeaderComponent, VclHeaderModule, VclHintFieldDirective, VclInternalSearchComponent, VclInternalSearchModule, VclLoadingCardComponent, VclLoadingCardModule, VclModalComponent, VclModalModule, VclNpsComponent, VclNpsModule, VclOptionComponent, VclPaginatorComponent, VclQrCodeComponent, VclQrCodeModule, VclQrCodeScannerComponent, VclQrCodeScannerModule, VclRippleDirective, VclRippleModule, VclSelectComponent, VclSelectModule, VclSelectOptionComponent, VclSnackBarComponent, VclSnackBarModule, VclSnackBarService, VclSortColumnDirective, VclSortDirective, VclSteppedHeaderComponent, VclSteppedHeaderModule, VclStepperComponent, VclStepperModule, VclStepsComponent, VclStepsModule, VclSuccessMessageComponent, VclTableComponent, VclTableModule, VclTagComponent, VclTagModule, VclSelectComponent$1 as ɵa, VclMegaMenuService as ɵb, VclMegaMenuComponent as ɵc, VclBackdropComponent as ɵd };

